webpackJsonp([0],{

/***/ "+9ca":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+O2L":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CustomerEdit = __webpack_require__("6cGw");

var _CustomerEdit2 = _interopRequireDefault(_CustomerEdit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var API_URL = 'customers'; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'Customers',
  components: {
    CustomerEdit: _CustomerEdit2.default
  },
  data: function data() {
    return {
      search: '',
      serverItemsLength: 0,
      items: [],
      customerData: {},
      firstLoading: true,
      loading: true,
      options: { page: 1, itemsPerPage: 25 },
      getTimer: '',
      editingCustomer: false,
      customerTypes: {
        1: 'Физическое лицо',
        2: 'Индивидуальный предприниматель',
        3: 'Юридическое лицо'
      },
      headers: [{
        text: 'Лицевой счёт',
        align: 'left',
        sortable: false,
        value: 'customer_number'
      }, {
        text: 'Тип лицевого счёта',
        align: 'left',
        sortable: false,
        value: 'customer_type'
      }, {
        text: 'Наименование',
        align: 'left',
        sortable: false,
        value: 'company_full_name'
      }, {
        text: 'Фамилия',
        align: 'left',
        sortable: false,
        value: 'last_name'
      }, {
        text: 'Имя',
        align: 'left',
        sortable: false,
        value: 'first_name'
      }, {
        text: 'Отчество',
        align: 'left',
        sortable: false,
        value: 'middle_name'
      }, { text: '', sortable: false, value: '' }]
    };
  },

  watch: {
    options: {
      handler: function handler() {
        this.getItemsApiTimer();
      },

      deep: true
    }
  },
  methods: {
    getItemsApi: function getItemsApi() {
      var _this = this;

      this.loading = true;
      this.axios.get('/api/' + API_URL + '/?per_page=' + this.options.itemsPerPage + '&page=' + this.options.page).then(function (response) {
        _this.items = response.data.results;
        _this.serverItemsLength = response.data.count;
      }).catch(function (err) {
        console.log(err);
      }).finally(function () {
        _this.firstLoading = false;
        _this.loading = false;
      });
    },
    getItemsApiTimer: function getItemsApiTimer() {
      var _this2 = this;

      clearTimeout(this.getTimer);
      this.getTimer = setTimeout(function () {
        _this2.getItemsApi();
      }, 100);
    },
    deleteItemApi: function deleteItemApi(item) {
      var _this3 = this;

      var id = item.customer_id;
      this.loading = true;
      this.axios.delete('/api/' + API_URL + '/' + id).then(function (response) {
        _this3.loading = false;
        var index = _this3.items.indexOf(item);
        _this3.items.splice(index, 1);
      }).catch(function (err) {
        _this3.loading = false;
        console.log(err);
      });
    },
    deleteItem: function deleteItem(item) {
      if (confirm('Вы действительно хотите удалить эту строку?')) {
        this.deleteItemApi(item);
      }
    },
    edit: function edit(item) {
      this.customerData = item;
      this.editingCustomer = true;
    },
    add: function add() {
      this.customerData = {
        company_bik: null,
        company_full_name: null,
        company_inn: null,
        company_kpp: null,
        company_ks: null,
        company_legal_address: null,
        company_ogrn: null,
        company_rs: null,
        company_short_name: null,
        created_at: null,
        customer_id: null,
        customer_number: null,
        customer_type: 1,
        first_name: null,
        last_name: null,
        middle_name: null,
        remark: null,
        snils: null
      };
      this.editingCustomer = true;
    },
    edited: function edited(customer) {
      if (this.customerData.customer_id != null) {
        Object.assign(this.customerData, customer);
      } else {
        this.items.push(customer);
      }
      this.editingCustomer = false;
    }
  }
};

/***/ }),

/***/ "+PTj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_c('div',[_c('div',{staticClass:"headline"},[_vm._v("\n        Добавление счетчика\n      ")])])]),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"addCounterForm"},[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{attrs:{"label":"Серийный номер","rules":_vm.inputRules,"required":""},model:{value:(_vm.counter.serial_num),callback:function ($$v) {_vm.$set(_vm.counter, "serial_num", $$v)},expression:"counter.serial_num"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-autocomplete',{attrs:{"items":_vm.counters_models,"label":"Модель","item-text":"name","item-value":"model_id","menu-props":{maxHeight:'auto'},"rules":_vm.inputRules,"required":""},model:{value:(_vm.counter.model_id),callback:function ($$v) {_vm.$set(_vm.counter, "model_id", $$v)},expression:"counter.model_id"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{attrs:{"label":"Коэффициент трансформации","rules":_vm.inputRules,"required":""},model:{value:(_vm.counter.coeff),callback:function ($$v) {_vm.$set(_vm.counter, "coeff", $$v)},expression:"counter.coeff"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","text":""},nativeOn:{"click":function($event){return _vm.addCounter($event)}}},[_vm._v("\n      Добавить\n    ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","text":""},nativeOn:{"click":function($event){return _vm.cancelAdding()}}},[_vm._v("\n      Отмена\n    ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+YuL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+Zml":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _VTreeview = __webpack_require__("IzUI");

var _VTreeview2 = _interopRequireDefault(_VTreeview);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: { VTreeview: _VTreeview2.default },
  props: {
    source: String,
    drawer: {
      type: Boolean,
      default: true
    },
    treeData: Array,
    selectedRepresentName: String,
    additionalData: Object
  },
  data: function data() {
    return {
      visible: true,
      dialog: false,
      show_presents: false,
      currentNode: null,
      newRepresentUrl: '/represent/new',
      items: [{ icon: 'play_for_work', text: 'Точки учёта', path: '/points' }, { icon: 'fas fa-clock', text: 'Задания', path: '/tasks' }, { icon: 'mdi-graphql', text: 'Мониторинг', path: '/monitoring' }, { icon: 'fas fa-id-card', text: 'Абоненты', path: '/customers' }, { icon: 'mdi-numeric', text: 'Счётчики', path: '/counters' }, { icon: 'mdi-account', text: 'Пользователи', path: '/users' }, { icon: 'mdi-account-group', text: 'Группы', path: '/permissions-groups' }, {
        icon: 'fas fa-file-alt',
        text: 'Справочники',
        model: false,
        children: [{ icon: 'fas fa-file-alt', text: 'Модели счётчиков', path: '/counters_resource' }]
      }, {
        icon: 'fas fa-file-alt',
        text: 'Шаблоны заявок',
        model: false,
        children: [{ icon: 'fas fa-file-alt', text: 'Типы заявок', path: '/documents-requests-types' }, { icon: 'fas fa-file-alt', text: 'Требуемые файлы заявок', path: '/documents-requests-required' }]
      }, {
        icon: 'fas fa-file-excel',
        text: 'Отчёты',
        model: false,
        children: [{ icon: 'fas fa-file-alt', text: 'Форма 008', path: '/report-008',
          title: 'Формирование отчета о показании счетчиков на указанную дату' }, { icon: 'fas fa-file-alt', text: 'Форма 001.02', path: '/report-00102',
          title: 'Отчет о потреблении электрической энергии за период с учетом тарифных зон' }, { icon: 'fas fa-file-alt', text: 'Форма 80020', path: '/report-80020',
          title: 'Профили мощности' }, { icon: 'fas fa-file-alt', text: 'Форма 010', path: '/report-010',
          title: 'Показание счетчиков и потребление электрической энергии за период с учетом тарифных зон' }]
      }, {
        icon: 'fas fa-file-alt',
        text: 'Аккаунт',
        model: false,
        children: [{ icon: 'fas fa-file-alt', text: 'Настройка аккаунта', path: '/account-settings' }, { icon: 'fas fa-file-alt', text: 'Email адреса', path: '/account-emails' }]
      }],
      openAll: false,
      selectedNode: null,
      showDrawer: true
    };
  },
  watch: {
    drawer: function drawer(val) {
      this.showDrawer = val;
    },
    showDrawer: function showDrawer() {
      this.visible = !this.visible;
    }
  },
  mounted: function mounted() {
    // show represents if url contain `represents` url
    this.show_presents = this.$route.path.indexOf('represents') >= 0;
  },

  methods: {
    selected: function selected(node) {
      this.selectedNode = node;
      this.currentNode = node;
      this.$emit('selected', node);
    },
    filterRepresent: function filterRepresent(val) {
      this.$emit('filterRepresent', val);
    },
    renameSelectedRepresent: function renameSelectedRepresent(val) {
      if (this.currentNode !== null) {
        this.currentNode.model.name = val;
      }
    },
    clearSelectedTreeNode: function clearSelectedTreeNode() {
      this.selectedNode = null;
      this.currentNode = null;
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "+gFL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var API_URL = 'represents'; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'Represents',
  data: function data() {
    return {
      editedRepresent: { name: '', remark: '', parent_id: this.$route.params.parentId }
    };
  },

  methods: {
    addRepresentApi: function addRepresentApi() {
      var _this = this;

      _axios2.default.post('/api/' + API_URL + '/', this.editedRepresent).then(function (response) {
        _this.$router.push({ path: '/represents/' + response.data.represent_id });
        _this.$emit('representAdded');
      }).catch(function (err) {
        console.log(err);
      });
    }
  }
};

/***/ }),

/***/ "+jQ6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DocumentsRequestsRequiredDetails = __webpack_require__("xoHE");

var _DocumentsRequestsRequiredDetails2 = _interopRequireDefault(_DocumentsRequestsRequiredDetails);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'DocumentsRequestsRequired',
  components: {
    DocumentsRequestsRequiredDetails: _DocumentsRequestsRequiredDetails2.default
  },
  data: function data() {
    return {
      loading: true,
      firstLoading: true,
      options: { page: 1, itemsPerPage: 25 },
      selectedItem: {},
      docTypes: [],
      editing: false,
      serverItemsLength: 0,
      headers: [{
        text: 'Название документа',
        align: 'left',
        sortable: false,
        value: 'doc_required_file_name'
      }, {
        text: 'Образец',
        align: 'left',
        sortable: false,
        value: 'example'
      }],
      fileLoading: false,
      getTimer: ''
    };
  },

  watch: {
    options: {
      handler: function handler() {
        this.getRequiredFilesTimer();
      },

      deep: true
    }
  },
  methods: {
    getRequiredFiles: function getRequiredFiles() {
      var _this = this;

      this.loading = true;
      this.axios.get('/api/document_required_file/?per_page=' + this.options.itemsPerPage + '&page=' + this.options.page).then(function (response) {
        _this.docTypes = response.data.results;
        _this.serverItemsLength = response.data.count;
      }).catch(function (err) {
        console.log(err);
      }).finally(function () {
        _this.firstLoading = false;
        _this.loading = false;
      });
    },
    getRequiredFilesTimer: function getRequiredFilesTimer() {
      var _this2 = this;

      clearTimeout(this.getTimer);
      this.getTimer = setTimeout(function () {
        _this2.getRequiredFiles();
      }, 100);
    },
    getDetails: function getDetails(item) {
      this.selectedItem = item;
      this.editing = true;
    },
    addRequiredDocument: function addRequiredDocument() {
      this.selectedItem = {
        doc_required_file_id: null,
        doc_required_file_name: ''
      };
      this.editing = true;
    },
    close: function close() {
      this.getRequiredFilesTimer();
      this.editing = false;
    },
    download: function download(file) {
      var _this3 = this;

      this.fileLoading = true;
      this.axios({
        url: '/api/download/' + file.file_name,
        method: 'GET',
        responseType: 'blob'
      }).then(function (response) {
        var blob = new Blob([response.data], { type: response.data.type });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        var contentDisposition = response.headers['content-disposition'];
        var fileName = file.file_name;
        if (contentDisposition) {
          var fileNameMatch = contentDisposition.match(/filename="(.+)"/);
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1];
          }
        }
        link.setAttribute('download', decodeURI(fileName));
        document.body.appendChild(link);
        link.click();
        link.remove();
        _this3.fileLoading = false;
      }).catch(function (err) {
        console.log(err);
        _this3.fileLoading = false;
      });
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "+rNa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('v-overlay',{attrs:{"value":_vm.fileLoading}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64"}})],1),_vm._v(" "),_c('v-form',[_c('v-card',{attrs:{"flat":"","max-width":"800"}},[_c('v-card-text',[_c('v-form',{ref:"detailsDocumentsRequiredForm"},[_c('v-text-field',{attrs:{"label":"Наименование файла","rules":[_vm.rules.reguired]},model:{value:(_vm.data.doc_required_file_name),callback:function ($$v) {_vm.$set(_vm.data, "doc_required_file_name", $$v)},expression:"data.doc_required_file_name"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Короткое имя файла","rules":[_vm.rules.reguired]},model:{value:(_vm.data.short_file_name),callback:function ($$v) {_vm.$set(_vm.data, "short_file_name", $$v)},expression:"data.short_file_name"}}),_vm._v(" "),(_vm.data.doc_required_file_example)?_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.download(_vm.data.doc_required_file_example)}}},[_vm._v("Образец")]):_vm._e(),_vm._v(" "),_c('v-file-input',{attrs:{"chips":"","label":"Образец документа"},model:{value:(_vm.data.file),callback:function ($$v) {_vm.$set(_vm.data, "file", $$v)},expression:"data.file"}})],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{staticClass:"mr-4",attrs:{"color":"success"},on:{"click":_vm.save}},[_vm._v("\n          Сохранить\n        ")]),_vm._v(" "),_c('v-btn',{staticClass:"mr-4",on:{"click":_vm.close}},[_vm._v("\n          Отмена\n        ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+v5I":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'CountersModelsParameters',
  data: function data() {
    return {
      items: [],
      loading: true,
      counter_model: null,
      headers: [{
        text: 'API параметр счетчика',
        align: 'left',
        value: 'parameter_name'
      }],
      breadcrumbsItems: [{
        text: 'Ресурс',
        disabled: false,
        href: 'counters_resource'
      }]
    };
  },
  mounted: function mounted() {
    this.counter_model = this.$route.query.counter_model;
    this.getItemsApi();
    this.fillBreadcrumb();
  },

  methods: {
    getItemsApi: function getItemsApi() {
      var _this = this;

      if (!this.counter_model) {
        this.loading = false;
        return;
      }
      this.loading = true;
      this.axios.get('/api/counters_models_parameters/?page_size=500&model_id=' + this.counter_model).then(function (response) {
        _this.items = response.data.results;
        _this.loading = false;
      }).catch(function (err) {
        _this.loading = false;
        console.log(err);
      });
    },
    fillBreadcrumb: function fillBreadcrumb() {
      var _this2 = this;

      if (!this.counter_model) {
        return;
      }
      this.axios.get('api/counters_models/' + this.counter_model + '/').then(function (response) {
        var model = response.data;
        _this2.axios.get('api/resources_types/' + model.resource_type.resource_type_id + '/').then(function (response) {
          _this2.breadcrumbsItems.push({
            text: response.data.name,
            disabled: false,
            href: 'counters_models_api?resource_type=' + model.resource_type.resource_type_id
          });
          _this2.axios.get('api/counters_api/' + model.counter_model_api + '/').then(function (modelApiResponse) {
            _this2.breadcrumbsItems.push({
              text: modelApiResponse.data.name,
              disabled: false,
              href: 'counters_models?resource_type=' + model.resource_type.resource_type_id + '&counter_model_api=' + model.counter_model_api
            });
            _this2.breadcrumbsItems.push({
              text: model.name,
              disabled: true
            });
          });
        });
      });
    },
    openBreadcrumbsUrl: function openBreadcrumbsUrl(item) {
      this.$router.push({ path: item.href });
    }
  }
};

/***/ }),

/***/ "+wU7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DataParameters_vue__ = __webpack_require__("OnoV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DataParameters_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DataParameters_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DataParameters_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DataParameters_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7311691a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DataParameters_vue__ = __webpack_require__("oOyZ");
function injectStyle (ssrContext) {
  __webpack_require__("g3JH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7311691a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DataParameters_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7311691a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DataParameters_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "/Noj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueChartjs = __webpack_require__("UlOv");

exports.default = {
  extends: _vueChartjs.Line,
  props: {
    chartdata: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: null
    }
  },
  mounted: function mounted() {
    this.renderChart(this.chartdata, this.options);
  }
};

/***/ }),

/***/ "/O73":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'CounterEdit',
  props: {
    counterData: {}
  },
  data: function data() {
    return {
      inputRules: [function (v) {
        return !!v || 'Заполните это поле!';
      }],
      counter: {}
    };
  },
  mounted: function mounted() {
    this.counter = Object.assign({}, this.counterData);
  },

  methods: {
    saveChanges: function saveChanges() {
      var _this = this;

      if (this.$refs.counterParamsForm.validate()) {
        if (this.counter.coeff !== this.counterData.coeff || this.counter.coeff_voltage !== this.counterData.coeff_voltage || this.counter.serial_num !== this.counterData.serial_num) {
          this.axios.patch('/api/counters/' + this.counter.counter_id + '/', this.counter).then(function (response) {
            _this.$emit('edited', _this.counter);
          }).catch(function (err) {
            _this.$emit('editError', err.response.data);
          });
        } else {
          this.$emit('cancel');
        }
      }
    }
  }
};

/***/ }),

/***/ "/c4q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0356c227_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFound_vue__ = __webpack_require__("4sjB");
function injectStyle (ssrContext) {
  __webpack_require__("4uV1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0356c227_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFound_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "/uWe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Customers_vue__ = __webpack_require__("+O2L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Customers_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Customers_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Customers_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Customers_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20007f10_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Customers_vue__ = __webpack_require__("1xgP");
function injectStyle (ssrContext) {
  __webpack_require__("LiKw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-20007f10"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Customers_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20007f10_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Customers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "/uXD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "06No":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[(_vm.loading)?_c('v-layout',{staticClass:"loading-indicator",attrs:{"justify-center":"","align-center":""}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":70,"width":7}})],1):_vm._e(),_vm._v(" "),_c('v-card-title',[_c('v-spacer'),_vm._v(" "),_c('v-text-field',{attrs:{"append-icon":"search","label":"Номер счетчика","single-line":"","hide-details":""},model:{value:(_vm.serialNumSearch),callback:function ($$v) {_vm.serialNumSearch=$$v},expression:"serialNumSearch"}})],1),_vm._v(" "),_c('v-card-text',[_c('v-data-table',{attrs:{"headers":_vm.availableCountersHeaders,"items":_vm.items,"options":_vm.options,"server-items-length":_vm.serverItemsLength,"no-data-text":"Нет данных для отображения","footer-props":{
        itemsPerPageText: 'Число счетчиков на странице',
        itemsPerPageOptions: [25, 50]
      },"dense":""},on:{"update:options":function($event){_vm.options=$event},"click:row":_vm.selected}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0WFi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CounterParametersData_vue__ = __webpack_require__("xM8X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CounterParametersData_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CounterParametersData_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CounterParametersData_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CounterParametersData_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_468ec181_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CounterParametersData_vue__ = __webpack_require__("Ro34");
function injectStyle (ssrContext) {
  __webpack_require__("3c05")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CounterParametersData_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_468ec181_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CounterParametersData_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "0mug":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0uD0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PointToolbar = __webpack_require__("bB1z");

var _PointToolbar2 = _interopRequireDefault(_PointToolbar);

var _TaskLogs = __webpack_require__("U+R7");

var _TaskLogs2 = _interopRequireDefault(_TaskLogs);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'PointsScheduler',
  components: {
    PointToolbar: _PointToolbar2.default,
    TaskLogs: _TaskLogs2.default
  },
  data: function data() {
    return {
      inputRules: [function (v) {
        return !!v || 'Заполните это поле!';
      }],
      showLog: false,
      tmpParameters: [],
      counterTasksHeaders: [{ text: 'Номер счётчика', sortable: false, value: 'counter_num' }, { text: 'Выполняется', sortable: false, value: 'enabled' }, { text: 'Действия', sortable: false, value: 'actions' }],
      editedTask: false,
      editedTaskItem: { counter_id: '', parameters: [], data_collecting_server_id: '', value: '', point_id: '' },
      editedCounterTaskIndex: -1,
      taskOnceDateValue: false,
      startTaskDate: false,
      taskDialog: false,
      tasksLoading: true,
      counterTasks: [],
      pointId: this.$route.params['id'],
      editing: false,
      point: {},
      counterParameters: [],
      dataCollectingServers: [],
      sheet: false,
      sendUpdate: false,
      cronVal: '',
      addTask: false,
      selectedTask: {},
      taskGroups: [],
      tmpTaskGroups: [],
      intervalSelect: '*/30 * * * *',
      intervals: [{ text: 'Каждые 30 минут', value: '*/30 * * * *' }, { text: 'Каждый час', value: '0 * * * *' }, { text: 'Раз в сутки в 00:00', value: '0 0 * * *' }]
    };
  },

  computed: {
    taskDialogTitle: function taskDialogTitle() {
      return this.editing ? 'Редактирование задания' : 'Новое задание';
    }
  },
  watch: {
    dialog: function dialog(val) {
      val || this.close();
    },

    'editedTaskItem.counter_parameters': function editedTaskItemCounter_parameters() {
      var _this = this;

      if (this.sendUpdate) {
        return;
      }
      this.tmpParameters = [];
      this.counterParameters.forEach(function (element) {
        if (_this.editedTaskItem.counter_parameters.includes(element.model_parameter_id)) {
          _this.tmpParameters.push(element);
        }
      });
      setTimeout(function () {
        _this.paramsLoading = false;
      }, 1000);
    },
    tmpTaskGroups: function tmpTaskGroups() {
      this.tmpParameters = [];
      for (var idx in this.tmpTaskGroups) {
        for (var paramIdx in this.counterParameters) {
          if (this.counterParameters[paramIdx].parameter__task_group === this.tmpTaskGroups[idx].group_id) {
            this.tmpParameters.push(this.counterParameters[paramIdx]);
          }
        }
      }
    }
  },
  mounted: function mounted() {
    this.getTasksApi();
    this.getPointApi();
    this.getCounterAvailableParameters();
    this.getCounterAvailableServers();
  },

  methods: {
    getPointApi: function getPointApi() {
      var self = this;
      _axios2.default.get('/api/points/' + this.pointId + '/').then(function (response) {
        self.point = response.data;
      }).catch(function (err) {
        console.log(err);
      });
    },
    getCounterAvailableParameters: function getCounterAvailableParameters() {
      var self = this;
      return new Promise(function (resolve, reject) {
        self.counterParameters = [];
        self.taskGroups = [];
        var tmpGroup = {};
        _axios2.default.get('/api/counters_data/available_params/?point_id=' + self.pointId).then(function (response) {
          self.counterParameters = self.counterParameters.concat(response.data);
          self.counterParameters.forEach(function (element) {
            if (element.parameter__task_group !== null) {
              tmpGroup[element.parameter__task_group] = element.parameter__task_group_name;
            }
          });
          for (var key in tmpGroup) {
            self.taskGroups.push({ 'name': tmpGroup[key], 'group_id': key });
          }
        }).catch(function (err) {
          console.log(err);
        });
      });
    },
    getCounterAvailableServers: function getCounterAvailableServers() {
      this.dataCollectingServers = [];
      var self = this;
      _axios2.default.get('/api/collecting_servers/').then(function (response) {
        self.dataCollectingServers = response.data;
      }).catch(function (err) {
        console.log(err);
      });
    },
    getTasksApi: function getTasksApi() {
      var _this2 = this;

      this.tasksLoading = true;
      var self = this;
      _axios2.default.get('/api/counters_tasks/?point_id=' + this.pointId).then(function (response) {
        self.counterTasks = response.data.results;
        self.tasksLoading = false;
      }).catch(function (err) {
        _this2.tasksLoading = false;
        console.log(err);
      });
    },
    closeTasks: function closeTasks() {
      this.taskDialog = false;
    },
    addTaskApi: function addTaskApi() {
      var _this3 = this;

      this.tasksLoading = true;
      var self = this;
      this.editedTaskItem.counter_parameters = [];
      this.tmpParameters.forEach(function (element) {
        self.editedTaskItem.counter_parameters.push(element.model_parameter_id);
      });
      this.editedTaskItem.value = this.cronVal;
      this.editedTaskItem.counter_id = this.point.counter_id;
      this.editedTaskItem.point_id = this.pointId;
      var taskGroup = [];
      this.tmpTaskGroups.forEach(function (element) {
        taskGroup.push(element.group_id);
      });
      this.editedTaskItem.task_group = taskGroup.join(',');
      _axios2.default.post('/api/counters_tasks/', this.editedTaskItem).then(function (response) {
        _this3.tasksLoading = false;
        _this3.counterTasks.push(response.data);
        _this3.closeTasksDialog();
      }).catch(function (err) {
        _this3.tasksLoading = false;
        console.log(err);
      });
    },
    updateTaskApi: function updateTaskApi() {
      var _this4 = this;

      this.sendUpdate = true;
      this.editedTaskItem.counter_parameters = [];
      this.tmpParameters.forEach(function (element) {
        _this4.editedTaskItem.counter_parameters.push(element.model_parameter_id);
      });
      var id = this.editedTaskItem.counter_task_id;
      var taskGroup = [];
      this.tmpTaskGroups.forEach(function (element) {
        taskGroup.push(element.group_id);
      });
      this.editedTaskItem.task_group = taskGroup.join(',');

      this.editedTaskItem.value = this.cronVal;
      this.tasksLoading = true;
      _axios2.default.put('/api/counters_tasks/' + id + '/', this.editedTaskItem).then(function (response) {
        _this4.sendUpdate = false;
        _this4.tasksLoading = false;
        Object.assign(_this4.counterTasks[_this4.editedCounterTaskIndex], response.data);
        _this4.closeTasksDialog();
      }).catch(function (err) {
        _this4.sendUpdate = false;
        _this4.tasksLoading = false;
        console.log(err);
      });
    },
    deleteCounterTask: function deleteCounterTask(item) {
      var _this5 = this;

      var id = item.counter_task_id;
      this.tasksLoading = true;
      _axios2.default.delete('/api/counters_tasks/' + id + '/').then(function (response) {
        _this5.tasksLoading = false;
        var index = _this5.counterTasks.indexOf(item);
        _this5.counterTasks.splice(index, 1);
      }).catch(function (err) {
        _this5.tasksLoading = false;
        console.log(err);
      });
    },
    startCounterTaskApi: function startCounterTaskApi(item) {
      var _this6 = this;

      var id = item.counter_task_id;
      _axios2.default.post('/api/counters_tasks/' + id + '/start_scheduler/').then(function (response) {
        var index = _this6.counterTasks.indexOf(item);
        Object.assign(_this6.counterTasks[index], response.data);
        _this6.editedTaskItem = Object.assign({}, response.data);
      }).catch(function (err) {
        console.log(err);
      });
    },
    stopCounterTaskApi: function stopCounterTaskApi(item) {
      var _this7 = this;

      var id = item.counter_task_id;
      _axios2.default.post('/api/counters_tasks/' + id + '/stop_scheduler/').then(function (response) {
        var index = _this7.counterTasks.indexOf(item);
        Object.assign(_this7.counterTasks[index], response.data);
        _this7.editedTaskItem = Object.assign({}, response.data);
      }).catch(function (err) {
        console.log(err);
      });
    },
    editCounterTask: function editCounterTask(item) {
      var _this8 = this;

      this.sendUpdate = false;
      this.editedCounterTaskIndex = this.counterTasks.indexOf(item);
      this.editedTaskItem = Object.assign({}, item);
      this.cronVal = this.editedTaskItem.value;
      if (this.cronVal.includes('30')) {
        // solution for old values
        this.cronVal = '*/30 * * * *';
      }
      this.editing = true;
      this.addTask = true;
      this.tmpTaskGroups = [];
      if (this.editedTaskItem.task_group != null) {
        var taskGroups = this.editedTaskItem.task_group.split(',');
        this.taskGroups.forEach(function (element) {
          if (taskGroups.includes(element.group_id)) {
            _this8.tmpTaskGroups.push(element);
          }
        });
      }
    },
    addCounterTask: function addCounterTask() {
      this.editing = false;
      this.taskDialog = true;
      this.addTask = true;
    },
    saveCounterTask: function saveCounterTask() {
      if (this.validate()) {
        if (this.editing === true) {
          this.updateTaskApi();
        } else {
          this.addTaskApi();
        }
        this.addTask = false;
      }
    },
    closeTasksDialog: function closeTasksDialog() {
      this.taskDialog = false;
      this.editing = false;
      this.addTask = false;
    },
    stopTasks: function stopTasks(item) {
      this.stopCounterTaskApi(item);
    },
    startTasks: function startTasks(item) {
      this.startCounterTaskApi(item);
    },
    viewCounterTaskLog: function viewCounterTaskLog(item) {
      this.selectedTask = item;
      this.showLog = true;
      this.editedCounterTaskIndex = this.counterTasks.indexOf(item);
    },
    validate: function validate() {
      if (this.$refs.scheduleForm.validate()) {
        return true;
      }
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "0xY2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.counter_model)?_c('v-breadcrumbs',{attrs:{"items":_vm.breadcrumbsItems},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
return [_c('v-breadcrumbs-item',{attrs:{"href":"#","disabled":item.disabled},on:{"click":function($event){return _vm.openBreadcrumbsUrl(item)}}},[_vm._v("\n        "+_vm._s(item.text)+"\n      ")])]}}],null,false,3791575482)}):_vm._e(),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"loading":_vm.loading,"fixed-header":"","group-by":"parameter_group","no-data-text":"Нет параметров для отображения","hide-default-footer":"","disable-pagination":"","dense":""},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
return [_c('tr',[_c('td',[_vm._v(_vm._s(item.parameter_name))])])]}},{key:"group.header",fn:function(ref){
var group = ref.group;
return [_c('tr',[_c('td',[_c('h2',[(group)?_c('h3',[_vm._v(_vm._s(group))]):_c('h3',[_vm._v("Параметры без группы")])])])])]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1/7J":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _UserNew = __webpack_require__("dzHQ");

var _UserNew2 = _interopRequireDefault(_UserNew);

var _UserEdit = __webpack_require__("me0x");

var _UserEdit2 = _interopRequireDefault(_UserEdit);

var _ChangePassword = __webpack_require__("lhx7");

var _ChangePassword2 = _interopRequireDefault(_ChangePassword);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var API_URL = 'users';
exports.default = {
  name: 'Users',
  components: {
    UserNew: _UserNew2.default,
    UserEdit: _UserEdit2.default,
    ChangePassword: _ChangePassword2.default
  },
  data: function data() {
    return {
      search: '',
      items: [],
      loading: true,
      firstLoading: true,
      options: { page: 1, itemsPerPage: 25 },
      serverItemsLength: 0,
      headers: [{
        text: 'Логин',
        align: 'left',
        sortable: false,
        value: 'username'
      }, {
        text: 'Имя',
        align: 'left',
        sortable: false,
        value: 'first_name'
      }, {
        text: 'Фамилия',
        align: 'left',
        sortable: false,
        value: 'last_name'
      }, {
        text: '',
        align: 'right',
        sortable: false,
        value: 'actions'
      }],
      adding: false,
      showSuccess: false,
      showSuccessMsg: false,
      editing: false,
      selectedUserData: {},
      showErrorMsg: false,
      showError: false,
      errorMsg: null,
      passwordChanging: false,
      getTimer: '',
      searchTimer: '',
      deleteTimer: ''
    };
  },

  watch: {
    options: {
      handler: function handler() {
        this.getUsersApiTimer();
      },

      deep: true
    },
    search: function search() {
      var _this = this;

      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(function () {
        _this.options.page = 1;
        _this.getUsersApiTimer();
      }, 500);
    }
  },
  mounted: function mounted() {
    if (this.$route.query.search) {
      this.search = this.$route.query.search;
    }
  },

  methods: {
    getUsersApi: function getUsersApi() {
      var _this2 = this;

      this.loading = true;
      this.axios.get('/api/' + API_URL + '/?per_page=' + this.options.itemsPerPage + '&page=' + this.options.page + '&search=' + this.search).then(function (response) {
        _this2.items = response.data.results;
        _this2.serverItemsLength = response.data.count;
      }).catch(function (err) {
        console.log(err);
      }).finally(function () {
        _this2.firstLoading = false;
        _this2.loading = false;
      });
    },
    getUsersApiTimer: function getUsersApiTimer() {
      var _this3 = this;

      clearTimeout(this.getTimer);
      this.getTimer = setTimeout(function () {
        _this3.getUsersApi();
      }, 100);
    },
    showErrorMessage: function showErrorMessage(msg) {
      var _this4 = this;

      this.errorMsg = msg;
      this.showError = true;
      this.showErrorMsg = true;
      setTimeout(function () {
        _this4.showError = false;
      }, 4000);
      setTimeout(function () {
        _this4.showErrorMsg = false;
      }, 4350);
    },
    deleteUserApi: function deleteUserApi(item) {
      var _this5 = this;

      this.axios.delete('/api/' + API_URL + '/' + item.user_id + '/').then(function (response) {
        _this5.items.splice(_this5.items.indexOf(item), 1);
        clearTimeout(_this5.deleteTimer);
        _this5.deleteTimer = setTimeout(function () {
          _this5.items.length || _this5.options.page === 1 || _this5.options.page--;
          _this5.getUsersApiTimer();
        }, 1000);
      }).catch(function (err) {
        _this5.showErrorMessage(err.response.data);
        console.log(err);
      });
    },
    addUser: function addUser() {
      this.adding = true;
    },
    cancelAdding: function cancelAdding() {
      this.adding = false;
    },
    userAdded: function userAdded() {
      var _this6 = this;

      this.getUsersApiTimer();
      this.adding = false;
      this.showSuccess = true;
      this.showSuccessMsg = true;
      setTimeout(function () {
        _this6.showSuccess = false;
      }, 3000);
      setTimeout(function () {
        _this6.showSuccessMsg = false;
      }, 3350);
    },
    editUser: function editUser(item) {
      this.selectedUserData = item;
      this.editing = true;
    },
    userEdited: function userEdited() {
      this.editing = false;
    },
    cancelEditing: function cancelEditing() {
      this.editing = false;
    },
    editUserError: function editUserError(msg) {
      this.editing = false;
      this.showErrorMessage(msg);
    },
    changePassword: function changePassword(item) {
      this.selectedUserData = item;
      this.passwordChanging = true;
    },
    passwordChanged: function passwordChanged() {
      this.passwordChanging = false;
    },
    cancelPasswordChanging: function cancelPasswordChanging() {
      this.passwordChanging = false;
    },
    changePasswordError: function changePasswordError(msg) {
      this.passwordChanging = false;
      this.showErrorMessage(msg);
    },
    deleteUser: function deleteUser(item) {
      if (confirm('Вы действительно хотите удалить данного пользователя?')) {
        this.deleteUserApi(item);
      }
    }
  }
};

/***/ }),

/***/ "14/s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__ = __webpack_require__("+Zml");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79ab01fa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__ = __webpack_require__("6+jA");
function injectStyle (ssrContext) {
  __webpack_require__("+YuL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79ab01fa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "17SK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CountersModels_vue__ = __webpack_require__("Zoqn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CountersModels_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CountersModels_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CountersModels_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CountersModels_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60be54e8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CountersModels_vue__ = __webpack_require__("ejtE");
function injectStyle (ssrContext) {
  __webpack_require__("qGW+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-60be54e8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CountersModels_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60be54e8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CountersModels_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "1EuA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1Tf8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1UkD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1efz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'CounterHistory',
  props: {
    counterData: {}
  },
  data: function data() {
    return {
      loading: true,
      options: {},
      items: [],
      serverItemsLength: 0,
      headers: [{
        text: 'Номер счётчика',
        align: 'right',
        sortable: false,
        value: 'counter_serial_num'
      }, {
        text: 'Дата операции',
        align: 'right',
        sortable: false,
        value: 'operation_date'
      }, {
        text: 'Тип операции',
        align: 'right',
        sortable: false,
        value: 'coper_type_name'
      }, {
        text: 'Комментарий',
        align: 'right',
        sortable: false,
        value: 'comment'
      }, {
        text: 'Имя Точки учёта',
        align: 'right',
        sortable: false,
        value: 'point_name'
      }, {
        text: 'Логин пользователя',
        align: 'right',
        sortable: false,
        value: 'user_name'
      }]
    };
  },

  watch: {
    options: {
      handler: function handler() {
        this.getCounterHistoryApi();
      },

      deep: true
    }
  },
  methods: {
    getCounterHistoryApi: function getCounterHistoryApi() {
      var _this = this;

      this.loading = true;
      _axios2.default.get('/api/counteropers/?counter_id=' + this.counterData.counter_id + '&per_page=' + this.options.itemsPerPage + '&page=' + this.options.page).then(function (response) {
        _this.items = response.data.results;
        _this.serverItemsLength = response.data.count;
        _this.loading = false;
      }).catch(function (err) {
        _this.loading = false;
        console.log(err);
      });
    },
    close: function close() {
      this.$emit('close');
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "1xgP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('v-layout',{staticClass:"loading-indicator",attrs:{"justify-center":"","align-center":""}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":70,"width":7}})],1):(_vm.editingCustomer)?_c('customer-edit',{attrs:{"customer-data":_vm.customerData},on:{"close":function($event){_vm.editingCustomer=false},"edited":_vm.edited,"error":function($event){_vm.editingCustomer=false}}}):_vm._e(),_vm._v(" "),_c('v-card',{directives:[{name:"show",rawName:"v-show",value:(!_vm.editingCustomer && !_vm.firstLoading),expression:"!editingCustomer && !firstLoading"}],staticClass:"customers-card"},[_c('v-btn',{attrs:{"fab":"","color":"primary"},on:{"click":_vm.add}},[_c('v-icon',[_vm._v("add")])],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"options":_vm.options,"search":_vm.search,"server-items-length":_vm.serverItemsLength,"fixed-header":"","dense":"","no-data-text":"Нет данных для отображения","footer-props":{
        itemsPerPageText: 'Число заданий на странице',
        itemsPerPageOptions: [25, 50]
      }},on:{"update:options":function($event){_vm.options=$event}},scopedSlots:_vm._u([{key:"item",fn:function(props){return _c('tr',{},[_c('td',[_vm._v(_vm._s(props.item.customer_number))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.customerTypes[props.item.customer_type]))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.company_full_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.last_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.first_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.middle_name))]),_vm._v(" "),_c('td',{staticClass:"justify-center px-0"},[_c('span',{staticClass:"action-btns"},[_c('v-btn',{staticClass:"mt-1",attrs:{"icon":"","title":"Редактировать"},on:{"click":function($event){return _vm.edit(props.item)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("\n                edit\n              ")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mt-1",attrs:{"icon":"","title":"Удалить"},on:{"click":function($event){return _vm.deleteItem(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("\n                delete\n              ")])],1)],1)])])}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2MXY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Report00102_vue__ = __webpack_require__("7HDv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Report00102_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Report00102_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Report00102_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Report00102_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ecac556_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Report00102_vue__ = __webpack_require__("hE3U");
function injectStyle (ssrContext) {
  __webpack_require__("2jED")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1ecac556"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Report00102_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ecac556_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Report00102_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "2jED":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3RXz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DocumentRequestDetails = __webpack_require__("x4kD");

var _DocumentRequestDetails2 = _interopRequireDefault(_DocumentRequestDetails);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HEADERS_VERSION = '1'; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'DocumentsRequests',
  components: {
    DocumentRequestDetails: _DocumentRequestDetails2.default
  },
  data: function data() {
    return {
      search: '',
      documents: [],
      loading: true,
      firstLoading: true,
      options: { page: 1, itemsPerPage: 25 },
      serverItemsLength: 0,
      selectedItem: {},
      headers: [{
        text: 'Номер заявления',
        align: 'left',
        sortable: false,
        value: 'request_number',
        visible: true
      }, {
        text: 'Дата подачи',
        align: 'left',
        sortable: false,
        value: 'request_date',
        visible: true
      }, {
        text: 'Обработать до',
        align: 'left',
        sortable: false,
        value: 'expired_date',
        visible: true
      }, {
        text: 'ФИО',
        align: 'right',
        sortable: false,
        value: 'user_name',
        visible: true
      }, {
        text: 'Лицевой счёт',
        align: 'right',
        sortable: false,
        value: 'customer_number',
        visible: true
      }, {
        text: 'Тип документа',
        align: 'left',
        sortable: false,
        value: 'type',
        visible: true
      }, {
        text: 'Статус',
        align: 'left',
        sortable: false,
        value: 'status',
        visible: true
      }, {
        text: 'Назначен на',
        align: 'right',
        sortable: false,
        value: 'assigned_user',
        visible: true
      }, {
        text: 'Уведомления',
        align: 'right',
        sortable: false,
        value: 'notifications',
        visible: true
      }, {
        text: 'Действия',
        align: 'right',
        sortable: false,
        value: 'actions',
        visible: true
      }],
      statuses: [],
      filteredStatuses: [],
      adding: false,
      editing: false,
      selectedUserData: {},
      isArchived: false,
      tableColumnsDialog: false,
      headersVersionChanged: false,
      getTimer: ''
    };
  },

  watch: {
    options: {
      handler: function handler() {
        this.getDocumentsApiTimer();
      },

      deep: true
    },
    isArchived: {
      handler: function handler() {
        this.getDocumentsApiTimer();
      },

      deep: true
    },
    headers: {
      handler: function handler(newVal) {
        var parsed = JSON.stringify(Object(newVal));
        localStorage.setItem('documentsHeaders', parsed);
        localStorage.setItem('documentsHeadersVersion', HEADERS_VERSION);
      },

      deep: true
    }
  },
  computed: {
    slctHeaders: function slctHeaders() {
      return this.headers.filter(function (header) {
        return header.visible;
      });
    }
  },
  mounted: function mounted() {
    this.getDocumentsStatusApi();
    if (localStorage.getItem('documentsHeaders')) {
      if (localStorage.getItem('documentsHeadersVersion') === HEADERS_VERSION) {
        this.headers = JSON.parse(localStorage.getItem('documentsHeaders'));
      } else {
        this.headersVersionChanged = true;
        localStorage.setItem('documentsHeadersVersion', HEADERS_VERSION);
        var parsed = JSON.stringify(Object(this.headers));
        localStorage.setItem('documentsHeaders', parsed);
      }
    }
  },

  methods: {
    getDocumentsApi: function getDocumentsApi() {
      var _this = this;

      this.loading = true;
      var archived = this.isArchived ? 1 : 0;
      this.axios.get('/api/document_request/?status=' + this.filteredStatuses + '&archived=' + archived + '&per_page=' + this.options.itemsPerPage + '&page=' + this.options.page).then(function (response) {
        _this.documents = response.data.results;
        _this.serverItemsLength = response.data.count;
      }).catch(function (err) {
        console.log(err);
      }).finally(function () {
        _this.firstLoading = false;
        _this.loading = false;
      });
    },
    getDocumentsApiTimer: function getDocumentsApiTimer() {
      var _this2 = this;

      clearTimeout(this.getTimer);
      this.getTimer = setTimeout(function () {
        _this2.getDocumentsApi();
      }, 100);
    },
    getDocumentsStatusApi: function getDocumentsStatusApi() {
      var _this3 = this;

      this.axios.get('/api/document_status/').then(function (response) {
        _this3.statuses = response.data.results;
      }).catch(function (err) {
        console.log(err);
      });
    },
    addToStatusFilter: function addToStatusFilter(status, toggle) {
      var index = this.filteredStatuses.indexOf(status.doc_status_id);
      if (index !== -1) {
        this.filteredStatuses.splice(index, 1);
      } else {
        this.filteredStatuses.push(status.doc_status_id);
      }
      this.getDocumentsApiTimer();
      toggle();
    },
    getDetails: function getDetails(item) {
      this.selectedItem = item;
      this.editing = true;
    },
    close: function close() {
      this.editing = false;
      this.getDocumentsApiTimer();
    },
    getStatusColor: function getStatusColor(statusId) {
      if (statusId === 2) {
        return 'orange';
      } else if (statusId === 3) {
        return 'green';
      } else if (statusId === 4) {
        return 'red';
      }
    },
    isShowHeaderData: function isShowHeaderData(headerName) {
      return this.slctHeaders.findIndex(function (el) {
        return el.value === headerName;
      }) > -1;
    },
    sendToArchive: function sendToArchive(item) {
      var _this4 = this;

      if (confirm('Вы действительно хотите отправить документ в архив?')) {
        this.axios.post('/api/document_request/' + item.doc_request_id + '/archive/').then(function () {
          _this4.getDocumentsApiTimer();
        }).catch(function (err) {
          console.log(err);
        });
      }
    },
    removeFromArchive: function removeFromArchive(item) {
      var _this5 = this;

      this.axios.post('/api/document_request/' + item.doc_request_id + '/unarchive/').then(function () {
        _this5.getDocumentsApiTimer();
      }).catch(function (err) {
        console.log(err);
      });
    }
  }
};

/***/ }),

/***/ "3W9t":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

var _ReportTreeNode = __webpack_require__("DUuK");

var _ReportTreeNode2 = _interopRequireDefault(_ReportTreeNode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: { ReportTreeNode: _ReportTreeNode2.default },
  data: function data() {
    return {
      begDate: null,
      endDate: null,
      representsSelectType: 'none',
      pointsSelectType: 'single',
      point: null,
      menuPoint: false,
      menuBegDate: false,
      menuEndDate: false,
      loading: false
    };
  },

  computed: {
    canGetReport: function canGetReport() {
      return this.begDate && this.endDate && this.point;
    },
    begDateComputed: function begDateComputed() {
      return this.formatDate(this.begDate);
    },
    endDateComputed: function endDateComputed() {
      return this.formatDate(this.endDate);
    }
  },
  methods: {
    pointSelect: function pointSelect(point) {
      this.point = point;
      this.menuPoint = false;
    },
    formatDate: function formatDate(date) {
      if (!date) return null;

      var _date$split = date.split('-'),
          _date$split2 = _slicedToArray(_date$split, 3),
          year = _date$split2[0],
          month = _date$split2[1],
          day = _date$split2[2];

      return day + '-' + month + '-' + year;
    },
    getReport: function getReport() {
      var _this = this;

      this.loading = true;
      (0, _axios2.default)({
        url: '/api/get_report/',
        method: 'POST',
        responseType: 'blob',
        params: {
          'point_id': this.point.id,
          'beg_date': this.begDate,
          'end_date': this.endDate,
          'report': 'Form80020Report' }
      }).then(function (response) {
        var blob = new Blob([response.data], { type: 'application/pdf' });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'report_80020.xlsx';
        link.click();
      }).finally(function () {
        _this.loading = false;
      });
    }
  }
};

/***/ }),

/***/ "3c05":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "47G0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4sjB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"NotFound__Wrapper"},[_c('span',{staticClass:"md-display-2"},[_vm._v("\n    Ops... 404.\n  ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4uV1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4ycq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('v-dialog',{attrs:{"max-width":"350"},model:{value:(_vm.headersVersionChanged),callback:function ($$v) {_vm.headersVersionChanged=$$v},expression:"headersVersionChanged"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Уведомление")]),_vm._v(" "),_c('v-card-text',[_c('v-container',[_c('p',[_vm._v("Настройки таблицы были сброшены в связи с обновлением системы.")])])],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","text":""},on:{"click":function($event){_vm.headersVersionChanged = false}}},[_vm._v("Ok")])],1)],1)],1),_vm._v(" "),(_vm.loading)?_c('v-layout',{staticClass:"loading-indicator",attrs:{"justify-center":"","align-center":""}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":70,"width":7}})],1):_vm._e(),_vm._v(" "),(_vm.editing)?_c('document-request-details',{attrs:{"data":_vm.selectedItem},on:{"close":_vm.close}}):_vm._e(),_vm._v(" "),_c('v-card',{directives:[{name:"show",rawName:"v-show",value:(!_vm.firstLoading && !_vm.editing),expression:"!firstLoading && !editing"}],staticClass:"main-card"},[_c('v-card-title',{staticClass:"action-head"},[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"5"}},[_c('v-row',{staticClass:"mb-3"},[_c('v-col',{attrs:{"cols":"2"}},[_c('h6',[_vm._v("Статус:")])]),_vm._v(" "),_c('v-col',{attrs:{"cols":"10"}},[_c('v-item-group',{attrs:{"multiple":""}},_vm._l((_vm.statuses),function(status,index){return _c('v-item',{key:index,scopedSlots:_vm._u([{key:"default",fn:function(ref){
var active = ref.active;
var toggle = ref.toggle;
return [_c('v-chip',{attrs:{"active-class":"blue--text","input-value":active},on:{"click":function($event){return _vm.addToStatusFilter(status, toggle)}}},[_vm._v("\n                    "+_vm._s(status.doc_status_name)+"\n                  ")])]}}],null,true)})}),1)],1)],1)],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"2"}},[_c('v-switch',{attrs:{"label":"Архивные"},model:{value:(_vm.isArchived),callback:function ($$v) {_vm.isArchived=$$v},expression:"isArchived"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"5"}},[_c('v-dialog',{attrs:{"max-width":"600"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({staticClass:"mt-3",attrs:{"text":""}},'v-btn',attrs,false),on),[_vm._v("\n                Выбрать колонки таблицы\n              ")])]}}]),model:{value:(_vm.tableColumnsDialog),callback:function ($$v) {_vm.tableColumnsDialog=$$v},expression:"tableColumnsDialog"}},[_vm._v(" "),_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Выбор колонок для отображения в таблице")]),_vm._v(" "),_c('v-card-text',[_c('v-container',[_c('v-row',_vm._l((_vm.headers),function(header){return _c('v-col',{key:header.value,attrs:{"cols":"6","sm":"4"}},[_c('v-checkbox',{staticClass:"pt-0 mt-0 pl-2",attrs:{"hide-details":"","label":header.text},model:{value:(header.visible),callback:function ($$v) {_vm.$set(header, "visible", $$v)},expression:"header.visible"}})],1)}),1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","text":""},on:{"click":function($event){_vm.tableColumnsDialog = false}}},[_vm._v("Ok")])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.slctHeaders,"items":_vm.documents,"options":_vm.options,"server-items-length":_vm.serverItemsLength,"fixed-header":"","no-data-text":"Нет данных для отображения","footer-props":{
        itemsPerPageText: 'Число документов на странице',
        itemsPerPageOptions: [25, 50]
      },"dense":""},on:{"update:options":function($event){_vm.options=$event}},scopedSlots:_vm._u([{key:"item",fn:function(ref){
      var item = ref.item;
return [_c('tr',{staticClass:"link-row"},[(_vm.isShowHeaderData('request_number'))?_c('td',{on:{"click":function($event){return _vm.getDetails(item)}}},[_vm._v("\n            "+_vm._s(item.request_number)+"\n          ")]):_vm._e(),_vm._v(" "),(_vm.isShowHeaderData('request_date'))?_c('td',{on:{"click":function($event){return _vm.getDetails(item)}}},[_vm._v(_vm._s(_vm._f("moment")(item.created_at,"DD/MM/YYYY")))]):_vm._e(),_vm._v(" "),(_vm.isShowHeaderData('expired_date'))?_c('td',{on:{"click":function($event){return _vm.getDetails(item)}}},[_vm._v(_vm._s(_vm._f("moment")(item.expired_date,"DD/MM/YYYY")))]):_vm._e(),_vm._v(" "),(_vm.isShowHeaderData('user_name'))?_c('td',{on:{"click":function($event){return _vm.getDetails(item)}}},[_vm._v(_vm._s(item.user.last_name)+" "+_vm._s(item.user.first_name)+" "+_vm._s(item.user.middle_name))]):_vm._e(),_vm._v(" "),(_vm.isShowHeaderData('customer_number'))?_c('td',{on:{"click":function($event){return _vm.getDetails(item)}}},[_vm._v(_vm._s(item.customer != null ? item.customer.customer_number : ''))]):_vm._e(),_vm._v(" "),(_vm.isShowHeaderData('type'))?_c('td',{on:{"click":function($event){return _vm.getDetails(item)}}},[_vm._v(_vm._s(item.type.name))]):_vm._e(),_vm._v(" "),(_vm.isShowHeaderData('status'))?_c('td',{on:{"click":function($event){return _vm.getDetails(item)}}},[_c('v-chip',{class:_vm.getStatusColor(item.status.id)},[_vm._v(_vm._s(item.status.name))])],1):_vm._e(),_vm._v(" "),(_vm.isShowHeaderData('assigned_user'))?_c('td',{on:{"click":function($event){return _vm.getDetails(item)}}},[(item.assigned_user )?[_vm._v("\n              "+_vm._s(item.assigned_user.last_name)+" "+_vm._s(item.assigned_user.first_name)+" "+_vm._s(item.assigned_user.middle_name)+"("+_vm._s(item.assigned_user.username)+")\n            ")]:_vm._e()],2):_vm._e(),_vm._v(" "),(_vm.isShowHeaderData('notifications'))?_c('td',{on:{"click":function($event){return _vm.getDetails(item)}}},[(item.unread_comments > 0)?_c('v-btn',{staticClass:"v-size--small red white--text",attrs:{"title":"Не прочитано сообщений","rounded":"","icon":"","small":""}},[_vm._v("\n              "+_vm._s(item.unread_comments)+"\n            ")]):_vm._e(),_vm._v(" "),(item.new_files > 0)?_c('v-btn',{staticClass:"v-size--small orange white--text",attrs:{"title":"Новых файлов","rounded":"","icon":"","small":""}},[_vm._v("\n              "+_vm._s(item.new_files)+"\n            ")]):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.isShowHeaderData('actions'))?_c('td',[(_vm.isArchived)?_c('v-btn',{staticClass:"v-size--small",attrs:{"title":"Убрать из архива","icon":"","small":""},on:{"click":function($event){return _vm.removeFromArchive(item)}}},[_c('v-icon',[_vm._v("mdi-package-up")])],1):_c('v-btn',{staticClass:"v-size--small",attrs:{"title":"Отправить в архив","icon":"","small":""},on:{"click":function($event){return _vm.sendToArchive(item)}}},[_c('v-icon',[_vm._v("mdi-package-down")])],1)],1):_vm._e()])]}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "565o":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

var _VChipsCombobox = __webpack_require__("XMIC");

var _VChipsCombobox2 = _interopRequireDefault(_VChipsCombobox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'PermissionsGroupNew',
  components: {
    VChipsCombobox: _VChipsCombobox2.default
  },
  props: {
    permissionsGroupData: {}
  },
  data: function data() {
    return {
      valid: true,
      tmpParameters: [],
      permissionsGroup: { name: '', permissions: [] },
      permissions: []
    };
  },
  mounted: function mounted() {
    this.getPermissions();
  },

  methods: {
    cancelEditing: function cancelEditing() {
      this.$emit('cancel');
    },
    getPermissions: function getPermissions() {
      var _this = this;

      _axios2.default.get('/api/permissions/').then(function (response) {
        _this.permissions = response.data.results;
      }).catch(function (err) {
        console.log(err);
      });
    },
    saveChanges: function saveChanges() {
      var _this2 = this;

      this.$validator.validate().then(function (valid) {
        if (valid) {
          _this2.axios.post('/api/permissions_groups/', _this2.permissionsGroup).then(function () {
            _this2.$emit('added');
          }).catch(function (err) {
            console.log(err);
          });
        }
      });
    }
  }
};

/***/ }),

/***/ "5JLS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'DocumentsRequestsTypeDetails',
  props: {
    data: {}
  },
  data: function data() {
    return {
      rules: {
        reguired: function reguired(v) {
          return !!v || 'Заполните это поле!';
        },
        typeReguired: function typeReguired(v) {
          return !!v || 'Необходимо выбрать тип абонента';
        }
      },
      requiredFilesList: [],
      requiredFiles: [],
      customerType: {},
      customerTypes: [{ customer_type_id: 1, customer_type_name: 'Физическое лицо' }, { customer_type_id: 2, customer_type_name: 'Индивидуальный предприниматель' }, { customer_type_id: 3, customer_type_name: 'Юридическое лицо' }]
    };
  },
  mounted: function mounted() {
    this.getRequiredFiles();
    this.getDocumentRequiredFiles();
  },

  methods: {
    getRequiredFiles: function getRequiredFiles() {
      var _this = this;

      this.axios.get('/api/document_required_file/').then(function (response) {
        _this.requiredFilesList = response.data.results;
      }).catch(function (err) {
        console.log(err);
      });
    },
    getDocumentRequiredFiles: function getDocumentRequiredFiles() {
      var _this2 = this;

      if (this.data.doc_type_id != null) {
        this.axios.get('/api/document_required_file/?document_type=' + this.data.doc_type_id).then(function (response) {
          _this2.requiredFiles = response.data.results;
        }).catch(function (err) {
          console.log(err);
        });
      }
    },
    save: function save() {
      var _this3 = this;

      if (this.$refs.detailsDocumentsTypeForm.validate()) {
        if (this.data.doc_type_id === null) {
          this.axios.post('/api/document_type/', this.data).then(function (response) {
            var reqFiles = { doc_type_id: response.data.doc_type_id, required_files: _this3.requiredFiles };
            _this3.axios.post('/api/document_required_file_link/', reqFiles).then(function () {
              _this3.$emit('close');
            }).catch(function (err) {
              console.log(err);
              _this3.loading = false;
            });
          }).catch(function (err) {
            console.log(err);
            _this3.loading = false;
          });
        } else {
          this.axios.patch('/api/document_type/' + this.data.doc_type_id + '/', this.data).then(function (response) {
            var reqFiles = { doc_type_id: response.data.doc_type_id, required_files: _this3.requiredFiles };
            _this3.axios.post('/api/document_required_file_link/', reqFiles).then(function () {
              _this3.$emit('close');
            }).catch(function (err) {
              console.log(err);
              _this3.loading = false;
            });
          }).catch(function (err) {
            console.log(err);
            _this3.loading = false;
          });
        }
      }
    },
    customerTypeChanged: function customerTypeChanged() {
      console.log('');
    },
    addRequired: function addRequired() {
      this.requiredFiles.push({ doc_required_file_id: null });
    },
    removeRequiredFile: function removeRequiredFile(index) {
      this.requiredFiles.splice(index, 1);
    }
  }
};

/***/ }),

/***/ "5Pl6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'PointCounterEditConnectParameters',
  props: {
    counterData: {}
  },
  data: function data() {
    return {
      inputRules: [function (v) {
        return !!v || 'Заполните это поле!';
      }],
      sourceParams: ['TCP', 'lorawandb'],
      sourceParam: {},
      dataParams: [],
      connectStatus: null
    };
  },

  computed: {
    visibleParams: function visibleParams() {
      var _this = this;

      return this.dataParams.filter(function (item) {
        return _this.sourceParam.value === 'TCP' ? item.param !== 'source' : item.param === 'net_address';
      });
    }
  },
  mounted: function mounted() {
    this.getConnectParameters();
  },

  methods: {
    getConnectParameters: function getConnectParameters() {
      var _this2 = this;

      this.axios.get('/api/counters/' + this.counterData.counter_id + '/conn_params/').then(function (response) {
        _this2.dataParams = response.data.map(function (param) {
          return {
            param: param.par_name,
            name: param.description,
            value: param.par_value,
            old_value: param.par_value
          };
        });
        console.log(response.data);
        _this2.sourceParam = _this2.dataParams.find(function (param) {
          return param.param === 'source';
        });
        if (!_this2.sourceParam.value) {
          _this2.sourceParam.value = 'TCP';
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    setConnectParameters: function setConnectParameters() {
      var _this3 = this;

      var connectParameters = { conn_params: this.visibleParams.filter(function (param) {
          return param.value !== param.old_value;
        }) };
      if (this.sourceParam.value !== this.sourceParam.old_value) {
        connectParameters.conn_params.push(this.sourceParam);
      }
      this.axios.put('/api/point_counter/' + this.counterData.counter_id + '/update_conn_params/', connectParameters).then(function (response) {
        _this3.$emit('edited');
      }).catch(function (err) {
        _this3.$emit('editError', err.response.data);
      });
    },
    checkConnectParameters: function checkConnectParameters() {
      this.connectStatus = this.connectStatus === 'Удачно' ? 'Ошибка' : 'Удачно';
    }
  }
};

/***/ }),

/***/ "5rGw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'PointCounterInstallExisted',
  props: ['modelId'],
  data: function data() {
    return {
      firstLoading: true,
      loading: false,
      serialNumSearch: '',
      counter: {},
      items: [],
      serverItemsLength: 0,
      options: {},
      availableCountersHeaders: [{
        text: 'Серийный номер',
        align: 'left',
        sortable: false,
        value: 'serial_num'
      }, {
        text: 'Модель',
        align: 'left',
        sortable: false,
        value: 'model.name'
      }, {
        text: 'Коэф.трансформации тока',
        align: 'left',
        sortable: false,
        value: 'coeff'
      }, {
        text: 'Коэф.трансформации напряжения',
        align: 'left',
        sortable: false,
        value: 'coeff_voltage'
      }],
      getTimer: '',
      searchTimer: ''
    };
  },

  watch: {
    modelId: function modelId(val) {
      if (val) {
        this.getCountersApiTimer();
      }
    },

    options: {
      handler: function handler() {
        this.getCountersApiTimer();
      },

      deep: true
    },
    serialNumSearch: function serialNumSearch() {
      var _this = this;

      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(function () {
        _this.options.page = 1;
        _this.getCountersApiTimer();
      }, 500);
    }
  },
  methods: {
    selected: function selected(item) {
      this.$emit('selected', item);
    },
    getCountersApi: function getCountersApi() {
      var _this2 = this;

      this.loading = true;
      this.axios.get('/api/counters/available_for_install/' + ('?per_page=' + this.options.itemsPerPage) + ('&page=' + this.options.page) + ('&search=' + this.serialNumSearch) + ('&model_id=' + this.modelId)).then(function (response) {
        _this2.items = response.data.results;
        _this2.serverItemsLength = response.data.count;
      }).catch(function (err) {
        console.log(err);
      }).finally(function () {
        _this2.firstLoading = false;
        _this2.loading = false;
      });
    },
    getCountersApiTimer: function getCountersApiTimer() {
      var _this3 = this;

      clearTimeout(this.getTimer);
      this.getTimer = setTimeout(function () {
        _this3.getCountersApi();
      }, 100);
    }
  }
};

/***/ }),

/***/ "5tHt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.loading)?_c('v-layout',{staticClass:"loading-indicator",attrs:{"justify-center":"","align-center":""}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":70,"width":7}})],1):_vm._e(),_vm._v(" "),(_vm.editing)?_c('account-emails-details',{attrs:{"data":_vm.selectedItem},on:{"close":_vm.close}}):_vm._e(),_vm._v(" "),_c('v-card',{directives:[{name:"show",rawName:"v-show",value:(!_vm.firstLoading && !_vm.editing),expression:"!firstLoading && !editing"}],staticClass:"main-card"},[_c('v-card-title',[_c('p',{staticClass:"text-h5"},[_vm._v("Email адреса аккаунта")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"fab":"","color":"primary","title":"Добавить"},on:{"click":_vm.addEmail}},[_c('v-icon',[_vm._v("add")])],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.emails,"options":_vm.options,"server-items-length":_vm.serverItemsLength,"fixed-header":"","no-data-text":"Нет данных для отображения","footer-props":{
        itemsPerPageText: 'Число email на странице',
        itemsPerPageOptions: [25, 50]
      },"dense":""},on:{"update:options":function($event){_vm.options=$event}},scopedSlots:_vm._u([{key:"item",fn:function(ref){
      var item = ref.item;
return [_c('tr',{staticClass:"link-row",on:{"click":function($event){return _vm.getDetails(item)}}},[_c('td',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.smtp_user))])])]}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5yF3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6+jA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-navigation-drawer',{attrs:{"width":"300px","fixed":"","clipped":_vm.$vuetify.breakpoint.lgAndUp,"app":""},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},[_c('v-text-field',{staticClass:"hidden-sm-and-down filter-represent",attrs:{"solo-inverted":"","prepend-icon":"search","label":"Поиск","background-color":"#fff","color":"#8799b6","hide-details":""},on:{"input":_vm.filterRepresent}}),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},[_c('v-list-group',{key:"represents",staticClass:"rep-list-group",attrs:{"prepend-icon":"mdi mdi-file-tree","append-icon":""},model:{value:(_vm.show_presents),callback:function ($$v) {_vm.show_presents=$$v},expression:"show_presents"}},[_c('v-list-item',{attrs:{"slot":"activator"},slot:"activator"},[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v("\n            Объекты\n            "),_c('span',[_c('v-btn',{staticClass:"add-new-represent",attrs:{"icon":"","to":_vm.newRepresentUrl}},[_c('v-icon',[_vm._v("fas fa-plus")])],1)],1)])],1)],1),_vm._v(" "),_c('v-treeview',{staticClass:"rep-tree",attrs:{"selected-represent-name":_vm.selectedRepresentName,"open-all":_vm.openAll},on:{"selected":_vm.selected},model:{value:(_vm.treeData),callback:function ($$v) {_vm.treeData=$$v},expression:"treeData"}})],1),_vm._v(" "),_vm._l((_vm.items),function(item){return [(item.children)?_c('v-list-group',{key:item.text,attrs:{"prepend-icon":item.icon,"append-icon":"","title":item.title},model:{value:(item.model),callback:function ($$v) {_vm.$set(item, "model", $$v)},expression:"item.model"}},[_c('v-list-item',{attrs:{"slot":"activator"},slot:"activator"},[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v("\n              "+_vm._s(item.text)+"\n              "),_c('v-icon',[_vm._v(_vm._s(item.model ? 'keyboard_arrow_up' : 'keyboard_arrow_down'))])],1)],1)],1),_vm._v(" "),_vm._l((item.children),function(child,i){return _c('v-list-item',{key:i,staticClass:"child-list-item",attrs:{"to":child.path,"title":child.title},on:{"click":_vm.clearSelectedTreeNode}},[(child.icon)?_c('v-list-item-action',[_c('v-icon',[_vm._v(_vm._s(child.icon))])],1):_vm._e(),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v("\n              "+_vm._s(child.text)+"\n            ")])],1)],1)})],2):_c('v-list-item',{key:item.text,attrs:{"to":item.path,"title":item.title},on:{"click":_vm.clearSelectedTreeNode}},[_c('v-list-item-action',[_c('v-icon',[_vm._v(_vm._s(item.icon))])],1),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-title',[(item.badge)?[_c('v-badge',{attrs:{"id":item.badgeId,"color":"pink","overlap":"","content":"0"}},[_vm._v("\n                "+_vm._s(item.text)+"\n              ")])]:[_vm._v("\n              "+_vm._s(item.text)+"\n            ")]],2)],1)],1)]}),_vm._v(" "),_c('v-list-item',{attrs:{"to":"/documents-requests"},on:{"click":_vm.clearSelectedTreeNode}},[_c('v-list-item-action',[_c('v-icon',[_vm._v("inbox")])],1),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-title',{staticStyle:{"height":"22px"}},[_vm._v("\n            Поступившие заявки\n          "),(_vm.additionalData)?[(_vm.additionalData.unassigned)?[_c('v-badge',{staticStyle:{"top":"-8px"},attrs:{"color":"pink","overlap":"","label":"Не назначенных заявок","content":_vm.additionalData.unassigned}})]:_vm._e(),_vm._v(" "),(_vm.additionalData.new_comments)?[_c('v-badge',{staticStyle:{"top":"-8px","left":"25px"},attrs:{"color":"orange","overlap":"","label":"Новых сообщений","content":_vm.additionalData.new_comments}})]:_vm._e()]:_vm._e()],2)],1)],1)],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "68CT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PermissionsGroupEdit_vue__ = __webpack_require__("ZMON");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PermissionsGroupEdit_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PermissionsGroupEdit_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PermissionsGroupEdit_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PermissionsGroupEdit_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c28ff16c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PermissionsGroupEdit_vue__ = __webpack_require__("r706");
function injectStyle (ssrContext) {
  __webpack_require__("amS/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c28ff16c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PermissionsGroupEdit_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c28ff16c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PermissionsGroupEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "68EO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'CustomerEdit',
  directives: {
    snils: {
      bind: function bind(el) {
        el.oninput = function (e) {
          var input = el.querySelector('input[name="snils"]');
          if (!e.isTrusted || !input) {
            return;
          }

          var x = input.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,2})/);
          input.value = x[1] + (x[2] ? '-' + x[2] : '') + (x[3] ? '-' + x[3] : '') + (x[4] ? ' ' + x[4] : '');
          input.dispatchEvent(new Event('input'));
        };
      }
    }
  },
  props: {
    customerData: {}
  },
  data: function data() {
    return {
      rules: {
        reguired: function reguired(v) {
          return !!v || 'Заполните это поле!';
        },
        ogrn13: function ogrn13(v) {
          return v && v.match('^[0-9]{13}$') || 'ОГРН должен состоять из 13 цифр';
        },
        ogrn15: function ogrn15(v) {
          return v && v.match('^[0-9]{15}$') || 'ОГРН должен состоять из 15 цифр';
        },
        kpp: function kpp(v) {
          return v && v.match('^[0-9]{9}$') || 'КПП должен состоять из 9 цифр';
        }
      },
      coeffs: {
        snils: [9, 8, 7, false, 6, 5, 4, false, 3, 2, 1],
        inn10: [2, 4, 10, 3, 5, 9, 4, 6, 8],
        inn11: [7, 2, 4, 10, 3, 5, 9, 4, 6, 8],
        inn12: [3, 7, 2, 4, 10, 3, 5, 9, 4, 6, 8]
      },
      localData: {},
      customerTypes: [{ customer_type_id: 1, customer_type_name: 'Физическое лицо' }, { customer_type_id: 2, customer_type_name: 'Индивидуальный предприниматель' }, { customer_type_id: 3, customer_type_name: 'Юридическое лицо' }],
      inputRules: [function (v) {
        return !!v || 'Заполните это поле!';
      }],
      customer: {}
    };
  },
  mounted: function mounted() {
    this.customer = Object.assign({}, this.customerData);
  },

  methods: {
    save: function save() {
      var _this = this;

      if (this.customer.customer_id != null) {
        this.axios.patch('/api/customers/' + this.customer.customer_id + '/', this.customer).then(function () {
          _this.$emit('edited', _this.customer);
        }).catch(function (err) {
          console.log(err);
          _this.$emit('error');
        });
      } else {
        this.axios.post('/api/customers/', this.customer).then(function (response) {
          _this.$emit('edited', response.data);
        }).catch(function (err) {
          console.log(err);
          _this.$emit('error');
        });
      }
    },
    snilsValidate: function snilsValidate(v) {
      if (!v || v.length !== 14) {
        return 'Снилс должен состоять из 11 цифр';
      }
      var checkSum = parseInt(v.slice(-2), 10);
      var sum = this.sumProduct(v, this.coeffs.snils) % 101 % 100;
      if (sum !== checkSum) {
        return 'Снилс неверен - не совпадает контрольная сумма';
      }
      return true;
    },
    innValidate: function innValidate(v) {
      var type = this.data.customer_type;
      if (type !== 2 && type !== 3) {
        return 'Неверный тип абонента';
      }

      var _$3$type = _slicedToArray({
        2: ['ИП', 12],
        3: ['Юр. лица', 10]
      }[type], 2),
          typePhrase = _$3$type[0],
          count = _$3$type[1];

      if (!v || !v.match('^[0-9]{' + count + '}$')) {
        return '\u0418\u041D\u041D ' + typePhrase + ' \u0434\u043E\u043B\u0436\u0435\u043D \u0441\u043E\u0441\u0442\u043E\u044F\u0442\u044C \u0438\u0437 ' + count + ' \u0446\u0438\u0444\u0440';
      }
      if (type === 2) {
        var checkSum11 = parseInt(v[10]);
        var checkSum12 = parseInt(v[11]);
        var sum11 = this.sumProduct(v, this.coeffs.inn11) % 11 % 10;
        var sum12 = this.sumProduct(v, this.coeffs.inn12) % 11 % 10;
        if (sum11 !== checkSum11 || sum12 !== checkSum12) {
          return 'ИНН неверен - не совпадает контрольная сумма';
        }
      } else {
        var checkSum10 = parseInt(v[9]);
        var sum10 = this.sumProduct(v, this.coeffs.inn10) % 11 % 10;
        if (sum10 !== checkSum10) {
          return 'ИНН неверен - не совпадает контрольная сумма';
        }
      }
      return true;
    },
    sumProduct: function sumProduct(v, coeffs) {
      var sum = 0;
      coeffs.forEach(function (coeff, i) {
        sum += coeff ? coeff * v[i] : 0;
      });
      return sum;
    }
  }
};

/***/ }),

/***/ "6cGw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerEdit_vue__ = __webpack_require__("68EO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerEdit_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerEdit_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerEdit_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerEdit_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c124b52_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerEdit_vue__ = __webpack_require__("T+j2");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerEdit_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c124b52_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "6e+Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('v-overlay',{attrs:{"value":_vm.fileLoading}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64"}})],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"600"},model:{value:(_vm.fileReasonDialog),callback:function ($$v) {_vm.fileReasonDialog=$$v},expression:"fileReasonDialog"}},[_c('v-card',[_c('v-card-title',[_vm._v("Укажите причину отказа принять файл")]),_vm._v(" "),_c('v-card-subtitle',[_vm._v("Данная причина будет указана абоненту")]),_vm._v(" "),_c('v-card-text',[_c('v-textarea',{attrs:{"solo":"","name":"input-7-4"},model:{value:(_vm.sendReasonParams.reason),callback:function ($$v) {_vm.$set(_vm.sendReasonParams, "reason", $$v)},expression:"sendReasonParams.reason"}})],1),_vm._v(" "),_c('v-card-text',{attrs:{"align":"right"}},[_c('v-btn',{on:{"click":_vm.sendErrorReasonCancel}},[_vm._v("Отмена")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"error"},on:{"click":_vm.sendErrorReason}},[_vm._v("Отправить")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"600"},model:{value:(_vm.declineReasonDialog),callback:function ($$v) {_vm.declineReasonDialog=$$v},expression:"declineReasonDialog"}},[_c('v-card',[_c('v-card-title',[_vm._v("Укажите причину отказа принять заявление")]),_vm._v(" "),_c('v-card-subtitle',[_vm._v("Данная причина будет указана абоненту")]),_vm._v(" "),_c('v-card-text',[_c('v-textarea',{attrs:{"solo":"","name":"input-7-4"},model:{value:(_vm.decline_reason),callback:function ($$v) {_vm.decline_reason=$$v},expression:"decline_reason"}})],1),_vm._v(" "),_c('v-card-text',{attrs:{"align":"right"}},[_c('v-btn',{on:{"click":_vm.sendDeclineReasonCancel}},[_vm._v("Отмена")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"error"},on:{"click":_vm.sendDeclineReason}},[_vm._v("Отправить")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"600"},model:{value:(_vm.agreeDialog),callback:function ($$v) {_vm.agreeDialog=$$v},expression:"agreeDialog"}},[_c('v-card',[_c('v-card-title',[_vm._v("Заявление принятно")]),_vm._v(" "),_c('v-card-subtitle',[_vm._v("Уведомление поступит на почту абонента")]),_vm._v(" "),_c('v-card-subtitle',[_vm._v("Пожалуйста прикрепите файлы которые будут направлены абоненту")]),_vm._v(" "),_c('v-card-text',[_vm._l((_vm.resultDocs),function(doc){return _c('v-file-input',{key:doc.id,attrs:{"chips":"","label":doc.docName},model:{value:(doc.file),callback:function ($$v) {_vm.$set(doc, "file", $$v)},expression:"doc.file"}})}),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{on:{"click":_vm.addResultDoc}},[_vm._v("Добавить документ")])],1)],2),_vm._v(" "),_c('v-card-text',{attrs:{"align":"right"}},[_c('v-btn',{on:{"click":_vm.sendAgreeCancel}},[_vm._v("Отмена")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"error"},on:{"click":_vm.sendAgree}},[_vm._v("Отправить")])],1)],1)],1),_vm._v(" "),_c('v-card',[_c('v-row',[_c('v-btn',{attrs:{"fab":"","text":""},on:{"click":_vm.close}},[_c('v-icon',[_vm._v("keyboard_backspace")])],1),_vm._v(" "),_c('p',{staticStyle:{"padding-top":"15px","font-size":"18px"}},[_vm._v("Заявление: "+_vm._s(_vm.data.request_number))])],1),_vm._v(" "),_c('v-card',[_c('v-card-title',[_vm._v("\n        Информация о пользователе:\n      ")]),_vm._v(" "),_c('v-card-text',[_c('v-row',{staticClass:"ml-2"},[_c('p',{staticClass:"font-weight-bold mr-2"},[_vm._v("Логин:")]),_vm._v(" "+_vm._s(_vm.data.user.username))]),_vm._v(" "),_c('v-row',{staticClass:"ml-2"},[_c('p',{staticClass:"font-weight-bold mr-2"},[_vm._v("ФИО:")]),_vm._v(" "+_vm._s(_vm.data.user.last_name)+" "+_vm._s(_vm.data.user.first_name)+" "+_vm._s(_vm.data.user.middle_name))])],1),_vm._v(" "),_c('v-card-title',[_vm._v("\n        Информация о Лицевом счёте ("+_vm._s(_vm.data.customer.customer_number)+"):\n      ")]),_vm._v(" "),_c('v-card-text',[(_vm.data.customer.customer_type===1)?_c('span',[_c('v-row',{staticClass:"ml-2"},[_c('p',{staticClass:"font-weight-bold mr-2"},[_vm._v("Снилс:")]),_vm._v(" "+_vm._s(_vm.data.customer.snils))]),_vm._v(" "),_c('v-row',{staticClass:"ml-2"},[_c('p',{staticClass:"font-weight-bold mr-2"},[_vm._v("Фамилия:")]),_vm._v(" "+_vm._s(_vm.data.customer.last_name))]),_vm._v(" "),_c('v-row',{staticClass:"ml-2"},[_c('p',{staticClass:"font-weight-bold mr-2"},[_vm._v("Имя:")]),_vm._v(" "+_vm._s(_vm.data.customer.first_name))]),_vm._v(" "),_c('v-row',{staticClass:"ml-2"},[_c('p',{staticClass:"font-weight-bold mr-2"},[_vm._v("Отчество:")]),_vm._v(" "+_vm._s(_vm.data.customer.middle_name))])],1):(_vm.data.customer.customer_type===2)?_c('span',[_c('v-row',{staticClass:"ml-2"},[_c('p',{staticClass:"font-weight-bold mr-2"},[_vm._v("ИНН:")]),_vm._v(" "+_vm._s(_vm.data.customer.company_inn))]),_vm._v(" "),_c('v-row',{staticClass:"ml-2"},[_c('p',{staticClass:"font-weight-bold mr-2"},[_vm._v("ОГРН:")]),_vm._v(" "+_vm._s(_vm.data.customer.company_ogrn))]),_vm._v(" "),_c('v-row',{staticClass:"ml-2"},[_c('p',{staticClass:"font-weight-bold mr-2"},[_vm._v("Фамилия:")]),_vm._v(" "+_vm._s(_vm.data.customer.last_name))]),_vm._v(" "),_c('v-row',{staticClass:"ml-2"},[_c('p',{staticClass:"font-weight-bold mr-2"},[_vm._v("Имя:")]),_vm._v(" "+_vm._s(_vm.data.customer.first_name))]),_vm._v(" "),_c('v-row',{staticClass:"ml-2"},[_c('p',{staticClass:"font-weight-bold mr-2"},[_vm._v("Отчество:")]),_vm._v(" "+_vm._s(_vm.data.customer.middle_name))])],1):(_vm.data.customer_type===3)?_c('span',[_c('v-row',{staticClass:"ml-2"},[_c('p',{staticClass:"font-weight-bold mr-2"},[_vm._v("ИНН:")]),_vm._v(" "+_vm._s(_vm.data.customer.company_inn))]),_vm._v(" "),_c('v-row',{staticClass:"ml-2"},[_c('p',{staticClass:"font-weight-bold mr-2"},[_vm._v("КПП:")]),_vm._v(" "+_vm._s(_vm.data.customer.company_kpp))]),_vm._v(" "),_c('v-row',{staticClass:"ml-2"},[_c('p',{staticClass:"font-weight-bold mr-2"},[_vm._v("ОГРН:")]),_vm._v(" "+_vm._s(_vm.data.customer.company_ogrn))]),_vm._v(" "),_c('v-row',{staticClass:"ml-2"},[_c('p',{staticClass:"font-weight-bold mr-2"},[_vm._v("Название_организации:")]),_vm._v(" "+_vm._s(_vm.data.customer.company_full_name))]),_vm._v(" "),_c('p',{staticClass:"font-weight-bold"},[_vm._v("Представитель")]),_vm._v(" "),_c('v-row',{staticClass:"ml-2"},[_c('p',{staticClass:"font-weight-bold mr-2"},[_vm._v("Фамилия:")]),_vm._v(" "+_vm._s(_vm.data.customer.last_name))]),_vm._v(" "),_c('v-row',{staticClass:"ml-2"},[_c('p',{staticClass:"font-weight-bold mr-2"},[_vm._v("Имя:")]),_vm._v(" "+_vm._s(_vm.data.customer.first_name))]),_vm._v(" "),_c('v-row',{staticClass:"ml-2"},[_c('p',{staticClass:"font-weight-bold mr-2"},[_vm._v("Отчество:")]),_vm._v(" "+_vm._s(_vm.data.customer.middle_name))])],1):_vm._e()])],1),_vm._v(" "),_c('v-card',[_c('v-card-title',[_vm._v("\n        Поступившее заявление:\n      ")]),_vm._v(" "),_c('v-card-text',[_c('v-row',{staticClass:"ml-2"},[_c('p',{staticClass:"font-weight-bold mr-2"},[_vm._v("Тип:")]),_vm._v(" "+_vm._s(_vm.data.type.name))]),_vm._v(" "),_c('v-row',{staticClass:"ml-2"},[_c('p',{staticClass:"font-weight-bold mr-2"},[_vm._v("Назначен на:")]),_vm._v(" "),(_vm.data.assigned_user )?[_vm._v("\n              "+_vm._s(_vm.data.assigned_user.last_name)+" "+_vm._s(_vm.data.assigned_user.first_name)+" "+_vm._s(_vm.data.assigned_user.middle_name))]:_vm._e(),_vm._v(" ("),_c('a',{on:{"click":_vm.assignOnMe}},[_vm._v("Назначить на меня")]),_vm._v(")")],2),_vm._v(" "),_c('v-row',{staticClass:"ml-2"},[_c('p',{staticClass:"font-weight-bold mr-2"},[_vm._v("Дата подачи:")]),_vm._v(" "+_vm._s(_vm._f("moment")(_vm.data.created_at,"DD/MM/YYYY")))]),_vm._v(" "),_c('v-row',{staticClass:"ml-2"},[_c('p',{staticClass:"font-weight-bold mr-2 pt-3"},[_vm._v("Обработать до:")]),_vm._v(" "),_c('v-menu',{ref:"expiredDateMenu",attrs:{"close-on-content-click":false,"return-value":_vm.expiredDate,"transition":"scale-transition","offset-y":"","min-width":"290px"},on:{"update:returnValue":function($event){_vm.expiredDate=$event},"update:return-value":function($event){_vm.expiredDate=$event}},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-text-field',_vm._g(_vm._b({attrs:{"label":"Дата истечения срока рассмотрения","prepend-icon":"event","readonly":""},model:{value:(_vm.data.expired_date),callback:function ($$v) {_vm.$set(_vm.data, "expired_date", $$v)},expression:"data.expired_date"}},'v-text-field',attrs,false),on))]}}]),model:{value:(_vm.expiredDateMenu),callback:function ($$v) {_vm.expiredDateMenu=$$v},expression:"expiredDateMenu"}},[_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","scrollable":""},model:{value:(_vm.data.expired_date),callback:function ($$v) {_vm.$set(_vm.data, "expired_date", $$v)},expression:"data.expired_date"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"text":"","color":"primary"},on:{"click":function($event){_vm.menu = false}}},[_vm._v("Отмена")]),_vm._v(" "),_c('v-btn',{attrs:{"text":"","color":"primary"},on:{"click":_vm.saveExpiredDate}},[_vm._v("OK")])],1)],1)],1),_vm._v(" "),_c('v-row',{staticClass:"ml-2"},[_c('p',{staticClass:"font-weight-bold mt-2 mr-2"},[_vm._v("Статус:")]),_vm._v(" "),_c('v-menu',{attrs:{"offset-y":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-chip',_vm._g(_vm._b({class:_vm.getStatusColor(_vm.data.status.id)},'v-chip',attrs,false),on),[_vm._v(_vm._s(_vm.data.status.name))])]}}])},[_vm._v(" "),_c('v-list',_vm._l((_vm.statuses),function(status){return _c('v-list-item',{key:status.doc_status_id,on:{"click":function($event){return _vm.changeStatus(status, _vm.data)}}},[_c('v-list-item-title',[_vm._v(_vm._s(status.doc_status_name))])],1)}),1)],1)],1),_vm._v(" "),(_vm.data.status.id === 4)?_c('v-row',{staticClass:"ml-2 red--text"},[_c('p',{staticClass:"font-weight-bold mr-2"},[_vm._v("Причина отказа:")]),_vm._v(" "+_vm._s(_vm.data.decline_reason))]):_vm._e(),_vm._v(" "),_c('v-btn',{staticClass:"primary",on:{"click":_vm.sendToExternal}},[_vm._v("Отправить заявку в энергосбыт")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(this.externalSendResult))]),_vm._v(" "),(_vm.data.external_send_date)?_c('p',[_vm._v("Дата отправки:"+_vm._s(_vm.data.external_send_date))]):_vm._e()],1),_vm._v(" "),(_vm.closeFiles)?_c('v-card-text',[_c('v-expansion-panels',[_c('v-expansion-panel',[_c('v-expansion-panel-header',{staticClass:"mt-n6 mb-n6"},[_c('v-card-title',{staticClass:"ml-n6"},[_c('v-avatar',{staticClass:"mr-3 rounded-0",attrs:{"size":"36"}},[_c('v-icon',{attrs:{"size":"36"}},[_vm._v("mdi-file-document-outline")])],1),_vm._v(" "),_c('span',{staticClass:"subtitle-1 font-weight-bold mb-n1"},[_vm._v("\n                Закрывающие документы\n              ")])],1)],1),_vm._v(" "),_c('v-expansion-panel-content',[_c('v-card-text',_vm._l((_vm.closeFiles),function(file){return _c('v-hover',{key:file.doc_close_id,scopedSlots:_vm._u([{key:"default",fn:function(ref){
var hover = ref.hover;
return [_c('v-card',{staticClass:"mx-auto mb-5",attrs:{"elevation":hover ? 12 : 2}},[_c('v-card-title',[_c('v-avatar',{staticClass:"mr-3 rounded-0",attrs:{"size":"36"}},[_c('v-icon',{attrs:{"size":"36"}},[_vm._v("mdi-file-document-outline")])],1),_vm._v(" "),_c('span',{staticClass:"subtitle-1 font-weight-bold mb-n1"},[_vm._v("\n                      "+_vm._s(file.doc_close_file.real_file_name)+"("+_vm._s(_vm._f("moment")(file.created_at,"DD/MM/YYYY"))+")\n                    ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"v-size--small green",attrs:{"dark":""},on:{"click":function($event){return _vm.download(file.doc_close_file)}}},[_vm._v("Скачать")])],1)],1)]}}],null,true)})}),1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-card-text',_vm._l((_vm.files),function(file){return _c('v-hover',{key:file.doc_request_attach_id,scopedSlots:_vm._u([{key:"default",fn:function(ref){
var hover = ref.hover;
return [_c('v-card',{staticClass:"mx-auto mb-5",attrs:{"elevation":hover ? 12 : 2}},[_c('v-card-title',[(file.comments_user_unviewed > 0)?_c('v-btn',{staticClass:"v-size--small red white--text",attrs:{"title":"Не прочитано сообщений","rounded":"","icon":"","small":""}},[_vm._v("\n                "+_vm._s(file.comments_user_unviewed)+"\n              ")]):_vm._e(),_vm._v(" "),_c('v-avatar',{staticClass:"mr-3 rounded-0",attrs:{"size":"36"}},[_c('v-icon',{attrs:{"size":"36"}},[_vm._v("mdi-file-document-outline")])],1),_vm._v(" "),_c('span',{staticClass:"subtitle-1 font-weight-bold mb-n1"},[_vm._v("\n                "+_vm._s(file.required_doc_type_name)+"("+_vm._s(_vm._f("moment")(file.created_at,"DD/MM/YYYY"))+")\n              ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"v-size--small green",attrs:{"dark":""},on:{"click":function($event){return _vm.download(file)}}},[_vm._v("Скачать")])],1),_vm._v(" "),_c('v-expansion-panels',[_c('v-expansion-panel',[_c('v-expansion-panel-header',{staticClass:"mt-n6 mb-n6",on:{"click":function($event){return _vm.makeViewed(file)}}},[_c('v-card-text',[_c('v-row',[_c('v-chip-group',{model:{value:(file.doc_request_attach_status),callback:function ($$v) {_vm.$set(file, "doc_request_attach_status", $$v)},expression:"file.doc_request_attach_status"}},_vm._l((_vm.fileStatuses),function(fileStatus){return _c('v-chip',{key:fileStatus.id,attrs:{"active-class":fileStatus.color,"value":fileStatus.id},on:{"click":function($event){return _vm.changeFileStatus(file, fileStatus)}}},[_vm._v("\n                            "+_vm._s(fileStatus.name)+"\n                          ")])}),1)],1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',[_vm._l((file.comments),function(comment){return _c('v-card',{key:comment.doc_attachment_comment_id,class:("d-flex justify-" + (_vm.getMessageAlign(comment)) + " mb-6"),attrs:{"flat":"","shaped":""}},[_c('v-card',{attrs:{"max-width":"500","color":_vm.getMessageColor(comment),"shaped":""}},[_c('v-card-text',[_vm._v(_vm._s(comment.doc_attachment_comment))])],1)],1)}),_vm._v(" "),_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('v-row',{staticClass:"mt-n5 mb-n5"},[_c('v-text-field',{attrs:{"rounded":"","background-color":"grey lighten-3"},model:{value:(file.newComment),callback:function ($$v) {_vm.$set(file, "newComment", $$v)},expression:"file.newComment"}}),_vm._v(" "),_c('p',{staticClass:"mt-3 ml-3"},[_c('v-btn',{attrs:{"rounded":""},on:{"click":function($event){return _vm.sendComment(file, file.newComment)}}},[_vm._v("Отправить")])],1)],1)],1)],1)],2)],1)],1)],1)]}}],null,true)})}),1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6sxV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_c('div',{staticClass:"headline"},[_vm._v("\n      Редактирование счетчика\n      ("+_vm._s(_vm.counterData.model_name || _vm.counterData.model.name)+",\n      "+_vm._s(_vm.counterData.serial_num)+")\n    ")])]),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"counterParamsForm"},[_c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-text-field',{attrs:{"label":"Серийный номер","rules":_vm.inputRules,"required":""},model:{value:(_vm.counter.serial_num),callback:function ($$v) {_vm.$set(_vm.counter, "serial_num", $$v)},expression:"counter.serial_num"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12"}},[_c('v-text-field',{attrs:{"label":"Коэффициент трансформации тока","rules":_vm.inputRules,"required":""},model:{value:(_vm.counter.coeff),callback:function ($$v) {_vm.$set(_vm.counter, "coeff", $$v)},expression:"counter.coeff"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12"}},[_c('v-text-field',{attrs:{"label":"Коэффициент трансформации напряжения","rules":_vm.inputRules,"required":""},model:{value:(_vm.counter.coeff_voltage),callback:function ($$v) {_vm.$set(_vm.counter, "coeff_voltage", $$v)},expression:"counter.coeff_voltage"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":_vm.saveChanges}},[_vm._v("Сохранить")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){return _vm.$emit('cancel')}}},[_vm._v("Отмена")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6yGu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var API_URL = 'points'; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'Point',
  data: function data() {
    return {
      search: '',
      firstLoading: true,
      loading: true,
      options: { page: 1, itemsPerPage: 25 },
      hasOptionsBeenWatched: false,
      dialog: false,
      serverItemsLength: 0,
      formActive: false,
      items: [],
      headers: [{ text: 'Наименование', value: 'name' }, { text: '', value: 'has_counter' }, {
        text: 'Число объектов принадлежности',
        sortable: false,
        align: 'center',
        value: 'point_represents_number' }, { text: 'Идентификатор', value: 'point_number' }, { text: 'Абонент', value: 'customer__name' }, { text: 'Адрес', value: 'address' }, { text: '', sortable: false, value: '' }],
      editedItem: {
        point_id: '',
        point_number: '',
        customer: '',
        address: '',
        geopoint: '',
        name: '',
        remark: '',
        counter: ''
      },
      defaultItem: {
        point_id: '',
        point_number: '',
        address: '',
        geopoint: '',
        name: '',
        remark: '',
        counter: ''
      },
      customers: [],
      showErrorMsg: false,
      showError: false,
      pointAddRules: [function (v) {
        return !!v || 'Заполните это поле!';
      }],
      getTimer: '',
      searchTimer: '',
      deleteTimer: ''
    };
  },

  watch: {
    dialog: function dialog(val) {
      val || this.close();
      val && this.getCustomersApi();
    },

    options: {
      handler: function handler() {
        this.getItemsApiTimer();
      },

      deep: true
    },
    search: function search(val) {
      var _this = this;

      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(function () {
        _this.options.page = 1;
        _this.getItemsApiTimer();
      }, 500);
    }
  },
  methods: {
    getItemsApi: function getItemsApi() {
      var _this2 = this;

      this.loading = true;
      _axios2.default.get('/api/' + API_URL + '/?' + ('per_page=' + this.options.itemsPerPage) + ('&page=' + this.options.page) + '&ordering=' + (this.options.sortDesc[0] ? '-' : '') + (this.options.sortBy[0] || '') + ('&search=' + this.search)).then(function (response) {
        _this2.items = response.data.results;
        _this2.serverItemsLength = response.data.count;
      }).catch(function (err) {
        console.log(err);
      }).finally(function () {
        _this2.firstLoading = false;
        _this2.loading = false;
      });
    },
    getItemsApiTimer: function getItemsApiTimer() {
      var _this3 = this;

      clearTimeout(this.getTimer);
      this.getTimer = setTimeout(function () {
        _this3.getItemsApi();
      }, 100);
    },
    getCustomersApi: function getCustomersApi() {
      var _this4 = this;

      _axios2.default.get('/api/customers/').then(function (response) {
        _this4.customers = response.data.results;
        console.log(_this4.customers);
      }).catch(function (err) {
        console.log(err);
      });
    },
    addItemApi: function addItemApi() {
      var _this5 = this;

      this.axios.post('/api/' + API_URL + '/', this.editedItem).then(function () {
        _this5.getItemsApiTimer();
        _this5.close();
      }).catch(function (err) {
        console.log(err);
      });
    },
    deleteItemApi: function deleteItemApi(item) {
      var _this6 = this;

      this.axios.delete('/api/' + API_URL + '/' + item.point_id).then(function () {
        _this6.items.splice(_this6.items.indexOf(item), 1);
        clearTimeout(_this6.deleteTimer);
        _this6.deleteTimer = setTimeout(function () {
          _this6.items.length || _this6.options.page === 1 || _this6.options.page--;
          _this6.getItemsApiTimer();
        }, 1000);
      }).catch(function (err) {
        console.log(err);
      });
    },
    validate: function validate() {
      if (this.$refs.form.validate()) {
        return true;
      }
    },
    deleteItem: function deleteItem(item) {
      if (confirm('Вы действительно хотите удалить эту строку?')) {
        this.deleteItemApi(item);
      }
    },
    addPoint: function addPoint() {
      this.formActive = true;
      this.getCustomersApi();
    },
    close: function close() {
      var _this7 = this;

      this.dialog = false;
      setTimeout(function () {
        _this7.editedItem = Object.assign({}, _this7.defaultItem);
      }, 300);
      this.formActive = false;
    },
    save: function save() {
      if (this.validate()) {
        this.addItemApi();
        this.formActive = false;
      }
    }
  }
};

/***/ }),

/***/ "7HDv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

var _ReportTreeNode = __webpack_require__("DUuK");

var _ReportTreeNode2 = _interopRequireDefault(_ReportTreeNode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: { ReportTreeNode: _ReportTreeNode2.default },
  data: function data() {
    return {
      begDate: null,
      endDate: null,
      representsSelectType: 'none',
      pointsSelectType: 'multiple',
      pointsId: [],
      maxSelectPoint: 3,
      menuBegDate: false,
      menuEndDate: false,
      loading: false
    };
  },

  computed: {
    canGetReport: function canGetReport() {
      return this.begDate && this.endDate && this.pointsId.length;
    },
    begDateComputed: function begDateComputed() {
      return this.formatDate(this.begDate);
    },
    endDateComputed: function endDateComputed() {
      return this.formatDate(this.endDate);
    },
    limitSelectedPoints: function limitSelectedPoints() {
      return this.pointsId.length >= this.maxSelectPoint;
    }
  },
  methods: {
    pointSelect: function pointSelect(point) {
      var key = this.pointsId.indexOf(point.id);
      if (point.is_selected && key === -1) {
        this.pointsId.push(point.id);
      }
      if (!point.is_selected && key !== -1) {
        this.pointsId.splice(key, 1);
      }
    },
    formatDate: function formatDate(date) {
      if (!date) return null;

      var _date$split = date.split('-'),
          _date$split2 = _slicedToArray(_date$split, 3),
          year = _date$split2[0],
          month = _date$split2[1],
          day = _date$split2[2];

      return day + '-' + month + '-' + year;
    },
    getReport: function getReport() {
      var _this = this;

      this.loading = true;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.pointsId[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var pointId = _step.value;

          (0, _axios2.default)({
            url: '/api/get_report/',
            method: 'POST',
            responseType: 'blob',
            params: {
              'point_id': pointId,
              'beg_date': this.begDate,
              'end_date': this.endDate,
              'report': 'Form00102Report' }
          }).then(function (response) {
            var blob = new Blob([response.data], { type: 'application/pdf' });
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = 'report_001.02.xlsx';
            link.click();
          }).finally(function () {
            _this.loading = false;
          });
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }
};

/***/ }),

/***/ "7Z1N":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7hPC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PointToolbar = __webpack_require__("bB1z");

var _PointToolbar2 = _interopRequireDefault(_PointToolbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'PointsScheduler',
  components: {
    PointToolbar: _PointToolbar2.default
  },
  data: function data() {
    return {};
  },

  computed: {
    pointFormTitle: function pointFormTitle() {
      return this.editedIndex === -1 ? 'Новая точка учёта' : 'Редактирование точки учета';
    }
  },
  watch: {
    dialog: function dialog(val) {
      val || this.close();
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "7pYT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LineChart_vue__ = __webpack_require__("tMdx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LineChart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LineChart_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LineChart_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LineChart_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LineChart_vue___default.a,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "84cH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{attrs:{"color":"teal darken-3","dark":"","app":"","height":"40","clipped-left":_vm.$vuetify.breakpoint.lgAndUp,"fixed":""}},[_c('v-toolbar-title',{staticClass:"ml-0 pl-3"},[_c('v-app-bar-nav-icon',{on:{"click":function($event){$event.stopPropagation();return _vm.change_drawer($event)}}}),_vm._v(" "),_c('span',{staticClass:"hidden-sm-and-down"},[_vm._v(_vm._s(_vm.title))])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',{staticClass:"user-fio"},[_vm._v("\n    "+_vm._s(_vm.user.first_name)+" "+_vm._s(_vm.user.last_name)+"\n  ")]),_vm._v(" "),_c('a',{staticClass:"exit-lnk",attrs:{"href":"#"},on:{"click":_vm.logout}},[_vm._v("\n    Выход\n  ")]),_vm._v(" "),_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-width":200,"offset-x":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"rounded":"","icon":""}},on),[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("\n          far fa-question-circle\n        ")])],1)]}}]),model:{value:(_vm.releaseVersion),callback:function ($$v) {_vm.releaseVersion=$$v},expression:"releaseVersion"}},[_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('a',{attrs:{"href":"#"}},[_vm._v("Справка ПО \"АСКУЭ\"")])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list',[_c('v-list-item',[_c('v-list-item-content',[_c('v-list-item-title',[_c('a',{attrs:{"href":"/release-notes"}},[_vm._v("Релиз 1.5.2")])])],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8MPD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"light":""}},[(_vm.loading)?_c('v-layout',{staticClass:"loading-indicator",attrs:{"justify-center":"","align-center":""}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":70,"width":7}})],1):_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('h2',[_vm._v("Профили мощности")])]),_vm._v(" "),_c('v-col',{attrs:{"cols":"auto"}},[_c('v-menu',{attrs:{"close-on-content-click":false,"content-class":"report-tree"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"report-tree-btn"},on),[_vm._v(_vm._s(_vm.point
              ? _vm.point.name
              : 'Выбрать точку учёта'))])]}}]),model:{value:(_vm.menuPoint),callback:function ($$v) {_vm.menuPoint=$$v},expression:"menuPoint"}},[_vm._v(" "),_c('report-tree-node',{attrs:{"is-root":true,"initial-represents":[],"initial-all-points":[],"represent-points":[],"represents-select-type":_vm.representsSelectType,"points-select-type":_vm.pointsSelectType,"limit-selected-points":false},on:{"point-select":_vm.pointSelect}})],1)],1),_vm._v(" "),_c('v-col',[_c('v-menu',{ref:"menuBegDate",attrs:{"close-on-content-click":false,"nudge-right":40,"transition":"scale-transition","offset-y":"","max-width":"290px","min-width":"290px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
              var on = ref.on;
return [_c('v-text-field',_vm._g({attrs:{"label":"Дата начала отчетного периода","prepend-icon":"event","readonly":""},model:{value:(_vm.begDateComputed),callback:function ($$v) {_vm.begDateComputed=$$v},expression:"begDateComputed"}},on))]}}]),model:{value:(_vm.menuBegDate),callback:function ($$v) {_vm.menuBegDate=$$v},expression:"menuBegDate"}},[_vm._v(" "),_c('v-date-picker',{attrs:{"locale":"ru-RU","no-title":""},on:{"input":function($event){_vm.menuBegDate = false}},model:{value:(_vm.begDate),callback:function ($$v) {_vm.begDate=$$v},expression:"begDate"}})],1)],1),_vm._v(" "),_c('v-col',[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"transition":"scale-transition","offset-y":"","max-width":"290px","min-width":"290px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
              var on = ref.on;
return [_c('v-text-field',_vm._g({attrs:{"label":"Дата окончания отчётного периода","prepend-icon":"event","readonly":""},model:{value:(_vm.endDateComputed),callback:function ($$v) {_vm.endDateComputed=$$v},expression:"endDateComputed"}},on))]}}]),model:{value:(_vm.menuEndDate),callback:function ($$v) {_vm.menuEndDate=$$v},expression:"menuEndDate"}},[_vm._v(" "),_c('v-date-picker',{attrs:{"locale":"ru-RU","no-title":""},on:{"input":function($event){_vm.menuEndDate = false}},model:{value:(_vm.endDate),callback:function ($$v) {_vm.endDate=$$v},expression:"endDate"}})],1)],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"disabled":!_vm.canGetReport},on:{"click":function($event){return _vm.getReport()}}},[_vm._v("\n      Сформировать\n    ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8kY9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _vuetify = __webpack_require__("3EgV");

var _vuetify2 = _interopRequireDefault(_vuetify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuetify2.default);

exports.default = new _vuetify2.default({
  icons: {
    iconfont: 'mdi'
  }
});

/***/ }),

/***/ "9HgN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9bI/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointCounterTakeOff_vue__ = __webpack_require__("ax5m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointCounterTakeOff_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointCounterTakeOff_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointCounterTakeOff_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointCounterTakeOff_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b4e860d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PointCounterTakeOff_vue__ = __webpack_require__("zGA6");
function injectStyle (ssrContext) {
  __webpack_require__("cuZ9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7b4e860d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointCounterTakeOff_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b4e860d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PointCounterTakeOff_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "9mSd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('point-toolbar',{attrs:{"point-info":_vm.point.name}}),_vm._v(" "),_c('v-container',[_c('v-card',[_c('v-card-title',[_vm._v("Векторная диаграмма полной мощности")]),_vm._v(" "),(_vm.phaseDataLoading)?_c('v-card-text',[_c('v-layout',{staticClass:"loading-indicator",attrs:{"justify-center":"","align-center":""}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":70,"width":7}})],1)],1):_vm._e(),_vm._v(" "),(!_vm.phaseDataLoading && _vm.hasPhaseData)?_c('v-card-text',{staticClass:"d-flex flex-row"},[_c('v-data-table',{staticClass:"pa-2 phase-table",attrs:{"headers":_vm.phaseDataHeaders,"items":_vm.phaseData,"items-per-page":50,"hide-default-footer":"","no-data-text":"Нет данных для отображения","dense":""}}),_vm._v(" "),_c('span',{staticClass:"pa-6"},[_c('svg',{attrs:{"width":"400","height":"280"}},[_c('line',{attrs:{"stroke-width":"15","x1":"30","y1":"30","x2":"15","y2":"30","stroke":"orange"}}),_vm._v(" "),_c('text',{staticClass:"small",attrs:{"x":"40","y":"35"}},[_vm._v("Фаза A")]),_vm._v(" "),_c('line',{attrs:{"stroke-width":"15","x1":"30","y1":"50","x2":"15","y2":"50","stroke":"green"}}),_vm._v(" "),_c('text',{staticClass:"small",attrs:{"x":"40","y":"55"}},[_vm._v("Фаза B")]),_vm._v(" "),_c('line',{attrs:{"stroke-width":"15","x1":"30","y1":"70","x2":"15","y2":"70","stroke":"blue"}}),_vm._v(" "),_c('text',{staticClass:"small",attrs:{"x":"40","y":"75"}},[_vm._v("Фаза C")]),_vm._v(" "),_c('defs',[_c('marker',{attrs:{"id":"arrow_orange","viewBox":"0 0 20 20","refX":"5","refY":"5","markerWidth":"6","markerHeight":"6","orient":"auto-start-reverse"}},[_c('path',{attrs:{"d":"M 0 0 L 10 5 L 0 10 z","fill":"orange"}})]),_vm._v(" "),_c('marker',{attrs:{"id":"arrow_green","viewBox":"0 0 20 20","refX":"5","refY":"5","markerWidth":"6","markerHeight":"6","orient":"auto-start-reverse"}},[_c('path',{attrs:{"d":"M 0 0 L 10 5 L 0 10 z","fill":"green"}})]),_vm._v(" "),_c('marker',{attrs:{"id":"arrow_blue","viewBox":"0 0 20 20","refX":"5","refY":"5","markerWidth":"6","markerHeight":"6","orient":"auto-start-reverse"}},[_c('path',{attrs:{"d":"M 0 0 L 10 5 L 0 10 z","fill":"blue"}})]),_vm._v(" "),_c('marker',{attrs:{"id":"arrow_black","viewBox":"0 0 20 20","refX":"5","refY":"5","markerWidth":"6","markerHeight":"6","orient":"auto-start-reverse"}},[_c('path',{attrs:{"d":"M 0 0 L 10 5 L 0 10 z","fill":"black"}})])]),_vm._v(" "),_c('text',{staticClass:"small",attrs:{"x":"335","y":"142"}},[_vm._v("90°")]),_vm._v(" "),_c('text',{staticClass:"small",attrs:{"x":"200","y":"275"}},[_vm._v("180°")]),_vm._v(" "),_c('text',{staticClass:"small",attrs:{"x":"55","y":"145"}},[_vm._v("270°")]),_vm._v(" "),_c('text',{staticClass:"small",attrs:{"x":"205","y":"15"}},[_vm._v("0°")]),_vm._v(" "),_c('circle',{staticStyle:{"fill":"white"},attrs:{"stroke-width":"2","stroke":"black","cx":"210","cy":"140","r":"120"}}),_vm._v(" "),_c('line',{attrs:{"stroke-width":"1","x1":"90","y1":"140","x2":"330","y2":"140","stroke":"black"}}),_vm._v(" "),_c('line',{attrs:{"stroke-width":"1","x1":"210","y1":"20","x2":"210","y2":"260","stroke":"black"}}),_vm._v(" "),_c('text',{staticClass:"heavy",attrs:{"x":"290","y":"15"}},[_vm._v("I")]),_vm._v(" "),_c('line',{attrs:{"stroke-width":"3","x1":"290","y1":"20","x2":"330","y2":"20","stroke":"black","marker-end":"url(#arrow_black)"}}),_vm._v(" "),_c('text',{staticClass:"heavy",attrs:{"x":"290","y":"40"}},[_vm._v("U")]),_vm._v(" "),_c('line',{attrs:{"stroke-width":"3","x1":"290","y1":"45","x2":"380","y2":"45","stroke":"black","marker-end":"url(#arrow_black)"}}),_vm._v(" "),(_vm.showLines)?_c('g',{staticClass:"phase-line"},[_c('path',{staticClass:"phase-one",attrs:{"d":'M210 ' + _vm.uOne + 'V140',"marker-start":"url(#arrow_orange)"}})]):_vm._e(),_vm._v(" "),(_vm.showLines)?_c('g',{staticClass:"phase-line",style:({ transform: 'rotate(' + _vm.angAdditionalOne + 'deg)' })},[_c('path',{staticClass:"phase-one",attrs:{"d":'M210 ' + _vm.iOne + 'V140',"marker-start":"url(#arrow_orange)"}})]):_vm._e(),_vm._v(" "),(_vm.showLines)?_c('g',{staticClass:"phase-line",style:({ transform: 'rotate(' + _vm.angTwo + 'deg)' })},[_c('path',{staticClass:"phase-two",attrs:{"d":'M210 ' + _vm.uTwo + 'V140',"marker-start":"url(#arrow_green)"}})]):_vm._e(),_vm._v(" "),(_vm.showLines)?_c('g',{staticClass:"phase-line",style:({ transform: 'rotate(' + _vm.angAdditionalTwo + 'deg)' })},[_c('path',{staticClass:"phase-two",attrs:{"d":'M210 ' + _vm.iTwo + 'V140',"marker-start":"url(#arrow_green)"}})]):_vm._e(),_vm._v(" "),(_vm.showLines)?_c('g',{staticClass:"phase-line",style:({ transform: 'rotate(' + _vm.angThree + 'deg)' })},[_c('path',{staticClass:"phase-three",attrs:{"d":'M210 ' + _vm.uThree + 'V140',"marker-start":"url(#arrow_blue)"}})]):_vm._e(),_vm._v(" "),(_vm.showLines)?_c('g',{staticClass:"phase-line",style:({ transform: 'rotate(' + _vm.angAdditionalThree + 'deg)' })},[_c('path',{staticClass:"phase-three",attrs:{"d":'M210 ' + _vm.iThree + 'V140',"marker-start":"url(#arrow_blue)"}})]):_vm._e()])])],1):_vm._e(),_vm._v(" "),(!_vm.phaseDataLoading && !_vm.hasPhaseData)?_c('v-card-text',{staticClass:"d-flex flex-row"},[_vm._v("\n        Нет данных по фазам счётчика.\n      ")]):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "A8K9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_c('div',{staticClass:"headline"},[_vm._v("\n      Настройки подключения ("+_vm._s(_vm.counterData.model_name)+", "+_vm._s(_vm.counterData.serial_num)+")\n    ")])]),_vm._v(" "),_c('v-card-text',[_c('v-select',{attrs:{"items":_vm.sourceParams,"label":"Источник данных"},model:{value:(_vm.sourceParam.value),callback:function ($$v) {_vm.$set(_vm.sourceParam, "value", $$v)},expression:"sourceParam.value"}}),_vm._v(" "),_vm._l((_vm.visibleParams),function(param){return _c('v-text-field',{key:param.param,attrs:{"label":param.name,"rules":_vm.inputRules,"required":""},model:{value:(param.value),callback:function ($$v) {_vm.$set(param, "value", $$v)},expression:"param.value"}})})],2),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":_vm.setConnectParameters}},[_vm._v("Сохранить")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){return _vm.$emit('cancel')}}},[_vm._v("Отмена")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "A92p":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AKqe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _LineChart = __webpack_require__("7pYT");

var _LineChart2 = _interopRequireDefault(_LineChart);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'PointCounterData',
  components: {
    LineChart: _LineChart2.default
  },
  data: function data() {
    return {
      point_id: this.$route.params['id'],
      tab: null,
      charsTab: null,
      counters: [],
      countersHeaders: [{
        text: 'Серийный номер',
        align: 'left',
        sortable: true,
        value: 'serial_num'
      }, {
        text: 'Модель',
        align: 'left',
        value: 'model'
      }, { text: '', value: '' }],
      tasksDialog: false,
      tasksLoading: false,
      countersDataLoading: false,
      selectedCounterId: '',
      counterTasks: [],
      countersLoading: false,
      countersAccumulatedDataLoading: false,
      countersDataHeaders: [{
        text: 'Дата и время',
        align: 'left',
        sortable: false,
        value: 'label'
      }, { text: 'Значение', value: 'value', sortable: false }],
      counterTasksHeaders: [{
        text: 'Частота выполнения',
        align: 'left',
        sortable: false,
        value: 'serial_num'
      }, { text: '', value: 'value', sortable: false },
      // { text: 'Дата и время начала', value: 'start_date' },
      { text: 'Выполняется', value: 'enabled' }, { text: 'Действия', value: 'actions' }],
      taskDialog: false,
      editedTaskIndex: -1,
      frequencies: [{ id: 'minutes', name: 'Минут' }, { id: 'hours', name: 'Часов' }, { id: 'days', name: 'Дней'
        // { id: 'WEEK', name: 'Недель' },
        // { id: 'MONTH', name: 'Месяцев' },
        // { id: 'ONCE', name: 'Единожды' }
      }],
      editedTaskItem: { counter_id: '' },
      editedCounterTaskIndex: -1,
      taskOnceDateValue: false,
      startTaskDate: false,
      loaded: false,
      countersData: [],
      countersData2: [],
      countersAccumulatedData: [],
      labels: [],
      available_params: [],
      parameter_id: '',
      reportIntervals: [{ interval: '30', name: 'Полчаса' }, { interval: '60', name: 'Час' }, { interval: '1440', name: 'День' }, { interval: '43200', name: 'Месяц' }, { interval: '525600', name: 'Год' }],
      accumulatedDataParams: [{ id: '0', name: 'На начало текущих суток' }, { id: '10030', name: '0:30 - для примера' }],
      accumulatedDataParam: '',
      reportInterval: '30'
    };
  },

  computed: {
    taskDialogTitle: function taskDialogTitle() {
      return this.editedTaskIndex === -1 ? 'Новое задание' : 'Редактирование задания';
    }
  },
  watch: {
    dialog: function dialog(val) {
      val || this.close();
    }
  },
  mounted: function mounted() {
    this.getPointCountersApi();
    this.getAvailableParams();
  },

  methods: {
    getPointCountersApi: function getPointCountersApi() {
      var _this = this;

      this.countersLoading = true;
      _axios2.default.get('/api/counters/?point_id=' + this.point_id).then(function (response) {
        _this.counters = response.data;
        _this.countersLoading = false;
      }).catch(function (err) {
        _this.countersLoading = false;
        console.log(err);
      });
    },
    getCounterTasksApi: function getCounterTasksApi() {
      var _this2 = this;

      this.tasksLoading = true;
      _axios2.default.get('/api/counters_tasks/?counter_id=' + this.selectedCounterId).then(function (response) {
        _this2.counterTasks = response.data;
        _this2.tasksLoading = false;
      }).catch(function (err) {
        _this2.tasksLoading = false;
        console.log(err);
      });
    },
    getAvailableParams: function getAvailableParams() {
      var _this3 = this;

      _axios2.default.get('/api/counters_data/available_params/?point_id=' + this.point_id).then(function (response) {
        _this3.available_params = response.data;
      }).catch(function (err) {
        console.log(err);
      });
    },
    openTasks: function openTasks(item) {
      this.selectedCounterId = item.counter_id;
      this.getCounterTasksApi();
      this.tasksDialog = true;
    },
    closeTasks: function closeTasks() {
      this.tasksDialog = false;
    },
    addTaskApi: function addTaskApi() {
      var _this4 = this;

      this.tasksLoading = true;
      this.editedTaskItem.counter_id = this.selectedCounterId;
      _axios2.default.post('/api/counters_tasks/', this.editedTaskItem).then(function (response) {
        _this4.tasksLoading = false;
        _this4.counterTasks.push(response.data);
        _this4.closeTasksDialog();
      }).catch(function (err) {
        _this4.tasksLoading = false;
        console.log(err);
      });
    },
    updateTaskApi: function updateTaskApi() {
      var _this5 = this;

      this.tasksLoading = true;
      this.editedTaskItem.counter_id = this.selectedCounterId;
      _axios2.default.put('/api/counters_tasks/', this.editedTaskItem).then(function (response) {
        _this5.tasksLoading = false;
        Object.assign(_this5.editedTaskItem[_this5.editedCounterTaskIndex], response.data);
        _this5.closeTasksDialog();
      }).catch(function (err) {
        _this5.tasksLoading = false;
        console.log(err);
      });
    },
    deleteCounterTask: function deleteCounterTask(item) {
      var _this6 = this;

      var id = item.counter_task_id;
      this.tasksLoading = true;
      _axios2.default.delete('/api/counters_tasks/' + id).then(function (response) {
        _this6.tasksLoading = false;
        var index = _this6.editedTaskItem.indexOf(item);
        _this6.editedTaskItem.splice(index, 1);
      }).catch(function (err) {
        _this6.tasksLoading = false;
        console.log(err);
      });
    },
    startCounterTaskApi: function startCounterTaskApi(item) {
      var _this7 = this;

      var id = item.counter_task_id;
      _axios2.default.post('/api/counters_tasks/' + id + '/start_scheduler/').then(function (response) {
        var index = _this7.counterTasks.indexOf(item);
        Object.assign(_this7.counterTasks[index], response.data);
        _this7.editedTaskItem = Object.assign({}, response.data);
      }).catch(function (err) {
        console.log(err);
      });
    },
    stopCounterTaskApi: function stopCounterTaskApi(item) {
      var _this8 = this;

      var id = item.counter_task_id;
      this.editedTaskItem.enabled = false;
      this.editedTaskItem.counter_id = this.selectedCounterId;
      _axios2.default.put('/api/counters_tasks/' + id + '/', this.editedTaskItem).then(function (response) {
        var index = _this8.counterTasks.indexOf(item);
        Object.assign(_this8.counterTasks[index], response.data);
        _this8.editedTaskItem = Object.assign({}, response.data);
      }).catch(function (err) {
        console.log(err);
      });
    },
    editCounterTask: function editCounterTask(item) {
      this.editedCounterTaskIndex = this.editedTaskItem.indexOf(item);
      this.editedTaskItem = Object.assign({}, item);
      this.taskDialog = true;
    },
    saveCounterTask: function saveCounterTask() {
      if (this.editedIndex > -1) {
        this.updateTaskApi();
      } else {
        this.addTaskApi();
      }
    },
    closeTasksDialog: function closeTasksDialog() {
      this.taskDialog = false;
    },
    stopTasks: function stopTasks(item) {
      this.stopCounterTaskApi(item);
    },
    startTasks: function startTasks(item) {
      this.startCounterTaskApi(item);
    },
    resetState: function resetState() {
      this.loaded = false;
    },
    requestAccumulatedData: function requestAccumulatedData() {
      var _this9 = this;

      this.resetState();
      if (this.parameter_id) {
        _axios2.default.get('/api/counters_accumulated_data/?point_id=' + this.point_id).then(function (response) {
          _this9.countersAccumulatedData = response.data;
          _this9.loaded = true;
        }).catch(function (err) {
          console.log(err);
        });
      }
    },
    requestData: function requestData() {
      var _this10 = this;

      this.resetState();
      this.requestAccumulatedData();
      if (this.parameter_id) {
        _axios2.default.get('/api/counters_profile_data/?point_id=' + this.point_id + '&parameter_id=' + this.parameter_id + '&interval=' + this.reportInterval).then(function (response) {
          _this10.countersData = response.data.map(function (data) {
            return data.value;
          });
          _this10.countersData2 = response.data;
          _this10.labels = response.data.map(function (data) {
            return data.label;
          });
          _this10.loaded = true;
        }).catch(function (err) {
          console.log(err);
        });
      }
    }
  }
};

/***/ }),

/***/ "AnLt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReleaseNotes_vue__ = __webpack_require__("dnJz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReleaseNotes_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReleaseNotes_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReleaseNotes_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReleaseNotes_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d957e82_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReleaseNotes_vue__ = __webpack_require__("bsIX");
function injectStyle (ssrContext) {
  __webpack_require__("yxfD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0d957e82"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReleaseNotes_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d957e82_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReleaseNotes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "AqzR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.vMoney = exports.vPhone = exports.vDate = exports.vDateFull = exports.vHour = exports.vHourFull = undefined;

var _vanillaMasker = __webpack_require__("lFEC");

var _vanillaMasker2 = _interopRequireDefault(_vanillaMasker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-new */
var vHourFull = exports.vHourFull = {
  bind: function bind(el) {
    (0, _vanillaMasker2.default)(el).maskPattern('99:99:99');
  }
};

var vHour = exports.vHour = {
  bind: function bind(el) {
    (0, _vanillaMasker2.default)(el).maskPattern('99:99');
  }
};

var vDateFull = exports.vDateFull = {
  bind: function bind(el) {
    (0, _vanillaMasker2.default)(el).maskPattern('99/99/9999');
  }
};

var vDate = exports.vDate = {
  bind: function bind(el) {
    (0, _vanillaMasker2.default)(el).maskPattern('99/99/99');
  }
};

var vPhone = exports.vPhone = {
  bind: function bind(el, binding) {
    var pattern = binding.value ? binding.value.mask : '(99) 99999-9999';
    (0, _vanillaMasker2.default)(el).maskPattern(pattern);
  }
};

var vMoney = exports.vMoney = {
  bind: function bind(el, binding) {
    var params = binding.value || {};

    (0, _vanillaMasker2.default)(el).maskMoney({
      // Decimal precision -> "90"
      precision: params.precision || 2,

      // Decimal separator -> ",90"
      separator: params.separator || ',',

      // Number delimiter -> "12.345.678"
      delimiter: params.delimiter || '.',

      // Money unit -> "R$ 12.345.678,90"
      unit: params.unit || 'R$',

      // Money unit -> "12.345.678,90 R$"
      suffixUnit: params.suffixUnit || '',
      // Force type only number instead decimal,
      // masking decimals with ",00"
      // Zero cents -> "R$ 1.234.567.890,00"
      zeroCents: !!params.zeroCents
    });
  }
};

/***/ }),

/***/ "Av08":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "B8X5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DynamicLineChart_vue__ = __webpack_require__("aL9m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DynamicLineChart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DynamicLineChart_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DynamicLineChart_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DynamicLineChart_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DynamicLineChart_vue___default.a,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "BVF4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Bp6Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.logsResIsLoading)?_c('v-progress-linear',{attrs:{"color":"blue","indeterminate":""}}):_vm._e(),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.logRows,"hide-default-footer":"","fixed-header":"","height":"300","single-expand":"","expanded":_vm.expanded,"no-data-text":"Нет данных для отображения","item-key":"start_date","show-expand":"","dense":""},on:{"update:expanded":function($event){_vm.expanded=$event}},scopedSlots:_vm._u([{key:"top",fn:function(){return [_c('div',{staticClass:"table-top"},[_vm._v("\n          "+_vm._s(_vm.task.represents ? 'Объект - ' + _vm.task.represents[0].name + ', ' : '')+"\n          "+_vm._s(_vm.task.point ? 'Точка учёта - ' + _vm.task.point[0].address + ' - ' + _vm.task.point[0].name + ', ' : '')+"\n          Номер счётчика - "+_vm._s(_vm.task.counter_num)+"\n        ")])]},proxy:true},{key:"item.start_date",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"nwrp"},[_vm._v(_vm._s(_vm._f("moment")(item.start_date,"DD/MM/YYYY HH:mm:ss")))])]}},{key:"item.success",fn:function(ref){
var item = ref.item;
return [_c('div',{class:{ 'task-error': !item.success }},[_vm._v(_vm._s(_vm.statusText(item.success)))])]}},{key:"expanded-item",fn:function(ref){
var headers = ref.headers;
var item = ref.item;
return [_c('td',{staticClass:"px-0",attrs:{"colspan":headers.length}},[_c('v-data-table',{attrs:{"headers":_vm.headersActions,"items":_vm.getitems(item.log),"hide-default-footer":"","hide-default-header":"","item-key":"name","dense":""},scopedSlots:_vm._u([{key:"item",fn:function(props){return _c('tr',{},[_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(props.item.date))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(props.item.text))])])}}],null,true)})],1)]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Caf9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CountersModelsResourceTypes_vue__ = __webpack_require__("Q+1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CountersModelsResourceTypes_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CountersModelsResourceTypes_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CountersModelsResourceTypes_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CountersModelsResourceTypes_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84c5a3f8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CountersModelsResourceTypes_vue__ = __webpack_require__("gr9q");
function injectStyle (ssrContext) {
  __webpack_require__("XpEI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CountersModelsResourceTypes_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84c5a3f8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CountersModelsResourceTypes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "CbU7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CountersModelsParameters_vue__ = __webpack_require__("+v5I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CountersModelsParameters_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CountersModelsParameters_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CountersModelsParameters_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CountersModelsParameters_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_586b0cb1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CountersModelsParameters_vue__ = __webpack_require__("0xY2");
function injectStyle (ssrContext) {
  __webpack_require__("KTcP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CountersModelsParameters_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_586b0cb1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CountersModelsParameters_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "CrJE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tasks_vue__ = __webpack_require__("fuxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tasks_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tasks_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tasks_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tasks_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15278768_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tasks_vue__ = __webpack_require__("n1OQ");
function injectStyle (ssrContext) {
  __webpack_require__("ZNHz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tasks_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15278768_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tasks_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "CzMf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',_vm._l((_vm.value),function(item){return _c('v-treeview-item',{key:item.id,staticClass:"v-treeview-item",attrs:{"model":item,"tree-types":_vm.treeTypes,"open-all":_vm.openAll},on:{"selected":_vm.selected}})}),1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DEvj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _vueRouter = __webpack_require__("/ocq");

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _vueResource = __webpack_require__("8+8L");

var _vueResource2 = _interopRequireDefault(_vueResource);

var _veeValidate = __webpack_require__("sUu7");

var _veeValidate2 = _interopRequireDefault(_veeValidate);

var _ru = __webpack_require__("+/GF");

var _ru2 = _interopRequireDefault(_ru);

var _vueTreeHalower = __webpack_require__("lTSm");

var _vueTreeHalower2 = _interopRequireDefault(_vueTreeHalower);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

var _vueMoment = __webpack_require__("8AgW");

var _vueMoment2 = _interopRequireDefault(_vueMoment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (Vue) {
  for (var _len = arguments.length, params = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    params[_key - 1] = arguments[_key];
  }

  params.filter(function (el) {
    return (typeof el === 'undefined' ? 'undefined' : _typeof(el)) === 'object';
  }).map(function (le) {
    return Vue.use(le);
  });
  Vue.use(_vueRouter2.default);
  Vue.use(_veeValidate2.default);
  _veeValidate.Validator.localize('ru', _ru2.default);
  Vue.use(_vueResource2.default);
  Vue.use(_vueTreeHalower2.default);
  Vue.use(_vueMoment2.default);
  _axios2.default.interceptors.request.use(function (config) {
    var token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = 'JWT ' + token;
    }
    return config;
  }, function (err) {
    return Promise.reject(err);
  });
  Vue.http.interceptors.push(function (request, next) {
    request.headers.set('Authorization', 'JWT ' + localStorage.getItem('token'));
    request.headers.set('Accept', 'application/json');
    next();
  });
  Object.defineProperties(Vue.prototype, {
    axios: {
      get: function get() {
        return _axios2.default;
      }
    }
  });
};

/***/ }),

/***/ "DUuK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportTreeNode_vue__ = __webpack_require__("JzRs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportTreeNode_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportTreeNode_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportTreeNode_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportTreeNode_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45df0293_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportTreeNode_vue__ = __webpack_require__("w6HK");
function injectStyle (ssrContext) {
  __webpack_require__("Smar")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-45df0293"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportTreeNode_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45df0293_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportTreeNode_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "EHCw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'AccountSettings',
  data: function data() {
    return {
      loading: false,
      firstLoading: true,
      currentUser: {},
      account_data: {},
      isEdited: false
    };
  },

  watch: {
    account_data: {
      handler: function handler() {
        this.isEdited = true;
      },

      deep: true
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.axios.get('/api/users/me/').then(function (response) {
      _this.currentUser = response.data;
      _this.getDetails();
    }).catch(function (err) {
      console.log(err);
    });
  },

  methods: {
    getDetails: function getDetails() {
      var _this2 = this;

      this.axios.get('/api/account/' + this.currentUser.account_id + '/').then(function (response) {
        _this2.account_data = response.data;
        _this2.loading = false;
        setTimeout(function () {
          _this2.isEdited = false;
        }, 100);
      }).catch(function (err) {
        console.log(err);
        _this2.loading = false;
      });
    },
    save: function save() {
      var _this3 = this;

      this.axios.patch('/api/account/' + this.currentUser.account_id + '/', this.account_data).then(function (response) {
        _this3.account_data = response.data;
        setTimeout(function () {
          _this3.isEdited = false;
        }, 100);
        _this3.loading = false;
      }).catch(function (err) {
        console.log(err);
        _this3.loading = false;
      });
    },
    cancel: function cancel() {
      this.getDetails();
    }
  }
};

/***/ }),

/***/ "EIRp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ej32":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Toolbar_vue__ = __webpack_require__("RzfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Toolbar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Toolbar_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Toolbar_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Toolbar_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6956cc6d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Toolbar_vue__ = __webpack_require__("84cH");
function injectStyle (ssrContext) {
  __webpack_require__("Ihda")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6956cc6d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Toolbar_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6956cc6d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Toolbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "EsQq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _PointCounterInstallExisted = __webpack_require__("rkeX");

var _PointCounterInstallExisted2 = _interopRequireDefault(_PointCounterInstallExisted);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'PointCounterInstall',
  components: {
    PointCounterInstallExisted: _PointCounterInstallExisted2.default
  },
  props: {
    pointId: {}
  },
  data: function data() {
    return {
      inputRules: [function (v) {
        return !!v || 'Заполните это поле!';
      }],
      operDateMenu: false,
      operDateVal: null,
      operDate: null,
      counter_oper: {
        operation_date: null
      },
      isExistingCounterSelected: false,
      existingCounter: {},
      counter: {},
      existingCounterMenu: false,
      counterSteps: ['Модель', 'Параметры подключения', 'Параметры счётчика'],
      currentStep: 1,
      resourcesTypes: [],
      resourceTypeId: null,
      modelsGroups: [],
      modelGroupId: null,
      models: [],
      sourceParams: ['TCP', 'lorawandb'],
      sourceParam: {},
      dataParams: [],
      connectStatus: null
    };
  },

  computed: {
    visibleParams: function visibleParams() {
      var _this = this;

      return this.dataParams.filter(function (item) {
        return _this.sourceParam.value === 'TCP' ? item.param !== 'source' : item.param === 'net_address';
      });
    }
  },
  watch: {
    resourceTypeId: function resourceTypeId() {
      this.modelGroupId = null;
      this.models = [];
    },
    modelGroupId: function modelGroupId() {
      this.counter = {};
      this.existingCounter = {};
    },
    'counter.model_id': function counterModel_id(val) {
      this.counter = { model_id: val };
      this.existingCounter = { model_id: val };
    },
    isExistingCounterSelected: function isExistingCounterSelected(val) {
      this.counter = { model_id: this.counter.model_id };
      if (val) {
        this.counter = Object.assign({}, this.counter, this.existingCounter);
      }
    },
    operDateVal: function operDateVal() {
      this.operDate = this.formatDate(this.operDateVal);
      this.counter_oper.operation_date = this.operDateVal;
    }
  },
  mounted: function mounted() {
    var currentDate = new Date();
    this.operDateVal = this.parseDate(currentDate.getDate() + '/' + (currentDate.getMonth() + 1) + '/' + currentDate.getFullYear());
    this.counter_oper.point_id = this.pointId;
    this.getResourcesTypesApi();
  },

  methods: {
    getResourcesTypesApi: function getResourcesTypesApi() {
      var _this2 = this;

      this.axios.get('/api/resources_types/').then(function (response) {
        _this2.resourcesTypes = response.data.results;
      }).catch(function (err) {
        console.log(err);
      });
    },
    getModelsGroupsApi: function getModelsGroupsApi() {
      var _this3 = this;

      this.axios.get('/api/counters_api/?resource_type=' + this.resourceTypeId).then(function (response) {
        _this3.modelsGroups = response.data.results;
      }).catch(function (err) {
        console.log(err);
      });
    },
    getModelsApi: function getModelsApi() {
      var _this4 = this;

      this.axios.get('/api/counters_models/?counter_model_api=' + this.modelGroupId).then(function (response) {
        _this4.models = response.data.results;
      }).catch(function (err) {
        console.log(err);
      });
    },
    getConnectParameters: function getConnectParameters() {
      var _this5 = this;

      this.axios.get('/api/counters/' + this.modelGroupId + '/model_conn_params/').then(function (response) {
        _this5.dataParams = response.data;
        _this5.dataParams.map(function (param) {
          param.value = '';
        });
        _this5.sourceParam = { param: 'source', value: 'TCP' };
        _this5.dataParams.push(_this5.sourceParam);
      }).catch(function (err) {
        console.log(err);
      });
    },
    checkConnectParameters: function checkConnectParameters() {
      this.connectStatus = this.connectStatus === 'Удачно' ? 'Ошибка' : 'Удачно';
    },
    selectCounter: function selectCounter(counter) {
      this.existingCounter = Object.assign({}, this.existingCounter, {
        counter_id: counter.counter_id,
        coeff: counter.coeff,
        coeff_voltage: counter.coeff_voltage,
        serial_num: counter.serial_num
      });
      this.counter = Object.assign({}, this.counter, this.existingCounter);
      this.existingCounterMenu = false;
    },
    nextCounterStep: function nextCounterStep(nextMethod) {
      this.currentStep++;

      if (nextMethod) {
        this[nextMethod]();
      }
    },
    addCounter: function addCounter() {
      var _this6 = this;

      if (this.$refs.counterParamsForm.validate()) {
        var connectParameters = { conn_params: this.dataParams };
        var url = this.counter.counter_id ? '/api/counters/' + this.counter.counter_id + '/update_and_install/' : '/api/counters/create_and_install/';
        this.axios.post(url, Object.assign({}, this.counter, this.counter_oper, connectParameters)).then(function (response) {
          response.data.install_date = _this6.counter_oper.operation_date + ' 00:00:00';
          _this6.$emit('installed', response.data);
        }).catch(function (err) {
          _this6.$emit('installError', err.response.data);
        });
      }
    },
    formatDate: function formatDate(date) {
      if (!date) return null;

      var _date$split = date.split('-'),
          _date$split2 = _slicedToArray(_date$split, 3),
          year = _date$split2[0],
          month = _date$split2[1],
          day = _date$split2[2];

      return day + '/' + month + '/' + year;
    },
    parseDate: function parseDate(date) {
      if (!date) return null;

      var _date$split3 = date.split('/'),
          _date$split4 = _slicedToArray(_date$split3, 3),
          day = _date$split4[0],
          month = _date$split4[1],
          year = _date$split4[2];

      return year + '-' + month.padStart(2, '0') + '-' + day.padStart(2, '0');
    }
  }
};

/***/ }),

/***/ "FMTb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointEdit_vue__ = __webpack_require__("o1aI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointEdit_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointEdit_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointEdit_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointEdit_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2969584c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PointEdit_vue__ = __webpack_require__("r7VN");
function injectStyle (ssrContext) {
  __webpack_require__("jkHD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointEdit_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2969584c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PointEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Forj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GjPQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GoxP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'DocumentRequestDetails',
  components: {},
  props: {
    data: {}
  },
  mounted: function mounted() {
    var _this = this;

    this.localdata = this.data;
    this.getDocumentsStatusApi();
    this.axios.get('/api/users/me/').then(function (response) {
      _this.currentUser = response.data;
    }).catch(function (err) {
      console.log(err);
    });
  },
  data: function data() {
    return {
      files: [{
        doc_request_attach_doc_request: null,
        doc_request_attach_doc_required: null,
        doc_request_attach_file: null,
        doc_request_attach_id: null,
        doc_request_attach_status: null,
        file_name: null,
        required_doc_type_name: null,
        status_name: null
      }],
      closeFiles: [],
      loading: true,
      firstLoading: true,
      localdata: {},
      statuses: [],
      serverItemsLength: 0,
      editing: false,
      passwordChanging: false,
      getTimer: '',
      searchTimer: '',
      deleteTimer: '',
      fileStatuses: [{ id: 3, name: 'На рассмотрении', color: 'blue' }, { id: 1, name: 'Принят', color: 'green' }, { id: 2, name: 'Отклонен', color: 'red' }],
      fileReasonDialog: false,
      declineReasonDialog: false,
      decline_reason: '',
      sendReasonParams: {
        fileId: null,
        fileStatus: null,
        reason: null
      },
      currentUser: {},
      resultDocs: [],
      resultDocId: 0,
      agreeDialog: false,
      externalSendResult: '',
      fileLoading: false,
      expiredDate: new Date().toISOString().substr(0, 10),
      expiredDateMenu: false
    };
  },

  watch: {
    localdata: {
      handler: function handler() {
        this.externalSendResult = '';
        this.makeDocumentViewed();
        this.getFilesApi();
        this.getResultFilesApi();
      },

      deep: true
    }
  },
  methods: {
    getFilesApi: function getFilesApi() {
      var _this2 = this;

      this.loading = false;
      this.axios.get('/api/document_request_attachment/?document_id=' + this.localdata.doc_request_id).then(function (response) {
        _this2.files = response.data.results;
        _this2.files.forEach(function (file) {
          file.expandedPanel = undefined;
        });
        _this2.loading = false;
      }).catch(function (err) {
        console.log(err);
        _this2.loading = false;
      });
    },
    getResultFilesApi: function getResultFilesApi() {
      var _this3 = this;

      this.loading = false;
      this.axios.get('/api/document_close_file/?document_id=' + this.localdata.doc_request_id).then(function (response) {
        _this3.closeFiles = response.data.results;
        _this3.loading = false;
      }).catch(function (err) {
        console.log(err);
        _this3.loading = false;
      });
    },
    getDocumentsStatusApi: function getDocumentsStatusApi() {
      var _this4 = this;

      this.firstLoading = false;
      this.loading = false;
      this.axios.get('/api/document_status/').then(function (response) {
        _this4.statuses = response.data.results;
        _this4.loading = false;
      }).catch(function (err) {
        console.log(err);
        _this4.loading = false;
      });
    },
    changeStatusApi: function changeStatusApi(statusId) {
      this.data.status.id = statusId;
      this.axios.patch('/api/document_request/' + this.data.doc_request_id + '/', { doc_status: statusId }).then(function () {}).catch(function (err) {
        console.log(err);
      });
    },
    changeStatus: function changeStatus(status) {
      if (status.doc_status_id === 4) {
        this.showDecline();
      } else if (status.doc_status_id === 3) {
        this.resultDocId = 0;
        this.showAgreeDialog();
      } else {
        this.changeStatusApi(status.doc_status_id);
      }
    },
    close: function close() {
      this.$emit('close');
    },
    download: function download(file) {
      var _this5 = this;

      this.fileLoading = true;
      this.axios({
        url: '/api/download/' + file.file_name,
        method: 'GET',
        responseType: 'blob'
      }).then(function (response) {
        var blob = new Blob([response.data], { type: response.data.type });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        var contentDisposition = response.headers['content-disposition'];
        var fileName = file.file_name;
        if (contentDisposition) {
          var fileNameMatch = contentDisposition.match(/filename="(.+)"/);
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1];
          }
        }
        link.setAttribute('download', decodeURI(fileName));
        document.body.appendChild(link);
        link.click();
        link.remove();
        _this5.fileLoading = false;
      }).catch(function (err) {
        console.log(err);
        _this5.fileLoading = false;
      });
    },
    getStatusColor: function getStatusColor(statusId) {
      if (statusId === 2) {
        return 'orange';
      } else if (statusId === 3) {
        return 'green';
      } else if (statusId === 4) {
        return 'red';
      }
    },
    changeFileStatusApi: function changeFileStatusApi(file, fileStatus) {
      this.axios.patch('/api/document_request_attachment/' + file.doc_request_attach_id + '/', { doc_request_attach_status: fileStatus.id }).then(function () {}).catch(function (err) {
        console.log(err);
      });
    },
    showFileReasonDialog: function showFileReasonDialog(file, fileStatus) {
      this.fileReasonDialog = true;
      this.sendReasonParams.file = file;
      this.sendReasonParams.fileStatus = fileStatus;
      this.sendReasonParams.reason = '';
    },
    changeFileStatus: function changeFileStatus(file, fileStatus) {
      if (fileStatus.id === 2) {
        this.showFileReasonDialog(file, fileStatus);
      } else {
        this.changeFileStatusApi(file, fileStatus);
      }
    },
    sendErrorReason: function sendErrorReason() {
      this.changeFileStatusApi(this.sendReasonParams.file, this.sendReasonParams.fileStatus);
      this.sendComment(this.sendReasonParams.file, this.sendReasonParams.reason);
      this.fileReasonDialog = false;
    },
    sendErrorReasonCancel: function sendErrorReasonCancel() {
      this.sendReasonParams.fileStatus = 3;
      this.fileReasonDialog = false;
    },
    showDecline: function showDecline() {
      this.declineReasonDialog = true;
    },
    sendDeclineReason: function sendDeclineReason() {
      var _this6 = this;

      this.declineReasonDialog = false;
      this.axios.patch('/api/document_request/' + this.data.doc_request_id + '/', { doc_status: 4, decline_reason: this.decline_reason }).then(function () {
        _this6.close();
      }).catch(function (err) {
        console.log(err);
      });
    },
    sendDeclineReasonCancel: function sendDeclineReasonCancel() {
      this.declineReasonDialog = false;
      this.decline_reason = '';
      this.data.doc_status = 2;
    },
    sendComment: function sendComment(file, comment) {
      var _this7 = this;

      this.axios.post('/api/document_request_attachment_comment/', { doc_attachment: file.doc_request_attach_id,
        doc_request_id: this.data.doc_request_id,
        doc_attachment_comment: comment
      }).then(function () {
        file.newComment = '';
        _this7.getFilesApi();
      }).catch(function (err) {
        console.log(err);
      });
    },
    makeDocumentViewed: function makeDocumentViewed() {
      var _this8 = this;

      this.axios.post('/api/document_request/' + this.data.doc_request_id + '/viewed/').then(function () {
        _this8.localdata.new_files = 0;
      }).catch(function (err) {
        console.log(err);
      });
    },
    makeViewed: function makeViewed(file) {
      this.axios.post('/api/document_request_attachment/' + file.doc_request_attach_id + '/viewed/').then(function () {
        file.comments_user_unviewed = 0;
      }).catch(function (err) {
        console.log(err);
      });
    },
    showAgreeDialog: function showAgreeDialog() {
      this.agreeDialog = true;
    },
    addResultDoc: function addResultDoc() {
      this.resultDocId += 1;
      this.resultDocs.push({
        id: this.resultDocId,
        file: null,
        docName: 'Документ',
        doc_required_file_id: '24'
      });
    },
    sendAgreeCancel: function sendAgreeCancel() {
      this.agreeDialog = false;
      this.resultDocs = [];
      this.resultDocId = 0;
    },
    sendAgree: function sendAgree() {
      var _this9 = this;

      if (this.resultDocs) {
        var formData = new FormData();
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = this.resultDocs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var docFile = _step.value;

            if (docFile.file) {
              formData.append('files', docFile.file, docFile.file.name + '$' + docFile.doc_required_file_id);
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        formData.append('doc_request_id', this.data.doc_request_id);

        this.axios.post('/api/document_close_file/', formData).then(function (response) {
          _this9.changeStatusApi(3);
          _this9.sendAgreeCancel();
          _this9.close();
        }).catch(function (error) {
          console.log(error);
        });
      } else {
        console.log('there are no files.');
      }
    },
    assignOnMe: function assignOnMe() {
      var _this10 = this;

      this.axios.patch('/api/document_request/' + this.data.doc_request_id + '/', { assigned_user_id: this.currentUser.user_id }).then(function () {
        _this10.data.assigned_user = _this10.currentUser;
      }).catch(function (err) {
        console.log(err);
      });
    },
    sendToExternal: function sendToExternal() {
      var _this11 = this;

      this.axios.post('/api/document_request/' + this.data.doc_request_id + '/send_to_external/').then(function (respose) {
        _this11.externalSendResult = 'Заявка успешно отправлена';
      }).catch(function (err) {
        _this11.externalSendResult = 'Произошла ошибка при отправке';
        console.log(err);
      });
    },
    saveExpiredDate: function saveExpiredDate() {
      this.$refs.expiredDateMenu.save(this.expiredDate);
      this.axios.patch('/api/document_request/' + this.data.doc_request_id + '/', { expired_date: this.data.expired_date }).catch(function (err) {
        console.log(err);
      });
    },
    getMessageAlign: function getMessageAlign(message) {
      if (message.created_by === this.currentUser.user_id) {
        return 'end';
      } else {
        return 'start';
      }
    },
    getMessageColor: function getMessageColor(message) {
      if (message.created_by === this.currentUser.user_id) {
        return 'blue lighten-5';
      }
    }
  }
};

/***/ }),

/***/ "GqrD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Hd3+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__("KSHM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31f78e76_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__("xvwV");
function injectStyle (ssrContext) {
  __webpack_require__("WMuv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31f78e76_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Hj5u":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ChangePassword',
  props: {
    userData: {}
  },
  data: function data() {
    var _this = this;

    return {
      user: {},
      showPassword1: false,
      showPassword2: false,
      showPassword3: false,
      autherror: '',
      currentPassword: '',
      newPassword: '',
      rules: {
        required: function required(value) {
          return !!value || 'Обязательно для заполнения.';
        },
        min: function min(v) {
          return v != null && v.length >= 8 || 'Минимальная длинна 8 символов';
        },
        passwordMatch: function passwordMatch(v) {
          return v === _this.newPassword || 'Пароли должны совпадать';
        }
      }
    };
  },

  watch: {
    currentPassword: function currentPassword() {
      this.autherror = '';
    }
  },
  mounted: function mounted() {
    this.user = this.userData;
  },

  methods: {
    cancelEditing: function cancelEditing() {
      this.$emit('cancel');
    },
    validate: function validate() {
      if (this.$refs.passwordChangeForm.validate()) {
        return true;
      }
    },
    saveChanges: function saveChanges() {
      var _this2 = this;

      if (this.validate()) {
        _axios2.default.post('/api/api-token-auth/', {
          username: this.user.username,
          password: this.currentPassword
        }).then(function (response) {
          _this2.user.password = _this2.newPassword;
          _this2.axios.patch('/api/users/' + _this2.userData.user_id + '/', _this2.user).then(function () {
            _this2.$emit('edited');
          }).catch(function (err) {
            _this2.$emit('editError', err.response.data);
          });
        }).catch(function () {
          _this2.autherror = 'Неверный пароль';
        });
      }
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "I4v2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.formActive)?_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Новая точка учета")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-form',{ref:"form"},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"md12":"","sm12":"","xs12":""}},[_c('v-text-field',{attrs:{"rules":_vm.pointAddRules,"label":"Наименование","required":""},model:{value:(_vm.editedItem.name),callback:function ($$v) {_vm.$set(_vm.editedItem, "name", $$v)},expression:"editedItem.name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md12":"","sm12":"","xs12":""}},[_c('v-text-field',{attrs:{"rules":_vm.pointAddRules,"label":"Идентификатор Точки учёта","required":""},model:{value:(_vm.editedItem.point_number),callback:function ($$v) {_vm.$set(_vm.editedItem, "point_number", $$v)},expression:"editedItem.point_number"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md12":"","sm12":"","xs12":""}},[_c('v-autocomplete',{attrs:{"items":_vm.customers,"menu-props":{maxHeight:'auto'},"item-text":"name","item-value":"customer_id","label":"Абонент","no-data-text":"Нет доступных абонентов"},model:{value:(_vm.editedItem.customer_id),callback:function ($$v) {_vm.$set(_vm.editedItem, "customer_id", $$v)},expression:"editedItem.customer_id"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md12":"","sm12":"","xs12":""}},[_c('v-text-field',{attrs:{"rules":_vm.pointAddRules,"label":"Адрес","required":""},model:{value:(_vm.editedItem.address),callback:function ($$v) {_vm.$set(_vm.editedItem, "address", $$v)},expression:"editedItem.address"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md12":"","sm12":"","xs12":""}},[_c('v-text-field',{attrs:{"label":"Примечание"},model:{value:(_vm.editedItem.remark),callback:function ($$v) {_vm.$set(_vm.editedItem, "remark", $$v)},expression:"editedItem.remark"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","text":""},nativeOn:{"click":function($event){return _vm.save($event)}}},[_vm._v("\n        Сохранить\n      ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","text":""},nativeOn:{"click":function($event){return _vm.close($event)}}},[_vm._v("\n        Отмена\n      ")])],1)],1):(_vm.loading)?_c('v-layout',{staticClass:"loading-indicator",attrs:{"align-center":"","justify-center":""}},[_c('v-progress-circular',{attrs:{"size":70,"width":7,"indeterminate":""}})],1):_vm._e(),_vm._v(" "),_c('v-card',{directives:[{name:"show",rawName:"v-show",value:(!_vm.formActive && !_vm.firstLoading),expression:"!formActive && !firstLoading"}],staticClass:"points-card"},[_c('v-card-title',[_c('v-text-field',{attrs:{"append-icon":"search","hide-details":"","label":"Поиск по наименованию и идентификатору ТУ","single-line":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","fab":"","title":"Добавить точку учёта"},on:{"click":_vm.addPoint}},[_c('v-icon',[_vm._v("add")])],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"footer-props":{
        itemsPerPageText: 'Число ТУ на странице',
        itemsPerPageOptions: [25, 50]
      },"headers":_vm.headers,"items":_vm.items,"options":_vm.options,"server-items-length":_vm.serverItemsLength,"dense":"","fixed-header":"","no-data-text":"Нет точек учёта для отображения"},on:{"update:options":function($event){_vm.options=$event}},scopedSlots:_vm._u([{key:"item",fn:function(props){return _c('tr',{},[_c('td',[_vm._v(_vm._s(props.item.name))]),_vm._v(" "),_c('td',[(!props.item.counter_id)?_c('v-icon',{attrs:{"color":"red","title":"Счётчик не установлен"}},[_vm._v("\n            fas fa-ban\n          ")]):_vm._e()],1),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[(props.item.represents != null)?_c('v-tooltip',{attrs:{"left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
      var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"color":"teal","fab":"","outlined":"","x-small":""}},on),[_vm._v("\n                "+_vm._s(props.item.represents.length)+"\n              ")])]}}],null,true)},[_vm._v(" "),_vm._l((props.item.represents),function(represent){return _c('div',{key:represent.represent_id},[_vm._v("\n              Объект "+_vm._s(represent.name)+"\n            ")])})],2):_c('v-btn',{attrs:{"color":"teal","fab":"","outlined":"","x-small":""}},[_vm._v("\n            0\n          ")])],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.point_number))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.customer ? props.item.customer.name : ''))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.address))]),_vm._v(" "),_c('td',{staticClass:"justify-center"},[_c('span',{staticClass:"action-btns"},[_c('v-btn',{attrs:{"to":("/points/" + (props.item.point_id) + "/edit"),"icon":"","title":"Редактировать"}},[_c('v-icon',{attrs:{"color":"grey"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{attrs:{"to":("/points/" + (props.item.point_id) + "/counters"),"icon":"","title":"Счетчики"}},[_c('v-icon',{attrs:{"color":"grey"}},[_vm._v("fas fa-tachometer-alt")])],1),_vm._v(" "),_c('v-btn',{attrs:{"to":("/points/" + (props.item.point_id) + "/scheduler"),"icon":"","title":"Расписание"}},[_c('v-icon',{attrs:{"color":"grey"}},[_vm._v("fas fa-clock")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","title":"Удалить"},on:{"click":function($event){return _vm.deleteItem(props.item)}}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("delete")])],1)],1)])])}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ihda":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Iwpa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocumentsRequestsTypeDetails_vue__ = __webpack_require__("5JLS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocumentsRequestsTypeDetails_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocumentsRequestsTypeDetails_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocumentsRequestsTypeDetails_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocumentsRequestsTypeDetails_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fc6d236_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DocumentsRequestsTypeDetails_vue__ = __webpack_require__("PtC2");
function injectStyle (ssrContext) {
  __webpack_require__("OXwQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0fc6d236"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocumentsRequestsTypeDetails_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fc6d236_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DocumentsRequestsTypeDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "IzUI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VTreeview_vue__ = __webpack_require__("pK6Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VTreeview_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VTreeview_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VTreeview_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VTreeview_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9ad3b3e4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VTreeview_vue__ = __webpack_require__("CzMf");
function injectStyle (ssrContext) {
  __webpack_require__("ej/o")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9ad3b3e4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VTreeview_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9ad3b3e4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VTreeview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "J6Rp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('point-toolbar',{attrs:{"point-info":_vm.point.name}}),_vm._v(" "),(_vm.addTask)?_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.taskDialogTitle))])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-flex',[_c('v-row',[_c('v-col',{staticClass:"mt-3",attrs:{"cols":"2"}},[_vm._v("Частота выполнения")]),_vm._v(" "),_c('v-col',{attrs:{"cols":"10"}},[_c('v-chip-group',{attrs:{"active-class":"primary--text"},model:{value:(_vm.cronVal),callback:function ($$v) {_vm.cronVal=$$v},expression:"cronVal"}},_vm._l((_vm.intervals),function(interval){return _c('v-chip',{key:interval.value,attrs:{"value":interval.value}},[_vm._v("\n                  "+_vm._s(interval.text)+"\n                ")])}),1)],1)],1)],1),_vm._v(" "),_c('v-form',{ref:"scheduleForm"},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-combobox',{attrs:{"items":_vm.taskGroups,"item-text":"name","item-value":"group_id","label":"Группа параметров","chips":true,"multiple":""},model:{value:(_vm.tmpTaskGroups),callback:function ($$v) {_vm.tmpTaskGroups=$$v},expression:"tmpTaskGroups"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-combobox',{attrs:{"items":_vm.counterParameters,"item-text":"name","item-value":"model_parameter_id","label":"Собираемые параметры","chips":true,"multiple":"","disabled":""},model:{value:(_vm.tmpParameters),callback:function ($$v) {_vm.tmpParameters=$$v},expression:"tmpParameters"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',[_c('v-flex',[_c('v-autocomplete',{attrs:{"items":_vm.dataCollectingServers,"label":"Сервер сбора данных","item-text":"server_name","item-value":"data_collecting_sever_id","menu-props":{maxHeight:'auto'},"rules":_vm.inputRules},model:{value:(_vm.editedTaskItem.data_collecting_server_id),callback:function ($$v) {_vm.$set(_vm.editedTaskItem, "data_collecting_server_id", $$v)},expression:"editedTaskItem.data_collecting_server_id"}})],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","text":""},nativeOn:{"click":function($event){return _vm.saveCounterTask()}}},[_vm._v("Сохранить")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","text":""},nativeOn:{"click":function($event){return _vm.closeTasksDialog()}}},[_vm._v("Отмена")])],1)],1):(_vm.tasksLoading)?_c('v-layout',{staticClass:"loading-indicator",attrs:{"justify-center":"","align-center":""}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":70,"width":7}})],1):_c('v-card',{staticClass:"point-sheduler-card"},[(_vm.point.counter_id)?_c('v-btn',{staticClass:"add-scheduler-button",attrs:{"fab":"","color":"primary"},nativeOn:{"click":function($event){return _vm.addCounterTask()}}},[_c('v-icon',[_vm._v("add")])],1):_vm._e(),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.counterTasksHeaders,"items":_vm.counterTasks,"fixed-header":"","hide-default-footer":"","dense":""},scopedSlots:_vm._u([{key:"item",fn:function(props){return _c('tr',{},[_c('td',[_vm._v("\n          "+_vm._s(props.item.counter_num)+"\n        ")]),_vm._v(" "),_c('td',[_c('span',{staticClass:"action-btns"},[(props.item.state === 'working')?_c('span',[_c('v-btn',{staticClass:"mt-1",attrs:{"icon":"","title":"Остановить выполнение расписания"},on:{"click":function($event){return _vm.stopTasks(props.item)}}},[_c('v-icon',{attrs:{"color":"red darken-1"}},[_vm._v("stop")])],1)],1):_c('span',[_c('v-btn',{staticClass:"mt-1",attrs:{"icon":"","title":"Запустить выполенение расписания"},on:{"click":function($event){return _vm.startTasks(props.item)}}},[(props.item.state === 'stopped')?_c('v-icon',{attrs:{"color":"green darken-1"}},[_vm._v("play_arrow")]):_c('v-icon',{attrs:{"color":"yellow darken-1"}},[_vm._v("pause")])],1)],1)])]),_vm._v(" "),_c('td',{staticClass:"px-0"},[_c('span',{staticClass:"action-btns"},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":"","title":"Редактирование расписание опроса прибора учета"},on:{"click":function($event){return _vm.editCounterTask(props.item)}}},[_c('v-icon',{attrs:{"color":"grey darken-1"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":"","title":"Удаление расписания опроса прибора учета"},on:{"click":function($event){return _vm.deleteCounterTask(props.item)}}},[_c('v-icon',{attrs:{"color":"grey darken-1"}},[_vm._v("delete")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":"","title":"Лог опроса прибора учета"},on:{"click":function($event){return _vm.viewCounterTaskLog(props.item)}}},[_c('v-icon',{attrs:{"color":"grey darken-1"}},[_vm._v("fas fa-file-alt")])],1)],1)])])}}])})],1),_vm._v(" "),_c('v-bottom-sheet',{model:{value:(_vm.showLog),callback:function ($$v) {_vm.showLog=$$v},expression:"showLog"}},[_c('task-logs',{attrs:{"task":_vm.selectedTask}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JSGx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JYOR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_c('div',{staticClass:"headline"},[_vm._v("\n      Сменить пароль пользователя "+_vm._s(_vm.user.username)+"\n    ")])]),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"passwordChangeForm"},[_c('v-container',[_c('v-row',[_c('v-text-field',{attrs:{"append-icon":_vm.showPassword1 ? 'visibility' : 'visibility_off',"type":_vm.showPassword1 ? 'text' : 'password',"label":"Текущий пароль","error-messages":_vm.autherror},on:{"click:append":function($event){_vm.showPassword1 = !_vm.showPassword1}},model:{value:(_vm.currentPassword),callback:function ($$v) {_vm.currentPassword=$$v},expression:"currentPassword"}})],1),_vm._v(" "),_c('v-row',[_c('v-text-field',{attrs:{"append-icon":_vm.showPassword2 ? 'visibility' : 'visibility_off',"rules":[_vm.rules.required, _vm.rules.min],"type":_vm.showPassword2 ? 'text' : 'password',"label":"Новый пароль"},on:{"click:append":function($event){_vm.showPassword2 = !_vm.showPassword2}},model:{value:(_vm.newPassword),callback:function ($$v) {_vm.newPassword=$$v},expression:"newPassword"}})],1),_vm._v(" "),_c('v-row',[_c('v-text-field',{attrs:{"append-icon":_vm.showPassword3 ? 'visibility' : 'visibility_off',"rules":[_vm.rules.required, _vm.rules.passwordMatch],"type":_vm.showPassword3 ? 'text' : 'password',"label":"Повторите пароль"},on:{"click:append":function($event){_vm.showPassword3 = !_vm.showPassword3}}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","text":""},nativeOn:{"click":function($event){return _vm.saveChanges($event)}}},[_vm._v("\n      Сохранить\n    ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","text":""},nativeOn:{"click":function($event){return _vm.cancelEditing($event)}}},[_vm._v("\n      Отмена\n    ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JzRs":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'ReportTreeNode',
  props: ['isRoot', 'initialRepresents', 'initialAllPoints', 'representPoints', 'representsSelectType', 'pointsSelectType', 'limitSelectedPoints'],
  data: function data() {
    return {
      represents: [],
      allPoints: []
    };
  },
  mounted: function mounted() {
    if (this.isRoot) {
      this.getRepresentsApi();
    } else {
      var _represents;

      (_represents = this.represents).push.apply(_represents, _toConsumableArray(this.initialRepresents));
      this.allPoints = this.initialAllPoints;
    }
  },

  methods: {
    getRepresentsApi: function getRepresentsApi() {
      var _this = this;

      _axios2.default.get('/api/represents/all/').then(function (response) {
        var represents = [];
        response.data.results.map(function (represent) {
          represents.push({
            'id': represent.represent_id,
            'parent_id': represent.parent_id,
            'name': represent.name,
            'status': 'initial',
            'is_selected': false,
            'children': [],
            'points': []
          });
        });
        _this.representsTreeFilling(null, represents);
      }).catch(function (err) {
        console.log(err);
      });
    },
    representsTreeFilling: function representsTreeFilling(parent, represents) {
      var _this2 = this;

      var children = represents.filter(function (represent) {
        return represent.parent_id === (parent ? parent.id : null);
      });
      children.map(function (child) {
        _this2.representsTreeFilling(child, represents);
      });
      if (parent) {
        var _parent$children;

        (_parent$children = parent.children).push.apply(_parent$children, _toConsumableArray(children));
      } else {
        var _represents2;

        (_represents2 = this.represents).push.apply(_represents2, _toConsumableArray(children));
      }
    },
    getRepresentPointsApi: function getRepresentPointsApi(represent) {
      var _this3 = this;

      _axios2.default.get('/api/represents/' + represent.id + '/points/').then(function (response) {
        response.data.map(function (point) {
          if (!_this3.allPoints[point.point_id]) {
            _this3.allPoints[point.point_id] = {
              'id': point.point_id,
              'name': point.name,
              'is_selected': false
            };
          }
          represent.points.push(_this3.allPoints[point.point_id]);
        });
        if (represent.is_selected) {
          represent.points.map(function (point) {
            point.is_selected = true;
            _this3.$emit('point-select', point);
          });
        }
        if (represent.children.length || represent.points.length) {
          represent.status = 'expanded';
        } else {
          represent.is_selected = false;
          represent.status = 'empty';
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    reprExpand: function reprExpand(represent) {
      if (represent.status === 'initial') {
        represent.status = 'loading';
        this.getRepresentPointsApi(represent);
        if (represent.is_selected) {
          this.$emit('selected-repr-expand', represent);
        }
      } else if (represent.status === 'minimized') {
        represent.status = 'expanded';
      } else if (represent.status === 'expanded') {
        represent.status = 'minimized';
      }
    }
  }
};

/***/ }),

/***/ "KSHM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
//
//
//
//
//
//


/***/ }),

/***/ "KTcP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KeRq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'CounterNew',
  data: function data() {
    return {
      inputRules: [function (v) {
        return !!v || 'Заполните это поле!';
      }],
      counter: {
        'serial_num': ''
      },
      counters_models: []
    };
  },
  mounted: function mounted() {
    this.getCountersModels();
  },

  methods: {
    cancelAdding: function cancelAdding() {
      this.$emit('cancel');
    },
    getCountersModels: function getCountersModels() {
      var _this = this;

      this.axios.get('/api/counters_models/').then(function (response) {
        _this.counters_models = response.data.results;
      }).catch(function (err) {
        console.log(err);
      });
    },
    addCounter: function addCounter() {
      var _this2 = this;

      if (this.validate()) {
        this.axios.post('/api/counters/', this.counter).then(function () {
          _this2.$emit('added');
        }).catch(function (err) {
          console.log(err);
        });
      }
    },
    validate: function validate() {
      if (this.$refs.addCounterForm.validate()) {
        return true;
      }
    }
  }
};

/***/ }),

/***/ "KllK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointProfile_vue__ = __webpack_require__("7hPC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointProfile_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointProfile_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointProfile_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointProfile_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d9ef9bf_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PointProfile_vue__ = __webpack_require__("uUv6");
function injectStyle (ssrContext) {
  __webpack_require__("kfwl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7d9ef9bf"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointProfile_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d9ef9bf_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PointProfile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Ldyo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'VTreeviewItem',
  props: ['model', 'treeTypes', 'openAll'],
  data: function data() {
    return {
      open: false,
      checked: this.$route.params.representId,
      createSubRepresent: false
    };
  },

  computed: {
    isFolder: function isFolder() {
      return this.model.children && this.model.children.length;
    }
  },
  created: function created() {
    var _this = this;

    this.open = this.model.children.some(function (x) {
      return x.represent_id === parseInt(_this.checked);
    });
  },

  watch: {
    openAll: function openAll(_openAll) {
      this.open = _openAll;
    },
    '$route': function $route(to, from) {
      this.checked = this.$route.params.representId;
    }
  },
  methods: {
    selected: function selected(node) {
      var _this2 = this;

      if (!this.createSubRepresent) {
        this.$emit('selected', node);
      } else {
        setTimeout(function () {
          _this2.createSubRepresent = false;
        }, 100);
      }
    },
    addNode: function addNode(newNode) {
      this.model.children.push(newNode);
    },
    toggle: function toggle() {
      if (this.isFolder) {
        this.open = !this.open;
      }
    },
    changePath: function changePath() {
      this.selected(this);
    }
  }
};

/***/ }),

/***/ "LiKw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LyXq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CountersModelsAPI_vue__ = __webpack_require__("o7gN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CountersModelsAPI_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CountersModelsAPI_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CountersModelsAPI_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CountersModelsAPI_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b029a670_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CountersModelsAPI_vue__ = __webpack_require__("zhaU");
function injectStyle (ssrContext) {
  __webpack_require__("vXv8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CountersModelsAPI_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b029a670_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CountersModelsAPI_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d3a5dfdc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("lZQK");
function injectStyle (ssrContext) {
  __webpack_require__("0mug")
  __webpack_require__("GqrD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d3a5dfdc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d3a5dfdc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "NDR4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var API_URL = 'data_sources'; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'DataSource',
  data: function data() {
    return {
      inputRules: [function (v) {
        return !!v || 'Заполните это поле!';
      }],
      search: '',
      totalItems: 0,
      items: [],
      loading: true,
      addSources: false,
      apiErrors: {},
      headers: [{
        text: 'Наименование',
        align: 'left',
        sortable: true,
        value: 'name'
      }, { text: 'Замечание', value: 'remark' }, { text: '', value: '' }],
      editedIndex: -1,
      editedItem: {
        source_id: '',
        name: '',
        remark: ''
      },
      defaultItem: {
        name: '',
        remark: ''
      }
    };
  },


  computed: {
    pointFormTitle: function pointFormTitle() {
      return this.editedIndex === -1 ? 'Новый источник данных' : 'Редактирование источника данных';
    }
  },
  watch: {
    dialog: function dialog(val) {
      val || this.close();
    }
  },

  mounted: function mounted() {
    this.getItemsApi();
  },

  methods: {
    getItemsApi: function getItemsApi() {
      var _this = this;

      this.loading = true;
      _axios2.default.get('/api/' + API_URL + '/?page_size=all').then(function (response) {
        _this.items = response.data.results;
        _this.loading = false;
      }).catch(function (err) {
        _this.loading = false;
        console.log(err);
      });
    },
    addItemApi: function addItemApi() {
      var _this2 = this;

      this.loading = true;
      _axios2.default.post('/api/' + API_URL + '/', this.editedItem).then(function (response) {
        _this2.loading = false;
        _this2.items.push(response.body);
        _this2.close();
      }).catch(function (err) {
        _this2.loading = false;
        console.log(err);

        // for (const errorInfo of err.body.errors) {
        //   if (errorInfo.field in this.$refs) {
        //     this.$refs[errorInfo.field].errorMessages = errorInfo.message
        //   }
        // }
        console.log(_this2.apiErrors);
      });
    },
    updateItemApi: function updateItemApi() {
      var _this3 = this;

      this.loading = true;
      var id = this.editedItem.source_id;
      _axios2.default.put('/api/' + API_URL + '/' + id + '/', this.editedItem).then(function (response) {
        _this3.loading = false;
        Object.assign(_this3.items[_this3.editedIndex], _this3.editedItem);
        _this3.close();
      }).catch(function (err) {
        _this3.loading = false;
        console.log(err);
      });
    },
    deleteItemApi: function deleteItemApi(item) {
      var _this4 = this;

      var id = item.source_id;
      this.loading = true;
      _axios2.default.delete('/api/' + API_URL + '/' + id).then(function (response) {
        _this4.loading = false;
        var index = _this4.items.indexOf(item);
        _this4.items.splice(index, 1);
      }).catch(function (err) {
        _this4.loading = false;
        console.log(err);
      });
    },
    editItem: function editItem(item) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.addSources = true;
    },
    deleteItem: function deleteItem(item) {
      if (confirm('Вы действительно хотите удалить эту строку?')) {
        this.deleteItemApi(item);
      }
    },
    close: function close() {
      var _this5 = this;

      this.apiErrors = [];
      setTimeout(function () {
        _this5.editedItem = Object.assign({}, _this5.defaultItem);
        _this5.editedIndex = -1;
      }, 300);
      this.addSources = false;
    },
    validate: function validate() {
      if (this.$refs.dataSourcesForm.validate()) {
        return true;
      }
    },
    save: function save() {
      if (this.validate()) {
        if (this.editedIndex > -1) {
          this.updateItemApi();
        } else {
          this.addItemApi();
        }
        this.addSources = false;
      }
    }
  }
};

/***/ }),

/***/ "NHnr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__("NYxO");

var _vuex2 = _interopRequireDefault(_vuex);

var _vueRouter = __webpack_require__("/ocq");

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _veeValidate = __webpack_require__("sUu7");

var _vuexRouterSync = __webpack_require__("9JMe");

var _plugins = __webpack_require__("DEvj");

var _plugins2 = _interopRequireDefault(_plugins);

var _directives = __webpack_require__("oetc");

var _directives2 = _interopRequireDefault(_directives);

var _validations = __webpack_require__("aGFK");

var _validations2 = _interopRequireDefault(_validations);

var _router = __webpack_require__("OFFm");

var _router2 = _interopRequireDefault(_router);

var _store = __webpack_require__("YtJ0");

var _store2 = _interopRequireDefault(_store);

var _vuetify = __webpack_require__("8kY9");

var _vuetify2 = _interopRequireDefault(_vuetify);

var _App = __webpack_require__("M93x");

var _App2 = _interopRequireDefault(_App);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Import of configuration / creation code created.
(0, _plugins2.default)(_vue2.default, _vuex2.default, _vueRouter2.default); // The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

(0, _directives2.default)(_vue2.default);
// theme(Vue)
(0, _validations2.default)(_veeValidate.Validator);

var store = new _vuex2.default.Store(_store2.default);
var router = (0, _router2.default)(_vueRouter2.default);

// Synchronization between routes and vuex.
// Ensures store status on all SPA pages.
(0, _vuexRouterSync.sync)(store, router);

// Importing the root component where the app will be rendered.
// eslint-disable-line

// Redirect to login page if token is not saved
router.beforeEach(function (to, from, next) {
  if (!store.state.isLogged && !(to.path === '/login')) {
    next('/login');
  }
  return next();
});

new _vue2.default({ // eslint-disable-line no-new
  vuetify: _vuetify2.default,
  router: router,
  store: store,
  el: '#app',
  components: { App: _App2.default },
  template: '<App/>'
});

/***/ }),

/***/ "Nftu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"full-height",attrs:{"id":"representToolbar"}},[_c('v-dialog',{attrs:{"width":"1100px"},model:{value:(_vm.showCounterParametersData),callback:function ($$v) {_vm.showCounterParametersData=$$v},expression:"showCounterParametersData"}},[(_vm.showCounterParametersData)?_c('counter-parameters-data',{attrs:{"is-open":_vm.showCounterParametersData,"counter-id":_vm.infoCounterId},on:{"close":_vm.closeCounterParametersData}}):_vm._e()],1),_vm._v(" "),(
        _vm.representIsLoading ||
        _vm.pointsDataLoading ||
        _vm.pointsDataLoading ||
        _vm.pointsCountersValuesDataLoading ||
        _vm.loadingRepresentAvailablePoints
      )?_c('v-layout',{staticClass:"loading-indicator",attrs:{"justify-center":"","align-center":""}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":70,"width":7}})],1):_c('v-flex',{attrs:{"d-flex":"","xs12":""}},[_c('v-card',{staticClass:"flex-grow-1",attrs:{"flat":""}},[_c('v-card-text',{staticClass:"represents-page"},[_c('v-tabs',{attrs:{"grow":"","active-class":"tab-active-class","icons-and-text":""},model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},[(_vm.representPoints.length > 0)?_c('v-tab',{attrs:{"href":"#rep-tab-chart"}},[_vm._v("\n              График\n              "),_c('v-icon',{staticClass:"chart-tab"},[_vm._v("mdi-chart-bar")])],1):_vm._e(),_vm._v(" "),(_vm.representPoints.length > 0)?_c('v-tab',{attrs:{"href":"#rep-tab-table"}},[_vm._v("\n              Таблица\n              "),_c('v-icon',{staticClass:"table-tab"},[_vm._v("mdi-table")])],1):_vm._e(),_vm._v(" "),(_vm.representPoints.length > 0)?_c('v-tab',{attrs:{"href":"#rep-tab-cnt-val-table"}},[_vm._v("\n              Показания счетчиков\n              "),_c('v-icon',{staticClass:"cnt-val-table-tab"},[_vm._v("mdi-counter")])],1):_vm._e(),_vm._v(" "),_c('v-tab',{attrs:{"href":"#rep-tab-config"}},[_vm._v("\n              Настройка\n              "),_c('v-icon',{staticClass:"config-tab"},[_vm._v("mdi-settings")])],1),_vm._v(" "),_c('v-tab',{attrs:{"href":"#rep-tab-points"}},[_vm._v("\n              Точки учёта\n              "),_c('v-icon',{staticClass:"point-tab"},[_vm._v("play_for_work")])],1)],1),_vm._v(" "),_c('v-tabs-items',{model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},[_c('v-tab-item',{attrs:{"value":"rep-tab-chart"}},[_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","pt-2":""}},[(!_vm.pointsDataLoading)?_c('line-chart',{ref:"pointsDataChart",attrs:{"chart-datasets":_vm.pointsDatasets,"chart-labels":_vm.pointsDataLabels}}):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-tab-item',{staticClass:"represent-table-tab",attrs:{"value":"rep-tab-table"}},[_c('v-layout',{staticClass:"mb-3",attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticClass:"text-center"},[_c('v-btn',{staticClass:"ma-2",attrs:{"rounded":"","color":"primary","href":_vm.pointsProfileCsvUrl}},[_vm._v("\n                      Экспорт\n                    ")])],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-data-table',{style:(_vm.opacityLoadTable),attrs:{"headers":_vm.pointsDataHeaders,"items":_vm.pointsData,"loading":_vm.pointsDataLoading,"hide-default-header":"","hide-default-footer":"","disable-pagination":"","fixed-header":"","dense":""},scopedSlots:_vm._u([{key:"header",fn:function(ref){
      var headers = ref.props.headers;
return [_c('thead',[_c('tr',_vm._l((headers),function(header){return _c('th',{staticClass:"text-end"},[(header.sign != undefined)?_c('v-icon',{attrs:{"color":"teal"}},[_vm._v(_vm._s(header.sign == 1 ? 'add_box' :
                              header.sign == -1 ? 'indeterminate_check_box' :
                              'exposure'))]):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(header.text))])],1)}),0)])]}},{key:"item",fn:function(ref){
                              var item = ref.item;
                              var headers = ref.headers;
return [_c('tr',[_c('td',{staticClass:"nwrp width-150 text-end"},[_vm._v("\n                          "+_vm._s(item.counter_date)+"\n                        ")]),_vm._v(" "),_vm._l((headers),function(header){return (header.value != 'counter_date')?_c('td',{staticClass:"text-end",class:{ no_data_color: item[header.value] == 'x'}},[_vm._v("\n                          "+_vm._s(item[header.value])+"\n                        ")]):_vm._e()})],2)]}}])})],1)],1)],1),_vm._v(" "),_c('v-tab-item',{staticClass:"represent-cnt-val-tab",attrs:{"value":"rep-tab-cnt-val-table"}},[_c('v-layout',[_c('v-flex',{attrs:{"xs4":"","pl-4":""}},[_c('div',{staticClass:"padding-top-14"},[_vm._v("\n                    Показания на\n                  ")])]),_vm._v(" "),_c('v-flex',{attrs:{"d-flex":"","xs6":""}},[_c('v-select',{staticClass:"padding-left-10",attrs:{"items":_vm.valueOnTime,"item-text":"text","item-value":"val","label":"","persistent-hint":"","single-line":""},model:{value:(_vm.currentValueOnTime),callback:function ($$v) {_vm.currentValueOnTime=$$v},expression:"currentValueOnTime"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticClass:"text-center"},[_c('v-btn',{attrs:{"rounded":"","color":"primary","href":_vm.pointsCountersValuesCsvUrl}},[_vm._v("\n                      Экспорт\n                    ")])],1)])],1),_vm._v(" "),(!_vm.pointsCountersValuesDataLoading)?_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-data-table',{attrs:{"headers":_vm.pointsCountersValuesHeaders,"items":_vm.pointsCountersValuesData,"loading":_vm.pointsCountersValuesDataLoading,"hide-default-header":"","hide-default-footer":"","disable-pagination":"","fixed-header":"","dense":""},scopedSlots:_vm._u([{key:"header",fn:function(ref){
                              var headers = ref.props.headers;
return [_c('thead',[_c('tr',_vm._l((headers),function(header){return _c('th',{staticClass:"text-end"},[(header.sign != undefined)?_c('v-icon',{attrs:{"color":"teal"}},[_vm._v(_vm._s(header.sign == 1 ? 'add_box' :
                              header.sign == -1 ? 'indeterminate_check_box' :
                              'exposure'))]):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(header.text))])],1)}),0)])]}},{key:"item",fn:function(ref){
                              var item = ref.item;
                              var headers = ref.headers;
return [_c('tr',[_c('td',{staticClass:"nwrp width-150 text-end"},[_vm._v("\n                          "+_vm._s(item.counter_date)+"\n                        ")]),_vm._v(" "),_vm._l((headers),function(header){return _c('td',{directives:[{name:"show",rawName:"v-show",value:(header.value != 'counter_date'),expression:"header.value != 'counter_date'"}],key:header.value,staticClass:"text-end",class:{ no_data_color: item[header.value] == 'x'}},[_vm._v("\n                          "+_vm._s(item[header.value])+"\n                        ")])})],2)]}}],null,false,1459818117)})],1)],1):_vm._e()],1),_vm._v(" "),_c('v-tab-item',{staticClass:"conf",attrs:{"value":"rep-tab-config"}},[_c('v-card',{staticClass:"width-600px",attrs:{"flat":""}},[_c('v-card-text',[_c('v-container',{staticClass:"width-600px"},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs5":""}},[_c('v-text-field',{ref:"name",attrs:{"label":"Наименование"},model:{value:(_vm.editedRepresent.name),callback:function ($$v) {_vm.$set(_vm.editedRepresent, "name", $$v)},expression:"editedRepresent.name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs5":""}},[_c('v-text-field',{attrs:{"label":"Примечание"},model:{value:(_vm.editedRepresent.remark),callback:function ($$v) {_vm.$set(_vm.editedRepresent, "remark", $$v)},expression:"editedRepresent.remark"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-checkbox',{attrs:{"label":"Проверять состояние"},model:{value:(_vm.editedRepresent.check_health),callback:function ($$v) {_vm.$set(_vm.editedRepresent, "check_health", $$v)},expression:"editedRepresent.check_health"}})],1)],1)],1),_vm._v(" "),(_vm.representPoints.length > 0)?_c('v-container',{staticClass:"width-600px"},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',[_vm._v("Период")])]),_vm._v(" "),_c('v-flex',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"d-flex":""}},[_c('v-radio-group',{staticClass:"width-100px",attrs:{"column":""},model:{value:(_vm.periodSelector),callback:function ($$v) {_vm.periodSelector=$$v},expression:"periodSelector"}},[_c('v-radio',{attrs:{"label":"Текущий","value":"current"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"С","value":"selected"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"d-flex":""}},[_c('v-layout',{staticClass:"padding-top-40"},[_c('v-flex',{attrs:{"xs4":""}},[_c('v-menu',{ref:"dateBeginMenu",staticClass:"min-width-190",attrs:{"disabled":_vm.periodSelector==='current',"close-on-content-click":false,"nudge-right":40,"transition":"scale-transition","offset-y":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
                              var on = ref.on;
return [_c('v-text-field',_vm._g({attrs:{"label":"Дата начала","readonly":"","disabled":_vm.periodSelector==='current'},on:{"blur":function($event){_vm.dateBeginVal = _vm.parseDate(_vm.dateBegin)}},model:{value:(_vm.dateBegin),callback:function ($$v) {_vm.dateBegin=$$v},expression:"dateBegin"}},on))]}}],null,false,3746004566),model:{value:(_vm.dateBeginMenu),callback:function ($$v) {_vm.dateBeginMenu=$$v},expression:"dateBeginMenu"}},[_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","scrollable":"","locale":"ru-RU","max":_vm.dateEndVal},on:{"input":function($event){_vm.dateBeginMenu = false}},model:{value:(_vm.dateBeginVal),callback:function ($$v) {_vm.dateBeginVal=$$v},expression:"dateBeginVal"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-menu',{ref:"dateEndMenu",staticClass:"min-width-1  90",attrs:{"close-on-content-click":false,"disabled":_vm.periodSelector==='current',"nudge-right":40,"transition":"scale-transition","offset-y":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
                              var on = ref.on;
return [_c('v-text-field',_vm._g({staticClass:"padding-left-10",attrs:{"disabled":_vm.periodSelector==='current',"label":"Дата окончания","readonly":""},on:{"blur":function($event){_vm.dateEndVal = _vm.parseDate(_vm.dateEnd)}},model:{value:(_vm.dateEnd),callback:function ($$v) {_vm.dateEnd=$$v},expression:"dateEnd"}},on))]}}],null,false,1527187710),model:{value:(_vm.dateEndMenu),callback:function ($$v) {_vm.dateEndMenu=$$v},expression:"dateEndMenu"}},[_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","scrollable":"","locale":"ru-RU","min":_vm.dateBeginVal,"max":_vm.currentPeriodEndDate},on:{"input":function($event){_vm.dateEndMenu = false}},model:{value:(_vm.dateEndVal),callback:function ($$v) {_vm.dateEndVal=$$v},expression:"dateEndVal"}})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',[_c('v-layout',[_c('v-flex',{attrs:{"xs6":""}},[_c('div',{staticClass:"padding-top-14"},[_vm._v("\n                              Формат отображаемой энергии\n                            ")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-select',{attrs:{"items":[
                                { state: 'кВатт*час (кВар/час)', abbr: 'kvch' },
                                { state: 'кВатт(кВар)', abbr: 'kv' } ],"item-text":"state","item-value":"abbr","label":"Select","persistent-hint":"","single-line":""},model:{value:(_vm.energyFormat),callback:function ($$v) {_vm.energyFormat=$$v},expression:"energyFormat"}})],1)],1)],1),_vm._v(" "),_c('v-flex',[_c('v-layout',[_c('v-flex',{attrs:{"xs6":""}},[_c('div',{staticClass:"padding-top-14"},[_vm._v("\n                              Вид энергии\n                            ")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-select',{attrs:{"items":_vm.energyTypes,"item-text":"text","item-value":"energy","label":"Вид энергии","persistent-hint":"","single-line":""},model:{value:(_vm.energyType),callback:function ($$v) {_vm.energyType=$$v},expression:"energyType"}})],1)],1)],1),_vm._v(" "),_c('v-flex',[_c('v-layout',[_c('v-flex',{attrs:{"xs6":""}},[_c('v-layout',{attrs:{"d-flex":"","xs12":""}},[_c('v-flex',{attrs:{"d-flex":"","xs6":""}},[(_vm.energyType == 'straight')?_c('v-checkbox',{attrs:{"hide-details":"","label":"Учёт потерь"},model:{value:(_vm.showLost),callback:function ($$v) {_vm.showLost=$$v},expression:"showLost"}}):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"d-flex":"","xs2":""}},[(_vm.showLost && _vm.energyType == 'straight')?_c('v-btn',{staticClass:"pick-color-btn margin-top-18",style:({ 'background-color': _vm.editedRepresent.lost_color }),nativeOn:{"click":function($event){return _vm.selectLostColor()}}}):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"d-flex":"","xs12":""}},[_c('v-flex',{attrs:{"d-flex":"","xs10":""}},[(_vm.showLost && _vm.energyType == 'straight')?_c('v-checkbox',{attrs:{"hide-details":"","label":"Потери в процентах"},model:{value:(_vm.showLostInPercentage),callback:function ($$v) {_vm.showLostInPercentage=$$v},expression:"showLostInPercentage"}}):_vm._e()],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"d-flex":"","xs12":""}},[_c('v-flex',{attrs:{"d-flex":"","xs10":""}},[(_vm.energyType == 'straight')?_c('v-checkbox',{attrs:{"hide-details":"","label":"Реактивная энергия"},model:{value:(_vm.reactiveEnergy),callback:function ($$v) {_vm.reactiveEnergy=$$v},expression:"reactiveEnergy"}}):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-radio-group',{attrs:{"column":""},model:{value:(_vm.valRound),callback:function ($$v) {_vm.valRound=$$v},expression:"valRound"}},[_c('v-radio',{attrs:{"label":"Без округления","value":"trunc"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"Округление до целого с остатком","value":"round0"}}),_vm._v(" "),_c('v-radio',{staticStyle:{"width":"160px"},attrs:{"label":"Округление до N знаков","value":"roundWith"}})],1),_vm._v(" "),_c('v-select',{staticClass:"rounding-selector",attrs:{"items":_vm.roundChoice,"item-text":"round","item-value":"round","label":"","persistent-hint":"","single-line":""},model:{value:(_vm.roundVal),callback:function ($$v) {_vm.roundVal=$$v},expression:"roundVal"}})],1)],1)],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"red darken-1","text":""},nativeOn:{"click":function($event){return _vm.deleteRepresent($event)}}},[_vm._v("\n                    Удалить\n                  ")]),_vm._v(" "),(_vm.changed == false)?_c('div',{staticClass:"subheading"},[_c('v-icon',{attrs:{"color":"green"}},[_vm._v("\n                      check_circle\n                    ")]),_vm._v("\n                    Изменений нет\n                  ")],1):(_vm.changed == true)?_c('div',{staticClass:"px-3 save_block"},[_c('v-btn',{attrs:{"color":"orange darken-1","text":""},nativeOn:{"click":function($event){return _vm.saveRepresent($event)}}},[_vm._v("\n                      Сохранить\n                    ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"red darken-1","text":""},nativeOn:{"click":function($event){return _vm.cancelRepresentChanges($event)}}},[_vm._v("\n                      Отмена\n                    ")])],1):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-tab-item',{attrs:{"value":"rep-tab-points"}},[(!_vm.loadingRepresentAvailablePoints && _vm.lookAvailablePoints)?_c('v-card',{staticClass:"form-factor-for-forms-full",attrs:{"flat":""}},[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Доступные точки учёта")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"blue--text darken-1",attrs:{"text":""},nativeOn:{"click":function($event){return _vm.closePointSelectDialog($event)}}},[_c('v-icon',[_vm._v("keyboard_arrow_left")]),_vm._v(" "),_c('span',[_vm._v("Назад")])],1)],1),_vm._v(" "),_c('v-card-title',[_c('v-spacer'),_vm._v(" "),_c('v-text-field',{attrs:{"append-icon":"search","label":"Наименование","single-line":"","hide-details":""},model:{value:(_vm.pointSearch),callback:function ($$v) {_vm.pointSearch=$$v},expression:"pointSearch"}})],1),_vm._v(" "),_c('v-card-text',[_c('v-data-table',{staticClass:"elevation-1 represent-available-points",attrs:{"headers":_vm.availablePointsHeaders,"items":_vm.representAvailablePoints,"search":_vm.pointSearch,"item-key":"point_id","flat":"","fixed-header":"","dense":"","footer-props":{
                      itemsPerPageText: 'Число ТУ на странице',
                      itemsPerPageOptions: [25, 50]
                    }},scopedSlots:_vm._u([{key:"item",fn:function(props){return _c('tr',{},[_c('td',[_c('v-checkbox',{attrs:{"primary":"","hide-details":""},nativeOn:{"click":function($event){return _vm.doAdRmPoint(props.item, $event)}},model:{value:(props.item.selected),callback:function ($$v) {_vm.$set(props.item, "selected", $$v)},expression:"props.item.selected"}})],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.name))]),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[(props.item.represents != null)?_c('v-tooltip',{attrs:{"left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
                    var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"x-small":"","outlined":"","fab":"","color":"teal"}},on),[_vm._v(_vm._s(props.item.represents.length))])]}}],null,true)},[_vm._v(" "),_vm._l((props.item.represents),function(represent){return _c('div',{key:represent.represent_id},[_vm._v("\n                            Объект "+_vm._s(represent.name)+"\n                          ")])})],2):_c('v-btn',{attrs:{"x-small":"","outlined":"","fab":"","color":"teal"}},[_vm._v("0")])],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.point_number))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.customer_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.address))])])}}],null,false,2938837542)},[_vm._v(" "),_c('v-alert',{attrs:{"slot":"no-results","value":true,"color":"error","icon":"warning"},slot:"no-results"},[_vm._v("\n                      Точка учёта содержащая \""+_vm._s(_vm.pointSearch)+"\" не найдена.\n                    ")])],1)],1)],1):(_vm.addPoints)?_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Новая точка учета")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-form',{ref:"addPointForm"},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{attrs:{"label":"Наименование","rules":_vm.pointAddRules,"required":""},model:{value:(_vm.newPoint.name),callback:function ($$v) {_vm.$set(_vm.newPoint, "name", $$v)},expression:"newPoint.name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{attrs:{"label":"Идентификатор Точки учёта","rules":_vm.pointAddRules,"required":""},model:{value:(_vm.newPoint.point_number),callback:function ($$v) {_vm.$set(_vm.newPoint, "point_number", $$v)},expression:"newPoint.point_number"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-autocomplete',{attrs:{"items":_vm.customers,"label":"Абонент","item-text":"name","item-value":"customer_id","no-data-text":"Нет доступных абонентов","menu-props":{maxHeight:'auto'}},model:{value:(_vm.newPoint.customer_id),callback:function ($$v) {_vm.$set(_vm.newPoint, "customer_id", $$v)},expression:"newPoint.customer_id"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{attrs:{"label":"Адрес","rules":_vm.pointAddRules,"required":""},model:{value:(_vm.newPoint.address),callback:function ($$v) {_vm.$set(_vm.newPoint, "address", $$v)},expression:"newPoint.address"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{attrs:{"label":"Примечание"},model:{value:(_vm.newPoint.remark),callback:function ($$v) {_vm.$set(_vm.newPoint, "remark", $$v)},expression:"newPoint.remark"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","text":""},nativeOn:{"click":function($event){return _vm.savePoint($event)}}},[_vm._v("\n                    Сохранить\n                  ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","text":""},nativeOn:{"click":function($event){return _vm.closePointCreateDialog($event)}}},[_vm._v("\n                    Отмена\n                  ")])],1)],1):_c('v-card',{attrs:{"flat":""}},[_c('v-card-title',[_c('v-flex',{staticClass:"panel-without-shadow",attrs:{"xs12":""}},[_c('v-expansion-panels',[_c('v-expansion-panel',[_c('v-expansion-panel-header',[_c('a',{staticClass:"represent-header-text represent-header-filter"},[_c('v-icon',[_vm._v("mdi-filter-outline")]),_vm._v("\n                            Колонки таблицы\n                          ")],1)]),_vm._v(" "),_c('v-expansion-panel-content',[_c('v-container',[_c('v-row',_vm._l((_vm.representPointsHeaders),function(header){return _c('v-col',{attrs:{"cols":"6","sm":"4"}},[_c('v-checkbox',{staticClass:"pt-0 mt-0",attrs:{"hide-details":"","label":header.text},model:{value:(header.visible),callback:function ($$v) {_vm.$set(header, "visible", $$v)},expression:"header.visible"}})],1)}),1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('a',{staticClass:"represent-header-text represent-header-attach",on:{"click":_vm.getRepresentAvailablePoints}},[_c('v-icon',[_vm._v("mdi-check-box-outline")]),_vm._v(" Присоединить точку учёта\n                    ")],1)]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('a',{staticClass:"represent-header-text represent-header-add",on:{"click":_vm.showPointCreateDialog}},[_c('v-icon',[_vm._v("mdi-plus-box-outline")]),_vm._v(" Добавить точку учёта\n                    ")],1)])],1),_vm._v(" "),(_vm.representPoints.length > 0)?_c('v-data-table',{staticClass:"represent-points",attrs:{"headers":_vm.slctRepresentPointsHeaders,"items":_vm.representPoints,"loadig":_vm.loadedRepresentPoints,"show-select":"","item-key":"point_id","hide-default-footer":"","disable-pagination":"","fixed-header":"","dense":""},on:{"toggle-select-all":function($event){return _vm.toggleAllRepresentPoints($event)},"item-selected":function($event){_vm.needToUpdatePointsData=true}},scopedSlots:_vm._u([{key:"header.data-table-select",fn:function(ref){
                    var on = ref.on;
                    var props = ref.props;
return [_c('span',[_c('v-simple-checkbox',_vm._g(_vm._b({},'v-simple-checkbox',props,false),on)),_vm._v("\n                      Отображать в отчёте\n                    ")],1)]}},{key:"item.data-table-select",fn:function(ref){
                    var item = ref.item;
                    var select = ref.select;
return [_c('v-simple-checkbox',{attrs:{"title":"Отображение или не отображение точки учета в режимах «График», «Таблицы» и «Показания счетчиков»"},on:{"input":function($event){return select($event)}},model:{value:(item.selected),callback:function ($$v) {_vm.$set(item, "selected", $$v)},expression:"item.selected"}})]}},{key:"item.order_num",fn:function(ref){
                    var item = ref.item;
return [_c('v-edit-dialog',{attrs:{"return-value":item.order_num,"lazy":""},on:{"update:returnValue":function($event){return _vm.$set(item, "order_num", $event)},"update:return-value":function($event){return _vm.$set(item, "order_num", $event)}}},[_c('v-btn',{attrs:{"icon":""}},[_vm._v(_vm._s(item.order_num))]),_vm._v(" "),_c('v-text-field',{attrs:{"slot":"input","type":"number","label":"Редактировать","single-line":""},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.updatePointOrder(item.represent_point_id, item.order_num)}},slot:"input",model:{value:(item.order_num),callback:function ($$v) {_vm.$set(item, "order_num", $$v)},expression:"item.order_num"}})],1)]}},{key:"item.customer_number",fn:function(ref){
                    var item = ref.item;
return [_c('span',[_vm._v("\n                      "+_vm._s(item.customer_name)+"\n                    ")])]}},{key:"item.name",fn:function(ref){
                    var item = ref.item;
return [_c('router-link',{attrs:{"to":'/points/' + item.point_id + '/edit',"title":"Переход в режим «Точки учета»"}},[_vm._v("\n                      "+_vm._s(item.name)+"\n                    ")])]}},{key:"item.counter",fn:function(ref){
                    var item = ref.item;
return [_c('span',[(item.counter_id)?_c('v-icon',{attrs:{"small":"","color":_vm.getResourceTypeIconColor(item.counter_model_resource_type_id)}},[_vm._v("\n                        "+_vm._s(_vm.getResourceTypeIcon(item.counter_model_resource_type_id))+"\n                      ")]):_vm._e(),_vm._v("\n                      "+_vm._s(item.counter_id ?
                        item.counter_serial_num + ' (' + item.counter_model_name + ')' :
                        'Счетчик не установлен')+"\n                      "),(item.counter_id)?_c('v-btn',{attrs:{"icon":"","title":"Информация о значениях параметров счетчика на конкретную дату и время"},on:{"click":function($event){return _vm.getCounterParametersData(item)}}},[_c('v-icon',[_vm._v("info")])],1):_vm._e()],1)]}},{key:"item.color",fn:function(ref){
                        var item = ref.item;
return [_c('v-btn',{staticClass:"represent-pick-color-btn ml-0",attrs:{"icon":"","title":"Цвет графика показаний счетчика в режиме «График»"},nativeOn:{"click":function($event){return _vm.selectColor(item)}}},[_c('div',{style:({ 'background-color': item.color })})])]}},{key:"item.sign",fn:function(ref){
                        var item = ref.item;
                        var value = ref.value;
return [_c('span',{staticClass:"sign-change"},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":"","title":"Значение «+» или «-» показаний счетчика при отображении их в режиме «Таблицы», для расчета потерь в сети"},on:{"click":function($event){return _vm.updatePointSign(item)}}},[(value == 1)?_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("add_box")]):_vm._e(),_vm._v(" "),(value == -1)?_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("indeterminate_check_box")]):_vm._e(),_vm._v(" "),(value == 0)?_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("exposure")]):_vm._e()],1)],1)]}},{key:"item.is_active",fn:function(ref){
                        var item = ref.item;
return [_c('div',{staticClass:"active-state-change",class:{ 'not-active-counter': !item.counter_is_active }},[_c('div',[(item.counter_id && item.counter_model_external_model === 'mercury_206')?_c('v-btn',{attrs:{"icon":"","title":"Отключение счетчика в точки учета в реальном режиме времени"},on:{"click":function($event){return _vm.changeActiveState(item)}}},[_c('v-icon',{attrs:{"color":item.counter_is_active ? 'red' : 'green'}},[_vm._v("\n                          power_settings_new\n                        ")])],1):_vm._e()],1)])]}}],null,false,3932816109),model:{value:(_vm.slctRepresentPoints),callback:function ($$v) {_vm.slctRepresentPoints=$$v},expression:"slctRepresentPoints"}}):_c('p',[_vm._v("Нет привязанных Точек учёта")]),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"352px"},model:{value:(_vm.colorSelectDialog),callback:function ($$v) {_vm.colorSelectDialog=$$v},expression:"colorSelectDialog"}},[_c('v-card',[_c('v-card-text',[_c('swatches-picker',{model:{value:(_vm.crntEditClr),callback:function ($$v) {_vm.crntEditClr=$$v},expression:"crntEditClr"}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","text":""},nativeOn:{"click":function($event){return _vm.selectColorCancel($event)}}},[_vm._v("\n                        Отмена\n                      ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","text":""},nativeOn:{"click":function($event){return _vm.selectColorOk($event)}}},[_vm._v("\n                        ОК\n                      ")])],1)],1)],1)],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Nx+9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OFFm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VueRouterObject = exports.routes = undefined;

var _Home = __webpack_require__("Hd3+");

var _Home2 = _interopRequireDefault(_Home);

var _Login = __webpack_require__("r51e");

var _Login2 = _interopRequireDefault(_Login);

var _DataParameters = __webpack_require__("+wU7");

var _DataParameters2 = _interopRequireDefault(_DataParameters);

var _CountersModels = __webpack_require__("17SK");

var _CountersModels2 = _interopRequireDefault(_CountersModels);

var _CountersModelsAPI = __webpack_require__("LyXq");

var _CountersModelsAPI2 = _interopRequireDefault(_CountersModelsAPI);

var _CountersModelsResourceTypes = __webpack_require__("Caf9");

var _CountersModelsResourceTypes2 = _interopRequireDefault(_CountersModelsResourceTypes);

var _CountersModelsParameters = __webpack_require__("CbU7");

var _CountersModelsParameters2 = _interopRequireDefault(_CountersModelsParameters);

var _DataSources = __webpack_require__("qfDW");

var _DataSources2 = _interopRequireDefault(_DataSources);

var _Represents = __webpack_require__("nBfR");

var _Represents2 = _interopRequireDefault(_Represents);

var _Customers = __webpack_require__("/uWe");

var _Customers2 = _interopRequireDefault(_Customers);

var _RepresentNew = __webpack_require__("z0Zy");

var _RepresentNew2 = _interopRequireDefault(_RepresentNew);

var _Points = __webpack_require__("ue3q");

var _Points2 = _interopRequireDefault(_Points);

var _Report = __webpack_require__("j9T+");

var _Report2 = _interopRequireDefault(_Report);

var _Report3 = __webpack_require__("2MXY");

var _Report4 = _interopRequireDefault(_Report3);

var _Report5 = __webpack_require__("lKWY");

var _Report6 = _interopRequireDefault(_Report5);

var _Report7 = __webpack_require__("OMNb");

var _Report8 = _interopRequireDefault(_Report7);

var _PointCountersData = __webpack_require__("qdT3");

var _PointCountersData2 = _interopRequireDefault(_PointCountersData);

var _PointEdit = __webpack_require__("FMTb");

var _PointEdit2 = _interopRequireDefault(_PointEdit);

var _PointCounters = __webpack_require__("ZENG");

var _PointCounters2 = _interopRequireDefault(_PointCounters);

var _PointConsumption = __webpack_require__("jHXo");

var _PointConsumption2 = _interopRequireDefault(_PointConsumption);

var _PointCounterPhase = __webpack_require__("XmpF");

var _PointCounterPhase2 = _interopRequireDefault(_PointCounterPhase);

var _Counters = __webpack_require__("oiLY");

var _Counters2 = _interopRequireDefault(_Counters);

var _PointProfile = __webpack_require__("KllK");

var _PointProfile2 = _interopRequireDefault(_PointProfile);

var _PointScheduler = __webpack_require__("jxeW");

var _PointScheduler2 = _interopRequireDefault(_PointScheduler);

var _Tasks = __webpack_require__("CrJE");

var _Tasks2 = _interopRequireDefault(_Tasks);

var _Monitoring = __webpack_require__("l8UC");

var _Monitoring2 = _interopRequireDefault(_Monitoring);

var _Users = __webpack_require__("y7i9");

var _Users2 = _interopRequireDefault(_Users);

var _PermissionsGroups = __webpack_require__("nMjn");

var _PermissionsGroups2 = _interopRequireDefault(_PermissionsGroups);

var _ReleaseNotes = __webpack_require__("AnLt");

var _ReleaseNotes2 = _interopRequireDefault(_ReleaseNotes);

var _DocumentsRequests = __webpack_require__("YK21");

var _DocumentsRequests2 = _interopRequireDefault(_DocumentsRequests);

var _DocumentsRequestsType = __webpack_require__("P2ny");

var _DocumentsRequestsType2 = _interopRequireDefault(_DocumentsRequestsType);

var _DocumentsRequestsRequired = __webpack_require__("qo9I");

var _DocumentsRequestsRequired2 = _interopRequireDefault(_DocumentsRequestsRequired);

var _AccountEmails = __webpack_require__("tGDa");

var _AccountEmails2 = _interopRequireDefault(_AccountEmails);

var _AccountSettings = __webpack_require__("pxuj");

var _AccountSettings2 = _interopRequireDefault(_AccountSettings);

var _NotFound = __webpack_require__("/c4q");

var _NotFound2 = _interopRequireDefault(_NotFound);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = exports.routes = [{
  path: '/',
  component: _Home2.default
}, {
  path: '/login',
  component: _Login2.default
}, {
  path: '/data_params',
  component: _DataParameters2.default,
  name: 'Типы параметров'
}, {
  path: '/counters_models',
  component: _CountersModels2.default,
  name: 'Модели приборов учета'
}, {
  path: '/counters_models_api',
  component: _CountersModelsAPI2.default,
  name: 'Группы моделей приборов учета'
}, {
  path: '/counters_resource',
  component: _CountersModelsResourceTypes2.default,
  name: 'Ресурс'
}, {
  path: '/counter_model_parameters',
  component: _CountersModelsParameters2.default,
  name: 'Параметры модели'
}, {
  path: '/data_sources',
  component: _DataSources2.default,
  name: 'Источники данных'
}, {
  path: '/counters',
  component: _Counters2.default,
  name: 'Счетчики'
}, {
  path: '/represents/:representId',
  component: _Represents2.default,
  name: 'Объекты'
}, {
  path: '/represent/:parentId/new',
  component: _RepresentNew2.default,
  name: 'Добавить дочерний объект'
}, {
  path: '/represent/new',
  component: _RepresentNew2.default,
  name: 'Добавить объект'
}, {
  path: '/points',
  component: _Points2.default,
  name: 'Точки учёта',
  children: [{
    path: ':id/point_counters_data',
    component: _PointCountersData2.default,
    name: 'Данные по ТУ'
  }]
}, {
  path: '/points/:id/edit',
  component: _PointEdit2.default,
  name: 'Редактирование точки учёта'
}, {
  path: '/points/:id/counters',
  component: _PointCounters2.default,
  name: 'Счетчики по точке учёта'
}, {
  path: '/points/:id/scheduler',
  component: _PointScheduler2.default,
  name: 'Расписание'
}, {
  path: '/points/:id/consumption',
  component: _PointConsumption2.default,
  name: 'Потребление'
}, {
  path: '/points/:id/phase',
  component: _PointCounterPhase2.default,
  name: 'Фазы'
}, {
  path: '/points/:id/profile',
  component: _PointProfile2.default,
  name: 'Профиль мощности'
}, {
  path: '/tasks',
  component: _Tasks2.default,
  name: 'Задания'
}, {
  path: '/monitoring',
  component: _Monitoring2.default,
  name: 'Мониторинг'
}, {
  path: '/customers',
  component: _Customers2.default,
  name: 'Абоненты'
}, {
  path: '/report-008',
  component: _Report2.default,
  name: 'Форма 008'
}, {
  path: '/report-00102',
  component: _Report4.default,
  name: 'Форма 001.02'
}, {
  path: '/report-80020',
  component: _Report6.default,
  name: 'Форма 80020'
}, {
  path: '/report-010',
  component: _Report8.default,
  name: 'Форма 010'
}, {
  path: '/users',
  component: _Users2.default,
  name: 'Пользователи'
}, {
  path: '/permissions-groups',
  component: _PermissionsGroups2.default,
  name: 'Права'
}, {
  path: '/documents-requests',
  component: _DocumentsRequests2.default,
  name: 'Поступившие заявки'
}, {
  path: '/documents-requests-types',
  component: _DocumentsRequestsType2.default,
  name: 'Типы заявок'
}, {
  path: '/documents-requests-required',
  component: _DocumentsRequestsRequired2.default,
  name: 'Требуемые файлы заявок'
}, {
  path: '/release-notes',
  component: _ReleaseNotes2.default,
  name: 'Информация о релизах'
}, {
  path: '/account-emails',
  component: _AccountEmails2.default,
  name: 'Email адреса акаунта'
}, {
  path: '/account-settings',
  component: _AccountSettings2.default,
  name: 'Настройки аккаутнта'
}, {
  path: '*',
  component: _NotFound2.default
}];

var VueRouterObject = exports.VueRouterObject = {
  routes: routes,
  mode: 'history',
  saveScrollPosition: true
};

exports.default = function (VueRouter) {
  return new VueRouter(VueRouterObject);
};

/***/ }),

/***/ "OMNb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Report010_vue__ = __webpack_require__("nO2C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Report010_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Report010_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Report010_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Report010_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_528d3301_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Report010_vue__ = __webpack_require__("fFfG");
function injectStyle (ssrContext) {
  __webpack_require__("q01A")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-528d3301"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Report010_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_528d3301_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Report010_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "OVKk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OXwQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OnoV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var API_URL = 'data_parameters'; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'DataParameters',
  data: function data() {
    return {
      inputRules: [function (v) {
        return !!v || 'Заполните это поле!';
      }],
      resources_types: [],
      search: '',
      dialog: false,
      totalItems: 0,
      addParameter: false,
      items: [],
      loading: true,
      headers: [{
        text: 'Наименование',
        align: 'left',
        sortable: true,
        value: 'name'
      }, {
        text: 'Тип энергоресурса',
        align: 'left',
        sortable: true,
        value: 'resource_type'
      }, { text: 'Замечание', value: 'remark' }, { text: '', value: '' }],
      editedIndex: -1,
      editedItem: {
        parameter_id: '',
        name: '',
        remark: '',
        resource_type_id: '',
        resource_type: {}
      },
      defaultPlace: {
        parameter_id: '',
        name: '',
        remark: '',
        resource_type_id: '',
        resource_type: {}
      }
    };
  },


  computed: {
    formTitle: function formTitle() {
      return this.editedIndex === -1 ? 'Новый тип параметра' : 'Редактирование параметра';
    }
  },

  mounted: function mounted() {
    this.getItemsApi();
    this.getResourcesTypesApi();
  },

  methods: {
    getResourcesTypesApi: function getResourcesTypesApi() {
      var _this = this;

      this.loading = true;
      _axios2.default.get('/api/resources_types/?page_size=all').then(function (response) {
        _this.resources_types = response.data.results;
        _this.loading = false;
      }).catch(function (err) {
        _this.loading = false;
        console.log(err);
      });
    },
    getItemsApi: function getItemsApi() {
      var _this2 = this;

      this.loading = true;
      _axios2.default.get('/api/' + API_URL + '/?page_size=all').then(function (response) {
        _this2.items = response.data.results;
        _this2.loading = false;
      }).catch(function (err) {
        _this2.loading = false;
        console.log(err);
      });
    },
    addItemApi: function addItemApi() {
      var _this3 = this;

      this.loading = true;
      var resourceTypeId = this.editedItem.resource_type.resource_type_id;
      this.editedItem.resource_type_id = resourceTypeId;
      _axios2.default.post('/api/' + API_URL + '/', this.editedItem).then(function (response) {
        _this3.loading = false;
        _this3.items.push(response.body);
        _this3.close();
      }).catch(function (err) {
        _this3.loading = false;
        console.log(err);
      });
    },
    updateItemApi: function updateItemApi() {
      var _this4 = this;

      this.loading = true;
      var id = this.editedItem.parameter_id;
      var resourceTypeId = this.editedItem.resource_type.resource_type_id;
      this.editedItem.resource_type_id = resourceTypeId;
      _axios2.default.put('/api/' + API_URL + '/' + id + '/', this.editedItem).then(function (response) {
        _this4.loading = false;
        Object.assign(_this4.items[_this4.editedIndex], response.body);
        _this4.close();
      }).catch(function (err) {
        _this4.loading = false;
        console.log(err);
      });
    },
    deleteItemApi: function deleteItemApi(item) {
      var _this5 = this;

      var id = item.parameter_id;
      this.loading = true;
      _axios2.default.delete('/api/' + API_URL + '/' + id).then(function (response) {
        _this5.loading = false;
        var index = _this5.items.indexOf(item);
        _this5.items.splice(index, 1);
      }).catch(function (err) {
        _this5.loading = false;
        console.log(err);
      });
    },
    editItem: function editItem(item) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.addParameter = true;
    },
    deleteItem: function deleteItem(item) {
      if (confirm('Вы действительно хотите удалить эту строку?')) {
        this.deleteItemApi(item);
      }
    },
    close: function close() {
      var _this6 = this;

      setTimeout(function () {
        _this6.editedItem = Object.assign({}, _this6.defaultPlace);
        _this6.editedIndex = -1;
      }, 300);
      this.addParameter = false;
    },
    validate: function validate() {
      if (this.$refs.dataParametersForm.validate()) {
        return true;
      }
    },
    save: function save() {
      if (this.validate()) {
        if (this.editedIndex > -1) {
          this.updateItemApi();
        } else {
          this.addItemApi();
        }
        this.addParameter = false;
      }
    }
  }
};

/***/ }),

/***/ "P2ny":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocumentsRequestsType_vue__ = __webpack_require__("if6w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocumentsRequestsType_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocumentsRequestsType_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocumentsRequestsType_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocumentsRequestsType_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84fa4450_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DocumentsRequestsType_vue__ = __webpack_require__("cdaD");
function injectStyle (ssrContext) {
  __webpack_require__("UO8w")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocumentsRequestsType_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84fa4450_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DocumentsRequestsType_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "PE1O":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PermissionsGroupNew = __webpack_require__("X9l2");

var _PermissionsGroupNew2 = _interopRequireDefault(_PermissionsGroupNew);

var _PermissionsGroupEdit = __webpack_require__("68CT");

var _PermissionsGroupEdit2 = _interopRequireDefault(_PermissionsGroupEdit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var API_URL = 'permissions_groups';
exports.default = {
  name: 'PermissionsGroups',
  components: {
    PermissionsGroupNew: _PermissionsGroupNew2.default,
    PermissionsGroupEdit: _PermissionsGroupEdit2.default
  },
  data: function data() {
    return {
      search: '',
      items: [],
      firstLoading: true,
      loading: true,
      options: { page: 1, itemsPerPage: 25 },
      serverItemsLength: 0,
      headers: [{
        text: 'Наименование',
        align: 'left',
        sortable: false,
        value: 'name'
      }, {
        text: '',
        align: 'right',
        sortable: false,
        value: 'actions'
      }],
      adding: false,
      showSuccess: false,
      showSuccessMsg: false,
      editing: false,
      selectedPermissionsGroupData: {},
      showErrorMsg: false,
      showError: false,
      errorMsg: null,
      getTimer: '',
      searchTimer: '',
      deleteTimer: ''
    };
  },

  watch: {
    options: {
      handler: function handler() {
        this.getPermissionsGroupsApiTimer();
      },

      deep: true
    },
    search: function search() {
      var _this2 = this;

      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(function () {
        _this2.options.page = 1;
        _this2.getPermissionsGroupsApiTimer();
      }, 500);
    },

    'editedTaskItem.counter_parameters': function editedTaskItemCounter_parameters() {
      if (this.sendUpdate) {
        return;
      }
      this.tmpParameters = [];
      var _this = this;
      this.counterParameters.forEach(function (element) {
        if (_this.editedTaskItem.counter_parameters.includes(element.model_parameter_id)) {
          _this.tmpParameters.push(element);
        }
      });
      setTimeout(function () {
        _this.paramsLoading = false;
      }, 1000);
    }
  },
  mounted: function mounted() {
    if (this.$route.query.search) {
      this.search = this.$route.query.search;
    }
  },

  methods: {
    getPermissionsGroupsApi: function getPermissionsGroupsApi() {
      var _this3 = this;

      this.loading = true;
      this.axios.get('/api/' + API_URL + '/?per_page=' + this.options.itemsPerPage + '&page=' + this.options.page + '&search=' + this.search).then(function (response) {
        _this3.items = response.data.results;
        _this3.serverItemsLength = response.data.count;
      }).catch(function (err) {
        console.log(err);
      }).finally(function () {
        _this3.firstLoading = false;
        _this3.loading = false;
      });
    },
    getPermissionsGroupsApiTimer: function getPermissionsGroupsApiTimer() {
      var _this4 = this;

      clearTimeout(this.getTimer);
      this.getTimer = setTimeout(function () {
        _this4.getPermissionsGroupsApi();
      }, 100);
    },
    showErrorMessage: function showErrorMessage(msg) {
      var _this5 = this;

      this.errorMsg = msg;
      this.showError = true;
      this.showErrorMsg = true;
      setTimeout(function () {
        _this5.showError = false;
      }, 4000);
      setTimeout(function () {
        _this5.showErrorMsg = false;
      }, 4350);
    },
    deletepermissionGroupApi: function deletepermissionGroupApi(item) {
      var _this6 = this;

      this.axios.delete('/api/' + API_URL + '/' + item.permissions_group_id + '/').then(function (response) {
        _this6.items.splice(_this6.items.indexOf(item), 1);
        clearTimeout(_this6.deleteTimer);
        _this6.deleteTimer = setTimeout(function () {
          _this6.items.length || _this6.options.page === 1 || _this6.options.page--;
          _this6.getPermissionsGroupsApiTimer();
        }, 1000);
      }).catch(function (err) {
        _this6.showErrorMessage(err.response.data);
        console.log(err);
      });
    },
    addPermissionsGroup: function addPermissionsGroup() {
      this.adding = true;
    },
    cancelAdding: function cancelAdding() {
      this.adding = false;
    },
    permissionsGroupAdded: function permissionsGroupAdded() {
      var _this7 = this;

      this.getPermissionsGroupsApiTimer();
      this.adding = false;
      this.showSuccess = true;
      this.showSuccessMsg = true;
      setTimeout(function () {
        _this7.showSuccess = false;
      }, 3000);
      setTimeout(function () {
        _this7.showSuccessMsg = false;
      }, 3350);
    },
    editPermissionsGroup: function editPermissionsGroup(item) {
      this.selectedPermissionsGroupData = item;
      this.editing = true;
    },
    permissionsGroupEdited: function permissionsGroupEdited() {
      this.editing = false;
    },
    cancelEditing: function cancelEditing() {
      this.editing = false;
    },
    editPermissionsGroupError: function editPermissionsGroupError(msg) {
      this.editing = false;
      this.showErrorMessage(msg);
    },
    deletePermissionsGroup: function deletePermissionsGroup(item) {
      if (confirm('Вы действительно хотите удалить данную группу?')) {
        this.deletepermissionGroupApi(item);
      }
    }
  }
};

/***/ }),

/***/ "PUub":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('point-toolbar',{attrs:{"point-info":_vm.point.name}}),_vm._v(" "),_c('v-container',[(_vm.loading)?_c('v-layout',{staticClass:"loading-indicator",attrs:{"justify-center":"","align-center":""}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":70,"width":7}})],1):_vm._e(),_vm._v(" "),(!_vm.loading)?_c('v-tabs',{attrs:{"color":"accent-4","right":""}},[_c('span',{staticClass:"month-menu"},[_c('v-menu',{ref:"monthMenu",attrs:{"close-on-content-click":false,"return-value":_vm.monthDate,"transition":"scale-transition","offset-y":"","max-width":"290px","min-width":"auto"},on:{"update:returnValue":function($event){_vm.monthDate=$event},"update:return-value":function($event){_vm.monthDate=$event}},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-text-field',_vm._g(_vm._b({attrs:{"label":"Месяц потребления","prepend-icon":"mdi-calendar","readonly":""},model:{value:(_vm.monthDate),callback:function ($$v) {_vm.monthDate=$$v},expression:"monthDate"}},'v-text-field',attrs,false),on))]}}],null,false,1982161232),model:{value:(_vm.monthSelectMenu),callback:function ($$v) {_vm.monthSelectMenu=$$v},expression:"monthSelectMenu"}},[_vm._v(" "),_c('v-date-picker',{attrs:{"type":"month","no-title":"","scrollable":"","locale":"ru"},model:{value:(_vm.monthDate),callback:function ($$v) {_vm.monthDate=$$v},expression:"monthDate"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"text":"","color":"primary"},on:{"click":function($event){_vm.monthSelectMenu = false}}},[_vm._v("\n              Отмена\n            ")]),_vm._v(" "),_c('v-btn',{attrs:{"text":"","color":"primary"},on:{"click":_vm.saveMonth}},[_vm._v("\n              OK\n            ")])],1)],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-tab',[_c('v-icon',[_vm._v("\n          mdi-table\n        ")])],1),_vm._v(" "),_c('v-tab',[_c('v-icon',[_vm._v("\n          mdi-chart-bar\n        ")])],1),_vm._v(" "),_c('v-tab-item',{key:1},[_c('v-data-table',{attrs:{"headers":_vm.consumptionDataHeaders,"items":_vm.consumptionByDate,"items-per-page":32,"fixed-header":"","hide-default-footer":"","no-data-text":"Нет данных для отображения","height":"80vh","dense":""},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
return [_c('tr',[_c('td',[_vm._v(_vm._s(item.consumption_date))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.counter_serial_num))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.counter_value))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.consumption))])])]}}],null,false,4264573583)})],1),_vm._v(" "),_c('v-tab-item',{key:2},[(_vm.loaded)?_c('line-chart',{attrs:{"chartdata":_vm.consumptionChartData,"options":_vm.consumptionChartOptions}}):_vm._e()],1)],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Pfc9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

var _ReportTreeNode = __webpack_require__("DUuK");

var _ReportTreeNode2 = _interopRequireDefault(_ReportTreeNode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: { ReportTreeNode: _ReportTreeNode2.default },
  data: function data() {
    return {
      date: null,
      representsSelectType: 'multiple',
      pointsSelectType: 'multiple',
      representsId: [],
      pointsId: [],
      menuDate: false,
      loading: false
    };
  },

  computed: {
    canGetReport: function canGetReport() {
      return this.date && (this.representsId.length || this.pointsId.length);
    },
    dateComputed: function dateComputed() {
      return this.formatDate(this.date);
    }
  },
  methods: {
    reprSelect: function reprSelect(represent) {
      var _this = this;

      if (represent.status === 'initial') {
        var key = this.representsId.indexOf(represent.id);
        if (represent.is_selected && key === -1) {
          this.representsId.push(represent.id);
        }
        if (!represent.is_selected && key !== -1) {
          this.representsId.splice(key, 1);
        }
      }
      represent.children.map(function (child) {
        child.is_selected = represent.is_selected;
        _this.reprSelect(child);
      });
      represent.points.map(function (point) {
        point.is_selected = represent.is_selected;
        _this.pointSelect(point);
      });
    },
    pointSelect: function pointSelect(point) {
      var key = this.pointsId.indexOf(point.id);
      if (point.is_selected && key === -1) {
        this.pointsId.push(point.id);
      }
      if (!point.is_selected && key !== -1) {
        this.pointsId.splice(key, 1);
      }
    },
    selectedReprExpand: function selectedReprExpand(represent) {
      this.representsId.splice(this.representsId.indexOf(represent.id), 1);
    },
    formatDate: function formatDate(date) {
      if (!date) return null;

      var _date$split = date.split('-'),
          _date$split2 = _slicedToArray(_date$split, 3),
          year = _date$split2[0],
          month = _date$split2[1],
          day = _date$split2[2];

      return day + '-' + month + '-' + year;
    },
    getReport: function getReport() {
      var _this2 = this;

      this.loading = true;
      (0, _axios2.default)({
        url: '/api/get_report/',
        method: 'POST',
        responseType: 'blob',
        params: {
          'represents_id': JSON.stringify(this.representsId).slice(1, -1),
          'points_id': JSON.stringify(this.pointsId).slice(1, -1),
          'date': this.date,
          'report': 'Form008Report'
        }
      }).then(function (response) {
        var blob = new Blob([response.data], { type: 'application/pdf' });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'report_008.xlsx';
        link.click();
      }).finally(function () {
        _this2.loading = false;
      });
    }
  }
};

/***/ }),

/***/ "PtC2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('v-form',[_c('v-card',{attrs:{"flat":"","max-width":"1000"}},[_c('v-card-text',{staticClass:"pb-0"},[_c('v-form',{ref:"detailsDocumentsTypeForm"},[_c('v-select',{attrs:{"items":_vm.customerTypes,"item-text":"customer_type_name","item-value":"customer_type_id","rules":[_vm.rules.typeReguired],"label":"Тип абонента","required":""},on:{"change":function($event){return _vm.customerTypeChanged()}},model:{value:(_vm.data.doc_customer_type_id),callback:function ($$v) {_vm.$set(_vm.data, "doc_customer_type_id", $$v)},expression:"data.doc_customer_type_id"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Наименование типа заявки","rules":[_vm.rules.reguired]},model:{value:(_vm.data.doc_type_name),callback:function ($$v) {_vm.$set(_vm.data, "doc_type_name", $$v)},expression:"data.doc_type_name"}}),_vm._v(" "),_c('v-text-field',{attrs:{"type":"number","label":"Число дней до ответа","rules":[_vm.rules.reguired]},model:{value:(_vm.data.expired_in_days),callback:function ($$v) {_vm.$set(_vm.data, "expired_in_days", $$v)},expression:"data.expired_in_days"}})],1)],1),_vm._v(" "),_c('v-card-text',{staticClass:"pt-0"},[_c('v-list',[_c('v-subheader',[_c('v-row',[_c('p',{staticClass:"mt-2"},[_vm._v("Требуемые документы")]),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},on:{"click":_vm.addRequired}},[_c('v-icon',[_vm._v("add")])],1)],1)],1),_vm._v(" "),_c('v-list-item-group',{attrs:{"color":"primary"}},_vm._l((_vm.requiredFiles),function(requiredFile,index){return _c('v-list-item',{key:index},[_c('v-list-item-content',{staticClass:"pt-0 pb-0"},[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"11"}},[_c('v-select',{staticClass:"text-none",attrs:{"items":_vm.requiredFilesList,"item-text":"doc_required_file_name","item-value":"doc_required_file_id","label":"Требуемый документ"},model:{value:(requiredFile.doc_required_file_id),callback:function ($$v) {_vm.$set(requiredFile, "doc_required_file_id", $$v)},expression:"requiredFile.doc_required_file_id"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"1"}},[_c('v-btn',{staticClass:"mt-4",attrs:{"title":"Убрать файл","icon":""},on:{"click":function($event){return _vm.removeRequiredFile(index)}}},[_c('v-icon',[_vm._v("remove")])],1)],1)],1)],1)],1)}),1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{staticClass:"mr-4",attrs:{"color":"success"},on:{"click":_vm.save}},[_vm._v("\n          Сохранить\n        ")]),_vm._v(" "),_c('v-btn',{staticClass:"mr-4",on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("\n          Отмена\n        ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Px/B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Chart_vue__ = __webpack_require__("/Noj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Chart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Chart_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Chart_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Chart_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Chart_vue___default.a,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Q+1k":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'CountersModelsResourceTypes',
  data: function data() {
    return {
      items: [],
      loading: true,
      headers: [{
        text: 'Наименование',
        align: 'left',
        sortable: true,
        value: 'name'
      }],
      breadcrumbsItems: [{
        text: 'Ресурс',
        disabled: true
      }]
    };
  },
  mounted: function mounted() {
    this.getItemsApi();
  },

  methods: {
    getItemsApi: function getItemsApi() {
      var _this = this;

      this.loading = true;
      this.axios.get('/api/resources_types/').then(function (response) {
        _this.items = response.data.results;
        _this.loading = false;
      }).catch(function (err) {
        _this.loading = false;
        console.log(err);
      });
    },
    openModelsApi: function openModelsApi(item) {
      this.$router.push({ path: 'counters_models_api', query: { resource_type: item.resource_type_id } });
    }
  }
};

/***/ }),

/***/ "QBRW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-stepper',{model:{value:(_vm.currentStep),callback:function ($$v) {_vm.currentStep=$$v},expression:"currentStep"}},[_c('v-card-title',[_c('div',{staticClass:"headline"},[_vm._v("\n        Добавление счетчика\n      ")])]),_vm._v(" "),_c('v-stepper-header',[_vm._l((_vm.counterSteps),function(step,key){return [_c('v-stepper-step',{key:key,attrs:{"complete":_vm.currentStep > key + 1,"editable":_vm.currentStep > key + 1,"step":key + 1}},[_vm._v(_vm._s(step))]),_vm._v(" "),(key < 4)?_c('v-divider',{key:(key + "-divider")}):_vm._e()]})],2),_vm._v(" "),_c('v-stepper-items',[_c('v-stepper-content',{attrs:{"step":"1"}},[_c('v-autocomplete',{attrs:{"items":_vm.resourcesTypes,"label":"Энергоресурс","item-text":"name","item-value":"resource_type_id","menu-props":{maxHeight:'auto'}},on:{"input":_vm.getModelsGroupsApi},model:{value:(_vm.resourceTypeId),callback:function ($$v) {_vm.resourceTypeId=$$v},expression:"resourceTypeId"}}),_vm._v(" "),_c('v-autocomplete',{attrs:{"items":_vm.modelsGroups,"disabled":!_vm.modelsGroups.length,"label":"Группа счётчиков","item-text":"name","item-value":"counter_model_api_id","menu-props":{maxHeight:'auto'}},on:{"input":_vm.getModelsApi},model:{value:(_vm.modelGroupId),callback:function ($$v) {_vm.modelGroupId=$$v},expression:"modelGroupId"}}),_vm._v(" "),_c('v-autocomplete',{attrs:{"items":_vm.models,"disabled":!_vm.models.length,"label":"Модель","item-text":"name","item-value":"model_id","menu-props":{maxHeight:'auto'}},on:{"input":function($event){return _vm.nextCounterStep('getConnectParameters')}},model:{value:(_vm.counter.model_id),callback:function ($$v) {_vm.$set(_vm.counter, "model_id", $$v)},expression:"counter.model_id"}}),_vm._v(" "),_c('div',{staticClass:"d-flex"},[_c('v-spacer'),_vm._v(" "),(_vm.counter.model_id)?_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){_vm.currentStep++}}},[_vm._v("Вперёд")]):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){return _vm.$emit('cancel')}}},[_vm._v("Отмена")])],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"2"}},[_c('v-select',{attrs:{"items":_vm.sourceParams,"label":"Источник данных"},model:{value:(_vm.sourceParam.value),callback:function ($$v) {_vm.$set(_vm.sourceParam, "value", $$v)},expression:"sourceParam.value"}}),_vm._v(" "),_vm._l((_vm.visibleParams),function(param){return _c('v-text-field',{key:param.param,attrs:{"label":param.name + ' (' + param.remark + ')'},model:{value:(param.value),callback:function ($$v) {_vm.$set(param, "value", $$v)},expression:"param.value"}})}),_vm._v(" "),_c('div',{staticClass:"d-flex"},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){_vm.currentStep++}}},[_vm._v("Вперёд")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){return _vm.$emit('cancel')}}},[_vm._v("Отмена")])],1)],2),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"3"}},[_c('v-radio-group',{attrs:{"column":false,"hide-details":""},model:{value:(_vm.isExistingCounterSelected),callback:function ($$v) {_vm.isExistingCounterSelected=$$v},expression:"isExistingCounterSelected"}},[_c('v-radio',{attrs:{"label":"Новый счетчик","color":"primary","value":false}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"Существующий счетчик","color":"primary","value":true}})],1),_vm._v(" "),_c('v-form',{ref:"counterParamsForm"},[_c('v-container',[_c('v-row',[(_vm.isExistingCounterSelected)?_c('v-col',{attrs:{"cols":"12"}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"transition":"scale-transition","offset-y":"","min-width":"290px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-text-field',_vm._g({attrs:{"label":"Существующий счётчик","rules":_vm.inputRules,"required":"","readonly":""},model:{value:(_vm.existingCounter.serial_num),callback:function ($$v) {_vm.$set(_vm.existingCounter, "serial_num", $$v)},expression:"existingCounter.serial_num"}},on))]}}],null,false,324666744),model:{value:(_vm.existingCounterMenu),callback:function ($$v) {_vm.existingCounterMenu=$$v},expression:"existingCounterMenu"}},[_vm._v(" "),_c('point-counter-install-existed',{attrs:{"model-id":_vm.counter.model_id},on:{"selected":_vm.selectCounter}})],1)],1):_vm._e(),_vm._v(" "),_c('v-col',{attrs:{"cols":"12"}},[_c('v-text-field',{attrs:{"label":"Серийный номер","rules":_vm.inputRules,"required":""},model:{value:(_vm.counter.serial_num),callback:function ($$v) {_vm.$set(_vm.counter, "serial_num", $$v)},expression:"counter.serial_num"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12"}},[_c('v-text-field',{attrs:{"label":"Коэффициент трансформации тока","rules":_vm.inputRules,"required":""},model:{value:(_vm.counter.coeff),callback:function ($$v) {_vm.$set(_vm.counter, "coeff", $$v)},expression:"counter.coeff"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12"}},[_c('v-text-field',{attrs:{"label":"Коэффициент трансформации напряжения","rules":_vm.inputRules,"required":""},model:{value:(_vm.counter.coeff_voltage),callback:function ($$v) {_vm.$set(_vm.counter, "coeff_voltage", $$v)},expression:"counter.coeff_voltage"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12"}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"transition":"scale-transition","offset-y":"","min-width":"290px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-text-field',_vm._g({attrs:{"label":"Дата операции","readonly":""},on:{"blur":function($event){_vm.operDateVal = _vm.parseDate(_vm.operDate)}},model:{value:(_vm.operDate),callback:function ($$v) {_vm.operDate=$$v},expression:"operDate"}},on))]}}]),model:{value:(_vm.operDateMenu),callback:function ($$v) {_vm.operDateMenu=$$v},expression:"operDateMenu"}},[_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","scrollable":"","locale":"ru-RU"},on:{"input":function($event){_vm.operDateMenu = false}},model:{value:(_vm.operDateVal),callback:function ($$v) {_vm.operDateVal=$$v},expression:"operDateVal"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"d-flex"},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":_vm.addCounter}},[_vm._v("Установить")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){return _vm.$emit('cancel')}}},[_vm._v("Отмена")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QFcg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('v-dialog',{attrs:{"width":"1100px"},model:{value:(_vm.showCounterParametersData),callback:function ($$v) {_vm.showCounterParametersData=$$v},expression:"showCounterParametersData"}},[_c('counter-parameters-data',{attrs:{"counter-id":_vm.selectedCounterData.counter_id,"is-open":_vm.showCounterParametersData},on:{"close":_vm.closeCounterParametersData}})],1),_vm._v(" "),_c('v-dialog',{attrs:{"width":"800px"},model:{value:(_vm.showCounterHistory),callback:function ($$v) {_vm.showCounterHistory=$$v},expression:"showCounterHistory"}},[(_vm.showCounterHistory)?_c('counter-history',{attrs:{"counter-data":_vm.selectedCounterData},on:{"close":_vm.closeCounterHistory}}):_vm._e()],1),_vm._v(" "),(_vm.adding)?_c('counter-new',{on:{"cancel":_vm.cancelAdding,"added":_vm.counterAdded}}):(_vm.editing)?_c('counter-edit',{attrs:{"counter-data":_vm.selectedCounterData},on:{"cancel":_vm.cancelEditing,"edited":_vm.counterEdited,"editError":_vm.editCounterError}}):(_vm.loading)?_c('v-layout',{staticClass:"loading-indicator",attrs:{"justify-center":"","align-center":""}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":70,"width":7}})],1):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.adding && !_vm.editing && !_vm.firstLoading),expression:"!adding && !editing && !firstLoading"}]},[_c('v-card',{staticClass:"counters-card"},[(_vm.showSuccessMsg)?_c('v-card-title',{staticClass:"success-message",class:{ 'success-message-hide': !_vm.showSuccess}},[_c('div',{staticClass:"headline success-message-text"},[_c('i',{staticClass:"far fa-check-circle"}),_vm._v(" Счетчик успешно добавлен")])]):_vm._e(),_vm._v(" "),(_vm.showErrorMsg)?_c('v-card-title',{staticClass:"error-message",class:{ 'error-message-hide': !_vm.showError}},[_c('div',{staticClass:"headline success-message-text"},[_c('i',{staticClass:"far fa-times-circle"}),_vm._v(" "+_vm._s(_vm.errorMsg))])]):_vm._e(),_vm._v(" "),_c('v-card-title',[_c('v-text-field',{attrs:{"append-icon":"search","label":"Поиск по номеру счетчика","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"options":_vm.options,"server-items-length":_vm.serverItemsLength,"fixed-header":"","dense":"","no-data-text":"Нет данных для отображения","footer-props":{
          itemsPerPageText: 'Число счетчиков на странице',
          itemsPerPageOptions: [25, 50]
        }},on:{"update:options":function($event){_vm.options=$event}},scopedSlots:_vm._u([{key:"item",fn:function(props){return _c('tr',{},[_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(props.item.serial_num))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(props.item.model.name))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(props.item.coeff))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(props.item.coeff_voltage))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('router-link',{attrs:{"to":'/points/' + props.item.point_id + '/counters',"title":"Переход в раздел Точки учета"}},[_vm._v(_vm._s(props.item.point_number))]),_vm._v(" "),(props.item.point_id)?_c('a',{staticClass:"external-link",attrs:{"target":"_blank","href":'/points/' + props.item.point_id + '/counters',"title":"Открыть раздел Точки учета, в новой вкладке(окне)"}},[_c('v-icon',[_vm._v("mdi-open-in-new")])],1):_vm._e()],1),_vm._v(" "),_c('td',{staticClass:"justify-center"},[_c('span',{staticClass:"action-btns"},[_c('v-btn',{staticClass:"mt-1",attrs:{"icon":"","title":"Информация"},on:{"click":function($event){return _vm.getCounterParametersData(props.item)}}},[_c('v-icon',[_vm._v("info")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mt-1",attrs:{"icon":"","title":"Редактировать"},on:{"click":function($event){return _vm.editCounter(props.item)}}},[_c('v-icon',{attrs:{"color":"grey"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mt-1",attrs:{"icon":"","title":"История операций по счётчику"},on:{"click":function($event){return _vm.counterHistory(props.item)}}},[_c('v-icon',{attrs:{"color":"grey darken-1"}},[_vm._v("mdi-history")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mt-1",attrs:{"icon":"","title":"Удалить"},on:{"click":function($event){return _vm.deleteCounter(props.item)}}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("delete")])],1)],1)])])}}])})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QpX1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'DocumentsRequestsRequiredDetails',
  props: {
    data: {}
  },
  data: function data() {
    return {
      rules: {
        reguired: function reguired(v) {
          return !!v || 'Заполните это поле!';
        }
      },
      fileLoading: false
    };
  },
  mounted: function mounted() {},

  methods: {
    sendFile: function sendFile() {
      var formData = new FormData();
      if (this.data.file) {
        formData.append('files', this.data.file, this.data.file.name);
      } else {
        return;
      }

      this.axios.patch('/api/document_required_file/' + this.data.doc_required_file_id + '/', formData).then(function () {}).catch(function (error) {
        console.log(error);
      });
    },
    close: function close() {
      this.$emit('close');
    },
    save: function save() {
      var _this = this;

      if (this.$refs.detailsDocumentsRequiredForm.validate()) {
        if (this.data.doc_required_file_id === null) {
          this.axios.post('/api/document_required_file/', this.data).then(function (response) {
            _this.data.doc_required_file_id = response.data.doc_required_file_id;
            _this.sendFile();
            _this.close();
          }).catch(function (err) {
            console.log(err);
            _this.loading = false;
          });
        } else {
          this.axios.patch('/api/document_required_file/' + this.data.doc_required_file_id + '/', this.data).then(function () {
            _this.sendFile();
            _this.close();
          }).catch(function (err) {
            console.log(err);
            _this.loading = false;
          });
        }
      }
    },
    download: function download(file) {
      var _this2 = this;

      this.fileLoading = true;
      this.axios({
        url: '/api/download/' + file.file_name,
        method: 'GET',
        responseType: 'blob'
      }).then(function (response) {
        var blob = new Blob([response.data], { type: response.data.type });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        var contentDisposition = response.headers['content-disposition'];
        var fileName = file.file_name;
        if (contentDisposition) {
          var fileNameMatch = contentDisposition.match(/filename="(.+)"/);
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1];
          }
        }
        link.setAttribute('download', decodeURI(fileName));
        document.body.appendChild(link);
        link.click();
        link.remove();
        _this2.fileLoading = false;
      }).catch(function (err) {
        console.log(err);
        _this2.fileLoading = false;
      });
    }
  }
};

/***/ }),

/***/ "RBpd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RgrO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _VChipsCombobox = __webpack_require__("XMIC");

var _VChipsCombobox2 = _interopRequireDefault(_VChipsCombobox);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'UserNew',
  components: {
    VChipsCombobox: _VChipsCombobox2.default
  },
  props: {
    userData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      valid: true,
      email_primary: null,
      user: { username: '', first_name: '', last_name: '', password: '', groups: [] },
      users_groups: [],
      showPassword1: false,
      showPassword2: false,
      confirmed_password: '',
      permissionsGroups: []
    };
  },
  mounted: function mounted() {
    this.getPermissionsGroupsApi();
  },

  methods: {
    cancelEditing: function cancelEditing() {
      this.$emit('cancel');
    },
    getPermissionsGroupsApi: function getPermissionsGroupsApi() {
      var _this = this;

      this.loading = true;
      _axios2.default.get('/api/permissions_groups/?per_page=100').then(function (response) {
        _this.permissionsGroups = response.data.results;
        _this.loading = false;
      }).catch(function (err) {
        _this.loading = false;
        console.log(err);
      });
    },
    saveChanges: function saveChanges() {
      var _this2 = this;

      this.$validator.validate().then(function (valid) {
        if (valid) {
          _this2.axios.post('/api/users/', _this2.user).then(function () {
            _this2.$emit('added');
          }).catch(function (err) {
            console.log(err);
          });
        }
      });
    }
  }
};

/***/ }),

/***/ "Ro34":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-toolbar',{attrs:{"flat":""}},[_c('v-toolbar-title',[_vm._v("\n      Счётчик: "+_vm._s(_vm.counter.serial_num)+"("+_vm._s(_vm.counter.model.name)+"), ТУ: "+_vm._s(_vm.counter.point_number)+"\n    ")]),_vm._v(" "),(_vm.taskInfo && _vm.taskInfo.status==='DONE')?_c('span',{staticClass:"last-update-info"},[_vm._v("Последнее обновление было: "+_vm._s(_vm._f("moment")(_vm.taskInfo.created_at,"DD/MM/YYYY HH:mm:ss"))+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.taskInfo && _vm.taskInfo.status==='PENDING')?_c('span',{staticClass:"last-update-info"},[_vm._v("Идёт сбор значений параметров, пожалуйста подождите "),(_vm.taskInfo && _vm.taskInfo.details)?_c('span',[_vm._v(" (получено "+_vm._s(_vm.taskInfo.details)+")")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.taskInfo && _vm.taskInfo.status==='ERROR')?_c('span',{staticClass:"last-update-info"},[_vm._v("Во время сбора параметров произошла ошибка, пожалуйста обратитесь к администратору\n    ")]):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","title":"Закрыть"},on:{"click":_vm.close}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-tabs',{attrs:{"background-color":"teal darken-3","dark":"","show-arrows":""}},[_c('v-tab',[_vm._v("\n      Значения параметров счётчика\n    ")]),_vm._v(" "),_c('v-tab',[_vm._v("\n      Значения фаз\n    ")]),_vm._v(" "),_c('v-tab',[_vm._v("\n      Настройки\n    ")]),_vm._v(" "),_c('v-tab-item',[(Object.keys(_vm.counterInfo).length === 0)?_c('div',{staticClass:"refresh-warn"},[_c('v-card',{attrs:{"flat":"","min-height":"400"}},[_c('v-card-text',[_vm._v("\n            Параметры ещё не загружены, нажмите кнопку \"Обновить\"\n            "),_c('v-btn',{attrs:{"icon":"","title":"Обновить показания"},on:{"click":_vm.refreshCounterInfoParameters}},[_c('span',{staticClass:"refresh-icon"},[_c('v-icon',[_vm._v("refresh")])],1)])],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-tabs',{attrs:{"vertical":""}},[_vm._l((_vm.counterInfo),function(paramValues,paramName){return _c('v-tab',{key:paramName},[_c('span',{staticClass:"parameter-name"},[_vm._v(_vm._s(paramName))])])}),_vm._v(" "),_vm._l((_vm.counterInfo),function(paramValues,paramName){return _c('v-tab-item',{key:paramName},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',_vm._l((paramValues),function(value){return _c('div',{key:value.name},[(value.value != null && value.value.indexOf('[') >= 0)?[_c('v-expansion-panels',[_c('v-expansion-panel',[_c('v-expansion-panel-header',[_vm._v(_vm._s(value.parameter_name))]),_vm._v(" "),_c('v-expansion-panel-content',_vm._l((_vm.test(value.value)),function(value,index){return _c('div',{key:index},[_vm._v("\n                          "+_vm._s(value)+"\n                        ")])}),0)],1)],1)]:[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"12","sm":"8"}},[_vm._v("\n                      "+_vm._s(value.parameter_name)+":\n                    ")]),_vm._v(" "),(value.value != null)?[_c('v-col',{attrs:{"cols":"12","sm":"2","align":"right"}},[_c('b',[_vm._v(_vm._s(value.value))])]),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","sm":"2","align":"right"}},[_vm._v("\n                        "+_vm._s(value.measurement)+"\n                      ")])]:_c('v-col',{attrs:{"cols":"12","sm":"4","align":"right"}},[_c('b',[_vm._v("Данные не были получены")])])],2)]],2)}),0)],1)],1)})],2)],1),_vm._v(" "),_c('v-tab-item',[_c('v-card',{attrs:{"flat":"","min-height":"400"}},[_c('v-card-title',[_vm._v("Векторная диаграмма полной мощности")]),_vm._v(" "),(!_vm.phaseDataLoading && _vm.hasPhaseData)?_c('v-card-text',{staticClass:"d-flex flex-row"},[_c('v-data-table',{staticClass:"pa-2 phase-table",attrs:{"headers":_vm.phaseDataHeaders,"items":_vm.phaseData,"items-per-page":50,"hide-default-footer":"","no-data-text":"Нет данных для отображения","dense":""}}),_vm._v(" "),_c('span',{staticClass:"pa-6"},[_c('svg',{attrs:{"width":"400","height":"280"}},[_c('line',{attrs:{"stroke-width":"15","x1":"30","y1":"30","x2":"15","y2":"30","stroke":"orange"}}),_vm._v(" "),_c('text',{staticClass:"small",attrs:{"x":"40","y":"35"}},[_vm._v("Фаза A")]),_vm._v(" "),_c('line',{attrs:{"stroke-width":"15","x1":"30","y1":"50","x2":"15","y2":"50","stroke":"green"}}),_vm._v(" "),_c('text',{staticClass:"small",attrs:{"x":"40","y":"55"}},[_vm._v("Фаза B")]),_vm._v(" "),_c('line',{attrs:{"stroke-width":"15","x1":"30","y1":"70","x2":"15","y2":"70","stroke":"blue"}}),_vm._v(" "),_c('text',{staticClass:"small",attrs:{"x":"40","y":"75"}},[_vm._v("Фаза C")]),_vm._v(" "),_c('defs',[_c('marker',{attrs:{"id":"arrow_orange","viewBox":"0 0 20 20","refX":"5","refY":"5","markerWidth":"6","markerHeight":"6","orient":"auto-start-reverse"}},[_c('path',{attrs:{"d":"M 0 0 L 10 5 L 0 10 z","fill":"orange"}})]),_vm._v(" "),_c('marker',{attrs:{"id":"arrow_green","viewBox":"0 0 20 20","refX":"5","refY":"5","markerWidth":"6","markerHeight":"6","orient":"auto-start-reverse"}},[_c('path',{attrs:{"d":"M 0 0 L 10 5 L 0 10 z","fill":"green"}})]),_vm._v(" "),_c('marker',{attrs:{"id":"arrow_blue","viewBox":"0 0 20 20","refX":"5","refY":"5","markerWidth":"6","markerHeight":"6","orient":"auto-start-reverse"}},[_c('path',{attrs:{"d":"M 0 0 L 10 5 L 0 10 z","fill":"blue"}})]),_vm._v(" "),_c('marker',{attrs:{"id":"arrow_black","viewBox":"0 0 20 20","refX":"5","refY":"5","markerWidth":"6","markerHeight":"6","orient":"auto-start-reverse"}},[_c('path',{attrs:{"d":"M 0 0 L 10 5 L 0 10 z","fill":"black"}})])]),_vm._v(" "),_c('text',{staticClass:"small",attrs:{"x":"335","y":"142"}},[_vm._v("90°")]),_vm._v(" "),_c('text',{staticClass:"small",attrs:{"x":"200","y":"275"}},[_vm._v("180°")]),_vm._v(" "),_c('text',{staticClass:"small",attrs:{"x":"55","y":"145"}},[_vm._v("270°")]),_vm._v(" "),_c('text',{staticClass:"small",attrs:{"x":"205","y":"15"}},[_vm._v("0°")]),_vm._v(" "),_c('circle',{staticStyle:{"fill":"white"},attrs:{"stroke-width":"2","stroke":"black","cx":"210","cy":"140","r":"120"}}),_vm._v(" "),_c('line',{attrs:{"stroke-width":"1","x1":"90","y1":"140","x2":"330","y2":"140","stroke":"black"}}),_vm._v(" "),_c('line',{attrs:{"stroke-width":"1","x1":"210","y1":"20","x2":"210","y2":"260","stroke":"black"}}),_vm._v(" "),_c('text',{staticClass:"heavy",attrs:{"x":"290","y":"15"}},[_vm._v("I")]),_vm._v(" "),_c('line',{attrs:{"stroke-width":"3","x1":"290","y1":"20","x2":"330","y2":"20","stroke":"black","marker-end":"url(#arrow_black)"}}),_vm._v(" "),_c('text',{staticClass:"heavy",attrs:{"x":"290","y":"40"}},[_vm._v("U")]),_vm._v(" "),_c('line',{attrs:{"stroke-width":"3","x1":"290","y1":"45","x2":"380","y2":"45","stroke":"black","marker-end":"url(#arrow_black)"}}),_vm._v(" "),(_vm.showLines)?_c('g',{staticClass:"phase-line"},[_c('path',{staticClass:"phase-one",attrs:{"d":'M210 ' + _vm.uOne + 'V140',"marker-start":"url(#arrow_orange)"}})]):_vm._e(),_vm._v(" "),(_vm.showLines)?_c('g',{staticClass:"phase-line",style:({ transform: 'rotate(' + _vm.angAdditionalOne + 'deg)' })},[_c('path',{staticClass:"phase-one",attrs:{"d":'M210 ' + _vm.iOne + 'V140',"marker-start":"url(#arrow_orange)"}})]):_vm._e(),_vm._v(" "),(_vm.showLines)?_c('g',{staticClass:"phase-line",style:({ transform: 'rotate(' + _vm.angTwo + 'deg)' })},[_c('path',{staticClass:"phase-two",attrs:{"d":'M210 ' + _vm.uTwo + 'V140',"marker-start":"url(#arrow_green)"}})]):_vm._e(),_vm._v(" "),(_vm.showLines)?_c('g',{staticClass:"phase-line",style:({ transform: 'rotate(' + _vm.angAdditionalTwo + 'deg)' })},[_c('path',{staticClass:"phase-two",attrs:{"d":'M210 ' + _vm.iTwo + 'V140',"marker-start":"url(#arrow_green)"}})]):_vm._e(),_vm._v(" "),(_vm.showLines)?_c('g',{staticClass:"phase-line",style:({ transform: 'rotate(' + _vm.angThree + 'deg)' })},[_c('path',{staticClass:"phase-three",attrs:{"d":'M210 ' + _vm.uThree + 'V140',"marker-start":"url(#arrow_blue)"}})]):_vm._e(),_vm._v(" "),(_vm.showLines)?_c('g',{staticClass:"phase-line",style:({ transform: 'rotate(' + _vm.angAdditionalThree + 'deg)' })},[_c('path',{staticClass:"phase-three",attrs:{"d":'M210 ' + _vm.iThree + 'V140',"marker-start":"url(#arrow_blue)"}})]):_vm._e()])])],1):_vm._e(),_vm._v(" "),(!_vm.phaseDataLoading && !_vm.hasPhaseData)?_c('v-card-text',{staticClass:"d-flex flex-row"},[_vm._v("\n          Нет данных по фазам счётчика.\n        ")]):_vm._e()],1)],1),_vm._v(" "),_c('v-tab-item',[_c('v-card',{attrs:{"flat":"","min-height":"400"}},[_c('v-card-text',[_c('v-expansion-panels',{attrs:{"multiple":""},model:{value:(_vm.panel),callback:function ($$v) {_vm.panel=$$v},expression:"panel"}},_vm._l((_vm.counterSelectedParams),function(params,groupName){return _c('v-expansion-panel',{key:groupName},[_c('v-expansion-panel-header',[_vm._v(_vm._s(groupName))]),_vm._v(" "),_c('v-expansion-panel-content',_vm._l((params),function(parameter){return _c('v-checkbox',{key:parameter.parameter_id,attrs:{"label":parameter.parameter_name,"hide-details":""},on:{"change":function($event){return _vm.updateParameter(parameter)}},model:{value:(parameter.is_selected),callback:function ($$v) {_vm.$set(parameter, "is_selected", $$v)},expression:"parameter.is_selected"}})}),1)],1)}),1)],1)],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('span',{staticClass:"pt-1 pr-4"},[_c('v-btn',{attrs:{"icon":"","title":"Обновить показания"},on:{"click":_vm.refreshCounterInfoParameters}},[_c('span',{staticClass:"refresh-icon-white"},[_c('v-icon',[_vm._v("refresh")])],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RzfN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: {
    title: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: function _default() {
        return [{ 'index': '1', 'option': 'Помощь' }, { 'index': '1', 'option': 'Admin' }];
      }
    }
  },
  data: function data() {
    return {
      user: {},
      releaseVersion: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.axios.get('/api/users/me/').then(function (response) {
      _this.user = response.data;
      if (!_this.user.is_stuff) {
        _this.$router.push('/login');
      }
    }).catch(function (err) {
      console.log(err);
    });
  },

  methods: {
    change_drawer: function change_drawer() {
      this.$emit('change_drawer');
    },
    logout: function logout() {
      localStorage.removeItem('token');
      this.$store.commit('LOGOUT_USER');
      this.$router.push({ path: '/login' });
    }
  }
};

/***/ }),

/***/ "S7eh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('v-overlay',{attrs:{"value":_vm.fileLoading}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64"}})],1),_vm._v(" "),(_vm.loading)?_c('v-layout',{staticClass:"loading-indicator",attrs:{"justify-center":"","align-center":""}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":70,"width":7}})],1):_vm._e(),_vm._v(" "),(_vm.editing)?_c('documents-requests-required-details',{attrs:{"data":_vm.selectedItem},on:{"close":_vm.close}}):_vm._e(),_vm._v(" "),_c('v-card',{directives:[{name:"show",rawName:"v-show",value:(!_vm.firstLoading && !_vm.editing),expression:"!firstLoading && !editing"}],staticClass:"main-card"},[_c('v-card-title',[_c('p',{staticClass:"text-h5"},[_vm._v("Требуемые файлы заявок")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"fab":"","color":"primary","title":"Добавить"},on:{"click":_vm.addRequiredDocument}},[_c('v-icon',[_vm._v("add")])],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.docTypes,"options":_vm.options,"server-items-length":_vm.serverItemsLength,"fixed-header":"","no-data-text":"Нет данных для отображения","footer-props":{
        itemsPerPageText: 'Число документов на странице',
        itemsPerPageOptions: [25, 50]
      },"dense":""},on:{"update:options":function($event){_vm.options=$event}},scopedSlots:_vm._u([{key:"item",fn:function(ref){
      var item = ref.item;
return [_c('tr',{staticClass:"link-row",on:{"click":function($event){return _vm.getDetails(item)}}},[_c('td',[_vm._v(_vm._s(item.doc_required_file_name))]),_vm._v(" "),_c('td',[(item.doc_required_file_example)?_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.download(item.doc_required_file_example)}}},[_vm._v("Образец")]):_vm._e()])])]}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Smar":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "StYQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Sxpv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {},
  data: function data() {
    return {
      valid: false,
      user: '',
      password: '',
      autherror: ''
    };
  },
  beforeCreate: function beforeCreate() {
    // if (this.$store.state.isLogged) {
    //   this.$router.push('/')
    // }
  },

  methods: {
    login: function login() {
      var _this = this;

      this.autherror = '';
      if (!this.valid || !this.user || !this.password) {
        return;
      }
      _axios2.default.post('/api/api-token-auth/', {
        username: this.user,
        password: this.password
      }).then(function (response) {
        localStorage.setItem('token', response.data.token);
        _this.$store.commit('LOGIN_USER');
        _this.$router.push({ path: '/' });
      }).catch(function (response) {
        console.warn(response);
        _this.autherror = 'Неверный логин или пароль';
      });
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "T+j2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"flat":""}},[_c('v-row',[_c('v-btn',{attrs:{"fab":"","text":""},on:{"click":function($event){return _vm.$emit('close')}}},[_c('v-icon',[_vm._v("keyboard_backspace")])],1),_vm._v(" "),_c('p',{staticStyle:{"padding-top":"15px","font-size":"18px"}},[_vm._v("\n      Лицевой счёт: "+_vm._s(_vm.customer.customer_number)+"\n    ")])],1),_vm._v(" "),_c('v-card',{staticClass:"ma-3",attrs:{"max-width":"800","flat":""}},[_c('v-select',{attrs:{"items":_vm.customerTypes,"item-text":"customer_type_name","item-value":"customer_type_id","label":"Тип абонента","disabled":_vm.customer.customer_id != null,"required":""},model:{value:(_vm.customer.customer_type),callback:function ($$v) {_vm.$set(_vm.customer, "customer_type", $$v)},expression:"customer.customer_type"}}),_vm._v(" "),(_vm.customer.customer_type===1)?_c('v-card-text',[_c('v-form',{ref:"customerDetailsForm"},[_c('v-text-field',{directives:[{name:"snils",rawName:"v-snils"}],attrs:{"label":"Снилс","name":"snils","rules":[_vm.snilsValidate]},model:{value:(_vm.customer.snils),callback:function ($$v) {_vm.$set(_vm.customer, "snils", $$v)},expression:"customer.snils"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Фамилия","rules":[_vm.rules.reguired]},model:{value:(_vm.customer.last_name),callback:function ($$v) {_vm.$set(_vm.customer, "last_name", $$v)},expression:"customer.last_name"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Имя","rules":[_vm.rules.reguired]},model:{value:(_vm.customer.first_name),callback:function ($$v) {_vm.$set(_vm.customer, "first_name", $$v)},expression:"customer.first_name"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Отчество","rules":[_vm.rules.reguired]},model:{value:(_vm.customer.middle_name),callback:function ($$v) {_vm.$set(_vm.customer, "middle_name", $$v)},expression:"customer.middle_name"}})],1)],1):(_vm.customer.customer_type===2)?_c('v-card-text',[_c('v-form',{ref:"customerDetailsForm"},[_c('v-text-field',{attrs:{"label":"ИНН","rules":[_vm.innValidate],"maxlength":"12"},model:{value:(_vm.customer.company_inn),callback:function ($$v) {_vm.$set(_vm.customer, "company_inn", $$v)},expression:"customer.company_inn"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"ОГРН","rules":[_vm.rules.ogrn15],"maxlength":"15"},model:{value:(_vm.customer.company_ogrn),callback:function ($$v) {_vm.$set(_vm.customer, "company_ogrn", $$v)},expression:"customer.company_ogrn"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Фамилия","rules":[_vm.rules.reguired]},model:{value:(_vm.customer.last_name),callback:function ($$v) {_vm.$set(_vm.customer, "last_name", $$v)},expression:"customer.last_name"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Имя","rules":[_vm.rules.reguired]},model:{value:(_vm.customer.first_name),callback:function ($$v) {_vm.$set(_vm.customer, "first_name", $$v)},expression:"customer.first_name"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Отчество","rules":[_vm.rules.reguired]},model:{value:(_vm.customer.middle_name),callback:function ($$v) {_vm.$set(_vm.customer, "middle_name", $$v)},expression:"customer.middle_name"}})],1)],1):(_vm.customer.customer_type===3)?_c('v-card-text',[_c('v-form',{ref:"customerDetailsForm"},[_c('v-text-field',{attrs:{"label":"ИНН","rules":[_vm.innValidate],"maxlength":"10"},model:{value:(_vm.customer.company_inn),callback:function ($$v) {_vm.$set(_vm.customer, "company_inn", $$v)},expression:"customer.company_inn"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"КПП","rules":[_vm.rules.kpp],"maxlength":"9"},model:{value:(_vm.customer.company_kpp),callback:function ($$v) {_vm.$set(_vm.customer, "company_kpp", $$v)},expression:"customer.company_kpp"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"ОГРН","rules":[_vm.rules.ogrn13],"maxlength":"13"},model:{value:(_vm.customer.company_ogrn),callback:function ($$v) {_vm.$set(_vm.customer, "company_ogrn", $$v)},expression:"customer.company_ogrn"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Название организации","rules":[_vm.rules.reguired]},model:{value:(_vm.customer.company_full_name),callback:function ($$v) {_vm.$set(_vm.customer, "company_full_name", $$v)},expression:"customer.company_full_name"}}),_vm._v(" "),_c('p',[_vm._v("Представитель")]),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Фамилия","rules":[_vm.rules.reguired]},model:{value:(_vm.customer.last_name),callback:function ($$v) {_vm.$set(_vm.customer, "last_name", $$v)},expression:"customer.last_name"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Имя","rules":[_vm.rules.reguired]},model:{value:(_vm.customer.first_name),callback:function ($$v) {_vm.$set(_vm.customer, "first_name", $$v)},expression:"customer.first_name"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Отчество","rules":[_vm.rules.reguired]},model:{value:(_vm.customer.middle_name),callback:function ($$v) {_vm.$set(_vm.customer, "middle_name", $$v)},expression:"customer.middle_name"}})],1)],1):_vm._e(),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{on:{"click":_vm.save}},[_vm._v("\n        Сохранить\n      ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TQxd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"light":""}},[(_vm.loading)?_c('v-layout',{staticClass:"loading-indicator",attrs:{"justify-center":"","align-center":""}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":70,"width":7}})],1):_c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('h2',[_vm._v("Формирование отчета о показании счетчиков на указанную дату")])]),_vm._v(" "),_c('v-col',{attrs:{"cols":"auto"}},[_c('v-menu',{attrs:{"close-on-content-click":false,"content-class":"report-tree"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"report-tree-btn"},on),[_vm._v("Выбрать объекты")])]}}])},[_vm._v(" "),_c('report-tree-node',{attrs:{"is-root":true,"initial-represents":[],"initial-all-points":[],"represent-points":[],"represents-select-type":_vm.representsSelectType,"points-select-type":_vm.pointsSelectType,"limit-selected-points":false},on:{"repr-select":_vm.reprSelect,"point-select":_vm.pointSelect,"selected-repr-expand":_vm.selectedReprExpand}})],1)],1),_vm._v(" "),_c('v-col',[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"transition":"scale-transition","offset-y":"","max-width":"290px","min-width":"290px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-text-field',_vm._g({attrs:{"label":"Дата","prepend-icon":"event","readonly":""},model:{value:(_vm.dateComputed),callback:function ($$v) {_vm.dateComputed=$$v},expression:"dateComputed"}},on))]}}]),model:{value:(_vm.menuDate),callback:function ($$v) {_vm.menuDate=$$v},expression:"menuDate"}},[_vm._v(" "),_c('v-date-picker',{attrs:{"locale":"ru-RU","no-title":""},on:{"input":function($event){_vm.menuDate = false}},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1)],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"disabled":!_vm.canGetReport},on:{"click":function($event){return _vm.getReport()}}},[_vm._v("\n      Сформировать\n    ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TSff":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("История операций по счётчику")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-data-table',{staticClass:"counter-history-table",attrs:{"headers":_vm.headers,"items":_vm.items,"loading":_vm.loading,"options":_vm.options,"server-items-length":_vm.serverItemsLength,"fixed-header":"","no-data-text":"Нет данных для отображения","footer-props":{
              itemsPerPageText: 'Число счетчиков на странице',
              itemsPerPageOptions: [25, 50]
            },"dense":""},on:{"update:options":function($event){_vm.options=$event}},scopedSlots:_vm._u([{key:"item",fn:function(props){return _c('tr',{},[_c('td',{staticClass:"text-right"},[_vm._v("\n                "+_vm._s(props.item.counter_serial_num)+"\n              ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                "+_vm._s(_vm._f("moment")(props.item.operation_date,"DD/MM/YYYY HH:mm:ss"))+"\n              ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                "+_vm._s(props.item.coper_type_name)+"\n              ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                "+_vm._s(props.item.comment)+"\n              ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                "+_vm._s(props.item.point_name)+"\n              ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                "+_vm._s(props.item.user_name)+"\n              ")])])}}])})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","text":""},nativeOn:{"click":function($event){return _vm.close($event)}}},[_vm._v("\n      Закрыть\n    ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "U+R7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TaskLogs_vue__ = __webpack_require__("qMZ1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TaskLogs_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TaskLogs_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TaskLogs_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TaskLogs_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b6bbb76_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TaskLogs_vue__ = __webpack_require__("Bp6Q");
function injectStyle (ssrContext) {
  __webpack_require__("vFUW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7b6bbb76"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TaskLogs_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b6bbb76_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TaskLogs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "UO8w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Uc/h":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WBhS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WMuv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Wjfh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CounterEdit_vue__ = __webpack_require__("/O73");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CounterEdit_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CounterEdit_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CounterEdit_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CounterEdit_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47a10584_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CounterEdit_vue__ = __webpack_require__("6sxV");
function injectStyle (ssrContext) {
  __webpack_require__("BVF4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-47a10584"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CounterEdit_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47a10584_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CounterEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Wy/a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'ChipsCombobox',
  props: {
    model: {
      required: true
    },
    itemText: {
      required: true
    },
    itemValue: {
      required: true
    },
    label: {
      required: true
    },
    items: {
      required: true
    }
  },
  data: function data() {
    return {
      internalModel: [],
      paramsLoading: false,
      updatingInternalModel: false
    };
  },

  watch: {
    items: function items() {
      this.updatingInternalModel = true;
      if (this.isSendUpdate) {
        return;
      }
      this.internalModel = [];
      var _this = this;
      this.items.forEach(function (element) {
        if (_this.model.includes(element[_this.itemValue])) {
          _this.internalModel.push(element);
        }
      });
      setTimeout(function () {
        _this.paramsLoading = false;
      }, 1000);
      this.updatingInternalModel = false;
    },
    internalModel: function internalModel() {
      if (this.updatingInternalModel) {
        return;
      }
      var _this = this;
      this.model.length = 0;
      this.internalModel.forEach(function (element) {
        _this.model.push(element[_this.itemValue]);
      });
    }
  }
};

/***/ }),

/***/ "X9l2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PermissionsGroupNew_vue__ = __webpack_require__("565o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PermissionsGroupNew_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PermissionsGroupNew_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PermissionsGroupNew_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PermissionsGroupNew_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c6e4fc68_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PermissionsGroupNew_vue__ = __webpack_require__("t5W4");
function injectStyle (ssrContext) {
  __webpack_require__("YWxB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c6e4fc68"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PermissionsGroupNew_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c6e4fc68_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PermissionsGroupNew_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "XMIC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VChipsCombobox_vue__ = __webpack_require__("Wy/a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VChipsCombobox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VChipsCombobox_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VChipsCombobox_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VChipsCombobox_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c2e891e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VChipsCombobox_vue__ = __webpack_require__("wTnL");
function injectStyle (ssrContext) {
  __webpack_require__("WBhS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VChipsCombobox_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c2e891e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VChipsCombobox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "XmpF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointCounterPhase_vue__ = __webpack_require__("dfLT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointCounterPhase_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointCounterPhase_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointCounterPhase_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointCounterPhase_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36fa5a82_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PointCounterPhase_vue__ = __webpack_require__("9mSd");
function injectStyle (ssrContext) {
  __webpack_require__("A92p")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-36fa5a82"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointCounterPhase_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36fa5a82_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PointCounterPhase_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "XpEI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YK21":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocumentsRequests_vue__ = __webpack_require__("3RXz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocumentsRequests_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocumentsRequests_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocumentsRequests_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocumentsRequests_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ef3f2f4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DocumentsRequests_vue__ = __webpack_require__("4ycq");
function injectStyle (ssrContext) {
  __webpack_require__("47G0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7ef3f2f4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocumentsRequests_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ef3f2f4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DocumentsRequests_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "YWxB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YtJ0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _channel = __webpack_require__("q3PU");

var _channel2 = _interopRequireDefault(_channel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// A Vuex instance is created by combining the state, the actions,
// and the mutations. Because the actions and mutations are just
// functions that do not depend on the instance itself, they can
// be easily tested or even hot-reloaded (see counter-hot example).

var state = {
  isLogged: !!localStorage.getItem('token')
};

var mutations = {
  LOGIN_USER: function LOGIN_USER(state) {
    state.isLogged = true;
  },
  LOGOUT_USER: function LOGOUT_USER(state) {
    state.isLogged = false;
  }
};

exports.default = {
  modules: {
    channel: _channel2.default
  },
  strict: true,
  state: state,
  mutations: mutations
};

/***/ }),

/***/ "Z7NA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointCounterEditConnectParameters_vue__ = __webpack_require__("5Pl6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointCounterEditConnectParameters_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointCounterEditConnectParameters_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointCounterEditConnectParameters_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointCounterEditConnectParameters_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_705ded5e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PointCounterEditConnectParameters_vue__ = __webpack_require__("A8K9");
function injectStyle (ssrContext) {
  __webpack_require__("EIRp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-705ded5e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointCounterEditConnectParameters_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_705ded5e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PointCounterEditConnectParameters_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "ZENG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointCounters_vue__ = __webpack_require__("zI7b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointCounters_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointCounters_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointCounters_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointCounters_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49f17b95_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PointCounters_vue__ = __webpack_require__("hBlR");
function injectStyle (ssrContext) {
  __webpack_require__("Uc/h")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointCounters_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49f17b95_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PointCounters_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "ZMON":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

var _VChipsCombobox = __webpack_require__("XMIC");

var _VChipsCombobox2 = _interopRequireDefault(_VChipsCombobox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'PermissionsGroupEdit',
  components: {
    VChipsCombobox: _VChipsCombobox2.default
  },
  props: {
    permissionsGroupData: {}
  },
  data: function data() {
    return {
      permissionsGroup: {},
      users_groups: [],
      permissions: []
    };
  },
  mounted: function mounted() {
    this.getPermissions();
    this.permissionsGroup = this.permissionsGroupData;
  },

  methods: {
    cancelEditing: function cancelEditing() {
      this.$emit('cancel');
    },
    saveChanges: function saveChanges() {
      var _this = this;

      this.axios.patch('/api/permissions_groups/' + this.permissionsGroupData.permissions_group_id + '/', this.permissionsGroup).then(function () {
        _this.$emit('edited');
      }).catch(function (err) {
        _this.$emit('editError', err.response.data);
      });
    },
    getPermissions: function getPermissions() {
      var _this2 = this;

      _axios2.default.get('/api/permissions/').then(function (response) {
        _this2.permissions = response.data.results;
      }).catch(function (err) {
        console.log(err);
      });
    }
  }
};

/***/ }),

/***/ "ZNHz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Zoqn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'CountersModels',
  data: function data() {
    return {
      totalItems: 0,
      items: [],
      loading: true,
      headers: [{
        text: 'Наименование',
        align: 'left',
        sortable: true,
        value: 'name'
      }, {
        text: 'Источник данных',
        align: 'left',
        sortable: true,
        value: 'source'
      }, {
        text: 'Тип энергоресурса',
        align: 'left',
        sortable: true,
        value: 'resource_type'
      }, {
        text: 'API счетчика',
        align: 'left',
        sortable: false,
        value: 'external_model'
      }, {
        text: 'Наличие хранимых данных',
        align: 'left',
        sortable: false,
        value: 'has_storage'
      }, {
        text: 'Разрядность счётчика',
        align: 'right',
        sortable: false,
        value: 'counter_width'
      }, {
        text: 'Знаков после запятой',
        align: 'right',
        sortable: false,
        value: 'decimal_places'
      }, { text: 'Примечание', value: 'remark' }],
      modelId: null,
      displayParameters: false,
      counter_model_api: null,
      resource_type: null,
      breadcrumbsItems: [{
        text: 'Ресурс',
        disabled: false,
        href: 'counters_resource'
      }]
    };
  },

  watch: {
    dialog: function dialog(val) {
      val || this.close();
    }
  },
  mounted: function mounted() {
    this.counter_model_api = this.$route.query.counter_model_api;
    this.resource_type = this.$route.query.resource_type;
    this.getItemsApi();
    this.fillBreadcrumb();
  },

  methods: {
    getItemsApi: function getItemsApi() {
      var _this = this;

      this.loading = true;
      var url = '/api/counters_models/';
      if (this.counter_model_api) {
        url += '?counter_model_api=' + this.counter_model_api;
      }
      this.axios.get(url).then(function (response) {
        _this.items = response.data.results;
        _this.loading = false;
      }).catch(function (err) {
        _this.loading = false;
        console.log(err);
      });
    },
    fillBreadcrumb: function fillBreadcrumb() {
      var _this2 = this;

      if (!this.resource_type) {
        return;
      }
      this.axios.get('api/resources_types/' + this.resource_type + '/').then(function (response) {
        _this2.breadcrumbsItems.push({
          text: response.data.name,
          disabled: false,
          href: 'counters_models_api?resource_type=' + _this2.resource_type
        });
        _this2.axios.get('api/counters_api/' + _this2.counter_model_api + '/').then(function (modelApiResponse) {
          _this2.breadcrumbsItems.push({
            text: modelApiResponse.data.name,
            disabled: true
          });
        });
      });
    },
    openBreadcrumbsUrl: function openBreadcrumbsUrl(item) {
      this.$router.push({ path: item.href });
    },
    showParameters: function showParameters(item) {
      this.$router.push({ path: 'counter_model_parameters',
        query: {
          counter_model: item.model_id
        }
      });
    }
  }
};

/***/ }),

/***/ "a1S9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CounterNew_vue__ = __webpack_require__("KeRq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CounterNew_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CounterNew_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CounterNew_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CounterNew_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e9d0ea9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CounterNew_vue__ = __webpack_require__("+PTj");
function injectStyle (ssrContext) {
  __webpack_require__("OVKk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1e9d0ea9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CounterNew_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e9d0ea9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CounterNew_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "a9T9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.loading)?_c('v-layout',{staticClass:"loading-indicator",attrs:{"justify-center":"","align-center":""}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":70,"width":7}})],1):_vm._e(),_vm._v(" "),_c('v-card',{staticClass:"main-card"},[_c('v-card-title',[_c('p',{staticClass:"text-h5"},[_vm._v("Настройки аккаунта")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-text',[_c('v-text-field',{attrs:{"label":"Наименование аккаунта"},model:{value:(_vm.account_data.name),callback:function ($$v) {_vm.$set(_vm.account_data, "name", $$v)},expression:"account_data.name"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Email сбыт"},model:{value:(_vm.account_data.external_notify_email),callback:function ($$v) {_vm.$set(_vm.account_data, "external_notify_email", $$v)},expression:"account_data.external_notify_email"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Email поддержки"},model:{value:(_vm.account_data.support_email),callback:function ($$v) {_vm.$set(_vm.account_data, "support_email", $$v)},expression:"account_data.support_email"}})],1),_vm._v(" "),_c('v-card-actions',[(_vm.isEdited)?_c('v-btn',{staticClass:"mr-4",attrs:{"color":"success"},on:{"click":_vm.save}},[_vm._v("\n            Сохранить\n          ")]):_vm._e(),_vm._v(" "),(_vm.isEdited)?_c('v-btn',{staticClass:"mr-4",on:{"click":_vm.cancel}},[_vm._v("\n            Отмена\n          ")]):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aGFK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var messages = {
  required: function required() {
    return 'Это поле обязательно к заполнению';
  },
  email: function email() {
    return 'Укажите правильный email';
  }
};

var dictionary = {
  en: {
    messages: messages
  },
  ru: {
    messages: messages
  }
};

exports.default = function (Validator) {
  // Example of how to use a custom validator
  Validator.localize(dictionary);
};

/***/ }),

/***/ "aL9m":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueChartjs = __webpack_require__("UlOv");

exports.default = {
  extends: _vueChartjs.Line,
  props: {
    chartDatasets: {
      type: Array,
      required: false
    },
    chartLabels: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      options: {
        tooltips: {
          position: 'average',
          mode: 'index',
          intersect: false
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            },
            gridLines: {
              display: true
            }
          }],
          xAxes: [{
            ticks: {
              maxRotation: 80
            },
            gridLines: {
              display: false
            }
          }]
        },
        legend: {
          display: false
        },
        responsive: true,
        maintainAspectRatio: false
      }
    };
  },

  watch: {
    chartDatasets: function chartDatasets() {
      this.update();
    }
  },
  mounted: function mounted() {
    this.update();
  },

  methods: {
    update: function update() {
      this.renderChart({
        labels: this.chartLabels,
        datasets: this.chartDatasets
      }, this.options);
    }
  }
};

/***/ }),

/***/ "amS/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ax5m":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'PointCounterTakeOff',
  props: {
    counterData: {}
  },
  data: function data() {
    return {
      operDateMenu: false,
      operDateVal: null,
      operDate: null,
      counter_oper: {
        'operation_date': null,
        'comment': null
      }
    };
  },

  watch: {
    operDateVal: function operDateVal() {
      this.operDate = this.formatDate(this.operDateVal);
      this.counter_oper.operation_date = this.operDateVal;
    }
  },
  mounted: function mounted() {
    var currentDate = new Date();
    this.operDateVal = this.parseDate(currentDate.getDate() + '/' + (currentDate.getMonth() + 1) + '/' + currentDate.getFullYear());
  },

  methods: {
    cancelEditing: function cancelEditing() {
      this.$emit('cancel');
    },
    saveChanges: function saveChanges() {
      var _this = this;

      this.axios.post('/api/point_counter/' + this.counterData.counter_id + '/take_off/', this.counter_oper).then(function () {
        _this.$emit('edited');
      }).catch(function (err) {
        _this.$emit('editError', err.response.data);
      });
    },
    formatDate: function formatDate(date) {
      if (!date) return null;

      var _date$split = date.split('-'),
          _date$split2 = _slicedToArray(_date$split, 3),
          year = _date$split2[0],
          month = _date$split2[1],
          day = _date$split2[2];

      return day + '/' + month + '/' + year;
    },
    parseDate: function parseDate(date) {
      if (!date) return null;

      var _date$split3 = date.split('/'),
          _date$split4 = _slicedToArray(_date$split3, 3),
          day = _date$split4[0],
          month = _date$split4[1],
          year = _date$split4[2];

      return year + '-' + month.padStart(2, '0') + '-' + day.padStart(2, '0');
    }
  }
};

/***/ }),

/***/ "bB1z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointToolbar_vue__ = __webpack_require__("uQuX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointToolbar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointToolbar_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointToolbar_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointToolbar_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15b19ff7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PointToolbar_vue__ = __webpack_require__("tlZN");
function injectStyle (ssrContext) {
  __webpack_require__("StYQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-15b19ff7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointToolbar_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15b19ff7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PointToolbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "bsIX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('v-card',{staticClass:"mx-auto",attrs:{"outlined":""}},[_c('v-list-item',{attrs:{"three-line":""}},[_c('v-list-item-content',[_c('div',{staticClass:"title"},[_vm._v("Версия: 1.5.2")]),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("Сборка: 22.12.2021 00:00")])])],1),_vm._v(" "),_c('v-list-item',{attrs:{"three-line":""}},[_c('v-list-item-content',[_c('div',{staticClass:"title"},[_vm._v("Версия: 1.3.3")]),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("Сборка: 20.05.2020 12:05")]),_vm._v(" "),_c('v-list-item-title',[_vm._v("Добавлен Личный Кабинет по Электросетям с возможностью:")]),_vm._v(" "),_c('v-list-item-subtitle',{staticClass:"pl-8"},[_vm._v("Занести информацию по аккаунту")]),_vm._v(" "),_c('v-list-item-subtitle',{staticClass:"pl-8"},[_vm._v("Занести информацию поабоненту в разрезе")]),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-subtitle',{staticClass:"pl-8"},[_vm._v("Физического лица")]),_vm._v(" "),_c('v-list-item-subtitle',{staticClass:"pl-8"},[_vm._v("Индивидуального предпринимателя")]),_vm._v(" "),_c('v-list-item-subtitle',{staticClass:"pl-8"},[_vm._v("Юридического лица")])],1),_vm._v(" "),_c('v-list-item-subtitle',{staticClass:"pl-8"},[_vm._v("Отправить заявление оператору Электрических сетей")]),_vm._v(" "),_c('v-list-item-subtitle',{staticClass:"pl-8"},[_vm._v("Получить помощь и поддержку от Электрических сетей")]),_vm._v(" "),_c('v-list-item-title',[_vm._v("Со стороны оператора:")]),_vm._v(" "),_c('v-list-item-subtitle',{staticClass:"pl-8"},[_vm._v("Добавлены «Шаблоны заявок»")]),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-subtitle',{staticClass:"pl-8"},[_vm._v("Добавлены «Типы заявок»")]),_vm._v(" "),_c('v-list-item-subtitle',{staticClass:"pl-8"},[_vm._v("Добавлены «Требуемые файлы заявок»")])],1),_vm._v(" "),_c('v-list-item-subtitle',{staticClass:"pl-8"},[_vm._v("Добавлена форма «Поступившие заявки», они позволяют")]),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-subtitle',{staticClass:"pl-8"},[_vm._v("Отрабатывать поступившие документы от абонента")]),_vm._v(" "),_c('v-list-item-subtitle',{staticClass:"pl-8"},[_vm._v("Отправлять документы абоненту")]),_vm._v(" "),_c('v-list-item-subtitle',{staticClass:"pl-8"},[_vm._v("Выносить решение о принятии или отказе по документам")])],1)],1)],1),_vm._v(" "),_c('v-list-item',{attrs:{"three-line":""}},[_c('v-list-item-content',[_c('div',{staticClass:"title"},[_vm._v("Версия: 1.2.3")]),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("Сборка: 19.05.2020 10:25")]),_vm._v(" "),_c('v-list-item-title',[_vm._v("Форма \"Объектов\":")]),_vm._v(" "),_c('v-list-item-subtitle',{staticClass:"pl-8"},[_vm._v("Ускорение получение информации на всех вкладках")]),_vm._v(" "),_c('v-list-item-subtitle',{staticClass:"pl-8"},[_vm._v("Ускорение получение информации на всех вкладках")]),_vm._v(" "),_c('v-list-item-subtitle',{staticClass:"pl-8"},[_vm._v("Добавлены всплывающие подсказки для всех контролов")]),_vm._v(" "),_c('v-list-item-subtitle',{staticClass:"pl-8"},[_vm._v("При присвоении ТУ добавлена информация о привязанных объектах")]),_vm._v(" "),_c('v-list-item-subtitle',{staticClass:"pl-8"},[_vm._v("При присовоении ТУ добавлена возможность просмотреть весь список")]),_vm._v(" "),_c('v-list-item-subtitle',{staticClass:"pl-8"},[_vm._v("Убран столбец \"Мониторинг\"")]),_vm._v(" "),_c('v-list-item-subtitle',{staticClass:"pl-8"},[_vm._v("Убран столбец \"Инфо\"")]),_vm._v(" "),_c('v-list-item-subtitle',{staticClass:"pl-8"},[_vm._v("Исправлена ошибка при переключениях между объектами")]),_vm._v(" "),_c('v-list-item-title',[_vm._v("Форма \"Текущие показания\":")]),_vm._v(" "),_c('v-list-item-subtitle',{staticClass:"pl-8"},[_vm._v("Получение данных сделано асинхронным")]),_vm._v(" "),_c('v-list-item-subtitle',{staticClass:"pl-8"},[_vm._v("Последние показания сохраняются")]),_vm._v(" "),_c('v-list-item-subtitle',{staticClass:"pl-8"},[_vm._v("Добавлена возможность выбора необходимых для получения показаний")]),_vm._v(" "),_c('v-list-item-subtitle',{staticClass:"pl-8"},[_vm._v("Добавлены параметры измерения")]),_vm._v(" "),_c('v-list-item-title',[_vm._v("Форма \"Точки учёта\":")]),_vm._v(" "),_c('v-list-item-subtitle',{staticClass:"pl-8"},[_vm._v("Добавлена информация об отсутсвующх счётчиках")]),_vm._v(" "),_c('v-list-item-subtitle',{staticClass:"pl-8"},[_vm._v("Добавлена информация о привязанных объектах")]),_vm._v(" "),_c('v-list-item-subtitle',{staticClass:"pl-8"},[_vm._v("Добавлены всплывающие подсказки для всех контролов")]),_vm._v(" "),_c('v-list-item-subtitle',{staticClass:"pl-8"},[_vm._v("На вкладке счётчиков добавлена информация о статусе счётчика")]),_vm._v(" "),_c('v-list-item-subtitle',{staticClass:"pl-8"},[_vm._v("На вкладке счётчиков добавлена информация о \"Коэф.трансформации тока\"")]),_vm._v(" "),_c('v-list-item-subtitle',{staticClass:"pl-8"},[_vm._v("На вкладке счётчиков доступность контролов меняется в зависимости от статуса счётчика")]),_vm._v(" "),_c('v-list-item-subtitle',{staticClass:"pl-8"},[_vm._v("На вкладке счётчиков при снятии счётчика добавлено поле \"Причина снятия счётчика\"")]),_vm._v(" "),_c('v-list-item-subtitle',{staticClass:"pl-8"},[_vm._v("Полностью изменена форма добавления счётчика по точке учёта")]),_vm._v(" "),_c('v-list-item-title',[_vm._v("Справочник \"Модели счётчиков\":")]),_vm._v(" "),_c('v-list-item-subtitle',{staticClass:"pl-8"},[_vm._v("Полностью переработана")]),_vm._v(" "),_c('v-list-item-title',[_vm._v("Отчёты:")]),_vm._v(" "),_c('v-list-item-subtitle',{staticClass:"pl-8"},[_vm._v("Добавлен - \"Профили мощности\"")]),_vm._v(" "),_c('v-list-item-subtitle',{staticClass:"pl-8"},[_vm._v("Добавлен - \"Показание счетчиков и потребление электрической энергии за период с учетом тарифных зон\"")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cBNx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cJ5F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[[_c('v-card',{staticClass:"monitoring-card"},[_c('v-card-title',[_c('v-flex',{staticClass:"panel-without-shadow",attrs:{"xs12":""}},[_c('v-expansion-panels',[_c('v-expansion-panel',{key:"1"},[_c('v-expansion-panel-header',[_c('a',{staticClass:"monitoring-header-text monitoring-header-params"},[_c('v-icon',[_vm._v("mdi-airplay")]),_vm._v("\n                  Параметры мониторинга\n                ")],1)]),_vm._v(" "),_c('v-expansion-panel-content',[_c('v-card-text',[_c('v-combobox',{attrs:{"type":"number","items":[5,10,20],"label":'Число отображаемых последних запросов к счётчику (макс '+_vm.lastInteractionsNumMax+')'},model:{value:(_vm.lastInteractionsNum),callback:function ($$v) {_vm.lastInteractionsNum=$$v},expression:"lastInteractionsNum"}}),_vm._v(" "),_c('v-combobox',{attrs:{"type":"number","items":[0,30,60],"label":'Частота обновления данных в сек (макс '+_vm.refreshPeriodMax+')'},model:{value:(_vm.refreshPeriod),callback:function ($$v) {_vm.refreshPeriod=$$v},expression:"refreshPeriod"}})],1)],1)],1)],1),_vm._v(" "),_c('v-chip-group',{attrs:{"active-class":"primary--text"},model:{value:(_vm.monitorStatusSelect),callback:function ($$v) {_vm.monitorStatusSelect=$$v},expression:"monitorStatusSelect"}},_vm._l((_vm.monitorStatuses),function(monitorStatus){return _c('v-chip',{key:monitorStatus.value,attrs:{"value":monitorStatus.value}},[_vm._v("\n              "+_vm._s(monitorStatus.text)+"\n            ")])}),1),_vm._v(" "),_c('v-switch',{attrs:{"label":"Отображать скрытые задания"},model:{value:(_vm.showHidden),callback:function ($$v) {_vm.showHidden=$$v},expression:"showHidden"}})],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"items":_vm.filteredTasks,"headers":_vm.monitoringHeaders,"fixed-header":"","no-data-text":"Нет заданий с ошибками","hide-default-footer":"","disable-pagination":"","loading":_vm.loading,"loading-text":"Пожалуйста подождите","dense":""},scopedSlots:_vm._u([{key:"item",fn:function(props){return _c('tr',{},[_c('td',[_c('span',{staticClass:"one-row"},[_c('router-link',{attrs:{"to":'/counters?search=' + props.item.counter_num,"title":"Переход в раздел счетчики"}},[_vm._v(_vm._s(props.item.counter_num))]),_vm._v(" "),_c('a',{staticClass:"external-link",attrs:{"target":"_blank","href":'/counters?search=' + props.item.counter_num,"title":"Открыть раздел счетчики, в новой вкладке(окне)"}},[_c('v-icon',[_vm._v("mdi-open-in-new")])],1)],1)]),_vm._v(" "),_c('td',{staticClass:"one-row"},[_c('router-link',{attrs:{"to":'/points/' + props.item.point_id + '/scheduler',"title":"Переход в раздел Точки учета"}},[_vm._v(_vm._s(props.item.point_name))]),_vm._v(" "),(props.item.point_name)?_c('a',{staticClass:"external-link",attrs:{"target":"_blank","href":'/points/' + props.item.point_id + '/scheduler',"title":"Открыть раздел Точки учета, в новой вкладке(окне)"}},[_c('v-icon',[_vm._v("mdi-open-in-new")])],1):_vm._e()],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.point_address))]),_vm._v(" "),_c('td',[(props.item.represents !== null)?[_vm._l((props.item.represents),function(represent){return [_c('div',{key:represent.name,staticClass:"one-row"},[_c('router-link',{attrs:{"to":'/represents/' + represent.represent_id,"title":"Переход в раздел Объекты учета"}},[_vm._v(_vm._s(represent.name))]),_vm._v(" "),(represent.represent_id)?_c('a',{staticClass:"external-link",attrs:{"target":"_blank","href":'/represents/' + represent.represent_id,"title":"Открыть раздел Объекты учета, в новой вкладке(окне)"}},[_c('v-icon',[_vm._v("mdi-open-in-new")])],1):_vm._e()],1)]})]:_vm._e()],2),_vm._v(" "),_c('td',[(props.item.last_values)?[_vm._l((props.item.last_values.slice().reverse()),function(item){return [_c('v-icon',{staticClass:"squares",attrs:{"color":item.success ? 'green' : 'red'}},[_vm._v("mdi-square")])]})]:_vm._e()],2),_vm._v(" "),_c('td',[_vm._v("\n            "+_vm._s(_vm._f("moment")(props.item.last_interaction_date,"DD/MM/YYYY HH:mm:ss"))+"\n          ")]),_vm._v(" "),_c('td',{staticClass:"one-row"},[_c('span',{staticClass:"action-btns"},[(_vm.hideFromFailedTasks[props.item.counter_task_id])?_c('v-btn',{staticClass:"mt-1",attrs:{"icon":"","title":"Вернуть из скрытых"},on:{"click":function($event){return _vm.hideFromResults(props.item, true)}}},[_c('v-icon',{attrs:{"color":"grey darken-1"}},[_vm._v("mdi-eye-off")])],1):_c('v-btn',{staticClass:"mt-1",attrs:{"icon":"","title":"Скрыть из результатов на 1 час"},on:{"click":function($event){return _vm.hideFromResults(props.item, false)}}},[_c('v-icon',{attrs:{"color":"grey darken-4"}},[_vm._v("mdi-eye")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mt-1",attrs:{"icon":"","title":"Журнал выполнения"},on:{"click":function($event){return _vm.viewCounterTaskLog(props.item)}}},[_c('v-icon',{attrs:{"color":"grey darken-1"}},[_vm._v("fas fa-file-alt")])],1)],1)])])}}])},[_c('div',{staticClass:"data-table-footer",attrs:{"slot":"footer"},slot:"footer"})])],1),_vm._v(" "),_c('v-bottom-sheet',{model:{value:(_vm.showLog),callback:function ($$v) {_vm.showLog=$$v},expression:"showLog"}},[_c('task-logs',{attrs:{"task":_vm.log_task}})],1)]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cdaD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.loading)?_c('v-layout',{staticClass:"loading-indicator",attrs:{"justify-center":"","align-center":""}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":70,"width":7}})],1):_vm._e(),_vm._v(" "),(_vm.editing)?_c('documents-requests-type-details',{attrs:{"data":_vm.selectedItem},on:{"close":_vm.close}}):_vm._e(),_vm._v(" "),_c('v-card',{directives:[{name:"show",rawName:"v-show",value:(!_vm.firstLoading && !_vm.editing),expression:"!firstLoading && !editing"}],staticClass:"main-card"},[_c('v-card-title',[_c('p',{staticClass:"text-h5"},[_vm._v("Типы документов")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"fab":"","color":"primary","title":"Добавить"},on:{"click":_vm.addDocumentType}},[_c('v-icon',[_vm._v("add")])],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.docTypes,"options":_vm.options,"server-items-length":_vm.serverItemsLength,"fixed-header":"","no-data-text":"Нет данных для отображения","footer-props":{
        itemsPerPageText: 'Число документов на странице',
        itemsPerPageOptions: [25, 50]
      },"dense":""},on:{"update:options":function($event){_vm.options=$event}},scopedSlots:_vm._u([{key:"item",fn:function(ref){
      var item = ref.item;
return [_c('tr',{staticClass:"link-row",on:{"click":function($event){return _vm.getDetails(item)}}},[_c('td',[_vm._v(_vm._s(item.doc_customer_type.customer_type_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.doc_type_name))])])]}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cuZ9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dLd/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.008f427.png";

/***/ }),

/***/ "dfLT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PointToolbar = __webpack_require__("bB1z");

var _PointToolbar2 = _interopRequireDefault(_PointToolbar);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'PointConsumption',
  components: {
    PointToolbar: _PointToolbar2.default
  },
  data: function data() {
    return {
      pointId: this.$route.params['id'],
      point: { name: '' },
      phaseDataHeaders: [{
        text: 'Наименование',
        align: 'left',
        sortable: false,
        value: 'name'
      }, {
        text: 'Фаза A',
        align: 'center',
        sortable: false,
        value: 'v1'
      }, {
        text: 'Фаза B',
        align: 'center',
        sortable: false,
        value: 'v2'
      }, {
        text: 'Фаза C',
        align: 'center',
        sortable: false,
        value: 'v3'
      }, {
        text: 'Сумма',
        align: 'center',
        sortable: false,
        value: 'v4'
      }, {
        text: '',
        align: 'center',
        sortable: false,
        value: 'measure'
      }],
      phaseData: [],
      additionalAng: 15,
      uOne: 0,
      iOne: 0,
      uTwo: 0,
      iTwo: 0,
      angTwo: 0,
      angAdditionalOne: 0,
      angAdditionalTwo: 0,
      uThree: 0,
      iThree: 0,
      angThree: 0,
      angAdditionalThree: 0,
      showLines: false,
      phaseDataLoading: true,
      hasPhaseData: false
    };
  },

  watch: {},
  mounted: function mounted() {
    this.getPointApi();
  },

  methods: {
    getPointApi: function getPointApi() {
      var _this = this;

      _axios2.default.get('/api/points/' + this.pointId + '/').then(function (response) {
        _this.point = response.data;
        if (_this.point.counter_id) {
          _this.getCounterPhaseData();
        } else {
          _this.phaseDataLoading = false;
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    getCounterPhaseData: function getCounterPhaseData() {
      var _this2 = this;

      _axios2.default.get('/api/counters/' + this.point.counter_id + '/phase/').then(function (response) {
        _this2.hasPhaseData = response.data.values_date != null;
        _this2.phaseData = response.data.values;
        var u1 = parseFloat(_this2.phaseData[4].v1);
        var u2 = parseFloat(_this2.phaseData[4].v2);
        var u3 = parseFloat(_this2.phaseData[4].v3);
        var i1 = parseFloat(_this2.phaseData[5].v1);
        var i2 = parseFloat(_this2.phaseData[5].v2);
        var i3 = parseFloat(_this2.phaseData[5].v3);
        _this2.angTwo = parseFloat(_this2.phaseData[6].v4);
        _this2.angThree = parseFloat(_this2.phaseData[6].v4) + parseFloat(_this2.phaseData[8].v4);

        var angAddOne = _this2.phaseData[9].v4 !== '' ? parseFloat(parseFloat(_this2.phaseData[9].v4)) : _this2.additionalAng;
        var angAddTwo = _this2.phaseData[10].v4 !== '' ? parseFloat(parseFloat(_this2.phaseData[10].v4)) : _this2.additionalAng;
        var angAddThree = _this2.phaseData[11].v4 !== '' ? parseFloat(parseFloat(_this2.phaseData[11].v4)) : _this2.additionalAng;

        var uMax = Math.max(u1, u2, u3, 0.001);
        var iMax = Math.max(i1, i2, i3, 0.001);
        var lineLen = 140;
        var shortLineLen = 70;
        var maxLineLen = 165;
        _this2.uOne = maxLineLen - lineLen / uMax * u1;
        _this2.iOne = lineLen - shortLineLen / iMax * i1;
        _this2.uTwo = maxLineLen - lineLen / uMax * u2;
        _this2.iTwo = lineLen - shortLineLen / iMax * i2;
        _this2.uThree = maxLineLen - lineLen / uMax * u3;
        _this2.iThree = lineLen - shortLineLen / iMax * i3;
        _this2.angAdditionalOne = angAddOne;
        _this2.angAdditionalTwo = _this2.angTwo + angAddTwo;
        _this2.angAdditionalThree = _this2.angThree + angAddThree;
        _this2.showLines = true;
        _this2.phaseDataLoading = false;
      }).catch(function (err) {
        _this2.phaseDataLoading = false;
        console.log(err);
      });
    }
  }
};

/***/ }),

/***/ "dnJz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'ReleaseNotes'
};

/***/ }),

/***/ "dzHQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserNew_vue__ = __webpack_require__("RgrO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserNew_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserNew_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserNew_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserNew_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22ac90f3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserNew_vue__ = __webpack_require__("lumk");
function injectStyle (ssrContext) {
  __webpack_require__("1EuA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-22ac90f3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserNew_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22ac90f3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserNew_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "ej/o":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ejtE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.resource_type)?_c('v-breadcrumbs',{attrs:{"items":_vm.breadcrumbsItems},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
return [_c('v-breadcrumbs-item',{attrs:{"href":"#","disabled":item.disabled},on:{"click":function($event){return _vm.openBreadcrumbsUrl(item)}}},[_vm._v("\n        "+_vm._s(item.text)+"\n      ")])]}}],null,false,3791575482)}):_vm._e(),_vm._v(" "),(!_vm.displayParameters)?_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"loading":_vm.loading,"fixed-header":"","no-data-text":"Нет моделей для отображения","hide-default-footer":"","disable-pagination":"","dense":""},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
return [_c('tr',{staticClass:"link-row",on:{"click":function($event){return _vm.showParameters(item)}}},[_c('td',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.source.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.resource_type.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.external_model.model_name))]),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[(item.has_storage)?_c('v-icon',{attrs:{"color":"green"}},[_vm._v("check")]):_vm._e()],1),_vm._v(" "),_c('td',{attrs:{"align":"right"}},[_vm._v(_vm._s(item.counter_width))]),_vm._v(" "),_c('td',{attrs:{"align":"right"}},[_vm._v(_vm._s(item.decimal_places))]),_vm._v(" "),_c('td',{attrs:{"align":"right"}},[_vm._v(_vm._s(item.remark))])])]}}],null,false,544789803)}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ewES":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountEmailsDetails_vue__ = __webpack_require__("l63n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountEmailsDetails_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountEmailsDetails_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountEmailsDetails_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountEmailsDetails_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bcc73d2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountEmailsDetails_vue__ = __webpack_require__("m6be");
function injectStyle (ssrContext) {
  __webpack_require__("w6S0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountEmailsDetails_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bcc73d2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountEmailsDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "fFfG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"light":""}},[(_vm.loading)?_c('v-layout',{staticClass:"loading-indicator",attrs:{"justify-center":"","align-center":""}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":70,"width":7}})],1):_c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('h2',[_vm._v("Показание счетчиков и потребление электрической энергии за период с учетом тарифных зон")])]),_vm._v(" "),_c('v-col',{attrs:{"cols":"auto"}},[_c('v-menu',{attrs:{"close-on-content-click":false,"content-class":"report-tree"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"report-tree-btn"},on),[_vm._v("Выбрать объекты")])]}}])},[_vm._v(" "),_c('report-tree-node',{attrs:{"is-root":true,"initial-represents":[],"initial-all-points":[],"represent-points":[],"represents-select-type":_vm.representsSelectType,"points-select-type":_vm.pointsSelectType,"limit-selected-points":false},on:{"repr-select":_vm.reprSelect,"point-select":_vm.pointSelect,"selected-repr-expand":_vm.selectedReprExpand}})],1)],1),_vm._v(" "),_c('v-col',[_c('v-menu',{ref:"menuBegDate",attrs:{"close-on-content-click":false,"nudge-right":40,"transition":"scale-transition","offset-y":"","max-width":"290px","min-width":"290px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-text-field',_vm._g({attrs:{"label":"Дата начала отчетного периода","prepend-icon":"event","readonly":""},model:{value:(_vm.begDateComputed),callback:function ($$v) {_vm.begDateComputed=$$v},expression:"begDateComputed"}},on))]}}]),model:{value:(_vm.menuBegDate),callback:function ($$v) {_vm.menuBegDate=$$v},expression:"menuBegDate"}},[_vm._v(" "),_c('v-date-picker',{attrs:{"locale":"ru-RU","no-title":""},on:{"input":function($event){_vm.menuBegDate = false}},model:{value:(_vm.begDate),callback:function ($$v) {_vm.begDate=$$v},expression:"begDate"}})],1)],1),_vm._v(" "),_c('v-col',[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"transition":"scale-transition","offset-y":"","max-width":"290px","min-width":"290px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-text-field',_vm._g({attrs:{"label":"Дата окончания отчётного периода","prepend-icon":"event","readonly":""},model:{value:(_vm.endDateComputed),callback:function ($$v) {_vm.endDateComputed=$$v},expression:"endDateComputed"}},on))]}}]),model:{value:(_vm.menuEndDate),callback:function ($$v) {_vm.menuEndDate=$$v},expression:"menuEndDate"}},[_vm._v(" "),_c('v-date-picker',{attrs:{"locale":"ru-RU","no-title":""},on:{"input":function($event){_vm.menuEndDate = false}},model:{value:(_vm.endDate),callback:function ($$v) {_vm.endDate=$$v},expression:"endDate"}})],1)],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"disabled":!_vm.canGetReport},on:{"click":function($event){return _vm.getReport()}}},[_vm._v("\n      Сформировать\n    ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fuxO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TaskLogs = __webpack_require__("U+R7");

var _TaskLogs2 = _interopRequireDefault(_TaskLogs);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'Tasks',
  components: {
    TaskLogs: _TaskLogs2.default
  },
  data: function data() {
    return {
      showLog: false,
      loading: true,
      options: { page: 1, itemsPerPage: 25 },
      serverItemsLength: 0,
      headers: [{ text: 'Номер счётчика', value: 'counter_num' }, { text: 'Модель счетчика', value: 'counter_model' }, { text: 'Номер Точки учёта', value: 'point_number' }, { text: 'Состояние', value: 'state' }, { text: 'Действия', value: 'actions' }],
      editedTaskItem: { counter_id: '', counter_parameters: [] },
      startTaskDate: false,
      tasks: [],
      getTimer: '',
      deleteTimer: '',
      search: '',
      searchTimer: ''
    };
  },

  watch: {
    options: {
      handler: function handler() {
        this.getTasksApiTimer();
      },

      deep: true
    },
    search: function search() {
      var _this = this;

      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(function () {
        _this.options.page = 1;
        _this.getTasksApiTimer();
      }, 500);
    }
  },
  mounted: function mounted() {
    if (this.$route.query.search) {
      this.search = this.$route.query.search;
    }
  },

  methods: {
    getTasksApi: function getTasksApi() {
      var _this2 = this;

      this.loading = true;
      _axios2.default.get('/api/counters_tasks/?per_page=' + this.options.itemsPerPage + '&page=' + this.options.page + '&search=' + this.search + '&order_by=counter_id').then(function (response) {
        _this2.tasks = response.data.results;
        _this2.serverItemsLength = response.data.count;
      }).catch(function (err) {
        console.log(err);
      }).finally(function () {
        _this2.loading = false;
      });
    },
    getTasksApiTimer: function getTasksApiTimer() {
      var _this3 = this;

      clearTimeout(this.getTimer);
      this.getTimer = setTimeout(function () {
        _this3.getTasksApi();
      }, 100);
    },
    startCounterTaskApi: function startCounterTaskApi(item) {
      var _this4 = this;

      var id = item.counter_task_id;
      _axios2.default.post('/api/counters_tasks/' + id + '/start_scheduler/').then(function (response) {
        var index = _this4.tasks.indexOf(item);
        Object.assign(_this4.tasks[index], response.data);
        _this4.editedTaskItem = Object.assign({}, response.data);
      }).catch(function (err) {
        console.log(err);
      });
    },
    stopCounterTaskApi: function stopCounterTaskApi(item) {
      var _this5 = this;

      var id = item.counter_task_id;
      _axios2.default.post('/api/counters_tasks/' + id + '/stop_scheduler/').then(function (response) {
        var index = _this5.tasks.indexOf(item);
        Object.assign(_this5.tasks[index], response.data);
        _this5.editedTaskItem = Object.assign({}, response.data);
      }).catch(function (err) {
        console.log(err);
      });
      this.taskEditing = false;
    },
    stopTasks: function stopTasks(item) {
      this.stopCounterTaskApi(item);
    },
    startTasks: function startTasks(item) {
      this.startCounterTaskApi(item);
    },
    viewCounterTaskLog: function viewCounterTaskLog(item) {
      this.showLog = true;
      this.editedCounterTaskIndex = this.tasks.indexOf(item);
      this.editedTaskItem = Object.assign({}, item);
    }
  }
};

/***/ }),

/***/ "g3JH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gMC7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AccountEmailsDetails = __webpack_require__("ewES");

var _AccountEmailsDetails2 = _interopRequireDefault(_AccountEmailsDetails);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'AccountEmails',
  components: {
    AccountEmailsDetails: _AccountEmailsDetails2.default
  },
  data: function data() {
    return {
      loading: true,
      firstLoading: true,
      options: { page: 1, itemsPerPage: 25 },
      selectedItem: {},
      emails: [],
      editing: false,
      serverItemsLength: 0,
      headers: [{
        text: 'Название почты',
        align: 'left',
        sortable: false,
        value: 'name'
      }, {
        text: 'Логин',
        align: 'left',
        sortable: false,
        value: 'smtp_user'
      }],
      getTimer: ''
    };
  },

  watch: {
    options: {
      handler: function handler() {
        this.getEmailsTimer();
      },

      deep: true
    }
  },
  methods: {
    getEmails: function getEmails() {
      var _this = this;

      this.loading = true;
      this.axios.get('/api/account_emails/?per_page=' + this.options.itemsPerPage + '&page=' + this.options.page).then(function (response) {
        _this.emails = response.data.results;
        _this.serverItemsLength = response.data.count;
      }).catch(function (err) {
        console.log(err);
      }).finally(function () {
        _this.firstLoading = false;
        _this.loading = false;
      });
    },
    getEmailsTimer: function getEmailsTimer() {
      var _this2 = this;

      clearTimeout(this.getTimer);
      this.getTimer = setTimeout(function () {
        _this2.getEmails();
      }, 100);
    },
    getDetails: function getDetails(item) {
      this.selectedItem = item;
      this.editing = true;
    },
    addEmail: function addEmail() {
      this.selectedItem = {
        account_email_id: null,
        name: ''
      };
      this.editing = true;
    },
    close: function close() {
      this.getEmailsTimer();
      this.editing = false;
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "gUJg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.adding)?_c('permissions-group-new',{on:{"cancel":_vm.cancelAdding,"added":_vm.permissionsGroupAdded}}):(_vm.editing)?_c('permissions-group-edit',{attrs:{"permissions-group-data":_vm.selectedPermissionsGroupData},on:{"cancel":_vm.cancelEditing,"edited":_vm.permissionsGroupEdited,"editError":_vm.editPermissionsGroupError}}):(_vm.loading)?_c('v-layout',{staticClass:"loading-indicator",attrs:{"justify-center":"","align-center":""}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":70,"width":7}})],1):_vm._e(),_vm._v(" "),_c('v-card',{directives:[{name:"show",rawName:"v-show",value:(!_vm.adding && !_vm.editing && !_vm.firstLoading),expression:"!adding && !editing && !firstLoading"}],staticClass:"groups-card"},[(_vm.showSuccessMsg)?_c('v-card-title',{staticClass:"success-message",class:{ 'success-message-hide': !_vm.showSuccess}},[_c('div',{staticClass:"headline success-message-text"},[_c('i',{staticClass:"far fa-check-circle"}),_vm._v("Группа прав добавлена")])]):_vm._e(),_vm._v(" "),(_vm.showErrorMsg)?_c('v-card-title',{staticClass:"error-message",class:{ 'error-message-hide': !_vm.showError}},[_c('div',{staticClass:"headline success-message-text"},[_c('i',{staticClass:"far fa-times-circle"}),_vm._v(" "+_vm._s(_vm.errorMsg))])]):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"fab":"","color":"primary"},on:{"click":_vm.addPermissionsGroup}},[_c('v-icon',[_vm._v("add")])],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"options":_vm.options,"server-items-length":_vm.serverItemsLength,"fixed-header":"","no-data-text":"Нет данных для отображения","footer-props":{
        itemsPerPageText: 'Число групп на странице',
        itemsPerPageOptions: [25, 50]
      },"dense":""},on:{"update:options":function($event){_vm.options=$event}},scopedSlots:_vm._u([{key:"item",fn:function(props){return _c('tr',{},[_c('td',[_vm._v(_vm._s(props.item.name))]),_vm._v(" "),_c('td',{staticClass:"justify-center px-0"},[_c('span',{staticClass:"action-btns"},[_c('v-btn',{staticClass:"mt-1",attrs:{"icon":"","title":"Редактировать"},on:{"click":function($event){return _vm.editPermissionsGroup(props.item)}}},[_c('v-icon',{attrs:{"color":"grey"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mt-1",attrs:{"icon":"","title":"Удалить"},on:{"click":function($event){return _vm.deletePermissionsGroup(props.item)}}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("delete")])],1)],1)])])}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gr9q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-breadcrumbs',{attrs:{"items":_vm.breadcrumbsItems}}),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"dense":"","disable-pagination":"","hide-default-footer":"","hide-default-header":""},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
return [_c('tr',{staticClass:"link-row",on:{"click":function($event){return _vm.openModelsApi(item)}}},[_c('td',[_vm._v(_vm._s(item.name))])])]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hBlR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('point-toolbar',{attrs:{"point-info":_vm.point.name}}),_vm._v(" "),(_vm.installing)?_c('point-counter-install',{attrs:{"point-id":_vm.point.point_id},on:{"cancel":_vm.cancelEditing,"installed":_vm.counterInstalled,"installError":_vm.editCounterError}}):_vm._e(),_vm._v(" "),(_vm.counterEditing)?_c('counter-edit',{attrs:{"counter-data":_vm.selectedCounterData},on:{"cancel":_vm.cancelEditing,"edited":_vm.counterEdited,"editError":_vm.editCounterError}}):_vm._e(),_vm._v(" "),(_vm.takingOff)?_c('point-counter-take-off',{attrs:{"counter-data":_vm.selectedCounterData},on:{"cancel":_vm.cancelEditing,"edited":_vm.counterTakeOff,"editError":_vm.editCounterError}}):_vm._e(),_vm._v(" "),(_vm.showCounterConnectParameters)?_c('point-counter-edit-connect-parameters',{attrs:{"counter-data":_vm.selectedCounterData},on:{"edited":_vm.counterConnectEdited,"cancel":_vm.cancelEditing,"editError":_vm.editCounterError}}):_vm._e(),_vm._v(" "),_c('v-dialog',{attrs:{"width":"800px"},model:{value:(_vm.showCounterHistory),callback:function ($$v) {_vm.showCounterHistory=$$v},expression:"showCounterHistory"}},[(_vm.showCounterHistory)?_c('counter-history',{attrs:{"counter-data":_vm.selectedCounterData},on:{"close":_vm.closeCounterHistory}}):_vm._e()],1),_vm._v(" "),(_vm.loading)?_c('v-layout',{staticClass:"loading-indicator",attrs:{"justify-center":"","align-center":""}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":70,"width":7}})],1):(_vm.showList)?_c('span',[_c('v-card',{staticClass:"point-counters-card"},[(_vm.showSuccessMsg)?_c('v-card-title',{staticClass:"success-message",class:{ 'success-message-hide': !_vm.showSuccess}},[_c('div',{staticClass:"headline success-message-text"},[_c('i',{staticClass:"far fa-check-circle"}),_vm._v(" Счетчик успешно добавлен")])]):_vm._e(),_vm._v(" "),(_vm.showErrorMsg)?_c('v-card-title',{staticClass:"error-message",class:{ 'error-message-hide': !_vm.showError}},[_c('div',{staticClass:"headline success-message-text"},[_c('i',{staticClass:"far fa-times-circle"}),_vm._v(" "+_vm._s(_vm.errorMsg))])]):_vm._e(),_vm._v(" "),(!_vm.point.counter_id)?_c('v-btn',{staticClass:"install-button",attrs:{"fab":"","color":"primary"},on:{"click":_vm.installCounter}},[_c('v-icon',[_vm._v("add")])],1):_vm._e(),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"fixed-header":"","no-data-text":"Нет данных для отображения","hide-default-footer":"","dense":""},scopedSlots:_vm._u([{key:"item",fn:function(props){return _c('tr',{},[_c('td',[_vm._v(_vm._s(props.item.is_current ? 'Установлен' : 'Снят'))]),_vm._v(" "),_c('td',[_vm._v("\n            "+_vm._s(props.item.serial_num)+"\n          ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.model_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.coeff))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.coeff_voltage))]),_vm._v(" "),(props.item.last_install_date)?_c('td',[_vm._v("\n            "+_vm._s(_vm._f("moment")(props.item.last_install_date,"DD/MM/YYYY HH:mm:ss"))+"\n          ")]):_c('td'),_vm._v(" "),_c('td',[_c('span',{staticClass:"action-btns"},[_c('v-btn',{attrs:{"icon":"","title":"Параметры подключения","disabled":!props.item.is_current},on:{"click":function($event){return _vm.editConnectParameters(props.item)}}},[_c('v-icon',{attrs:{"color":"grey darken-1"}},[_vm._v("mdi-ethernet-cable")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","title":"Редактирование счетчика"},on:{"click":function($event){return _vm.editCounter(props.item)}}},[_c('v-icon',{attrs:{"color":"grey darken-1"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","title":"История операций по счётчику"},on:{"click":function($event){return _vm.counterHistory(props.item)}}},[_c('v-icon',{attrs:{"color":"grey darken-1"}},[_vm._v("mdi-history")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","title":"Снятие счётчика","disabled":!props.item.is_current},on:{"click":function($event){return _vm.takeOff(props.item)}}},[_c('v-icon',{attrs:{"color":"grey darken-1"}},[_vm._v("mdi-cancel")])],1)],1)])])}}])})],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hE3U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"light":""}},[(_vm.loading)?_c('v-layout',{staticClass:"loading-indicator",attrs:{"justify-center":"","align-center":""}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":70,"width":7}})],1):_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('h2',[_vm._v("Отчет о потреблении электрической энергии за период с учетом тарифных зон")])]),_vm._v(" "),_c('v-col',{attrs:{"cols":"auto"}},[_c('v-menu',{attrs:{"close-on-content-click":false,"content-class":"report-tree"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"report-tree-btn"},on),[_vm._v("Выбрать точки учёта")])]}}])},[_vm._v(" "),_c('report-tree-node',{attrs:{"is-root":true,"initial-represents":[],"initial-all-points":[],"represent-points":[],"represents-select-type":_vm.representsSelectType,"points-select-type":_vm.pointsSelectType,"limit-selected-points":_vm.limitSelectedPoints},on:{"point-select":_vm.pointSelect}})],1)],1),_vm._v(" "),_c('v-col',[_c('v-menu',{ref:"menuBegDate",attrs:{"close-on-content-click":false,"nudge-right":40,"transition":"scale-transition","offset-y":"","max-width":"290px","min-width":"290px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-text-field',_vm._g({attrs:{"label":"Дата начала отчетного периода","prepend-icon":"event","readonly":""},model:{value:(_vm.begDateComputed),callback:function ($$v) {_vm.begDateComputed=$$v},expression:"begDateComputed"}},on))]}}]),model:{value:(_vm.menuBegDate),callback:function ($$v) {_vm.menuBegDate=$$v},expression:"menuBegDate"}},[_vm._v(" "),_c('v-date-picker',{attrs:{"locale":"ru-RU","no-title":""},on:{"input":function($event){_vm.menuBegDate = false}},model:{value:(_vm.begDate),callback:function ($$v) {_vm.begDate=$$v},expression:"begDate"}})],1)],1),_vm._v(" "),_c('v-col',[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"transition":"scale-transition","offset-y":"","max-width":"290px","min-width":"290px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-text-field',_vm._g({attrs:{"label":"Дата окончания отчётного периода","prepend-icon":"event","readonly":""},model:{value:(_vm.endDateComputed),callback:function ($$v) {_vm.endDateComputed=$$v},expression:"endDateComputed"}},on))]}}]),model:{value:(_vm.menuEndDate),callback:function ($$v) {_vm.menuEndDate=$$v},expression:"menuEndDate"}},[_vm._v(" "),_c('v-date-picker',{attrs:{"locale":"ru-RU","no-title":""},on:{"input":function($event){_vm.menuEndDate = false}},model:{value:(_vm.endDate),callback:function ($$v) {_vm.endDate=$$v},expression:"endDate"}})],1)],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"disabled":!_vm.canGetReport},on:{"click":function($event){return _vm.getReport()}}},[_vm._v("\n      Сформировать\n    ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hNWR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_c('div',{staticClass:"headline"},[_vm._v("\n      Редактирование пользователя\n    ")])]),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"userEditForm"},[_c('v-container',[_c('v-row',[_c('v-text-field',{attrs:{"label":"Логин","rules":_vm.inputRules,"required":""},model:{value:(_vm.user.username),callback:function ($$v) {_vm.$set(_vm.user, "username", $$v)},expression:"user.username"}})],1),_vm._v(" "),_c('v-row',[_c('v-text-field',{attrs:{"label":"Имя","rules":_vm.inputRules,"required":""},model:{value:(_vm.user.first_name),callback:function ($$v) {_vm.$set(_vm.user, "first_name", $$v)},expression:"user.first_name"}})],1),_vm._v(" "),_c('v-row',[_c('v-text-field',{attrs:{"label":"Фамилия","rules":_vm.inputRules,"required":""},model:{value:(_vm.user.last_name),callback:function ($$v) {_vm.$set(_vm.user, "last_name", $$v)},expression:"user.last_name"}})],1),_vm._v(" "),_c('v-row',[_c('v-text-field',{attrs:{"label":"Email","rules":_vm.inputRules,"required":""},model:{value:(_vm.user.email),callback:function ($$v) {_vm.$set(_vm.user, "email", $$v)},expression:"user.email"}})],1),_vm._v(" "),_c('v-row',[_c('v-chips-combobox',{attrs:{"model":_vm.user.groups,"items":_vm.permissionsGroups,"item-text":"name","item-value":"permissions_group_id","label":"Группа"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","text":""},nativeOn:{"click":function($event){return _vm.saveChanges($event)}}},[_vm._v("\n      Сохранить\n    ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","text":""},nativeOn:{"click":function($event){return _vm.cancelEditing($event)}}},[_vm._v("\n      Отмена\n    ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iBqS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "if6w":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DocumentsRequestsTypeDetails = __webpack_require__("Iwpa");

var _DocumentsRequestsTypeDetails2 = _interopRequireDefault(_DocumentsRequestsTypeDetails);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'DocumentsRequestsType',
  components: {
    DocumentsRequestsTypeDetails: _DocumentsRequestsTypeDetails2.default
  },
  data: function data() {
    return {
      loading: true,
      firstLoading: true,
      options: { page: 1, itemsPerPage: 25 },
      selectedItem: {},
      docTypes: [],
      editing: false,
      serverItemsLength: 0,
      headers: [{
        text: 'Тип абонента',
        align: 'left',
        sortable: false,
        value: 'customer_type_name'
      }, {
        text: 'Название документа',
        align: 'left',
        sortable: false,
        value: 'doc_type_name'
      }],
      getTimer: ''
    };
  },

  watch: {
    options: {
      handler: function handler() {
        this.getDocumentsTypesTimer();
      },

      deep: true
    }
  },
  methods: {
    getDocumentsTypes: function getDocumentsTypes() {
      var _this = this;

      this.loading = true;
      this.axios.get('/api/document_type/?per_page=' + this.options.itemsPerPage + '&page=' + this.options.page).then(function (response) {
        _this.docTypes = response.data.results;
        _this.serverItemsLength = response.data.count;
      }).catch(function (err) {
        console.log(err);
      }).finally(function () {
        _this.firstLoading = false;
        _this.loading = false;
      });
    },
    getDocumentsTypesTimer: function getDocumentsTypesTimer() {
      var _this2 = this;

      clearTimeout(this.getTimer);
      this.getTimer = setTimeout(function () {
        _this2.getDocumentsTypes();
      }, 100);
    },
    getDetails: function getDetails(item) {
      this.selectedItem = item;
      this.editing = true;
    },
    addDocumentType: function addDocumentType() {
      this.selectedItem = {
        doc_type_id: null,
        doc_type_name: '',
        expired_in_days: 10,
        doc_customer_type_id: 1
      };
      this.editing = true;
    },
    close: function close() {
      this.getDocumentsTypesTimer();
      this.editing = false;
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "im2A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.addSources == false)?_c('v-btn',{staticClass:"mb-2",attrs:{"color":"primary","dark":""},on:{"click":function($event){_vm.addSources = true}}},[_vm._v("\n    Добавить\n  ")]):_vm._e(),_vm._v(" "),(_vm.addSources == true)?_c('v-container',[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.formTitle))])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-form',{ref:"dataSourcesForm"},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{ref:"name",attrs:{"label":"Наименование","rules":_vm.inputRules,"required":""},model:{value:(_vm.editedItem.name),callback:function ($$v) {_vm.$set(_vm.editedItem, "name", $$v)},expression:"editedItem.name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{attrs:{"label":"Примечание"},model:{value:(_vm.editedItem.remark),callback:function ($$v) {_vm.$set(_vm.editedItem, "remark", $$v)},expression:"editedItem.remark"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){return _vm.save($event)}}},[_vm._v("\n          Сохранить\n        ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){return _vm.close($event)}}},[_vm._v("\n          Отмена\n        ")])],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.addSources == false)?_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.items,"search":_vm.search,"total-items":_vm.totalItems,"loading":_vm.loading,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.remark))]),_vm._v(" "),_c('td',{staticClass:"justify-center layout px-0"},[_c('v-btn',{staticClass:"mx-0 my-0",attrs:{"icon":""},on:{"click":function($event){return _vm.editItem(props.item)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("\n            edit\n          ")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0 my-0",attrs:{"icon":""},on:{"click":function($event){return _vm.deleteItem(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("\n            delete\n          ")])],1)],1)]}}],null,false,1526608519)}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "j35W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "j9T+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Report008_vue__ = __webpack_require__("Pfc9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Report008_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Report008_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Report008_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Report008_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fd683f8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Report008_vue__ = __webpack_require__("TQxd");
function injectStyle (ssrContext) {
  __webpack_require__("Nx+9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2fd683f8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Report008_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fd683f8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Report008_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "jBDd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jHXo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointConsumption_vue__ = __webpack_require__("zIsa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointConsumption_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointConsumption_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointConsumption_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointConsumption_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b33cea4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PointConsumption_vue__ = __webpack_require__("PUub");
function injectStyle (ssrContext) {
  __webpack_require__("Av08")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1b33cea4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointConsumption_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b33cea4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PointConsumption_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "jkHD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jxeW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointScheduler_vue__ = __webpack_require__("0uD0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointScheduler_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointScheduler_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointScheduler_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointScheduler_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ad0bf638_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PointScheduler_vue__ = __webpack_require__("J6Rp");
function injectStyle (ssrContext) {
  __webpack_require__("nO7M")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointScheduler_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ad0bf638_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PointScheduler_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "kfwl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kjdz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CounterHistory_vue__ = __webpack_require__("1efz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CounterHistory_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CounterHistory_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CounterHistory_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CounterHistory_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f4a53548_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CounterHistory_vue__ = __webpack_require__("TSff");
function injectStyle (ssrContext) {
  __webpack_require__("vRFU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CounterHistory_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f4a53548_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CounterHistory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "kn3o":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "l63n":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'AccountEmailsDetails',
  props: {
    data: {}
  },
  data: function data() {
    return {
      encryptionTypes: ['SSL', 'STARTTLS']
    };
  },
  mounted: function mounted() {},

  methods: {
    close: function close() {
      this.$emit('close');
    },
    save: function save() {
      var _this = this;

      if (this.data.account_email_id === null) {
        this.axios.post('/api/account_emails/', this.data).then(function (response) {
          _this.data.account_email_id = response.data.account_email_id;
          _this.close();
        }).catch(function (err) {
          console.log(err);
          _this.loading = false;
        });
      } else {
        this.axios.patch('/api/account_emails/' + this.data.account_email_id + '/', this.data).then(function () {
          _this.close();
        }).catch(function (err) {
          console.log(err);
          _this.loading = false;
        });
      }
    }
  }
};

/***/ }),

/***/ "l8UC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Monitoring_vue__ = __webpack_require__("nSOi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Monitoring_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Monitoring_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Monitoring_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Monitoring_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64a9b720_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Monitoring_vue__ = __webpack_require__("cJ5F");
function injectStyle (ssrContext) {
  __webpack_require__("kn3o")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-64a9b720"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Monitoring_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64a9b720_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Monitoring_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "lKWY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Report80020_vue__ = __webpack_require__("3W9t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Report80020_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Report80020_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Report80020_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Report80020_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_502e2ea8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Report80020_vue__ = __webpack_require__("8MPD");
function injectStyle (ssrContext) {
  __webpack_require__("7Z1N")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-502e2ea8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Report80020_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_502e2ea8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Report80020_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "lZQK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"app"}},[(!_vm.isLoginPage)?_c('sidebar',{ref:"sidbar",attrs:{"drawer":_vm.showDrawer,"tree-data":_vm.treeData,"additional-data":_vm.sidebarAdditionalData,"test-data":_vm.sidebarAdditionalDataString},on:{"selected":_vm.representSelected,"filterRepresent":_vm.filterRepresent}}):_vm._e(),_vm._v(" "),(!_vm.isLoginPage)?_c('toolbar',{attrs:{"title":_vm.formTitle,"drawerx":_vm.showDrawer},on:{"change_drawer":_vm.change_drawer}}):_vm._e(),_vm._v(" "),_c('v-content',{staticClass:"main-content"},[_c('keep-alive',[_c('transition',{attrs:{"name":"slide-fade","mode":"out-in"}},[_c('router-view',{on:{"renameSelectedRepresent":_vm.renameSelectedRepresent,"rebuildRepresents":_vm.rebuildRepresents,"representAdded":_vm.representAdded}})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lhx7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangePassword_vue__ = __webpack_require__("Hj5u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangePassword_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangePassword_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangePassword_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangePassword_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7715767c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChangePassword_vue__ = __webpack_require__("JYOR");
function injectStyle (ssrContext) {
  __webpack_require__("+9ca")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7715767c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangePassword_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7715767c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChangePassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "lpX1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lumk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"flex-grow-1":"","xs12":""}},[_c('v-card',[_c('v-card-title',[_c('div',[_c('div',{staticClass:"headline"},[_vm._v("\n            Добавление пользователя\n          ")])])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-form',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Логин","name":"login","data-vv-as":"Логин","error-messages":_vm.errors.collect('login')},model:{value:(_vm.user.username),callback:function ($$v) {_vm.$set(_vm.user, "username", $$v)},expression:"user.username"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{attrs:{"label":"Имя"},model:{value:(_vm.user.first_name),callback:function ($$v) {_vm.$set(_vm.user, "first_name", $$v)},expression:"user.first_name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{attrs:{"label":"Фамилия"},model:{value:(_vm.user.last_name),callback:function ($$v) {_vm.$set(_vm.user, "last_name", $$v)},expression:"user.last_name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-chips-combobox',{attrs:{"model":_vm.user.groups,"items":_vm.permissionsGroups,"item-text":"name","item-value":"permissions_group_id","label":"Группа"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:8'),expression:"'required|min:8'"}],ref:"password1",attrs:{"error-messages":_vm.errors.first('password1'),"append-icon":_vm.showPassword1 ? 'visibility' : 'visibility_off',"type":_vm.showPassword1 ? 'text' : 'password',"name":"password1","data-vv-as":"Пароль","label":"Пароль"},on:{"click:append":function($event){_vm.showPassword1 = !_vm.showPassword1}},model:{value:(_vm.user.password),callback:function ($$v) {_vm.$set(_vm.user, "password", $$v)},expression:"user.password"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|confirmed:password1'),expression:"'required|confirmed:password1'"}],attrs:{"error-messages":_vm.errors.first('password2'),"append-icon":_vm.showPassword2 ? 'visibility' : 'visibility_off',"type":_vm.showPassword2 ? 'text' : 'password',"name":"password2","data-vv-as":"повторного пароля","label":"Повторите пароль"},on:{"click:append":function($event){_vm.showPassword2 = !_vm.showPassword2}},model:{value:(_vm.confirmed_password),callback:function ($$v) {_vm.confirmed_password=$$v},expression:"confirmed_password"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","text":""},nativeOn:{"click":function($event){return _vm.saveChanges($event)}}},[_vm._v("\n          Сохранить\n        ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","text":""},nativeOn:{"click":function($event){return _vm.cancelEditing()}}},[_vm._v("\n          Отмена\n        ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "m6be":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('v-form',[_c('v-card',{attrs:{"flat":"","max-width":"800"}},[_c('v-card-text',[_c('v-text-field',{attrs:{"label":"Наименование почты"},model:{value:(_vm.data.name),callback:function ($$v) {_vm.$set(_vm.data, "name", $$v)},expression:"data.name"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Сервер"},model:{value:(_vm.data.smtp_host),callback:function ($$v) {_vm.$set(_vm.data, "smtp_host", $$v)},expression:"data.smtp_host"}}),_vm._v(" "),_c('v-text-field',{attrs:{"type":"number","label":"Порт"},model:{value:(_vm.data.smtp_port),callback:function ($$v) {_vm.$set(_vm.data, "smtp_port", $$v)},expression:"data.smtp_port"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Логин"},model:{value:(_vm.data.smtp_user),callback:function ($$v) {_vm.$set(_vm.data, "smtp_user", $$v)},expression:"data.smtp_user"}}),_vm._v(" "),_c('v-text-field',{attrs:{"type":"password","label":"Пароль"},model:{value:(_vm.data.smtp_password),callback:function ($$v) {_vm.$set(_vm.data, "smtp_password", $$v)},expression:"data.smtp_password"}}),_vm._v(" "),_c('v-select',{attrs:{"items":_vm.encryptionTypes,"rules":[function (v) { return !!v || 'Необходимо выбрать тип шифрования'; }],"label":"Тип шифрования"},model:{value:(_vm.data.smtp_encryption),callback:function ($$v) {_vm.$set(_vm.data, "smtp_encryption", $$v)},expression:"data.smtp_encryption"}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{staticClass:"mr-4",attrs:{"color":"success"},on:{"click":_vm.save}},[_vm._v("\n            Сохранить\n          ")]),_vm._v(" "),_c('v-btn',{staticClass:"mr-4",on:{"click":_vm.close}},[_vm._v("\n            Отмена\n          ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "me0x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserEdit_vue__ = __webpack_require__("t8j/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserEdit_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserEdit_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserEdit_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserEdit_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5de17223_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserEdit_vue__ = __webpack_require__("hNWR");
function injectStyle (ssrContext) {
  __webpack_require__("Forj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5de17223"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserEdit_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5de17223_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "mtmr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "n1OQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('v-data-table',{staticClass:"tasks-table",attrs:{"headers":_vm.headers,"items":_vm.tasks,"options":_vm.options,"server-items-length":_vm.serverItemsLength,"loading":_vm.loading,"fixed-header":"","dense":"","no-data-text":"Нет данных для отображения","footer-props":{
      itemsPerPageText: 'Число заданий на странице',
      itemsPerPageOptions: [25, 50]
    }},on:{"update:options":function($event){_vm.options=$event}},scopedSlots:_vm._u([{key:"top",fn:function(){return [_c('v-card-title',[_c('v-text-field',{attrs:{"append-icon":"search","label":"Поиск по номеру счетчика","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1)]},proxy:true},{key:"item",fn:function(props){return _c('tr',{},[_c('td',[_c('router-link',{attrs:{"to":'/counters?search=' + props.item.counter_num,"title":"Переход в раздел счетчики"}},[_vm._v(_vm._s(props.item.counter_num))]),_vm._v(" "),_c('a',{staticClass:"external-link",attrs:{"target":"_blank","href":'/counters?search=' + props.item.counter_num,"title":"Открыть раздел счетчики, в новой вкладке(окне)"}},[_c('v-icon',[_vm._v("mdi-open-in-new")])],1)],1),_vm._v(" "),_c('td',[_vm._v("\n        "+_vm._s(props.item.counter_model)+"\n      ")]),_vm._v(" "),_c('td',[_c('router-link',{attrs:{"to":'/points/' + props.item.point_id + '/scheduler',"title":"Переход в раздел Точки учета"}},[_vm._v(_vm._s(props.item.point_number))]),_vm._v(" "),(props.item.point_number)?_c('a',{staticClass:"external-link",attrs:{"target":"_blank","href":'/points/' + props.item.point_id + '/scheduler',"title":"Открыть раздел Точки учета, в новой вкладке(окне)"}},[_c('v-icon',[_vm._v("mdi-open-in-new")])],1):_vm._e()],1),_vm._v(" "),_c('td',[_c('span',{staticClass:"action-btns"},[(props.item.state === 'working')?_c('span',[_c('v-btn',{staticClass:"mt-1",attrs:{"icon":"","title":"Остановить выполнение расписания"},on:{"click":function($event){return _vm.stopTasks(props.item)}}},[_c('v-icon',{attrs:{"color":"red darken-1"}},[_vm._v("stop")])],1)],1):_c('span',[_c('v-btn',{staticClass:"mt-1",attrs:{"icon":"","title":"Запустить выполенение расписания"},on:{"click":function($event){return _vm.startTasks(props.item)}}},[(props.item.state === 'stopped')?_c('v-icon',{attrs:{"color":"green darken-1"}},[_vm._v("play_arrow")]):_c('v-icon',{attrs:{"color":"yellow darken-1"}},[_vm._v("pause")])],1)],1)])]),_vm._v(" "),_c('td',[_c('span',{staticClass:"action-btns"},[_c('v-btn',{staticClass:"mt-1",attrs:{"icon":"","title":"Лог выполнения"},on:{"click":function($event){return _vm.viewCounterTaskLog(props.item)}}},[_c('v-icon',{attrs:{"color":"grey darken-1"}},[_vm._v("fas fa-file-alt")])],1)],1)])])}}])}),_vm._v(" "),_c('v-bottom-sheet',{model:{value:(_vm.showLog),callback:function ($$v) {_vm.showLog=$$v},expression:"showLog"}},[_c('task-logs',{attrs:{"task":_vm.editedTaskItem}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nBfR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Represents_vue__ = __webpack_require__("wPNm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Represents_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Represents_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Represents_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Represents_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_603b70de_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Represents_vue__ = __webpack_require__("Nftu");
function injectStyle (ssrContext) {
  __webpack_require__("iBqS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Represents_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_603b70de_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Represents_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "nMjn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PermissionsGroups_vue__ = __webpack_require__("PE1O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PermissionsGroups_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PermissionsGroups_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PermissionsGroups_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PermissionsGroups_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4509a157_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PermissionsGroups_vue__ = __webpack_require__("gUJg");
function injectStyle (ssrContext) {
  __webpack_require__("tlLp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PermissionsGroups_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4509a157_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PermissionsGroups_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "nO2C":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

var _ReportTreeNode = __webpack_require__("DUuK");

var _ReportTreeNode2 = _interopRequireDefault(_ReportTreeNode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: { ReportTreeNode: _ReportTreeNode2.default },
  data: function data() {
    return {
      begDate: null,
      endDate: null,
      representsSelectType: 'multiple',
      pointsSelectType: 'multiple',
      representsId: [],
      pointsId: [],
      menuBegDate: false,
      menuEndDate: false,
      loading: false
    };
  },

  computed: {
    canGetReport: function canGetReport() {
      return this.begDate && this.endDate && (this.representsId.length || this.pointsId.length);
    },
    begDateComputed: function begDateComputed() {
      return this.formatDate(this.begDate);
    },
    endDateComputed: function endDateComputed() {
      return this.formatDate(this.endDate);
    }
  },
  methods: {
    reprSelect: function reprSelect(represent) {
      var _this = this;

      if (represent.status === 'initial') {
        var key = this.representsId.indexOf(represent.id);
        if (represent.is_selected && key === -1) {
          this.representsId.push(represent.id);
        }
        if (!represent.is_selected && key !== -1) {
          this.representsId.splice(key, 1);
        }
      }
      represent.children.map(function (child) {
        child.is_selected = represent.is_selected;
        _this.reprSelect(child);
      });
      represent.points.map(function (point) {
        point.is_selected = represent.is_selected;
        _this.pointSelect(point);
      });
    },
    pointSelect: function pointSelect(point) {
      var key = this.pointsId.indexOf(point.id);
      if (point.is_selected && key === -1) {
        this.pointsId.push(point.id);
      }
      if (!point.is_selected && key !== -1) {
        this.pointsId.splice(key, 1);
      }
    },
    selectedReprExpand: function selectedReprExpand(represent) {
      this.representsId.splice(this.representsId.indexOf(represent.id), 1);
    },
    formatDate: function formatDate(date) {
      if (!date) return null;

      var _date$split = date.split('-'),
          _date$split2 = _slicedToArray(_date$split, 3),
          year = _date$split2[0],
          month = _date$split2[1],
          day = _date$split2[2];

      return day + '-' + month + '-' + year;
    },
    getReport: function getReport() {
      var _this2 = this;

      this.loading = true;
      (0, _axios2.default)({
        url: '/api/get_report/',
        method: 'POST',
        responseType: 'blob',
        params: {
          'represents_id': JSON.stringify(this.representsId).slice(1, -1),
          'points_id': JSON.stringify(this.pointsId).slice(1, -1),
          'beg_date': this.begDate,
          'end_date': this.endDate,
          'report': 'Form010Report'
        }
      }).then(function (response) {
        var blob = new Blob([response.data], { type: 'application/pdf' });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'report_010.xlsx';
        link.click();
      }).finally(function () {
        _this2.loading = false;
      });
    }
  }
};

/***/ }),

/***/ "nO7M":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nSOi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

var _TaskLogs = __webpack_require__("U+R7");

var _TaskLogs2 = _interopRequireDefault(_TaskLogs);

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Tasks',
  components: {
    TaskLogs: _TaskLogs2.default
  },
  data: function data() {
    return {
      tasks: [],
      hideFromFailedTasks: {},
      refreshPeriod: 0,
      refreshPeriodDefault: 0,
      refreshPeriodMin: 10,
      refreshPeriodMax: 600,
      log_task: {},
      execInterval: null,
      loading: false,
      showLog: false,
      lastInteractionsNum: 10,
      lastInteractionsNumDefault: 10,
      lastInteractionsNumMax: 100,
      monitoringHeaders: [{ text: 'Номер счётчика', value: 'counter_num' }, { text: 'Наименование ТУ', value: 'point_name' }, { text: 'Адрес ТУ', value: 'address' }, { text: 'Объекты', value: 'represents' }, { text: 'Статус последних заданий', value: 'last_tasks' }, { text: 'Дата последнего задания', value: 'last_interaction_date' }, { text: 'Действия', value: 'actions' }],
      monitorStatuses: [{ text: 'Пауза из-за ошибок', value: 'PAUSED_FAILED' }, { text: 'Работающие с перебоями', value: 'UNSTABLE' }, { text: 'Остановленные с ошибками', value: 'STOPPED_FAILED' }],
      monitorStatusSelect: 'PAUSED_FAILED',
      showHidden: false,
      search: ''
    };
  },

  computed: {
    filteredTasks: function filteredTasks() {
      var _this = this;

      var res = [];
      var currDatetime = new Date();
      this.tasks.forEach(function (val) {
        var existed = _this.hideFromFailedTasks[val.counter_task_id];
        if (_this.showHidden || existed === undefined || existed < currDatetime) {
          res.push(val);
          if (existed && existed < currDatetime) {
            delete _this.hideFromFailedTasks[val.counter_task_id];
            localStorage.hideFromFailedTasks = JSON.stringify(_this.hideFromFailedTasks);
          }
        }
      });
      return res;
    }
  },
  watch: {
    refreshPeriod: function refreshPeriod(newVal, oldVal) {
      if (newVal > this.refreshPeriodMax) {
        this.refreshPeriod = this.refreshPeriodMax;
        return;
      }
      if (newVal != 0 && newVal < this.refreshPeriodMin) {
        this.refreshPeriod = this.refreshPeriodMin;
        return;
      }
      if (newVal === oldVal) {
        return;
      }
      this.runPeriodicRefresh();
      localStorage.monitoringRefreshPeriod = newVal;
    },
    lastInteractionsNum: function lastInteractionsNum(newVal, oldVal) {
      if (newVal > this.lastInteractionsNumMax) {
        this.lastInteractionsNum = this.lastInteractionsNumMax;
        return;
      }
      if (newVal === oldVal) {
        return;
      }
      this.getFailedTasks();
      localStorage.lastInteractionsNum = newVal;
    },
    monitorStatusSelect: function monitorStatusSelect() {
      this.getFailedTasks();
    }
  },
  mounted: function mounted() {
    this.runPeriodicRefresh();
    if (localStorage.monitoringRefreshPeriod) {
      this.refreshPeriod = localStorage.monitoringRefreshPeriod;
    }
    if (localStorage.lastInteractionsNum) {
      this.lastInteractionsNum = localStorage.lastInteractionsNum;
    } else {
      this.getFailedTasks();
    }
  },

  methods: {
    getFailedTasks: function getFailedTasks() {
      var _this2 = this;

      this.loading = true;
      _axios2.default.get('/api/monitoring/', { params: { interactions_num: this.lastInteractionsNum, mts: this.monitorStatusSelect } }).then(function (response) {
        _this2.loading = false;
        _this2.tasks = response.data;
      }).catch(function (err) {
        _this2.loading = false;
        console.log(err);
      });
    },
    viewCounterTaskLog: function viewCounterTaskLog(item) {
      this.showLog = true;
      this.log_task = item;
    },
    runPeriodicRefresh: function runPeriodicRefresh() {
      var _this3 = this;

      clearInterval(this.execInterval);
      if (this.refreshPeriod != 0) {
        this.execInterval = setInterval(function () {
          _this3.getFailedTasks();
        }, this.refreshPeriod * 1000);
      }
    },
    hideFromResults: function hideFromResults(item, isShow) {
      if (isShow) {
        _vue2.default.delete(this.hideFromFailedTasks, item.counter_task_id);
      } else {
        var currDatetime = new Date();
        _vue2.default.set(this.hideFromFailedTasks, item.counter_task_id, currDatetime.setHours(currDatetime.getHours() + 1));
      }
      localStorage.hideFromFailedTasks = JSON.stringify(this.hideFromFailedTasks);
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "o1aI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

var _PointToolbar = __webpack_require__("bB1z");

var _PointToolbar2 = _interopRequireDefault(_PointToolbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var API_URL = 'points';
exports.default = {
  name: 'Points',
  components: {
    PointToolbar: _PointToolbar2.default
  },
  data: function data() {
    return {
      pointEditRules: [function (v) {
        return !!v || 'Заполните это поле!';
      }],
      point_id: this.$route.params['id'],
      update: true,
      changed: true,
      visible: false,
      editedItem: {
        point_id: '',
        point_number: '',
        customer: '',
        address: '',
        geopoint: '',
        name: '',
        remark: '',
        counter: '',
        energy_limit: null
      },
      defaultItem: {
        point_id: '',
        point_number: '',
        address: '',
        geopoint: '',
        name: '',
        remark: '',
        counter: '',
        energy_limit: 5000
      },
      customers: [],
      pointConsumption: 0,
      showConsumptionEditMenu: false
    };
  },

  watch: {
    editedItem: function editedItem() {
      this.changeForm();
    }
  },
  mounted: function mounted() {
    this.getItemApi();
    this.getCustomers();
  },

  methods: {
    getCustomers: function getCustomers() {
      var _this = this;

      _axios2.default.get('/api/customers/?page_size=all').then(function (response) {
        _this.customers = response.data.results;
      }).catch(function (err) {
        console.log(err);
      });
    },
    getItemApi: function getItemApi() {
      var _this2 = this;

      _axios2.default.get('/api/' + API_URL + '/' + this.point_id + '/').then(function (response) {
        _this2.editedItem = Object.assign({}, response.data);
        setTimeout(function () {
          return _this2.changed = false;
        }, 10);
        _this2.getPointConsumption();
      }).catch(function (err) {
        console.log(err);
      });
    },
    getPointConsumption: function getPointConsumption() {
      var _this3 = this;

      _axios2.default.get('/api/' + API_URL + '/' + this.point_id + '/consumption/').then(function (response) {
        /** @property {string} response.data.consumption__sum */
        _this3.pointConsumption = response.data.consumption__sum || 0;
        setTimeout(function () {
          return _this3.changed = false;
        }, 10);
      }).catch(function (err) {
        console.log(err);
      });
    },
    updateItemApi: function updateItemApi() {
      var _this4 = this;

      _axios2.default.put('/api/' + API_URL + '/' + this.point_id + '/', this.editedItem).then(function (response) {
        Object.assign(_this4.editedItem, response.data);
        setTimeout(function () {
          return _this4.changed = false;
        }, 10);
      }).catch(function (err) {
        console.log(err);
      });
    },
    addItemApi: function addItemApi() {
      var _this5 = this;

      _axios2.default.post('/api/' + API_URL + '/', this.editedItem).then(function (response) {
        _this5.loading = false;
        _this5.editedItem = Object.assign({}, response.data);
        setTimeout(function () {
          return _this5.changed = false;
        }, 10);
      }).catch(function (err) {
        console.log(err);
      });
    },
    changeForm: function changeForm() {
      if (!this.changed) {
        this.changed = true;
      }
    },
    validate: function validate() {
      if (this.$refs.pointEditForm.validate()) {
        return true;
      }
    },
    save: function save() {
      if (this.validate()) {
        this.showConsumptionEditMenu = false;
        if (this.update) {
          this.updateItemApi();
        } else {
          this.addItemApi();
        }
      }
    },
    cancel: function cancel() {
      this.showConsumptionEditMenu = false;
      this.getItemApi();
    }
  }
};

/***/ }),

/***/ "o7gN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'CountersModelsAPI',
  data: function data() {
    return {
      items: [],
      loading: true,
      resource_type: null,
      headers: [{
        text: 'Наименование',
        align: 'left',
        sortable: true,
        value: 'name'
      }],
      breadcrumbsItems: [{
        text: 'Ресурс',
        disabled: false,
        href: 'counters_resource'
      }]
    };
  },
  mounted: function mounted() {
    this.resource_type = this.$route.query.resource_type;
    this.getModelsApi();
    this.fillBreadcrumb();
  },

  methods: {
    getModelsApi: function getModelsApi() {
      var _this = this;

      this.loading = true;
      var url = '/api/counters_api/';
      if (this.resource_type) {
        url += '?resource_type=' + this.resource_type;
      }
      this.axios.get(url).then(function (response) {
        _this.items = response.data.results;
        _this.loading = false;
      }).catch(function (err) {
        _this.loading = false;
        console.log(err);
      });
    },
    openModels: function openModels(item) {
      this.$router.push({ path: 'counters_models',
        query: {
          counter_model_api: item.counter_model_api_id,
          resource_type: this.resource_type } });
    },
    fillBreadcrumb: function fillBreadcrumb() {
      var _this2 = this;

      if (!this.resource_type) {
        return;
      }
      this.axios.get('api/resources_types/' + this.resource_type + '/').then(function (response) {
        _this2.breadcrumbsItems.push({
          text: response.data.name,
          disabled: true
        });
      });
    },
    openBreadcrumbsUrl: function openBreadcrumbsUrl(item) {
      this.$router.push({ path: item.href });
    }
  }
};

/***/ }),

/***/ "oOyZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.addParameter == false)?_c('v-btn',{staticClass:"mb-2",attrs:{"color":"primary","dark":""},on:{"click":function($event){_vm.addParameter = true}}},[_vm._v("\n    Добавить\n  ")]):_vm._e(),_vm._v(" "),(_vm.addParameter == true)?_c('v-container',[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.formTitle))])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-form',{ref:"dataParametersForm"},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{ref:"name",attrs:{"label":"Наименование","rules":_vm.inputRules,"required":""},model:{value:(_vm.editedItem.name),callback:function ($$v) {_vm.$set(_vm.editedItem, "name", $$v)},expression:"editedItem.name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-autocomplete',{attrs:{"items":_vm.resources_types,"label":"Тип энергоресурса","item-text":"name","item-value":"resource_type_id","return-object":"","menu-props":{maxHeight:'auto'},"rules":_vm.inputRules,"required":""},model:{value:(_vm.editedItem.resource_type),callback:function ($$v) {_vm.$set(_vm.editedItem, "resource_type", $$v)},expression:"editedItem.resource_type"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{attrs:{"label":"Примечание"},model:{value:(_vm.editedItem.remark),callback:function ($$v) {_vm.$set(_vm.editedItem, "remark", $$v)},expression:"editedItem.remark"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){return _vm.save($event)}}},[_vm._v("\n          Сохранить\n        ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){return _vm.close($event)}}},[_vm._v("\n          Отмена\n        ")])],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.addParameter == false)?_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.items,"search":_vm.search,"total-items":_vm.totalItems,"loading":_vm.loading,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.resource_type.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.remark))]),_vm._v(" "),_c('td',{staticClass:"justify-center layout px-0"},[_c('v-btn',{staticClass:"mx-0 my-0",attrs:{"icon":""},on:{"click":function($event){return _vm.editItem(props.item)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("\n            edit\n          ")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0 my-0",attrs:{"icon":""},on:{"click":function($event){return _vm.deleteItem(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("\n            delete\n          ")])],1)],1)]}}],null,false,3753488914)}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oetc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _masks = __webpack_require__("AqzR");

exports.default = function (Vue) {
  Vue.directive('vdate', _masks.vDate);
};

/***/ }),

/***/ "oiLY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Counters_vue__ = __webpack_require__("pFDy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Counters_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Counters_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Counters_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Counters_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fbeefd32_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Counters_vue__ = __webpack_require__("QFcg");
function injectStyle (ssrContext) {
  __webpack_require__("t4dI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Counters_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fbeefd32_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Counters_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "pFDy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CounterNew = __webpack_require__("a1S9");

var _CounterNew2 = _interopRequireDefault(_CounterNew);

var _CounterEdit = __webpack_require__("Wjfh");

var _CounterEdit2 = _interopRequireDefault(_CounterEdit);

var _CounterHistory = __webpack_require__("kjdz");

var _CounterHistory2 = _interopRequireDefault(_CounterHistory);

var _CounterParametersData = __webpack_require__("0WFi");

var _CounterParametersData2 = _interopRequireDefault(_CounterParametersData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var API_URL = 'counters';
exports.default = {
  name: 'Counters',
  components: {
    CounterNew: _CounterNew2.default,
    CounterEdit: _CounterEdit2.default,
    CounterHistory: _CounterHistory2.default,
    CounterParametersData: _CounterParametersData2.default
  },
  data: function data() {
    return {
      showCounterParametersData: false,
      search: '',
      items: [],
      firstLoading: true,
      loading: true,
      options: { page: 1, itemsPerPage: 25 },
      serverItemsLength: 0,
      headers: [{
        text: 'Номер счетчика',
        align: 'right',
        sortable: false,
        value: 'serial_num'
      }, {
        text: 'Модель',
        align: 'right',
        sortable: false,
        value: 'model'
      }, {
        text: 'Коэф. трансформации тока',
        align: 'right',
        sortable: false,
        value: 'coeff'
      }, {
        text: 'Коэф. трансформации напряжения',
        align: 'right',
        sortable: false,
        value: 'coeff_voltage'
      }, {
        text: 'Номер Точки учёта',
        align: 'right',
        sortable: false,
        value: 'point_number'
      }, {
        text: '',
        align: 'right',
        sortable: false,
        value: 'actions'
      }],
      adding: false,
      showSuccess: false,
      showSuccessMsg: false,
      editing: false,
      selectedCounterData: {},
      showErrorMsg: false,
      showError: false,
      errorMsg: null,
      showCounterHistory: false,
      getTimer: '',
      searchTimer: '',
      deleteTimer: ''
    };
  },

  watch: {
    options: {
      handler: function handler() {
        this.getCountersApiTimer();
      },

      deep: true
    },
    search: function search() {
      var _this = this;

      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(function () {
        _this.options.page = 1;
        _this.getCountersApiTimer();
      }, 500);
    }
  },
  mounted: function mounted() {
    if (this.$route.query.search) {
      this.search = this.$route.query.search;
    }
  },

  methods: {
    getCountersApi: function getCountersApi() {
      var _this2 = this;

      this.loading = true;
      this.axios.get('/api/' + API_URL + '/?per_page=' + this.options.itemsPerPage + '&page=' + this.options.page + '&search=' + this.search).then(function (response) {
        _this2.items = response.data.results;
        _this2.serverItemsLength = response.data.count;
      }).catch(function (err) {
        console.log(err);
      }).finally(function () {
        _this2.firstLoading = false;
        _this2.loading = false;
      });
    },
    getCountersApiTimer: function getCountersApiTimer() {
      var _this3 = this;

      clearTimeout(this.getTimer);
      this.getTimer = setTimeout(function () {
        _this3.getCountersApi();
      }, 100);
    },
    showErrorMessage: function showErrorMessage(msg) {
      var _this4 = this;

      this.errorMsg = msg;
      this.showError = true;
      this.showErrorMsg = true;
      setTimeout(function () {
        _this4.showError = false;
      }, 4000);
      setTimeout(function () {
        _this4.showErrorMsg = false;
      }, 4350);
    },
    deleteCounterApi: function deleteCounterApi(item) {
      var _this5 = this;

      this.axios.delete('/api/' + API_URL + '/' + item.counter_id + '/').then(function (response) {
        _this5.items.splice(_this5.items.indexOf(item), 1);
        clearTimeout(_this5.deleteTimer);
        _this5.deleteTimer = setTimeout(function () {
          _this5.items.length || _this5.options.page === 1 || _this5.options.page--;
          _this5.getCountersApiTimer();
        }, 1000);
      }).catch(function (err) {
        _this5.showErrorMessage(err.response.data);
        console.log(err);
      });
    },
    addCounter: function addCounter() {
      this.adding = true;
    },
    cancelAdding: function cancelAdding() {
      this.adding = false;
    },
    counterAdded: function counterAdded() {
      var _this6 = this;

      this.getCountersApiTimer();
      this.adding = false;
      this.showSuccess = true;
      this.showSuccessMsg = true;
      setTimeout(function () {
        _this6.showSuccess = false;
      }, 3000);
      setTimeout(function () {
        _this6.showSuccessMsg = false;
      }, 3350);
    },
    editCounter: function editCounter(item) {
      this.selectedCounterData = item;
      this.editing = true;
    },
    counterEdited: function counterEdited(counter) {
      Object.assign(this.selectedCounterData, counter);
      this.editing = false;
    },
    cancelEditing: function cancelEditing() {
      this.editing = false;
    },
    editCounterError: function editCounterError(msg) {
      this.editing = false;
      this.showErrorMessage(msg);
    },
    counterHistory: function counterHistory(item) {
      this.selectedCounterData = item;
      this.showCounterHistory = true;
    },
    closeCounterHistory: function closeCounterHistory() {
      this.showCounterHistory = false;
    },
    deleteCounter: function deleteCounter(item) {
      if (confirm('Вы действительно хотите удалить эту строку?')) {
        this.deleteCounterApi(item);
      }
    },
    getCounterParametersData: function getCounterParametersData(counter) {
      this.selectedCounterData = counter;
      this.showCounterParametersData = true;
    },
    closeCounterParametersData: function closeCounterParametersData() {
      this.showCounterParametersData = false;
    }
  }
};

/***/ }),

/***/ "pK6Z":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _VTreeviewItem = __webpack_require__("yeu0");

var _VTreeviewItem2 = _interopRequireDefault(_VTreeviewItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'VTreeview',
  components: {
    VTreeviewItem: _VTreeviewItem2.default
  },
  props: ['value', 'treeTypes', 'openAll', 'contextItems', 'editName', 'selectedRepresentName'],
  data: function data() {
    return {};
  },
  created: function created() {},

  methods: {
    selected: function selected(node) {
      this.$emit('selected', node);
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "pxuj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountSettings_vue__ = __webpack_require__("EHCw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountSettings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountSettings_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountSettings_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountSettings_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2522a4d4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountSettings_vue__ = __webpack_require__("a9T9");
function injectStyle (ssrContext) {
  __webpack_require__("1UkD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountSettings_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2522a4d4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountSettings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "q01A":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "q3PU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var mutations = {
  removeChannel: function removeChannel(state, channel) {
    state.channels.splice(channel, 1);
  },
  addChannel: function addChannel(state, channel) {
    state.channels.unshift(channel);
  }
};

var actions = {
  removeChannel: function removeChannel(_ref, channel) {
    var commit = _ref.commit;

    if (!isNaN(Number(channel))) {
      commit('removeChannel', channel);
    }
  },
  addChannel: function addChannel(_ref2, channel) {
    var commit = _ref2.commit;

    if (channel && (typeof channel === 'undefined' ? 'undefined' : _typeof(channel)) === 'object' && !channel.hasOwnProperty('length')) {
      commit('addChannel', channel);
    }
  }
};

var getters = {
  getChannels: function getChannels(state) {
    return state.channels;
  }
};

var state = {
  channels: []
};

exports.default = {
  namespaced: true,
  actions: actions,
  getters: getters,
  state: state,
  mutations: mutations
};

/***/ }),

/***/ "qGW+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qIsp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"light":""}},[_c('v-layout',[_c('v-flex',{staticClass:"login_wrapper",attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('v-card',{staticClass:"login_cardwrappper"},[_c('v-img',{attrs:{"src":__webpack_require__("dLd/"),"contain":true,"height":"100px"}}),_vm._v(" "),_c('v-card-actions',[_c('v-form',{staticClass:"login_form_wrapper",model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Имя","name":"user","rules":(!_vm.errors.first('user')) ? [true] : [_vm.errors.first('user')],"required":""},model:{value:(_vm.user),callback:function ($$v) {_vm.user=$$v},expression:"user"}}),_vm._v(" "),_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Пароль","type":"password","name":"password","rules":(!_vm.errors.first('password')) ? [true] : [_vm.errors.first('password')],"required":""},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}),_vm._v(" "),_c('span',{staticClass:"cmd-container"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.autherror),expression:"autherror"}],staticClass:"cmd-error"},[_vm._v(_vm._s(_vm.autherror))])]),_vm._v(" "),_c('p',{staticClass:"text-right"},[_c('v-btn',{on:{"click":_vm.login}},[_vm._v("\n                Войти\n              ")])],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qMZ1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'TaskLogs',
  props: {
    task: {
      required: true
    }
  },
  data: function data() {
    return {
      expanded: [],
      logsResIsLoading: false,
      headers: [{
        text: 'Дата и время',
        sortable: false,
        value: 'start_date'
      }, { text: 'Результат', value: 'success' }, { text: '', value: 'data-table-expand' }],
      logRows: [],
      headersActions: [{ text: 'date', value: 'date' }, { text: 'text', value: 'text' }]
    };
  },

  watch: {
    'task.counter_task_id': function taskCounter_task_id(val) {
      this.updateLog(val);
    }
  },
  created: function created() {
    this.updateLog(this.task.counter_task_id);
  },

  methods: {
    updateLog: function updateLog(id) {
      var _this = this;

      if (!id) {
        return;
      }
      this.logRows = [];
      this.logsResIsLoading = true;
      this.axios.get('/api/tasks_logs/?task_id=' + id).then(function (response) {
        _this.logRows = response.data.results;
        _this.logsResIsLoading = false;
      }).catch(function (err) {
        _this.logsResIsLoading = false;
        console.log(err);
      });
    },
    getitems: function getitems(log) {
      var res = [];
      log.forEach(function (row) {
        res.push({ 'date': row[0], 'text': row[1] });
      });
      return res;
    },
    statusText: function statusText(isSuccess) {
      return isSuccess ? 'Выполнено' : 'Ошибка';
    }
  }
};

/***/ }),

/***/ "qUzq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-dialog',{ref:"tasksDialog",attrs:{"fullscreen":""},model:{value:(_vm.tasksDialog),callback:function ($$v) {_vm.tasksDialog=$$v},expression:"tasksDialog"}},[_c('v-card',[_c('v-card-title',[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){return _vm.closeTasks()}}},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Расписание снятия показаний")])],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500px"},model:{value:(_vm.taskDialog),callback:function ($$v) {_vm.taskDialog=$$v},expression:"taskDialog"}},[_c('v-btn',{staticClass:"mb-2",attrs:{"slot":"activator","color":"primary","dark":""},slot:"activator"},[_vm._v("\n            Добавить\n          ")]),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.taskDialogTitle))])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',[_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""}},[(_vm.editedTaskItem.interval == 'ONCE')?_c('span',[_c('v-menu',{ref:"taskOnceDateValue",attrs:{"lazy":"","close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","nudge-right":40,"min-width":"290px","return-value":_vm.editedTaskItem.value},on:{"update:returnValue":function($event){return _vm.$set(_vm.editedTaskItem, "value", $event)},"update:return-value":function($event){return _vm.$set(_vm.editedTaskItem, "value", $event)}},model:{value:(_vm.taskOnceDateValue),callback:function ($$v) {_vm.taskOnceDateValue=$$v},expression:"taskOnceDateValue"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Дата выполнения","prepend-icon":"event","readonly":"","required":""},slot:"activator",model:{value:(_vm.editedTaskItem.value),callback:function ($$v) {_vm.$set(_vm.editedTaskItem, "value", $$v)},expression:"editedTaskItem.value"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","scrollable":""},model:{value:(_vm.editedTaskItem.value),callback:function ($$v) {_vm.$set(_vm.editedTaskItem, "value", $$v)},expression:"editedTaskItem.value"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.taskOnceDateValue = false}}},[_vm._v("Отмена")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){return _vm.$refs.taskOnceDateValue.save(_vm.editedTaskItem.value)}}},[_vm._v("OK")])],1)],1)],1):_c('span',[_c('v-text-field',{attrs:{"mask":"#######","label":"Каждые","required":""},model:{value:(_vm.editedTaskItem.value),callback:function ($$v) {_vm.$set(_vm.editedTaskItem, "value", $$v)},expression:"editedTaskItem.value"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""}},[_c('v-autocomplete',{attrs:{"items":_vm.frequencies,"label":"","item-text":"name","item-value":"id","menu-props":{maxHeight:'auto'},"required":""},model:{value:(_vm.editedTaskItem.interval),callback:function ($$v) {_vm.$set(_vm.editedTaskItem, "interval", $$v)},expression:"editedTaskItem.interval"}})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){return _vm.saveCounterTask()}}},[_vm._v("\n                Сохранить\n              ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){return _vm.closeTasksDialog()}}},[_vm._v("\n                Отмена\n              ")])],1)],1)],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('v-data-table',{attrs:{"headers":_vm.counterTasksHeaders,"items":_vm.counterTasks,"loading":_vm.tasksLoading,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.interval))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.value))]),_vm._v(" "),_c('td',[(props.item.enabled)?_c('span',[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.stopTasks(props.item)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("stop")])],1)],1):_c('span',[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.startTasks(props.item)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("play_arrow")])],1)],1)]),_vm._v(" "),_c('td',{staticClass:"justify-center layout px-0"},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.editCounterTask(props.item)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("\n                      edit\n                    ")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.deleteCounterTask(props.item)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("\n                      delete\n                    ")])],1)],1)]}}])})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-tabs',{attrs:{"slot":"extension","align-with-title":""},slot:"extension",model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('v-tabs-slider',{attrs:{"color":"yellow"}}),_vm._v(" "),_c('v-tab',{key:0},[_vm._v("\n      Данные\n    ")]),_vm._v(" "),_c('v-tab',{key:1},[_vm._v("\n      Сбор данных\n    ")])],1),_vm._v(" "),_c('v-tabs-items',{model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('v-tab-item',{key:0},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":""}},[_c('v-select',{attrs:{"items":_vm.available_params,"label":"Параметр счетчика","item-text":"name","item-value":"id"},model:{value:(_vm.parameter_id),callback:function ($$v) {_vm.parameter_id=$$v},expression:"parameter_id"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":""}},[_c('v-select',{attrs:{"items":_vm.reportIntervals,"label":"Интервал","item-text":"name","item-value":"interval","menu-props":{maxHeight:'auto'},"required":""},model:{value:(_vm.reportInterval),callback:function ($$v) {_vm.reportInterval=$$v},expression:"reportInterval"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":""}},[_c('v-btn',{on:{"click":function($event){return _vm.requestData()}}},[_vm._v("\n                  Сформировать\n                ")])],1)],1)],1),_vm._v(" "),_c('v-tabs',{attrs:{"slot":"extension","align-with-title":""},slot:"extension",model:{value:(_vm.charsTab),callback:function ($$v) {_vm.charsTab=$$v},expression:"charsTab"}},[_c('v-tabs-slider',{attrs:{"color":"yellow"}}),_vm._v(" "),_c('v-tab',{key:0},[_vm._v("\n              График\n            ")]),_vm._v(" "),_c('v-tab',{key:1},[_vm._v("\n              Таблица\n            ")]),_vm._v(" "),_c('v-tab',{key:2},[_vm._v("\n              Показания счетчиков\n            ")])],1),_vm._v(" "),_c('v-tabs-items',{model:{value:(_vm.charsTab),callback:function ($$v) {_vm.charsTab=$$v},expression:"charsTab"}},[_c('v-tab-item',{key:0},[(_vm.loaded)?_c('line-chart',{attrs:{"chart-data":_vm.countersData,"chart-labels":_vm.labels}}):_vm._e()],1),_vm._v(" "),_c('v-tab-item',{key:1},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.countersDataHeaders,"items":_vm.countersData2,"loading":_vm.countersDataLoading,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.label))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.value))])]}}])})],1),_vm._v(" "),_c('v-tab-item',{key:2},[_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":""}},[_c('v-select',{attrs:{"items":_vm.accumulatedDataParams,"label":"Варианты предоставления информации по накопленной энергии","item-text":"name","item-value":"id","menu-props":{maxHeight:'auto'},"required":""},model:{value:(_vm.accumulatedDataParam),callback:function ($$v) {_vm.accumulatedDataParam=$$v},expression:"accumulatedDataParam"}})],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.countersDataHeaders,"items":_vm.countersAccumulatedData,"loading":_vm.countersAccumulatedDataLoading,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.label))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.value))])]}}])})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-tab-item',{key:1},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.countersHeaders,"items":_vm.counters,"loading":_vm.countersLoading,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.serial_num))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.model.name))]),_vm._v(" "),_c('td',{staticClass:"justify-center layout px-0"},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.openTasks(props.item)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("\n                    date_range\n                  ")])],1)],1)]}}])})],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qdT3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointCountersData_vue__ = __webpack_require__("AKqe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointCountersData_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointCountersData_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointCountersData_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointCountersData_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_289b4d72_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PointCountersData_vue__ = __webpack_require__("qUzq");
function injectStyle (ssrContext) {
  __webpack_require__("JSGx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-289b4d72"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointCountersData_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_289b4d72_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PointCountersData_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "qfDW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DataSources_vue__ = __webpack_require__("NDR4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DataSources_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DataSources_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DataSources_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DataSources_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_160ae36c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DataSources_vue__ = __webpack_require__("im2A");
function injectStyle (ssrContext) {
  __webpack_require__("5yF3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-160ae36c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DataSources_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_160ae36c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DataSources_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "qo9I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocumentsRequestsRequired_vue__ = __webpack_require__("+jQ6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocumentsRequestsRequired_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocumentsRequestsRequired_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocumentsRequestsRequired_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocumentsRequestsRequired_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a108a4c2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DocumentsRequestsRequired_vue__ = __webpack_require__("S7eh");
function injectStyle (ssrContext) {
  __webpack_require__("j35W")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocumentsRequestsRequired_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a108a4c2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DocumentsRequestsRequired_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "r51e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("Sxpv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_125cbc99_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("qIsp");
function injectStyle (ssrContext) {
  __webpack_require__("1Tf8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-125cbc99"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_125cbc99_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "r706":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"flex-grow-1":"","xs12":""}},[_c('v-card',[_c('v-card-title',[_c('div',[_c('div',{staticClass:"headline"},[_vm._v("\n            Редактирование пользователя\n          ")])])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Наименование","name":"name","data-vv-as":"Наименование","error-messages":_vm.errors.collect('name')},model:{value:(_vm.permissionsGroup.name),callback:function ($$v) {_vm.$set(_vm.permissionsGroup, "name", $$v)},expression:"permissionsGroup.name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-chips-combobox',{attrs:{"model":_vm.permissionsGroup.permissions,"items":_vm.permissions,"item-text":"name","item-value":"permission_id","label":"Права"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","text":""},nativeOn:{"click":function($event){return _vm.saveChanges($event)}}},[_vm._v("\n          Сохранить\n        ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","text":""},nativeOn:{"click":function($event){return _vm.cancelEditing()}}},[_vm._v("\n          Отмена\n        ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "r7VN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('point-toolbar'),_vm._v(" "),_c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"xs":"12","sm":"12","md":"6"}},[_c('v-card',{staticClass:"main-card"},[_c('v-card-text',[_c('v-form',{ref:"pointEditForm",attrs:{"lazy-validation":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Наименование","rules":_vm.pointEditRules,"required":""},on:{"input":_vm.changeForm},model:{value:(_vm.editedItem.name),callback:function ($$v) {_vm.$set(_vm.editedItem, "name", $$v)},expression:"editedItem.name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Идентификатор Точки учёта","rules":_vm.pointEditRules,"required":""},on:{"input":_vm.changeForm},model:{value:(_vm.editedItem.point_number),callback:function ($$v) {_vm.$set(_vm.editedItem, "point_number", $$v)},expression:"editedItem.point_number"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-autocomplete',{attrs:{"items":_vm.customers,"label":"Абонент","item-text":"name","item-value":"customer_id","no-data-text":"Нет доступных абонентов","menu-props":{maxHeight:'auto'}},on:{"input":_vm.changeForm},model:{value:(_vm.editedItem.customer_id),callback:function ($$v) {_vm.$set(_vm.editedItem, "customer_id", $$v)},expression:"editedItem.customer_id"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Адрес","rules":_vm.pointEditRules,"required":""},on:{"input":_vm.changeForm},model:{value:(_vm.editedItem.address),callback:function ($$v) {_vm.$set(_vm.editedItem, "address", $$v)},expression:"editedItem.address"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Примечание"},on:{"input":_vm.changeForm},model:{value:(_vm.editedItem.remark),callback:function ($$v) {_vm.$set(_vm.editedItem, "remark", $$v)},expression:"editedItem.remark"}})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-col',{attrs:{"xs":"12","sm":"12","md":"6"}},[_c('v-card',{staticClass:"main-card"},[_c('v-card-title',[_vm._v("Лимит потребления по точке учета")]),_vm._v(" "),_c('v-card-text',[_c('div',{staticClass:"d-flex flex-column"},[_c('div',[_c('svg',{attrs:{"width":"15","height":"15"}},[_c('line',{attrs:{"stroke-width":"30","x1":"0","y1":"0","x2":"15","y2":"0","stroke":"#e5e5e5"}})]),_vm._v(" "),_c('span',[_vm._v("Установленный лимит: "),_c('v-menu',{attrs:{"close-on-content-click":false,"absolute":"","offset-y":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('a',_vm._g(_vm._b({attrs:{"href":"#"}},'a',attrs,false),on),[_vm._v(_vm._s(_vm.editedItem.energy_limit))])]}}]),model:{value:(_vm.showConsumptionEditMenu),callback:function ($$v) {_vm.showConsumptionEditMenu=$$v},expression:"showConsumptionEditMenu"}},[_vm._v(" "),_c('v-card',{staticClass:"pa-4 pb-0"},[_c('v-text-field',{attrs:{"label":"Наименование","type":"number"},on:{"input":_vm.changeForm},model:{value:(_vm.editedItem.energy_limit),callback:function ($$v) {_vm.$set(_vm.editedItem, "energy_limit", $$v)},expression:"editedItem.energy_limit"}}),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"text":""},on:{"click":function($event){_vm.showConsumptionEditMenu = false}}},[_vm._v("\n                      Ок\n                    ")])],1)],1)],1),_vm._v(" кВт*ч")],1)])]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-column"},[_c('div',[_c('svg',{attrs:{"width":"15","height":"15"}},[_c('line',{attrs:{"stroke-width":"30","x1":"0","y1":"0","x2":"15","y2":"0","stroke":"#cddb39"}})]),_vm._v(" "),_c('span',[_vm._v("Потребление в текущем месяце: "+_vm._s(_vm.pointConsumption)+" кВт*ч")])])]),_vm._v(" "),_c('div',{staticClass:"text-center pt-4"},[_c('v-progress-circular',{attrs:{"rotate":90,"size":230,"width":15,"value":_vm.pointConsumption/_vm.editedItem.energy_limit*100,"color":"lime"}},[_c('div',{staticClass:"text-center"},[_c('div',{staticClass:"text-h4 black--text"},[_vm._v(_vm._s(_vm.pointConsumption))]),_vm._v(" "),_c('div',{staticClass:"text-h6 black--text"},[_vm._v("кВт*ч")])])])],1)])],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),(_vm.changed)?_c('div',{staticClass:"px-3 save_block"},[_c('v-btn',{attrs:{"color":"orange darken-1","text":""},nativeOn:{"click":function($event){return _vm.save($event)}}},[_vm._v("\n          Сохранить\n        ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"red darken-1","text":""},nativeOn:{"click":function($event){return _vm.cancel($event)}}},[_vm._v("\n          Отмена\n        ")])],1):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rkeX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointCounterInstallExisted_vue__ = __webpack_require__("5rGw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointCounterInstallExisted_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointCounterInstallExisted_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointCounterInstallExisted_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointCounterInstallExisted_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e9e8dec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PointCounterInstallExisted_vue__ = __webpack_require__("06No");
function injectStyle (ssrContext) {
  __webpack_require__("cBNx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1e9e8dec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointCounterInstallExisted_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e9e8dec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PointCounterInstallExisted_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "t1Sn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "t4dI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "t5W4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"flex-grow-1":"","xs12":""}},[_c('v-card',[_c('v-card-title',[_c('div',{staticClass:"headline"},[_vm._v("\n          Добавление группы прав\n        ")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-form',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Наименование","name":"name","data-vv-as":"Наименование","error-messages":_vm.errors.collect('name')},model:{value:(_vm.permissionsGroup.name),callback:function ($$v) {_vm.$set(_vm.permissionsGroup, "name", $$v)},expression:"permissionsGroup.name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-chips-combobox',{attrs:{"model":_vm.permissionsGroup.permissions,"items":_vm.permissions,"item-text":"name","item-value":"permission_id","label":"Права"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","text":""},nativeOn:{"click":function($event){return _vm.saveChanges($event)}}},[_vm._v("\n          Сохранить\n        ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","text":""},nativeOn:{"click":function($event){return _vm.cancelEditing()}}},[_vm._v("\n          Отмена\n        ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "t8j/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _VChipsCombobox = __webpack_require__("XMIC");

var _VChipsCombobox2 = _interopRequireDefault(_VChipsCombobox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'UserEdit',
  components: {
    VChipsCombobox: _VChipsCombobox2.default
  },
  props: {
    userData: {}
  },
  data: function data() {
    return {
      inputRules: [function (v) {
        return !!v || 'Заполните это поле!';
      }],
      user: {},
      users_groups: [],
      permissionsGroups: []
    };
  },
  mounted: function mounted() {
    this.user = this.userData;
    this.getPermissionsGroupsApi();
  },

  methods: {
    cancelEditing: function cancelEditing() {
      this.$emit('cancel');
    },
    getPermissionsGroupsApi: function getPermissionsGroupsApi() {
      var _this = this;

      this.loading = true;
      this.axios.get('/api/permissions_groups/?per_page=100').then(function (response) {
        _this.permissionsGroups = response.data.results;
        _this.loading = false;
      }).catch(function (err) {
        _this.loading = false;
        console.log(err);
      });
    },
    validate: function validate() {
      if (this.$refs.userEditForm.validate()) {
        return true;
      }
    },
    saveChanges: function saveChanges() {
      var _this2 = this;

      if (this.validate()) {
        this.axios.patch('/api/users/' + this.userData.user_id + '/', this.user).then(function () {
          _this2.$emit('edited');
        }).catch(function (err) {
          _this2.$emit('editError', err.response.data);
        });
      }
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "tGDa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountEmails_vue__ = __webpack_require__("gMC7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountEmails_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountEmails_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountEmails_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountEmails_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c559603e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountEmails_vue__ = __webpack_require__("5tHt");
function injectStyle (ssrContext) {
  __webpack_require__("GjPQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountEmails_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c559603e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountEmails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "tMdx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueChartjs = __webpack_require__("UlOv");

exports.default = {
  extends: _vueChartjs.Line,
  props: {
    chartData: {
      type: Array,
      required: false
    },
    chartLabels: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      options: {
        tooltips: {
          position: 'average',
          mode: 'index',
          intersect: false
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            },
            gridLines: {
              display: true
            }
          }],
          xAxes: [{
            ticks: {
              maxRotation: 80
            },
            gridLines: {
              display: false
            }
          }]
        },
        legend: {
          display: false
        },
        responsive: true,
        maintainAspectRatio: false
      }
    };
  },
  mounted: function mounted() {
    this.renderChart({
      labels: this.chartLabels,
      datasets: [{
        label: '',
        borderColor: '#249EBF',
        pointBackgroundColor: 'white',
        borderWidth: 1,
        pointBorderColor: '#249EBF',
        backgroundColor: 'transparent',
        data: this.chartData
      }]
    }, this.options);
  }
};

/***/ }),

/***/ "tlLp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tlZN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar',{attrs:{"flat":""}},[_c('v-btn',{attrs:{"fab":"","text":""},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('v-icon',[_vm._v("keyboard_backspace")])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.pointInfo))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',{staticClass:"hidden-sm-and-down"},[_vm._l((_vm.pointTabs),function(tab){return [_c('v-btn',{key:tab.title,attrs:{"text":"","to":'/points/' + _vm.point_id + tab.path}},[_vm._v("\n        "+_vm._s(tab.title)+"\n      ")])]})],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uQuX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'PointToolbar',
  props: {
    pointInfo: {}
  },
  data: function data() {
    return {
      point_id: this.$route.params['id'],
      pointTabs: [{ icon: '', title: 'Основное', path: '/edit' }, { icon: '', title: 'Потребление', path: '/consumption' }, { icon: '', title: 'Фазы', path: '/phase' }, { icon: '', title: 'Счетчики', path: '/counters' }, { icon: '', title: 'Расписание', path: '/scheduler' }]
    };
  }
};

/***/ }),

/***/ "uUv6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('point-toolbar'),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_vm._v("\n            Профиль мощности\n          ")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ue3q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Points_vue__ = __webpack_require__("6yGu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Points_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Points_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Points_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Points_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13086b7a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Points_vue__ = __webpack_require__("I4v2");
function injectStyle (ssrContext) {
  __webpack_require__("t1Sn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-13086b7a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Points_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13086b7a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Points_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-SG": "oYA3",
	"./en-SG.js": "oYA3",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "vFUW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vRFU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vXv8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "w6HK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.represents),function(represent){return _c('div',{key:-represent.id,staticClass:"report-tree-node",class:{ 'node-pt4': _vm.representsSelectType !== 'multiple' }},[(_vm.representsSelectType === 'multiple')?_c('v-checkbox',{attrs:{"disabled":represent.status === 'empty',"hide-details":""},on:{"change":function($event){return _vm.$emit('repr-select', represent)}},scopedSlots:_vm._u([{key:"append",fn:function(){return [(represent.status !== 'empty')?_c('div',{staticClass:"represent-label represent-selectable",on:{"click":function($event){return _vm.reprExpand(represent)}}},[_vm._v("\n          "+_vm._s(represent.name)+"\n          "),_c('v-icon',[_vm._v("\n            "+_vm._s(represent.status === 'expanded'
                ? 'fas fa-caret-down'
                : represent.status === 'loading'
                  ? 'mdi-reload'
                  : 'fas fa-caret-right')+"\n          ")])],1):_c('div',{staticClass:"represent-label"},[_vm._v("\n          "+_vm._s(represent.name)+"\n        ")])]},proxy:true}],null,true),model:{value:(represent.is_selected),callback:function ($$v) {_vm.$set(represent, "is_selected", $$v)},expression:"represent.is_selected"}}):_vm._e(),_vm._v(" "),(_vm.representsSelectType === 'none')?[(represent.status !== 'empty')?_c('div',{staticClass:"represent-label represent-selectable",on:{"click":function($event){return _vm.reprExpand(represent)}}},[_vm._v("\n        "+_vm._s(represent.name)+"\n        "),_c('v-icon',[_vm._v("\n          "+_vm._s(represent.status === 'expanded'
              ? 'fas fa-caret-down'
              : represent.status === 'loading'
                ? 'mdi-reload'
                : 'fas fa-caret-right')+"\n        ")])],1):_c('div',{staticClass:"represent-label"},[_vm._v("\n        "+_vm._s(represent.name)+"\n      ")])]:_vm._e(),_vm._v(" "),(represent.status === 'expanded' || represent.status === 'loading')?_c('report-tree-node',{attrs:{"is-root":false,"initial-represents":represent.children,"initial-all-points":_vm.allPoints,"represent-points":represent.points,"represents-select-type":_vm.representsSelectType,"points-select-type":_vm.pointsSelectType,"limit-selected-points":_vm.limitSelectedPoints},on:{"repr-select":function($event){return _vm.$emit('repr-select', $event)},"point-select":function($event){return _vm.$emit('point-select', $event)},"selected-repr-expand":function($event){return _vm.$emit('selected-repr-expand', $event)}}}):_vm._e()],2)}),_vm._v(" "),(_vm.pointsSelectType === 'multiple')?_vm._l((_vm.representPoints),function(point){return _c('div',{key:point.id,staticClass:"report-tree-node point-node"},[_c('v-checkbox',{attrs:{"disabled":_vm.limitSelectedPoints && !point.is_selected,"label":point.name,"hide-details":""},on:{"change":function($event){return _vm.$emit('point-select', point)}},model:{value:(point.is_selected),callback:function ($$v) {_vm.$set(point, "is_selected", $$v)},expression:"point.is_selected"}})],1)}):_vm._e(),_vm._v(" "),(_vm.pointsSelectType === 'single')?_vm._l((_vm.representPoints),function(point){return _c('div',{key:point.id,staticClass:"report-tree-node point-node",on:{"click":function($event){return _vm.$emit('point-select', point)}}},[_vm._v("\n      "+_vm._s(point.name)+"\n    ")])}):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "w6S0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wLbH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{ref:"name",attrs:{"label":"Наименование"},model:{value:(_vm.editedRepresent.name),callback:function ($$v) {_vm.$set(_vm.editedRepresent, "name", $$v)},expression:"editedRepresent.name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{attrs:{"label":"Примечание"},model:{value:(_vm.editedRepresent.remark),callback:function ($$v) {_vm.$set(_vm.editedRepresent, "remark", $$v)},expression:"editedRepresent.remark"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-checkbox',{attrs:{"hide-details":"","label":"Проверять состояние"},model:{value:(_vm.editedRepresent.check_health),callback:function ($$v) {_vm.$set(_vm.editedRepresent, "check_health", $$v)},expression:"editedRepresent.check_health"}})],1),_vm._v(" "),(_vm.editedRepresent.check_health)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{attrs:{"label":"IP Адресс"},model:{value:(_vm.editedRepresent.health_check_ip),callback:function ($$v) {_vm.$set(_vm.editedRepresent, "health_check_ip", $$v)},expression:"editedRepresent.health_check_ip"}})],1):_vm._e(),_vm._v(" "),(_vm.editedRepresent.check_health)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{attrs:{"label":"Порт"},model:{value:(_vm.editedRepresent.health_check_port),callback:function ($$v) {_vm.$set(_vm.editedRepresent, "health_check_port", $$v)},expression:"editedRepresent.health_check_port"}})],1):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","text":""},nativeOn:{"click":function($event){return _vm.addRepresentApi($event)}}},[_vm._v("\n      Сохранить\n    ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wPNm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

var _DynamicLineChart = __webpack_require__("B8X5");

var _DynamicLineChart2 = _interopRequireDefault(_DynamicLineChart);

var _CounterParametersData = __webpack_require__("0WFi");

var _CounterParametersData2 = _interopRequireDefault(_CounterParametersData);

var _vueColor = __webpack_require__("Zzkc");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var API_URL = 'represents';

Date.prototype.toHHMM = function () {
  var hours = this.getUTCHours();
  var minutes = this.getMinutes();
  hours = hours < 10 ? '0' + hours : hours;
  minutes = minutes < 10 ? '0' + minutes : minutes;
  return hours + ':' + minutes;
};

exports.default = {
  name: 'Represents',
  components: {
    LineChart: _DynamicLineChart2.default,
    CounterParametersData: _CounterParametersData2.default,
    'swatches-picker': _vueColor.Swatches
  },
  props: ['model'],
  data: function data() {
    return {
      pointAddRules: [function (v) {
        return !!v || 'Заполните это поле!';
      }],
      editPoint: null,
      changed: true,
      colorSelectDialog: false,
      pointAddDialog: null,
      counterId: '',
      counter: {},
      opacityLoadTable: '',
      dataGroup: 30,
      lookAvailablePoints: false,
      addPoints: false,
      dataGroupItems: [{ value: 30, text: '30 минут' }, { value: 60, text: '60 минут' }, { value: 1440, text: 'День' }],
      pointsDataLoading: false,
      pointSearch: '',
      dataFilterMonthMenu: false,
      dataFilterMonthVal: null,
      activeTab: null,
      dataTabs: null,
      editedRepresent: {},
      currentRepresent: {},
      loadingRepresentAvailablePoints: false,
      pointsDataHeaders: [],
      pointsData: [],
      editLostColor: false,
      availablePointsHeaders: [{
        text: '',
        sortable: false,
        align: 'center',
        value: 'selected' }, {
        text: 'Наименование',
        sortable: false,
        align: 'center',
        value: 'name' }, {
        text: 'Число объектов принадлежности',
        sortable: false,
        align: 'center',
        value: 'point_represents_number' }, {
        text: 'Идентификатор',
        sortable: false,
        align: 'center',
        value: 'point_number' }, {
        text: 'Абонент',
        sortable: false,
        align: 'center',
        value: 'customer_name' }, {
        text: 'Адрес',
        sortable: false,
        align: 'center',
        value: 'address' }],
      loadedRepresentPoints: false,
      representPoints: [],
      representPointsHeaders: [{
        text: '№ПП',
        sortable: false,
        value: 'order_num',
        visible: true }, {
        text: 'Лицевой счёт Абонента',
        sortable: false,
        value: 'customer_number',
        visible: true }, {
        text: 'Наименование',
        sortable: false,
        value: 'name',
        visible: true }, {
        text: '№ счётчика и модель',
        sortable: false,
        value: 'counter',
        visible: true }, {
        text: 'Адрес',
        sortable: false,
        value: 'address',
        visible: true }, {
        text: 'Цвет',
        sortable: false,
        value: 'color',
        visible: true }, {
        text: 'Знак',
        sortable: false,
        value: 'sign',
        visible: true }, {
        text: 'Питание',
        sortable: false,
        value: 'is_active',
        visible: true }],
      representAvailablePoints: [],
      defaultRepresent: {
        name: '',
        title: 'new'
      },
      pointsCountersValuesHeaders: [],
      pointsCountersValuesData: [],
      pointsCountersValuesDataLoading: false,
      currentRepresentId: null,
      pointsDataLabels: [],
      pointsDatasets: [],
      crntEditClr: 'red',
      needToUpdatePointsData: true,
      representIsLoading: true,
      periodSelector: 'current',
      dateBeginVal: null,
      dateBegin: null,
      closeOnContentClick: false,
      dateBeginMenu: false,
      dateEnd: null,
      dateEndMenu: false,
      dateEndVal: null,
      currentPeriodBeginDate: '',
      currentPeriodEndDate: '',
      energyFormat: 'kvch',
      showTableSum: true,
      valRound: 'roundWith',
      roundVal: 2,
      pointsCountersValuesCsvUrl: null,
      pointsProfileCsvUrl: null,
      roundChoice: [{ round: 1 }, { round: 2 }, { round: 3 }, { round: 4 }, { round: 5 }],
      showLost: true,
      showLostInPercentage: false,
      getSum: false,
      postSum: false,
      countersData: null,
      energyType: 'straight',
      energyTypes: [{ energy: 'straight', text: 'Прямая' }, { energy: 'reverse', text: 'Обратная' }],
      currentValueOnTime: '0',
      reactiveEnergy: false,
      valueOnTime: [],
      newPoint: {},
      customers: [],
      execInterval: null,
      lastHalfHourNum: 12,
      lastHalfHourNumDefault: 12,
      lastHalfHourNumMax: 168,
      needToRebuildRepresents: false,
      slctRepresentPoints: [],
      showCounterParametersData: false,
      infoCounterId: null
    };
  },

  computed: {
    slctRepresentPointsHeaders: function slctRepresentPointsHeaders() {
      return this.representPointsHeaders.filter(function (header) {
        return header.visible;
      });
    }
  },
  watch: {
    showLost: function showLost(newShowLostVal) {
      this.needToUpdatePointsData = true;
      localStorage.presentShowLost = newShowLostVal;
    },
    showLostInPercentage: function showLostInPercentage(newShowLostInPercentageVal) {
      this.needToUpdatePointsData = true;
      localStorage.presentShowLostInPercentage = newShowLostInPercentageVal;
    },
    pointsDataLoading: function pointsDataLoading() {
      if (this.pointsDataLoading == false) {
        this.opacityLoadTable = 'opacity: 1';
      } else {
        this.opacityLoadTable = 'opacity: 0';
      }
    },
    'editedRepresent.name': function editedRepresentName() {
      this.changed = true;
    },
    'editedRepresent.remark': function editedRepresentRemark() {
      this.changed = true;
    },
    'editedRepresent.check_health': function editedRepresentCheck_health() {
      this.changed = true;
    },
    representPointsHeaders: {
      handler: function handler(newVal) {
        var parsed = JSON.stringify(Object(newVal));
        localStorage.setItem('representPointsHeaders', parsed);
      },

      deep: true
    },
    roundVal: function roundVal(newRoundVal) {
      this.needToUpdatePointsData = true;
      localStorage.presentRoundVal = newRoundVal;
    },
    valRound: function valRound(newValRound) {
      this.needToUpdatePointsData = true;
      localStorage.presentValRound = newValRound;
    },
    dataGroup: function dataGroup(newDataGroup) {
      this.needToUpdatePointsData = true;
      localStorage.presentDataGroup = newDataGroup;
    },
    periodSelector: function periodSelector(newPeriodSelectorVal) {
      this.needToUpdatePointsData = true;
      if (newPeriodSelectorVal == 'current') {
        this.dateBeginVal = this.currentPeriodBeginDate;
        this.dateEndVal = this.currentPeriodEndDate;
      }
      localStorage.presentPeriodSelectorVal = newPeriodSelectorVal;
    },
    dateBeginVal: function dateBeginVal(newDateBegVal) {
      this.dateBegin = this.formatDate(newDateBegVal);
      this.needToUpdatePointsData = true;
      localStorage.presentDateBeginVal = newDateBegVal;
    },
    dateEndVal: function dateEndVal(newDateEndVal) {
      this.dateEnd = this.formatDate(newDateEndVal);
      this.needToUpdatePointsData = true;
      localStorage.presentDateEndVal = newDateEndVal;
    },
    reactiveEnergy: function reactiveEnergy(newReactiveEnergy) {
      this.needToUpdatePointsData = true;
      localStorage.presentReactiveEnergy = newReactiveEnergy;
    },
    energyType: function energyType(newEnergyType) {
      this.needToUpdatePointsData = true;
      localStorage.presentEnergyType = newEnergyType;
    },
    energyFormat: function energyFormat(newEnergyFormat) {
      this.needToUpdatePointsData = true;
      localStorage.presentEnergyFormat = newEnergyFormat;
    },
    currentValueOnTime: function currentValueOnTime() {
      this.getPointsData();
    },
    '$route': function $route(to, from) {
      this.getRepresentInfoApi(this.$route.params.representId);
      this.needToUpdatePointsData = true;
      this.activeTab = 'rep-tab-points';
    },
    activeTab: function activeTab(val) {
      if (val === 'rep-tab-table' || val === 'rep-tab-cnt-val-table') {
        if (this.needToUpdatePointsData) {
          this.getPointsData();
          this.needToUpdatePointsData = false;
        }
      }
      if (val === 'rep-tab-chart') {
        this.loadGraph();
      }
    },
    lastHalfHourNum: function lastHalfHourNum(newVal, oldVal) {
      if (newVal != +newVal) {
        this.lastHalfHourNum = this.lastHalfHourNumDefault;
        return;
      }
      if (newVal > this.lastHalfHourNumMax) {
        this.lastHalfHourNum = this.lastHalfHourNumMax;
        return;
      }
      if (newVal === oldVal) {
        return;
      }
      if (this.currentRepresentId) {
        this.getRepresentPoints();
      }
      localStorage.lastHalfHourNum = newVal;
    }
  },
  mounted: function mounted() {
    this.initGraphNames();
    if (localStorage.lastHalfHourNum) {
      this.lastHalfHourNum = localStorage.lastHalfHourNum;
    }
    this.getRepresentInfoApi(this.$route.params.representId);
    var currentDate = new Date();
    this.currentPeriodBeginDate = this.parseDate('01/' + (currentDate.getMonth() + 1) + '/' + currentDate.getFullYear());
    this.currentPeriodEndDate = this.parseDate(currentDate.getDate() + '/' + (currentDate.getMonth() + 1) + '/' + currentDate.getFullYear());
    this.activeTab = 'rep-tab-points';
    this.needToUpdatePointsData = true;
    this.dateBeginVal = localStorage.presentDateBeginVal || this.currentPeriodBeginDate;
    this.dateEndVal = localStorage.presentDateEndVal || this.currentPeriodEndDate;

    if (localStorage.getItem('representPointsHeaders')) {
      this.representPointsHeaders = JSON.parse(localStorage.getItem('representPointsHeaders'));
    }
    if (localStorage.presentPeriodSelectorVal) {
      this.periodSelector = localStorage.presentPeriodSelectorVal;
    }

    if (localStorage.presentDataGroup) {
      this.dataGroup = Number(localStorage.presentDataGroup);
    }

    if (localStorage.presentEnergyFormat) {
      this.energyFormat = localStorage.presentEnergyFormat;
    }
    if (localStorage.presentShowLost) {
      this.showLost = localStorage.presentShowLost;
    }
    if (localStorage.presentShowLostInPercentage) {
      this.showLostInPercentage = localStorage.presentShowLostInPercentage;
    }
    if (localStorage.presentReactiveEnergy) {
      this.reactiveEnergy = localStorage.presentReactiveEnergy;
    }
    if (localStorage.presentEnergyType) {
      this.energyType = localStorage.presentEnergyType;
    }
    if (localStorage.presentValRound) {
      this.valRound = localStorage.presentValRound;
    }
    if (localStorage.presentRoundVal) {
      this.roundVal = localStorage.presentRoundVal;
    }
  },

  methods: {
    initGraphNames: function initGraphNames() {
      this.valueOnTime = [{ 'text': 'Начало дня', 'val': 0 }];
      for (var i = 1; i < 48; i++) {
        this.valueOnTime.push({ 'text': new Date(30 * 60000 * i).toHHMM(), 'val': i * 30 });
      }
    },
    getRepresentInfoApi: function getRepresentInfoApi(id) {
      var _this = this;

      this.representIsLoading = true;
      _axios2.default.get('/api/' + API_URL + '/' + id + '/').then(function (response) {
        _this.editedRepresent = Object.assign({}, response.data);
        _this.currentRepresent = Object.assign({}, response.data);
        _this.currentRepresentId = id;
        _this.getRepresentPoints();
        setTimeout(function () {
          return _this.changed = false;
        }, 10);
      }).catch(function (err) {
        console.log(err);
        _this.representIsLoading = false;
      });
    },
    updateRepresentApi: function updateRepresentApi() {
      var _this2 = this;

      var representUpdateJson = {
        'represent_id': this.editedRepresent.represent_id,
        'name': this.editedRepresent.name,
        'remark': this.editedRepresent.remark,
        'lost_color': this.editedRepresent.lost_color,
        'check_health': this.editedRepresent.check_health,
        'health_check_ip': this.editedRepresent.health_check_ip,
        'health_check_port': this.editedRepresent.health_check_port
      };
      _axios2.default.put('/api/' + API_URL + '/' + representUpdateJson.represent_id + '/', representUpdateJson).then(function (response) {
        _this2.$emit('renameSelectedRepresent', _this2.editedRepresent.name);
        setTimeout(function () {
          return _this2.changed = false;
        }, 10);
        if (_this2.needToRebuildRepresents) {
          _this2.$emit('rebuildRepresents');
          _this2.needToRebuildRepresents = false;
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    deleteRepresentApi: function deleteRepresentApi() {
      var _this3 = this;

      var id = this.editedRepresent.represent_id;
      _axios2.default.delete('/api/' + API_URL + '/' + id).then(function (response) {
        _this3.$router.push({ path: '/represent/new' });
        _this3.$emit('rebuildRepresents');
      }).catch(function (err) {
        console.log(err);
      });
    },

    loadGraph: function loadGraph() {
      if (this.countersData == null || this.needToUpdatePointsData) {
        this.getPointsData(this.loadGraph);
        this.needToUpdatePointsData = false;
        return;
      }
      this.pointsDataLabels = this.countersData.items.map(function (data) {
        return data.counter_date;
      });
      var pointsDatasets = [];
      if (this.countersData.items.length !== 0) {
        var headersKeys = Object.keys(this.countersData.items[0]);
        for (var headerKey in headersKeys) {
          if (headersKeys[headerKey] !== 'counter_date') {
            var color = this.countersData.points_colors[headersKeys[headerKey]];
            if (color === undefined) {
              color = 'red';
            }
            var borderDash = [];
            if (headersKeys[headerKey].indexOf('reverse') > 0) {
              borderDash = [2, 2];
            }
            if (headersKeys[headerKey] === 'lost') {
              color = this.editedRepresent.lost_color;
            }
            if (headersKeys[headerKey] === 'lost_percentage') {
              color = this.editedRepresent.lost_color;
            }
            pointsDatasets.push({
              label: this.countersData.headers[headerKey].text,
              borderColor: color,
              borderDash: borderDash,
              pointBackgroundColor: 'white',
              borderWidth: 1,
              pointBorderColor: color,
              lineTension: 0,
              backgroundColor: 'transparent',
              pointRadius: 0,
              data: this.countersData.items.map(function (data) {
                return data[headersKeys[headerKey]];
              })
            });
          }
        }
      }
      this.pointsDatasets = pointsDatasets;
    },
    getProfileData: function getProfileData(callback) {
      var _this4 = this;

      this.pointsDataLoading = true;
      if (this.currentRepresentId === null) {
        return;
      }
      var url = '/api/represents/' + this.currentRepresentId + '/points_profile_data/?interval=' + this.dataGroup + '&reactive_energy=' + this.reactiveEnergy + '&energy_type=' + this.energyType + '&energy_format=' + this.energyFormat;
      if (this.periodSelector == 'selected') {
        url += '&beginDate=' + this.dateBeginVal + '&endDate=' + this.dateEndVal;
      }
      if (this.showLost) {
        url += '&showLost=' + this.showLost;
      }
      if (this.showLostInPercentage) {
        url += '&showLostInPercentage=' + this.showLostInPercentage;
      }
      var pointsForReport = this.representPoints.reduce(function (filtered, point) {
        if (point.selected) {
          filtered.push(point.point_id);
        }
        return filtered;
      }, []);
      url += '&points=' + pointsForReport;
      if (this.valRound === 'round0') {
        url += '&roundVal=0';
      } else if (this.valRound === 'trunc') {
        url += '&roundVal=-1';
      } else if (this.valRound === 'roundWith') {
        url += '&roundVal=' + this.roundVal;
      }
      this.pointsProfileCsvUrl = url.replace('points_profile_data', 'points_profile_csv');

      _axios2.default.get(url).then(function (response) {
        _this4.pointsDataLoading = false;
        _this4.pointsDataHeaders = response.data.headers;
        _this4.pointsData = response.data.items;
        _this4.countersData = response.data;
        typeof callback === 'function' && callback();
      }).catch(function (err) {
        _this4.pointsDataLoading = false;
        console.log(err);
      });
    },
    getPointsCountersValues: function getPointsCountersValues() {
      var _this5 = this;

      if (this.currentRepresentId === null) {
        return;
      }
      this.pointsCountersValuesDataLoading = true;
      var url = '/api/represents/' + this.currentRepresentId + '/points_counters_values/?minutes_from_day_begin=' + this.currentValueOnTime;
      if (this.periodSelector == 'selected') {
        url += '&beginDate=' + this.dateBeginVal + '&endDate=' + this.dateEndVal;
      }
      this.pointsCountersValuesCsvUrl = url.replace('points_counters_values', 'points_counter_values_csv');
      _axios2.default.get(url).then(function (response) {
        _this5.pointsCountersValuesHeaders = response.data.headers;
        _this5.pointsCountersValuesData = response.data.items;
        _this5.pointsCountersValuesDataLoading = false;
      }).catch(function (err) {
        _this5.pointsCountersValuesDataLoading = false;
        console.log(err);
      });
    },
    getPointsData: function getPointsData(callback) {
      this.getProfileData(callback);
      this.getPointsCountersValues();
    },
    getRepresentPoints: function getRepresentPoints() {
      var _this6 = this;

      this.lookAvailablePoints = false;
      this.addPoints = false;
      _axios2.default.get('/api/represents/' + this.currentRepresentId + '/points/', { params: { halfs_num: this.lastHalfHourNum } }).then(function (response) {
        _this6.representPoints = response.data;
        _this6.representPoints.map(function (x) {
          x.selected = true;
          return x;
        });
        _this6.slctRepresentPoints = _this6.representPoints;
        _this6.loadedRepresentPoints = true;
        _this6.representIsLoading = false;
      }).catch(function (err) {
        console.log(err);
      });
    },
    getRepresentAvailablePoints: function getRepresentAvailablePoints() {
      var _this7 = this;

      this.loadingRepresentAvailablePoints = true;
      this.pointAddDialog = true;
      this.lookAvailablePoints = true;
      if (this.currentRepresentId != null) {
        _axios2.default.get('/api/represents/' + this.currentRepresentId + '/available_points/').then(function (response) {
          _this7.representAvailablePoints = response.data;
          _this7.loadingRepresentAvailablePoints = false;
        }).catch(function (err) {
          _this7.loadingRepresentAvailablePoints = false;
          console.log(err);
        });
      }
    },
    addPointToRepresent: function addPointToRepresent(pointId) {
      var _this8 = this;

      if (this.currentRepresentId != null) {
        _axios2.default.post('/api/represents/' + this.currentRepresentId + '/add_point/?point_id=' + pointId).then(function (response) {
          _this8.getRepresentPoints();
          _this8.needToUpdatePointsData = true;
        }).catch(function (err) {
          console.log(err);
        });
      }
    },
    delPointFromRepresent: function delPointFromRepresent(pointId) {
      var _this9 = this;

      if (this.currentRepresentId != null) {
        _axios2.default.post('/api/represents/' + this.currentRepresentId + '/del_point/?point_id=' + pointId).then(function () {
          _this9.getRepresentPoints();
          _this9.needToUpdatePointsData = true;
        }).catch(function (err) {
          console.log(err);
        });
      }
    },
    doAdRmPoint: function doAdRmPoint(item) {
      if (item.selected) {
        this.addPointToRepresent(item.point_id);
      } else {
        this.delPointFromRepresent(item.point_id);
      }
      return true;
    },
    deleteRepresent: function deleteRepresent() {
      if (confirm('Вы действительно хотите удалить этот объект?')) {
        this.deleteRepresentApi();
      }
    },
    saveRepresent: function saveRepresent() {
      this.updateRepresentApi();
    },
    cancelRepresentChanges: function cancelRepresentChanges() {
      var _this10 = this;

      if (confirm('Вы уверены?')) {
        this.editedRepresent = Object.assign({}, this.currentRepresent);
        setTimeout(function () {
          return _this10.changed = false;
        }, 10);
      }
    },
    updatePointSign: function updatePointSign(item) {
      var _this11 = this;

      _axios2.default.post('/api/represents/' + this.currentRepresentId + '/update_point_sign/?represent_point_id=' + item.represent_point_id).then(function (response) {
        item.sign = response.data.sign;
        _this11.needToUpdatePointsData = true;
      }).catch(function (err) {
        console.log(err);
      });
    },
    changeActiveState: function changeActiveState(item) {
      var action = item.counter_is_active ? 'отключить' : 'включить';
      if (confirm('\u0412\u044B \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0445\u043E\u0442\u0438\u0442\u0435 ' + action + ' \u0434\u0430\u043D\u043D\u044B\u0439 \u0441\u0447\u0451\u0442\u0447\u0438\u043A?')) {
        _axios2.default.post('/api/counters/' + item.counter_id + '/change_active_state/').then(function () {
          item.counter_is_active = item.counter_is_active != true;
        }).catch(function (err) {
          console.log(err);
        });
      }
    },
    updatePointColor: function updatePointColor(item) {
      var _this12 = this;

      _axios2.default.post('/api/represents/' + this.currentRepresentId + '/update_point_color/?represent_point_id=' + item.represent_point_id, { color: item.color }).then(function () {
        _this12.needToUpdatePointsData = true;
      }).catch(function (err) {
        console.log(err);
      });
    },
    closePointSelectDialog: function closePointSelectDialog() {
      this.pointAddDialog = 0;
      this.lookAvailablePoints = false;
    },
    selectLostColor: function selectLostColor() {
      this.colorSelectDialog = true;
      this.editLostColor = true;
    },
    selectColor: function selectColor(item) {
      this.colorSelectDialog = true;
      this.editPoint = item;
    },
    selectColorOk: function selectColorOk() {
      this.colorSelectDialog = false;
      if (this.editLostColor) {
        this.editLostColor = false;
        this.editedRepresent.lost_color = this.crntEditClr.hex;
        this.updateRepresentApi();
        this.getPointsData();
      } else {
        this.editPoint.color = this.crntEditClr.hex;
        this.updatePointColor(this.editPoint);
      }
    },
    selectColorCancel: function selectColorCancel() {
      this.colorSelectDialog = false;
      this.editLostColor = false;
    },
    formatDate: function formatDate(date) {
      if (!date) return null;

      var _date$split = date.split('-'),
          _date$split2 = _slicedToArray(_date$split, 3),
          year = _date$split2[0],
          month = _date$split2[1],
          day = _date$split2[2];

      return day + '/' + month + '/' + year;
    },
    parseDate: function parseDate(date) {
      if (!date) return null;

      var _date$split3 = date.split('/'),
          _date$split4 = _slicedToArray(_date$split3, 3),
          day = _date$split4[0],
          month = _date$split4[1],
          year = _date$split4[2];

      return year + '-' + month.padStart(2, '0') + '-' + day.padStart(2, '0');
    },
    updatePointOrder: function updatePointOrder(repPointId, orderValue) {
      var _this13 = this;

      _axios2.default.post('/api/represents/' + this.currentRepresentId + '/update_point_order/?represent_point_id=' + repPointId, { 'order_num': orderValue }).then(function () {
        _this13.getRepresentPoints();
        _this13.needToUpdatePointsData = true;
      }).catch(function (err) {
        console.log(err);
      });
    },
    getCustomers: function getCustomers() {
      var _this14 = this;

      _axios2.default.get('/api/customers/').then(function (response) {
        _this14.customers = response.data.results;
      }).catch(function (err) {
        console.log(err);
      });
    },
    showPointCreateDialog: function showPointCreateDialog() {
      if (this.customers.length === 0) {
        this.getCustomers();
      }
      this.addPoints = true;
    },
    addPointApi: function addPointApi() {
      var _this15 = this;

      _axios2.default.post('/api/points/', this.newPoint).then(function (response) {
        _this15.addPointToRepresent(response.data.point_id);
        _this15.closePointCreateDialog();
        _this15.getRepresentPoints();
      }).catch(function (err) {
        console.log(err);
      });
    },
    closePointCreateDialog: function closePointCreateDialog() {
      var _this16 = this;

      this.addPoints = false;
      setTimeout(function () {
        _this16.newPoint = {};
      }, 300);
    },
    validate: function validate() {
      if (this.$refs.addPointForm.validate()) {
        return true;
      }
    },
    savePoint: function savePoint() {
      if (this.validate()) {
        this.addPointApi();
        this.addPoints = false;
      }
    },
    toggleAllRepresentPoints: function toggleAllRepresentPoints($event) {
      this.representPoints.forEach(function (item) {
        item.selected = $event.value;
      });
      this.needToUpdatePointsData = true;
    },
    closeCounterParametersData: function closeCounterParametersData() {
      this.showCounterParametersData = false;
    },
    getCounterParametersData: function getCounterParametersData(item) {
      this.infoCounterId = item.counter_id;
      this.showCounterParametersData = true;
    },
    getResourceTypeIcon: function getResourceTypeIcon(resourceId) {
      if (resourceId == 1) {
        return 'fas fa-bolt';
      } else if (resourceId == 2) {
        return 'fas fa-tint';
      } else if (resourceId == 3) {
        return 'fas fa-fire';
      }
    },
    getResourceTypeIconColor: function getResourceTypeIconColor(resourceId) {
      if (resourceId == 1) {
        return '#002DFFFF';
      } else if (resourceId == 2) {
        return '#36cffd';
      } else if (resourceId == 3) {
        return '#002DFFFF';
      }
    }
  }
};

/***/ }),

/***/ "wTnL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-combobox',{attrs:{"items":_vm.items,"item-text":_vm.itemText,"item-value":_vm.itemValue,"label":_vm.label,"chips":true,"multiple":""},model:{value:(_vm.internalModel),callback:function ($$v) {_vm.internalModel=$$v},expression:"internalModel"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wcjt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.adding)?_c('user-new',{on:{"cancel":_vm.cancelAdding,"added":_vm.userAdded}}):(_vm.editing)?_c('user-edit',{attrs:{"user-data":_vm.selectedUserData},on:{"cancel":_vm.cancelEditing,"edited":_vm.userEdited,"editError":_vm.editUserError}}):(_vm.passwordChanging)?_c('change-password',{attrs:{"user-data":_vm.selectedUserData},on:{"cancel":_vm.cancelPasswordChanging,"edited":_vm.passwordChanged,"editError":_vm.changePasswordError}}):(_vm.loading)?_c('v-layout',{staticClass:"loading-indicator",attrs:{"justify-center":"","align-center":""}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":70,"width":7}})],1):_vm._e(),_vm._v(" "),_c('v-card',{directives:[{name:"show",rawName:"v-show",value:(!_vm.adding && !_vm.editing && !_vm.passwordChanging && !_vm.firstLoading),expression:"!adding && !editing && !passwordChanging && !firstLoading"}],staticClass:"users-card"},[(_vm.showSuccessMsg)?_c('v-card-title',{staticClass:"success-message",class:{ 'success-message-hide': !_vm.showSuccess}},[_c('div',{staticClass:"headline success-message-text"},[_c('i',{staticClass:"far fa-check-circle"}),_vm._v("Пользователь добавлен")])]):_vm._e(),_vm._v(" "),(_vm.showErrorMsg)?_c('v-card-title',{staticClass:"error-message",class:{ 'error-message-hide': !_vm.showError}},[_c('div',{staticClass:"headline success-message-text"},[_c('i',{staticClass:"far fa-times-circle"}),_vm._v(" "+_vm._s(_vm.errorMsg))])]):_vm._e(),_vm._v(" "),_c('v-card-title',[_c('v-text-field',{attrs:{"append-icon":"search","label":"Поиск по имени пользователя","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"fab":"","color":"primary"},on:{"click":_vm.addUser}},[_c('v-icon',[_vm._v("add")])],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"options":_vm.options,"server-items-length":_vm.serverItemsLength,"fixed-header":"","no-data-text":"Нет данных для отображения","footer-props":{
        itemsPerPageText: 'Число пользователей на странице',
        itemsPerPageOptions: [25, 50]
      },"dense":""},on:{"update:options":function($event){_vm.options=$event}},scopedSlots:_vm._u([{key:"item",fn:function(props){return _c('tr',{},[_c('td',[_vm._v(_vm._s(props.item.username))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.first_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.last_name))]),_vm._v(" "),_c('td',{staticClass:"justify-center px-0"},[_c('span',{staticClass:"action-btns"},[_c('v-btn',{staticClass:"mt-1",attrs:{"icon":"","title":"Редактировать"},on:{"click":function($event){return _vm.editUser(props.item)}}},[_c('v-icon',{attrs:{"color":"grey"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mt-1",attrs:{"icon":"","title":"Сменить пароль"},on:{"click":function($event){return _vm.changePassword(props.item)}}},[_c('v-icon',{attrs:{"color":"grey"}},[_vm._v("mdi-lock-reset")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mt-1",attrs:{"icon":"","title":"Удалить"},on:{"click":function($event){return _vm.deleteUser(props.item)}}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("delete")])],1)],1)])])}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "x4kD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocumentRequestDetails_vue__ = __webpack_require__("GoxP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocumentRequestDetails_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocumentRequestDetails_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocumentRequestDetails_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocumentRequestDetails_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ae3a1d9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DocumentRequestDetails_vue__ = __webpack_require__("6e+Q");
function injectStyle (ssrContext) {
  __webpack_require__("lpX1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocumentRequestDetails_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ae3a1d9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DocumentRequestDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "xJD8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Sidebar = __webpack_require__("14/s");

var _Sidebar2 = _interopRequireDefault(_Sidebar);

var _Toolbar = __webpack_require__("Ej32");

var _Toolbar2 = _interopRequireDefault(_Toolbar);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'App',
  components: {
    Sidebar: _Sidebar2.default,
    Toolbar: _Toolbar2.default
  },
  props: {
    source: String,
    title: String
  },
  data: function data() {
    return {
      showDrawer: true,
      treeData: [],
      treeServerData: [],
      selectedRepresentName: null,
      sidebarAdditionalData: {},
      sidebarAdditionalDataString: ''
    };
  },
  computed: {
    formTitle: function formTitle() {
      return this.$route.name;
    },
    isLoginPage: function isLoginPage() {
      return this.$route.path === '/login';
    },
    isLogged: function isLogged() {
      return this.$store.state.isLogged;
    }
  },
  watch: {
    name: function name(newName) {
      localStorage.name = newName;
    },
    isLogged: function isLogged() {
      this.getRepresentsApi();
    }
  },
  mounted: function mounted() {
    this.getRepresentsApi();
    this.checkDocuments();
    setInterval(function (self) {
      return function () {
        self.checkDocuments();
      };
    }(this), 10000);
    // this.checkRepresentsHealth()
    // setInterval(
    //   (function (self) {
    //     return function () {
    //       self.checkRepresentsHealth()
    //     }
    //   })(this), 10000)
  },

  methods: {
    updateRepresentHealthStatus: function updateRepresentHealthStatus(id, isOn) {
      var el = document.getElementById('tree' + id);
      if (el != null) {
        el.classList.remove('on');
        el.classList.remove('off');
        if (isOn) {
          el.classList.add('on');
        } else {
          el.classList.add('off');
        }
      }
    },
    checkDocuments: function checkDocuments() {
      var _this = this;

      _axios2.default.get('/api/document_request/check/').then(function (response) {
        _this.sidebarAdditionalData = response.data;
      }).catch(function (err) {
        console.log(err);
      });
    },
    checkRepresentsHealth: function checkRepresentsHealth() {
      var _this2 = this;

      var reprUrl = '/api/represent_health_check/';
      _axios2.default.get(reprUrl).then(function (response) {
        for (var key in response.data) {
          _this2.updateRepresentHealthStatus(key, response.data[key]);
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    change_drawer: function change_drawer() {
      this.showDrawer = !this.showDrawer;
    },
    getRepresentsApi: function getRepresentsApi() {
      var _this3 = this;

      if (!this.isLogged) {
        return;
      }
      var reprUrl = '/api/represents/?page_size=all';
      _axios2.default.get(reprUrl).then(function (response) {
        _this3.treeServerData = response.data.results;
        _this3.filterRepresent('');
      }).catch(function (err) {
        console.log(err);
      });
    },
    representSelected: function representSelected(node) {
      // eslint-disable-next-line handle-callback-err
      this.$router.push({ path: '/represents/' + node.model.represent_id }).catch(function (err) {});
    },
    filterData: function filterData(data, tm, searchText) {
      var t = void 0;
      function addIfFound(addTo, element) {
        if (element.search_text.length > 0) {
          if (element.search_text.toUpperCase().indexOf(searchText.toUpperCase()) >= 0) {
            addTo.push(element);
          }
        } else {
          addTo.push(element);
        }
      }
      for (var d in data) {
        var dd = Object.assign({}, data[d]);
        if (dd.children.length > 0) {
          t = Object.assign({}, dd);
          t.children = [];
          this.filterData(dd.children, t.children, searchText);
          if (t.children.length > 0) {
            tm.push(t);
          }
        } else {
          addIfFound(tm, dd);
        }
      }
    },
    filterRepresent: function filterRepresent(val) {
      this.treeData = [];
      this.filterData(this.treeServerData, this.treeData, val);
    },
    renameSelectedRepresent: function renameSelectedRepresent(name) {
      this.$refs.sidbar.renameSelectedRepresent(name);
    },
    rebuildRepresents: function rebuildRepresents() {
      this.getRepresentsApi();
    },
    representAdded: function representAdded() {
      this.getRepresentsApi();
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "xM8X":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'CounterParameters',
  props: {
    counterId: {},
    isOpen: {}
  },
  data: function data() {
    return {
      counter: {
        point_number: '',
        serial_num: '',
        model: { name: '' }
      },
      counterInfo: {},
      taskInfo: {},
      needToRefreshStatusInfo: true,
      counterSelectedParams: [],
      panel: [],
      phaseDataHeaders: [{
        text: 'Наименование',
        align: 'left',
        sortable: false,
        value: 'name'
      }, {
        text: 'Фаза A',
        align: 'center',
        sortable: false,
        value: 'v1'
      }, {
        text: 'Фаза B',
        align: 'center',
        sortable: false,
        value: 'v2'
      }, {
        text: 'Фаза C',
        align: 'center',
        sortable: false,
        value: 'v3'
      }, {
        text: 'Сумма',
        align: 'center',
        sortable: false,
        value: 'v4'
      }, {
        text: '',
        align: 'center',
        sortable: false,
        value: 'measure'
      }],
      phaseData: [],
      additionalAng: 15,
      uOne: 0,
      iOne: 0,
      uTwo: 0,
      iTwo: 0,
      angTwo: 0,
      angAdditionalOne: 0,
      angAdditionalTwo: 0,
      uThree: 0,
      iThree: 0,
      angThree: 0,
      angAdditionalThree: 0,
      showLines: false,
      phaseDataLoading: true,
      hasPhaseData: false
    };
  },

  watch: {
    counterId: {
      handler: function handler() {
        if (this.counterId === undefined) {}
      },

      immediate: true
    },
    isOpen: {
      handler: function handler(val) {
        this.needToRefreshStatusInfo = val;
        if (val) {
          this.getCounterInfo();
          this.getCounterParametersToCollect();
        } else {
          this.counterInfo = {};
          this.taskInfo = {};
        }
      },

      immediate: true
    }
  },
  methods: {
    getCounterPhaseData: function getCounterPhaseData() {
      var _this = this;

      _axios2.default.get('/api/counters/' + this.counterId + '/phase/').then(function (response) {
        _this.hasPhaseData = response.data.values_date != null;
        _this.phaseData = response.data.values;
        var u1 = parseFloat(_this.phaseData[4].v1);
        var u2 = parseFloat(_this.phaseData[4].v2);
        var u3 = parseFloat(_this.phaseData[4].v3);
        var i1 = parseFloat(_this.phaseData[5].v1);
        var i2 = parseFloat(_this.phaseData[5].v2);
        var i3 = parseFloat(_this.phaseData[5].v3);
        _this.angTwo = parseFloat(_this.phaseData[6].v4);
        _this.angThree = parseFloat(_this.phaseData[6].v4) + parseFloat(_this.phaseData[8].v4);

        var angAddOne = _this.phaseData[9].v4 !== '' ? parseFloat(parseFloat(_this.phaseData[9].v4)) : _this.additionalAng;
        var angAddTwo = _this.phaseData[10].v4 !== '' ? parseFloat(parseFloat(_this.phaseData[10].v4)) : _this.additionalAng;
        var angAddThree = _this.phaseData[11].v4 !== '' ? parseFloat(parseFloat(_this.phaseData[11].v4)) : _this.additionalAng;

        var uMax = Math.max(u1, u2, u3, 0.001);
        var iMax = Math.max(i1, i2, i3, 0.001);
        var lineLen = 140;
        var shortLineLen = 70;
        var maxLineLen = 165;
        _this.uOne = maxLineLen - lineLen / uMax * u1;
        _this.iOne = lineLen - shortLineLen / iMax * i1;
        _this.uTwo = maxLineLen - lineLen / uMax * u2;
        _this.iTwo = lineLen - shortLineLen / iMax * i2;
        _this.uThree = maxLineLen - lineLen / uMax * u3;
        _this.iThree = lineLen - shortLineLen / iMax * i3;
        _this.angAdditionalOne = angAddOne;
        _this.angAdditionalTwo = _this.angTwo + angAddTwo;
        _this.angAdditionalThree = _this.angThree + angAddThree;
        _this.showLines = true;
        _this.phaseDataLoading = false;
      }).catch(function (err) {
        console.log(err);
        _this.phaseDataLoading = false;
      });
    },
    getCounterInfoParameters: function getCounterInfoParameters() {
      var _this2 = this;

      _axios2.default.get('/api/counter/' + this.counterId + '/get_current_data/').then(function (response) {
        _this2.counterInfo = response.data.data;
        _this2.taskInfo = response.data.task;
        _this2.getCounterPhaseData();
        if (_this2.taskInfo && _this2.taskInfo.status === 'PENDING') {
          if (_this2.needToRefreshStatusInfo) {
            setTimeout(function () {
              _this2.getCounterInfoParameters();
            }, 1000);
          }
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    refreshCounterInfoParameters: function refreshCounterInfoParameters() {
      var _this3 = this;

      if (confirm('Вы уверены что хотите обновить инфрмацию по последним значениям параметров счётчика?')) {
        _axios2.default.get('/api/counter/' + this.counterId + '/get_current_data/?refresh=1').then(function () {
          _this3.getCounterInfoParameters();
        }).catch(function (err) {
          console.log(err);
        });
      }
    },
    getCounterInfo: function getCounterInfo() {
      var _this4 = this;

      _axios2.default.get('/api/counters/' + this.counterId + '/').then(function (response) {
        _this4.counter = response.data;
        _this4.getCounterInfoParameters();
      }).catch(function (err) {
        console.log(err);
      });
    },
    getCounterParametersToCollect: function getCounterParametersToCollect() {
      var _this5 = this;

      _axios2.default.get('/api/counters_parameters_to_collect/all_parameters_by_counter/?counter_id=' + this.counterId).then(function (response) {
        _this5.counterSelectedParams = response.data.reduce(function (map, obj) {
          var groupName = obj.parameter_group;
          if (groupName === '') {
            groupName = 'Параметры без группы';
          }
          if (!map[groupName]) {
            map[groupName] = [];
          }
          map[groupName].push(obj);
          return map;
        }, {});
      }).catch(function (err) {
        console.log(err);
      });
    },
    close: function close() {
      this.$emit('close');
      this.counterInfo = {};
      this.needToRefreshStatusInfo = false;
    },
    updateParameter: function updateParameter(param) {
      if (param.is_selected) {
        _axios2.default.post('/api/counters_parameters_to_collect/', {
          counter_id: this.counterId,
          parameter_id: param.parameter_id
        }).catch(function (err) {
          console.log(err);
        });
      } else {
        _axios2.default.post('/api/counters_parameters_to_collect/unselect/', {
          counter_id: this.counterId,
          parameter_id: param.parameter_id
        }).catch(function (err) {
          console.log(err);
        });
      }
    },
    test: function test(value) {
      var result = void 0;
      try {
        result = JSON.parse(value.replace(/'/g, '"'));
      } catch (e) {
        result = [value];
      }
      return result;
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "xoHE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocumentsRequestsRequiredDetails_vue__ = __webpack_require__("QpX1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocumentsRequestsRequiredDetails_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocumentsRequestsRequiredDetails_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocumentsRequestsRequiredDetails_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocumentsRequestsRequiredDetails_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_307dc920_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DocumentsRequestsRequiredDetails_vue__ = __webpack_require__("+rNa");
function injectStyle (ssrContext) {
  __webpack_require__("RBpd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocumentsRequestsRequiredDetails_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_307dc920_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DocumentsRequestsRequiredDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "xpb5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"tree-node"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checked),expression:"checked"}],attrs:{"id":_vm.model.represent_id,"type":"radio","name":"rad"},domProps:{"value":_vm.model.represent_id,"checked":_vm._q(_vm.checked,_vm.model.represent_id)},on:{"change":function($event){_vm.checked=_vm.model.represent_id}}}),_vm._v(" "),_c('label',{key:"label",staticClass:"tree-text"},[_c('div',{staticClass:"text-lable",attrs:{"title":_vm.model.name},on:{"click":_vm.changePath}},[_c('v-icon',{staticClass:"health-check",class:[
          { on: 1 || _vm.model.check_health },
          { partly: 0 },
          { off: 0 && !_vm.model.check_health }
        ]},[_vm._v("mdi-home-variant")]),_vm._v(" "),_c('span',{staticClass:"item-name",class:{ 'empty-item-name': !_vm.isFolder }},[_vm._v(_vm._s(_vm.model.name))]),_vm._v(" "),(_vm.isFolder)?_c('span',{key:_vm.model.represent_id,staticClass:"item-btns v-btn v-btn--icon",on:{"click":function($event){$event.stopPropagation();return _vm.toggle($event)}}},[_c('v-icon',[_vm._v("fas fa-caret-"+_vm._s(_vm.open ? 'down' : 'right'))])],1):_vm._e(),_c('v-btn',{staticClass:"item-btns",attrs:{"icon":"","to":("/represent/" + (_vm.model.represent_id) + "/new")},on:{"click":function($event){_vm.createSubRepresent=true}}},[_c('v-icon',[_vm._v("fas fa-plus")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"tree-children"},[(_vm.isFolder)?_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.open),expression:"open"}]},_vm._l((_vm.model.children),function(child){return _c('v-treeview-item',{key:child.represent_id,attrs:{"model":child,"tree-types":_vm.treeTypes,"open-all":_vm.openAll},on:{"addNode":_vm.addNode,"selected":_vm.selected}})}),1):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xvwV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"light":""}},[_c('v-layout')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "y7i9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Users_vue__ = __webpack_require__("1/7J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Users_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Users_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Users_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Users_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fac152e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Users_vue__ = __webpack_require__("wcjt");
function injectStyle (ssrContext) {
  __webpack_require__("mtmr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Users_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fac152e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Users_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "yaKo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointCounterInstall_vue__ = __webpack_require__("EsQq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointCounterInstall_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointCounterInstall_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointCounterInstall_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointCounterInstall_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_045ecde3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PointCounterInstall_vue__ = __webpack_require__("QBRW");
function injectStyle (ssrContext) {
  __webpack_require__("9HgN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-045ecde3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointCounterInstall_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_045ecde3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PointCounterInstall_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "yeu0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VTreeviewItem_vue__ = __webpack_require__("Ldyo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VTreeviewItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VTreeviewItem_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VTreeviewItem_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VTreeviewItem_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9144bcac_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VTreeviewItem_vue__ = __webpack_require__("xpb5");
function injectStyle (ssrContext) {
  __webpack_require__("/uXD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9144bcac"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VTreeviewItem_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9144bcac_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VTreeviewItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "yxfD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "z0Zy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RepresentNew_vue__ = __webpack_require__("+gFL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RepresentNew_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RepresentNew_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RepresentNew_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RepresentNew_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d0863ac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RepresentNew_vue__ = __webpack_require__("wLbH");
function injectStyle (ssrContext) {
  __webpack_require__("jBDd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RepresentNew_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d0863ac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RepresentNew_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "zGA6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_c('div',{staticClass:"headline"},[_vm._v("\n      Снятие счетчика с точки учёта\n    ")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"transition":"scale-transition","offset-y":"","min-width":"290px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-text-field',_vm._g({attrs:{"label":"Дата операции","readonly":""},on:{"blur":function($event){_vm.operDateVal = _vm.parseDate(_vm.operDate)}},model:{value:(_vm.operDate),callback:function ($$v) {_vm.operDate=$$v},expression:"operDate"}},on))]}}]),model:{value:(_vm.operDateMenu),callback:function ($$v) {_vm.operDateMenu=$$v},expression:"operDateMenu"}},[_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","scrollable":"","locale":"ru-RU"},on:{"input":function($event){_vm.operDateMenu = false}},model:{value:(_vm.operDateVal),callback:function ($$v) {_vm.operDateVal=$$v},expression:"operDateVal"}})],1)],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12"}},[_c('v-text-field',{attrs:{"label":"Причина снятия счётчика","required":""},model:{value:(_vm.counter_oper.comment),callback:function ($$v) {_vm.$set(_vm.counter_oper, "comment", $$v)},expression:"counter_oper.comment"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","text":""},nativeOn:{"click":function($event){return _vm.saveChanges($event)}}},[_vm._v("\n      Снять счётчик\n    ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","text":""},nativeOn:{"click":function($event){return _vm.cancelEditing()}}},[_vm._v("\n      Отмена\n    ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zI7b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PointCounterInstall = __webpack_require__("yaKo");

var _PointCounterInstall2 = _interopRequireDefault(_PointCounterInstall);

var _CounterHistory = __webpack_require__("kjdz");

var _CounterHistory2 = _interopRequireDefault(_CounterHistory);

var _CounterEdit = __webpack_require__("Wjfh");

var _CounterEdit2 = _interopRequireDefault(_CounterEdit);

var _PointCounterTakeOff = __webpack_require__("9bI/");

var _PointCounterTakeOff2 = _interopRequireDefault(_PointCounterTakeOff);

var _PointCounterEditConnectParameters = __webpack_require__("Z7NA");

var _PointCounterEditConnectParameters2 = _interopRequireDefault(_PointCounterEditConnectParameters);

var _PointToolbar = __webpack_require__("bB1z");

var _PointToolbar2 = _interopRequireDefault(_PointToolbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'PointCounters',
  components: {
    PointCounterInstall: _PointCounterInstall2.default,
    CounterHistory: _CounterHistory2.default,
    CounterEdit: _CounterEdit2.default,
    PointCounterTakeOff: _PointCounterTakeOff2.default,
    PointCounterEditConnectParameters: _PointCounterEditConnectParameters2.default,
    PointToolbar: _PointToolbar2.default
  },
  data: function data() {
    return {
      pointId: this.$route.params['id'],
      point: {
        'counter_id': 0
      },
      items: [],
      loading: true,
      pointHaveCounter: true,
      headers: [{
        text: 'Статус',
        align: 'left',
        sortable: false,
        value: 'is_current'
      }, {
        text: 'Серийный номер',
        align: 'left',
        sortable: false,
        value: 'serial_num'
      }, {
        text: 'Модель',
        align: 'left',
        sortable: false,
        value: 'model'
      }, {
        text: 'Коэф. трансформации тока',
        align: 'left',
        sortable: false,
        value: 'coef'
      }, {
        text: 'Коэф. трансформации напряжения',
        align: 'left',
        sortable: false,
        value: 'coeff_voltage'
      }, {
        text: 'Дата установки',
        align: 'left',
        sortable: false,
        value: 'install_date'
      }, { text: '', sortable: false, value: '' }],
      installing: false,
      showSuccess: false,
      showSuccessMsg: false,
      editing: false,
      showList: true,
      counterEditing: false,
      takingOff: false,
      selectedCounterData: {},
      showErrorMsg: false,
      showError: false,
      errorMsg: null,
      showCounterHistory: false,
      showCounterConnectParameters: false
    };
  },

  watch: {
    editing: function editing(val) {
      this.showList = !val;
      if (!val) {
        this.counterEditing = this.showCounterConnectParameters = this.takingOff = this.installing = false;
      }
    }
  },
  mounted: function mounted() {
    this.getCountersApi();
  },

  methods: {
    getCountersApi: function getCountersApi() {
      var _this = this;

      this.getPointApi();
      this.axios.get('/api/points/' + this.pointId + '/counters/').then(function (response) {
        _this.items = response.data.results;
      }).catch(function (err) {
        console.log(err);
      }).finally(function () {
        _this.loading = false;
      });
    },
    getPointApi: function getPointApi() {
      var _this2 = this;

      this.axios.get('/api/points/' + this.pointId + '/').then(function (response) {
        _this2.point = response.data;
      }).catch(function (err) {
        console.log(err);
      });
    },
    showErrorMessage: function showErrorMessage(msg) {
      var _this3 = this;

      this.errorMsg = msg;
      this.showError = true;
      this.showErrorMsg = true;
      setTimeout(function () {
        _this3.showError = false;
      }, 4000);
      setTimeout(function () {
        _this3.showErrorMsg = false;
      }, 4350);
    },
    counterInstalled: function counterInstalled(counterData) {
      var counter = this.items.find(function (item) {
        return item.counter_id === counterData.counter_id;
      });
      if (counter) {
        counter.serial_num = counterData.serial_num;
        counter.coeff = counterData.coeff;
        counter.coeff_voltage = counterData.coeff_voltage;
        counter.is_current = true;
        counter.last_install_date = counterData.install_date;
      } else {
        this.items.unshift({
          counter_id: counterData.counter_id,
          model_name: counterData.model.name,
          serial_num: counterData.serial_num,
          model_id: counterData.model_id,
          remark: counterData.remark,
          is_active: counterData.is_active,
          coeff: counterData.coeff,
          coeff_voltage: counterData.coeff_voltage,
          is_current: true,
          last_install_date: counterData.install_date,
          last_takeoff_date: ''
        });
      }
      this.point.counter_id = counterData.counter_id;
      this.editing = false;
    },
    counterEdited: function counterEdited(counter) {
      Object.assign(this.selectedCounterData, counter);
      this.editing = false;
    },
    counterTakeOff: function counterTakeOff() {
      this.selectedCounterData.is_current = false;
      this.point.counter_id = null;
      this.editing = false;
    },
    counterConnectEdited: function counterConnectEdited() {
      this.editing = false;
    },
    cancelEditing: function cancelEditing() {
      this.editing = false;
    },
    editCounterError: function editCounterError(msg) {
      this.editing = false;
      this.showErrorMessage(msg);
    },
    editConnectParameters: function editConnectParameters(item) {
      this.selectedCounterData = item;
      this.editing = true;
      this.showCounterConnectParameters = true;
    },
    installCounter: function installCounter() {
      this.installing = true;
      this.editing = true;
    },
    editCounter: function editCounter(item) {
      this.selectedCounterData = item;
      this.editing = true;
      this.counterEditing = true;
    },
    takeOff: function takeOff(item) {
      if (item.is_current === false) {
        this.showErrorMessage('Cчётчик не установлен на Точку учёта');
        return;
      }
      this.selectedCounterData = item;
      this.editing = true;
      this.takingOff = true;
    },
    counterHistory: function counterHistory(item) {
      this.selectedCounterData = item;
      this.showCounterHistory = true;
    },
    closeCounterHistory: function closeCounterHistory() {
      this.showCounterHistory = false;
    }
  }
};

/***/ }),

/***/ "zIsa":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PointToolbar = __webpack_require__("bB1z");

var _PointToolbar2 = _interopRequireDefault(_PointToolbar);

var _Chart = __webpack_require__("Px/B");

var _Chart2 = _interopRequireDefault(_Chart);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'PointConsumption',
  components: {
    PointToolbar: _PointToolbar2.default,
    LineChart: _Chart2.default
  },
  data: function data() {
    return {
      pointId: this.$route.params['id'],
      loaded: true,
      point: { name: '' },
      consumptionChartData: null,
      consumptionChartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false
        }
      },
      consumptionDataHeaders: [{
        text: 'Дата',
        align: 'left',
        sortable: false,
        value: 'consumption_date'
      }, {
        text: 'Номер счетчика',
        align: 'left',
        sortable: false,
        value: 'counter_serial_num'
      }, {
        text: 'Показания',
        align: 'left',
        sortable: false,
        value: 'counter_value'
      }, {
        text: 'Потребление',
        align: 'left',
        sortable: false,
        value: 'consumption'
      }],
      consumptionByDate: [],
      monthDate: new Date().toISOString().substr(0, 7),
      monthSelectMenu: false
    };
  },

  watch: {},
  mounted: function mounted() {
    this.getPointByDateConsumption();
    this.getPointApi();
  },

  methods: {
    getPointApi: function getPointApi() {
      var _this = this;

      _axios2.default.get('/api/points/' + this.pointId + '/').then(function (response) {
        _this.point = response.data;
        _this.loaded = true;
      }).catch(function (err) {
        _this.loaded = true;
        console.log(err);
      });
    },
    saveMonth: function saveMonth() {
      this.$refs.monthMenu.save(this.monthDate);
      this.getPointByDateConsumption();
    },
    getPointByDateConsumption: function getPointByDateConsumption() {
      var _this2 = this;

      /**
       * Data of response contain
       * @param data.consumption_date
       * @param data.consumption
       */
      this.loaded = false;
      _axios2.default.get('/api/points/' + this.pointId + '/consumption_by_date/', { params: { month: this.monthDate } }).then(function (response) {
        _this2.consumptionByDate = response.data;
        var consumptionDates = [];
        var consumptionValues = [];
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = _this2.consumptionByDate[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var v = _step.value;

            consumptionDates.push(v.consumption_date);
            consumptionValues.push(v.consumption);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        _this2.consumptionChartData = {
          labels: consumptionDates,
          datasets: [{
            label: 'Потребление',
            backgroundColor: '#f87979',
            data: consumptionValues
          }]
        };
        _this2.loaded = true;
      }).catch(function (err) {
        _this2.loaded = true;
        console.log(err);
      });
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "zhaU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.resource_type)?_c('v-breadcrumbs',{attrs:{"items":_vm.breadcrumbsItems},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
return [_c('v-breadcrumbs-item',{attrs:{"href":"#","disabled":item.disabled},on:{"click":function($event){return _vm.openBreadcrumbsUrl(item)}}},[_vm._v("\n        "+_vm._s(item.text)+"\n      ")])]}}],null,false,3791575482)}):_vm._e(),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"fixed-header":"","no-data-text":"Нет группа моделей для отображения","hide-default-footer":"","disable-pagination":"","hide-default-header":"","dense":""},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
return [_c('tr',{staticClass:"link-row",on:{"click":function($event){return _vm.openModels(item)}}},[_c('td',[_vm._v(_vm._s(item.name))])])]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.c4170fd1558a6635f05e.js